(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[617],{

/***/ 3086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ autocomplete; }
});

;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/checkOptions.js

function checkOptions(options) {
   false ? 0 : void 0;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/createCancelablePromiseList.js
function createCancelablePromiseList() {
  var list = [];
  return {
    add: function add(cancelablePromise) {
      list.push(cancelablePromise);
      return cancelablePromise.finally(function () {
        list = list.filter(function (item) {
          return item !== cancelablePromise;
        });
      });
    },
    cancelAll: function cancelAll() {
      list.forEach(function (promise) {
        return promise.cancel();
      });
    },
    isEmpty: function isEmpty() {
      return list.length === 0;
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/createStore.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function createStore(reducer, props, onStoreStateChange) {
  var state = props.initialState;
  return {
    getState: function getState() {
      return state;
    },
    dispatch: function dispatch(action, payload) {
      var prevState = _objectSpread({}, state);

      state = reducer(state, {
        type: action,
        props: props,
        payload: payload
      });
      onStoreStateChange({
        state: state,
        prevState: prevState
      });
    },
    pendingRequests: createCancelablePromiseList()
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/flatten.js
function flatten(values) {
  return values.reduce(function (a, b) {
    return a.concat(b);
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/getAutocompleteSetters.js
function getAutocompleteSetters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getAutocompleteSetters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getAutocompleteSetters_ownKeys(Object(source), !0).forEach(function (key) { getAutocompleteSetters_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getAutocompleteSetters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getAutocompleteSetters_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function getAutocompleteSetters(_ref) {
  var store = _ref.store;

  var setActiveItemId = function setActiveItemId(value) {
    store.dispatch('setActiveItemId', value);
  };

  var setQuery = function setQuery(value) {
    store.dispatch('setQuery', value);
  };

  var setCollections = function setCollections(rawValue) {
    var baseItemId = 0;
    var value = rawValue.map(function (collection) {
      return getAutocompleteSetters_objectSpread(getAutocompleteSetters_objectSpread({}, collection), {}, {
        // We flatten the stored items to support calling `getAlgoliaResults`
        // from the source itself.
        items: flatten(collection.items).map(function (item) {
          return getAutocompleteSetters_objectSpread(getAutocompleteSetters_objectSpread({}, item), {}, {
            __autocomplete_id: baseItemId++
          });
        })
      });
    });
    store.dispatch('setCollections', value);
  };

  var setIsOpen = function setIsOpen(value) {
    store.dispatch('setIsOpen', value);
  };

  var setStatus = function setStatus(value) {
    store.dispatch('setStatus', value);
  };

  var setContext = function setContext(value) {
    store.dispatch('setContext', value);
  };

  return {
    setActiveItemId: setActiveItemId,
    setQuery: setQuery,
    setCollections: setCollections,
    setIsOpen: setIsOpen,
    setStatus: setStatus,
    setContext: setContext
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/getItemsCount.js
function getItemsCount(state) {
  if (state.collections.length === 0) {
    return 0;
  }

  return state.collections.reduce(function (sum, collection) {
    return sum + collection.items.length;
  }, 0);
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/generateAutocompleteId.js
var autocompleteId = 0;
function generateAutocompleteId() {
  return "autocomplete-".concat(autocompleteId++);
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/invariant.js
/**
 * Throws an error if the condition is not met in development mode.
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */
function invariant(condition, message) {
  if (true) {
    return;
  }

  if (!condition) {
    throw new Error("[Autocomplete] ".concat(typeof message === 'function' ? message() : message));
  }
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/decycle.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * Decycles objects with circular references.
 * This is used to print cyclic structures in development environment only.
 */
function decycle(obj) {
  var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();

  if (true) {
    return obj;
  }

  if (seen.has(obj)) {
    return '[Circular]';
  }

  var newSeen = seen.add(obj);

  if (Array.isArray(obj)) {
    return obj.map(function (x) {
      return decycle(x, newSeen);
    });
  }

  return Object.fromEntries(Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return [key, decycle(value, newSeen)];
  }));
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/noop.js
var noop = function noop() {};
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/getNormalizedSources.js
function getNormalizedSources_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getNormalizedSources_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getNormalizedSources_ownKeys(Object(source), !0).forEach(function (key) { getNormalizedSources_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getNormalizedSources_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getNormalizedSources_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getNormalizedSources_typeof(obj) { "@babel/helpers - typeof"; return getNormalizedSources_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, getNormalizedSources_typeof(obj); }


function getNormalizedSources(getSources, params) {
  var seenSourceIds = [];
  return Promise.resolve(getSources(params)).then(function (sources) {
    invariant(Array.isArray(sources), function () {
      return "The `getSources` function must return an array of sources but returned type ".concat(JSON.stringify(getNormalizedSources_typeof(sources)), ":\n\n").concat(JSON.stringify(decycle(sources), null, 2));
    });
    return Promise.all(sources // We allow `undefined` and `false` sources to allow users to use
    // `Boolean(query) && source` (=> `false`).
    // We need to remove these values at this point.
    .filter(function (maybeSource) {
      return Boolean(maybeSource);
    }).map(function (source) {
      invariant(typeof source.sourceId === 'string', 'A source must provide a `sourceId` string.');

      if (seenSourceIds.includes(source.sourceId)) {
        throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(source.sourceId), " is not unique."));
      }

      seenSourceIds.push(source.sourceId);
      var defaultSource = {
        getItemInputValue: function getItemInputValue(_ref) {
          var state = _ref.state;
          return state.query;
        },
        getItemUrl: function getItemUrl() {
          return undefined;
        },
        onSelect: function onSelect(_ref2) {
          var setIsOpen = _ref2.setIsOpen;
          setIsOpen(false);
        },
        onActive: noop,
        onResolve: noop
      };
      Object.keys(defaultSource).forEach(function (key) {
        defaultSource[key].__default = true;
      });

      var normalizedSource = getNormalizedSources_objectSpread(getNormalizedSources_objectSpread({}, defaultSource), source);

      return Promise.resolve(normalizedSource);
    }));
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/getDefaultProps.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || getDefaultProps_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getDefaultProps_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getDefaultProps_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getDefaultProps_arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return getDefaultProps_arrayLikeToArray(arr); }

function getDefaultProps_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function getDefaultProps_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getDefaultProps_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getDefaultProps_ownKeys(Object(source), !0).forEach(function (key) { getDefaultProps_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getDefaultProps_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getDefaultProps_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function getDefaultProps(props, pluginSubscribers) {
  var _props$id;

  /* eslint-disable no-restricted-globals */
  var environment = typeof window !== 'undefined' ? window : {};
  /* eslint-enable no-restricted-globals */

  var plugins = props.plugins || [];
  return getDefaultProps_objectSpread(getDefaultProps_objectSpread({
    debug: false,
    openOnFocus: false,
    placeholder: '',
    autoFocus: false,
    defaultActiveItemId: null,
    stallThreshold: 300,
    environment: environment,
    shouldPanelOpen: function shouldPanelOpen(_ref) {
      var state = _ref.state;
      return getItemsCount(state) > 0;
    },
    reshape: function reshape(_ref2) {
      var sources = _ref2.sources;
      return sources;
    }
  }, props), {}, {
    // Since `generateAutocompleteId` triggers a side effect (it increments
    // an internal counter), we don't want to execute it if unnecessary.
    id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : generateAutocompleteId(),
    plugins: plugins,
    // The following props need to be deeply defaulted.
    initialState: getDefaultProps_objectSpread({
      activeItemId: null,
      query: '',
      completion: null,
      collections: [],
      isOpen: false,
      status: 'idle',
      context: {}
    }, props.initialState),
    onStateChange: function onStateChange(params) {
      var _props$onStateChange;

      (_props$onStateChange = props.onStateChange) === null || _props$onStateChange === void 0 ? void 0 : _props$onStateChange.call(props, params);
      plugins.forEach(function (x) {
        var _x$onStateChange;

        return (_x$onStateChange = x.onStateChange) === null || _x$onStateChange === void 0 ? void 0 : _x$onStateChange.call(x, params);
      });
    },
    onSubmit: function onSubmit(params) {
      var _props$onSubmit;

      (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 ? void 0 : _props$onSubmit.call(props, params);
      plugins.forEach(function (x) {
        var _x$onSubmit;

        return (_x$onSubmit = x.onSubmit) === null || _x$onSubmit === void 0 ? void 0 : _x$onSubmit.call(x, params);
      });
    },
    onReset: function onReset(params) {
      var _props$onReset;

      (_props$onReset = props.onReset) === null || _props$onReset === void 0 ? void 0 : _props$onReset.call(props, params);
      plugins.forEach(function (x) {
        var _x$onReset;

        return (_x$onReset = x.onReset) === null || _x$onReset === void 0 ? void 0 : _x$onReset.call(x, params);
      });
    },
    getSources: function getSources(params) {
      return Promise.all([].concat(_toConsumableArray(plugins.map(function (plugin) {
        return plugin.getSources;
      })), [props.getSources]).filter(Boolean).map(function (getSources) {
        return getNormalizedSources(getSources, params);
      })).then(function (nested) {
        return flatten(nested);
      }).then(function (sources) {
        return sources.map(function (source) {
          return getDefaultProps_objectSpread(getDefaultProps_objectSpread({}, source), {}, {
            onSelect: function onSelect(params) {
              source.onSelect(params);
              pluginSubscribers.forEach(function (x) {
                var _x$onSelect;

                return (_x$onSelect = x.onSelect) === null || _x$onSelect === void 0 ? void 0 : _x$onSelect.call(x, params);
              });
            },
            onActive: function onActive(params) {
              source.onActive(params);
              pluginSubscribers.forEach(function (x) {
                var _x$onActive;

                return (_x$onActive = x.onActive) === null || _x$onActive === void 0 ? void 0 : _x$onActive.call(x, params);
              });
            },
            onResolve: function onResolve(params) {
              source.onResolve(params);
              pluginSubscribers.forEach(function (x) {
                var _x$onResolve;

                return (_x$onResolve = x.onResolve) === null || _x$onResolve === void 0 ? void 0 : _x$onResolve.call(x, params);
              });
            }
          });
        });
      });
    },
    navigator: getDefaultProps_objectSpread({
      navigate: function navigate(_ref3) {
        var itemUrl = _ref3.itemUrl;
        environment.location.assign(itemUrl);
      },
      navigateNewTab: function navigateNewTab(_ref4) {
        var itemUrl = _ref4.itemUrl;
        var windowReference = environment.open(itemUrl, '_blank', 'noopener');
        windowReference === null || windowReference === void 0 ? void 0 : windowReference.focus();
      },
      navigateNewWindow: function navigateNewWindow(_ref5) {
        var itemUrl = _ref5.itemUrl;
        environment.open(itemUrl, '_blank', 'noopener');
      }
    }, props.navigator)
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/reshape.js
function reshape_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function reshape_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? reshape_ownKeys(Object(source), !0).forEach(function (key) { reshape_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : reshape_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function reshape_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function reshape(_ref) {
  var collections = _ref.collections,
      props = _ref.props,
      state = _ref.state;
  // Sources are grouped by `sourceId` to conveniently pick them via destructuring.
  // Example: `const { recentSearchesPlugin } = sourcesBySourceId`
  var originalSourcesBySourceId = collections.reduce(function (acc, collection) {
    return reshape_objectSpread(reshape_objectSpread({}, acc), {}, reshape_defineProperty({}, collection.source.sourceId, reshape_objectSpread(reshape_objectSpread({}, collection.source), {}, {
      getItems: function getItems() {
        // We provide the resolved items from the collection to the `reshape` prop.
        return flatten(collection.items);
      }
    })));
  }, {});

  var _props$plugins$reduce = props.plugins.reduce(function (acc, plugin) {
    if (plugin.reshape) {
      return plugin.reshape(acc);
    }

    return acc;
  }, {
    sourcesBySourceId: originalSourcesBySourceId,
    state: state
  }),
      sourcesBySourceId = _props$plugins$reduce.sourcesBySourceId;

  var reshapeSources = props.reshape({
    sourcesBySourceId: sourcesBySourceId,
    sources: Object.values(sourcesBySourceId),
    state: state
  }); // We reconstruct the collections with the items modified by the `reshape` prop.

  return flatten(reshapeSources).filter(Boolean).map(function (source) {
    return {
      source: source,
      items: source.getItems()
    };
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/mapToAlgoliaResponse.js
function mapToAlgoliaResponse_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function mapToAlgoliaResponse_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? mapToAlgoliaResponse_ownKeys(Object(source), !0).forEach(function (key) { mapToAlgoliaResponse_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mapToAlgoliaResponse_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function mapToAlgoliaResponse_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function mapToAlgoliaResponse(rawResults) {
  var results = rawResults.map(function (result) {
    var _hits;

    return mapToAlgoliaResponse_objectSpread(mapToAlgoliaResponse_objectSpread({}, result), {}, {
      hits: (_hits = result.hits) === null || _hits === void 0 ? void 0 : _hits.map(function (hit) {
        // Bring support for the Insights plugin.
        return mapToAlgoliaResponse_objectSpread(mapToAlgoliaResponse_objectSpread({}, hit), {}, {
          __autocomplete_indexName: result.index,
          __autocomplete_queryID: result.queryID
        });
      })
    });
  });
  return {
    results: results,
    hits: results.map(function (result) {
      return result.hits;
    }).filter(Boolean),
    facetHits: results.map(function (result) {
      var _facetHits;

      return (_facetHits = result.facetHits) === null || _facetHits === void 0 ? void 0 : _facetHits.map(function (facetHit) {
        // Bring support for the highlighting components.
        return {
          label: facetHit.value,
          count: facetHit.count,
          _highlightResult: {
            label: {
              value: facetHit.highlighted
            }
          }
        };
      });
    }).filter(Boolean)
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/resolve.js
function resolve_typeof(obj) { "@babel/helpers - typeof"; return resolve_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, resolve_typeof(obj); }

function resolve_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function resolve_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? resolve_ownKeys(Object(source), !0).forEach(function (key) { resolve_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : resolve_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function resolve_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function resolve_toConsumableArray(arr) { return resolve_arrayWithoutHoles(arr) || resolve_iterableToArray(arr) || resolve_unsupportedIterableToArray(arr) || resolve_nonIterableSpread(); }

function resolve_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function resolve_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return resolve_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return resolve_arrayLikeToArray(o, minLen); }

function resolve_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function resolve_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return resolve_arrayLikeToArray(arr); }

function resolve_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




function isDescription(item) {
  return Boolean(item.execute);
}

function isRequesterDescription(description) {
  return Boolean(description === null || description === void 0 ? void 0 : description.execute);
}

function preResolve(itemsOrDescription, sourceId, state) {
  if (isRequesterDescription(itemsOrDescription)) {
    var contextParameters = itemsOrDescription.requesterId === 'algolia' ? Object.assign.apply(Object, [{}].concat(resolve_toConsumableArray(Object.keys(state.context).map(function (key) {
      var _state$context$key;

      return (_state$context$key = state.context[key]) === null || _state$context$key === void 0 ? void 0 : _state$context$key.__algoliaSearchParameters;
    })))) : {};
    return resolve_objectSpread(resolve_objectSpread({}, itemsOrDescription), {}, {
      requests: itemsOrDescription.queries.map(function (query) {
        return {
          query: itemsOrDescription.requesterId === 'algolia' ? resolve_objectSpread(resolve_objectSpread({}, query), {}, {
            params: resolve_objectSpread(resolve_objectSpread({}, contextParameters), query.params)
          }) : query,
          sourceId: sourceId,
          transformResponse: itemsOrDescription.transformResponse
        };
      })
    });
  }

  return {
    items: itemsOrDescription,
    sourceId: sourceId
  };
}
function resolve(items) {
  var packed = items.reduce(function (acc, current) {
    if (!isDescription(current)) {
      acc.push(current);
      return acc;
    }

    var searchClient = current.searchClient,
        execute = current.execute,
        requesterId = current.requesterId,
        requests = current.requests;
    var container = acc.find(function (item) {
      return isDescription(current) && isDescription(item) && item.searchClient === searchClient && Boolean(requesterId) && item.requesterId === requesterId;
    });

    if (container) {
      var _container$items;

      (_container$items = container.items).push.apply(_container$items, resolve_toConsumableArray(requests));
    } else {
      var request = {
        execute: execute,
        requesterId: requesterId,
        items: requests,
        searchClient: searchClient
      };
      acc.push(request);
    }

    return acc;
  }, []);
  var values = packed.map(function (maybeDescription) {
    if (!isDescription(maybeDescription)) {
      return Promise.resolve(maybeDescription);
    }

    var _ref = maybeDescription,
        execute = _ref.execute,
        items = _ref.items,
        searchClient = _ref.searchClient;
    return execute({
      searchClient: searchClient,
      requests: items
    });
  });
  return Promise.all(values).then(function (responses) {
    return flatten(responses);
  });
}
function postResolve(responses, sources, store) {
  return sources.map(function (source) {
    var matches = responses.filter(function (response) {
      return response.sourceId === source.sourceId;
    });
    var results = matches.map(function (_ref2) {
      var items = _ref2.items;
      return items;
    });
    var transform = matches[0].transformResponse;
    var items = transform ? transform(mapToAlgoliaResponse(results)) : results;
    source.onResolve({
      source: source,
      results: results,
      items: items,
      state: store.getState()
    });
    invariant(Array.isArray(items), function () {
      return "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned type ").concat(JSON.stringify(resolve_typeof(items)), ":\n\n").concat(JSON.stringify(decycle(items), null, 2), ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems");
    });
    invariant(items.every(Boolean), "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned ").concat(JSON.stringify(undefined), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"));
    return {
      source: source,
      items: items
    };
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/createConcurrentSafePromise.js
/**
 * Creates a runner that executes promises in a concurrent-safe way.
 *
 * This is useful to prevent older promises to resolve after a newer promise,
 * otherwise resulting in stale resolved values.
 */
function createConcurrentSafePromise() {
  var basePromiseId = -1;
  var latestResolvedId = -1;
  var latestResolvedValue = undefined;
  return function runConcurrentSafePromise(promise) {
    basePromiseId++;
    var currentPromiseId = basePromiseId;
    return Promise.resolve(promise).then(function (x) {
      // The promise might take too long to resolve and get outdated. This would
      // result in resolving stale values.
      // When this happens, we ignore the promise value and return the one
      // coming from the latest resolved value.
      //
      // +----------------------------------+
      // |        100ms                     |
      // | run(1) +--->  R1                 |
      // |        300ms                     |
      // | run(2) +-------------> R2 (SKIP) |
      // |        200ms                     |
      // | run(3) +--------> R3             |
      // +----------------------------------+
      if (latestResolvedValue && currentPromiseId < latestResolvedId) {
        return latestResolvedValue;
      }

      latestResolvedId = currentPromiseId;
      latestResolvedValue = x;
      return x;
    });
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/createCancelablePromise.js
function createInternalCancelablePromise(promise, initialState) {
  var state = initialState;
  return {
    then: function then(onfulfilled, onrejected) {
      return createInternalCancelablePromise(promise.then(createCallback(onfulfilled, state, promise), createCallback(onrejected, state, promise)), state);
    },
    catch: function _catch(onrejected) {
      return createInternalCancelablePromise(promise.catch(createCallback(onrejected, state, promise)), state);
    },
    finally: function _finally(onfinally) {
      if (onfinally) {
        state.onCancelList.push(onfinally);
      }

      return createInternalCancelablePromise(promise.finally(createCallback(onfinally && function () {
        state.onCancelList = [];
        return onfinally();
      }, state, promise)), state);
    },
    cancel: function cancel() {
      state.isCanceled = true;
      var callbacks = state.onCancelList;
      state.onCancelList = [];
      callbacks.forEach(function (callback) {
        callback();
      });
    },
    isCanceled: function isCanceled() {
      return state.isCanceled === true;
    }
  };
}

function createCancelablePromise(executor) {
  return createInternalCancelablePromise(new Promise(function (resolve, reject) {
    return executor(resolve, reject);
  }), {
    isCanceled: false,
    onCancelList: []
  });
}

createCancelablePromise.resolve = function (value) {
  return cancelable(Promise.resolve(value));
};

createCancelablePromise.reject = function (reason) {
  return cancelable(Promise.reject(reason));
};

function cancelable(promise) {
  return createInternalCancelablePromise(promise, {
    isCanceled: false,
    onCancelList: []
  });
}

function createCallback(onResult, state, fallback) {
  if (!onResult) {
    return fallback;
  }

  return function callback(arg) {
    if (state.isCanceled) {
      return arg;
    }

    return onResult(arg);
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/getActiveItem.js
// We don't have access to the autocomplete source when we call `onKeyDown`
// or `onClick` because those are native browser events.
// However, we can get the source from the suggestion index.
function getCollectionFromActiveItemId(state) {
  // Given 3 sources with respectively 1, 2 and 3 suggestions: [1, 2, 3]
  // We want to get the accumulated counts:
  // [1, 1 + 2, 1 + 2 + 3] = [1, 3, 3 + 3] = [1, 3, 6]
  var accumulatedCollectionsCount = state.collections.map(function (collections) {
    return collections.items.length;
  }).reduce(function (acc, collectionsCount, index) {
    var previousValue = acc[index - 1] || 0;
    var nextValue = previousValue + collectionsCount;
    acc.push(nextValue);
    return acc;
  }, []); // Based on the accumulated counts, we can infer the index of the suggestion.

  var collectionIndex = accumulatedCollectionsCount.reduce(function (acc, current) {
    if (current <= state.activeItemId) {
      return acc + 1;
    }

    return acc;
  }, 0);
  return state.collections[collectionIndex];
}
/**
 * Gets the highlighted index relative to a suggestion object (not the absolute
 * highlighted index).
 *
 * Example:
 *  [['a', 'b'], ['c', 'd', 'e'], ['f']]
 *                      ↑
 *         (absolute: 3, relative: 1)
 */


function getRelativeActiveItemId(_ref) {
  var state = _ref.state,
      collection = _ref.collection;
  var isOffsetFound = false;
  var counter = 0;
  var previousItemsOffset = 0;

  while (isOffsetFound === false) {
    var currentCollection = state.collections[counter];

    if (currentCollection === collection) {
      isOffsetFound = true;
      break;
    }

    previousItemsOffset += currentCollection.items.length;
    counter++;
  }

  return state.activeItemId - previousItemsOffset;
}

function getActiveItem(state) {
  var collection = getCollectionFromActiveItemId(state);

  if (!collection) {
    return null;
  }

  var item = collection.items[getRelativeActiveItemId({
    state: state,
    collection: collection
  })];
  var source = collection.source;
  var itemInputValue = source.getItemInputValue({
    item: item,
    state: state
  });
  var itemUrl = source.getItemUrl({
    item: item,
    state: state
  });
  return {
    item: item,
    itemInputValue: itemInputValue,
    itemUrl: itemUrl,
    source: source
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/onInput.js
var _excluded = ["event", "nextState", "props", "query", "refresh", "store"];

function onInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function onInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? onInput_ownKeys(Object(source), !0).forEach(function (key) { onInput_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : onInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function onInput_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var lastStalledId = null;
var runConcurrentSafePromise = createConcurrentSafePromise();
function onInput(_ref) {
  var event = _ref.event,
      _ref$nextState = _ref.nextState,
      nextState = _ref$nextState === void 0 ? {} : _ref$nextState,
      props = _ref.props,
      query = _ref.query,
      refresh = _ref.refresh,
      store = _ref.store,
      setters = _objectWithoutProperties(_ref, _excluded);

  if (lastStalledId) {
    props.environment.clearTimeout(lastStalledId);
  }

  var setCollections = setters.setCollections,
      setIsOpen = setters.setIsOpen,
      setQuery = setters.setQuery,
      setActiveItemId = setters.setActiveItemId,
      setStatus = setters.setStatus;
  setQuery(query);
  setActiveItemId(props.defaultActiveItemId);

  if (!query && props.openOnFocus === false) {
    var _nextState$isOpen;

    var collections = store.getState().collections.map(function (collection) {
      return onInput_objectSpread(onInput_objectSpread({}, collection), {}, {
        items: []
      });
    });
    setStatus('idle');
    setCollections(collections);
    setIsOpen((_nextState$isOpen = nextState.isOpen) !== null && _nextState$isOpen !== void 0 ? _nextState$isOpen : props.shouldPanelOpen({
      state: store.getState()
    })); // We make sure to update the latest resolved value of the tracked
    // promises to keep late resolving promises from "cancelling" the state
    // updates performed in this code path.
    // We chain with a void promise to respect `onInput`'s expected return type.

    var _request = cancelable(runConcurrentSafePromise(collections).then(function () {
      return Promise.resolve();
    }));

    return store.pendingRequests.add(_request);
  }

  setStatus('loading');
  lastStalledId = props.environment.setTimeout(function () {
    setStatus('stalled');
  }, props.stallThreshold); // We track the entire promise chain triggered by `onInput` before mutating
  // the Autocomplete state to make sure that any state manipulation is based on
  // fresh data regardless of when promises individually resolve.
  // We don't track nested promises and only rely on the full chain resolution,
  // meaning we should only ever manipulate the state once this concurrent-safe
  // promise is resolved.

  var request = cancelable(runConcurrentSafePromise(props.getSources(onInput_objectSpread({
    query: query,
    refresh: refresh,
    state: store.getState()
  }, setters)).then(function (sources) {
    return Promise.all(sources.map(function (source) {
      return Promise.resolve(source.getItems(onInput_objectSpread({
        query: query,
        refresh: refresh,
        state: store.getState()
      }, setters))).then(function (itemsOrDescription) {
        return preResolve(itemsOrDescription, source.sourceId, store.getState());
      });
    })).then(resolve).then(function (responses) {
      return postResolve(responses, sources, store);
    }).then(function (collections) {
      return reshape({
        collections: collections,
        props: props,
        state: store.getState()
      });
    });
  }))).then(function (collections) {
    var _nextState$isOpen2;

    // Parameters passed to `onInput` could be stale when the following code
    // executes, because `onInput` calls may not resolve in order.
    // If it becomes a problem we'll need to save the last passed parameters.
    // See: https://codesandbox.io/s/agitated-cookies-y290z
    setStatus('idle');
    setCollections(collections);
    var isPanelOpen = props.shouldPanelOpen({
      state: store.getState()
    });
    setIsOpen((_nextState$isOpen2 = nextState.isOpen) !== null && _nextState$isOpen2 !== void 0 ? _nextState$isOpen2 : props.openOnFocus && !query && isPanelOpen || isPanelOpen);
    var highlightedItem = getActiveItem(store.getState());

    if (store.getState().activeItemId !== null && highlightedItem) {
      var item = highlightedItem.item,
          itemInputValue = highlightedItem.itemInputValue,
          itemUrl = highlightedItem.itemUrl,
          source = highlightedItem.source;
      source.onActive(onInput_objectSpread({
        event: event,
        item: item,
        itemInputValue: itemInputValue,
        itemUrl: itemUrl,
        refresh: refresh,
        source: source,
        state: store.getState()
      }, setters));
    }
  }).finally(function () {
    setStatus('idle');

    if (lastStalledId) {
      props.environment.clearTimeout(lastStalledId);
    }
  });
  return store.pendingRequests.add(request);
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/onKeyDown.js
var onKeyDown_excluded = ["event", "props", "refresh", "store"];

function onKeyDown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function onKeyDown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? onKeyDown_ownKeys(Object(source), !0).forEach(function (key) { onKeyDown_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : onKeyDown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function onKeyDown_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function onKeyDown_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = onKeyDown_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function onKeyDown_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function onKeyDown_onKeyDown(_ref) {
  var event = _ref.event,
      props = _ref.props,
      refresh = _ref.refresh,
      store = _ref.store,
      setters = onKeyDown_objectWithoutProperties(_ref, onKeyDown_excluded);

  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
    // eslint-disable-next-line no-inner-declarations
    var triggerScrollIntoView = function triggerScrollIntoView() {
      var nodeItem = props.environment.document.getElementById("".concat(props.id, "-item-").concat(store.getState().activeItemId));

      if (nodeItem) {
        if (nodeItem.scrollIntoViewIfNeeded) {
          nodeItem.scrollIntoViewIfNeeded(false);
        } else {
          nodeItem.scrollIntoView(false);
        }
      }
    }; // eslint-disable-next-line no-inner-declarations


    var triggerOnActive = function triggerOnActive() {
      var highlightedItem = getActiveItem(store.getState());

      if (store.getState().activeItemId !== null && highlightedItem) {
        var item = highlightedItem.item,
            itemInputValue = highlightedItem.itemInputValue,
            itemUrl = highlightedItem.itemUrl,
            source = highlightedItem.source;
        source.onActive(onKeyDown_objectSpread({
          event: event,
          item: item,
          itemInputValue: itemInputValue,
          itemUrl: itemUrl,
          refresh: refresh,
          source: source,
          state: store.getState()
        }, setters));
      }
    }; // Default browser behavior changes the caret placement on ArrowUp and
    // ArrowDown.


    event.preventDefault(); // When re-opening the panel, we need to split the logic to keep the actions
    // synchronized as `onInput` returns a promise.

    if (store.getState().isOpen === false && (props.openOnFocus || Boolean(store.getState().query))) {
      onInput(onKeyDown_objectSpread({
        event: event,
        props: props,
        query: store.getState().query,
        refresh: refresh,
        store: store
      }, setters)).then(function () {
        store.dispatch(event.key, {
          nextActiveItemId: props.defaultActiveItemId
        });
        triggerOnActive(); // Since we rely on the DOM, we need to wait for all the micro tasks to
        // finish (which include re-opening the panel) to make sure all the
        // elements are available.

        setTimeout(triggerScrollIntoView, 0);
      });
    } else {
      store.dispatch(event.key, {});
      triggerOnActive();
      triggerScrollIntoView();
    }
  } else if (event.key === 'Escape') {
    // This prevents the default browser behavior on `input[type="search"]`
    // from removing the query right away because we first want to close the
    // panel.
    event.preventDefault();
    store.dispatch(event.key, null); // Hitting the `Escape` key signals the end of a user interaction with the
    // autocomplete. At this point, we should ignore any requests that are still
    // pending and could reopen the panel once they resolve, because that would
    // result in an unsolicited UI behavior.

    store.pendingRequests.cancelAll();
  } else if (event.key === 'Tab') {
    store.dispatch('blur', null); // Hitting the `Escape` key signals the end of a user interaction with the
    // autocomplete. At this point, we should ignore any requests that are still
    // pending and could reopen the panel once they resolve, because that would
    // result in an unsolicited UI behavior.

    store.pendingRequests.cancelAll();
  } else if (event.key === 'Enter') {
    // No active item, so we let the browser handle the native `onSubmit` form
    // event.
    if (store.getState().activeItemId === null || store.getState().collections.every(function (collection) {
      return collection.items.length === 0;
    })) {
      // If requests are still pending when the panel closes, they could reopen
      // the panel once they resolve.
      // We want to prevent any subsequent query from reopening the panel
      // because it would result in an unsolicited UI behavior.
      if (!props.debug) {
        store.pendingRequests.cancelAll();
      }

      return;
    } // This prevents the `onSubmit` event to be sent because an item is
    // highlighted.


    event.preventDefault();

    var _ref2 = getActiveItem(store.getState()),
        item = _ref2.item,
        itemInputValue = _ref2.itemInputValue,
        itemUrl = _ref2.itemUrl,
        source = _ref2.source;

    if (event.metaKey || event.ctrlKey) {
      if (itemUrl !== undefined) {
        source.onSelect(onKeyDown_objectSpread({
          event: event,
          item: item,
          itemInputValue: itemInputValue,
          itemUrl: itemUrl,
          refresh: refresh,
          source: source,
          state: store.getState()
        }, setters));
        props.navigator.navigateNewTab({
          itemUrl: itemUrl,
          item: item,
          state: store.getState()
        });
      }
    } else if (event.shiftKey) {
      if (itemUrl !== undefined) {
        source.onSelect(onKeyDown_objectSpread({
          event: event,
          item: item,
          itemInputValue: itemInputValue,
          itemUrl: itemUrl,
          refresh: refresh,
          source: source,
          state: store.getState()
        }, setters));
        props.navigator.navigateNewWindow({
          itemUrl: itemUrl,
          item: item,
          state: store.getState()
        });
      }
    } else if (event.altKey) {// Keep native browser behavior
    } else {
      if (itemUrl !== undefined) {
        source.onSelect(onKeyDown_objectSpread({
          event: event,
          item: item,
          itemInputValue: itemInputValue,
          itemUrl: itemUrl,
          refresh: refresh,
          source: source,
          state: store.getState()
        }, setters));
        props.navigator.navigate({
          itemUrl: itemUrl,
          item: item,
          state: store.getState()
        });
        return;
      }

      onInput(onKeyDown_objectSpread({
        event: event,
        nextState: {
          isOpen: false
        },
        props: props,
        query: itemInputValue,
        refresh: refresh,
        store: store
      }, setters)).then(function () {
        source.onSelect(onKeyDown_objectSpread({
          event: event,
          item: item,
          itemInputValue: itemInputValue,
          itemUrl: itemUrl,
          refresh: refresh,
          source: source,
          state: store.getState()
        }, setters));
      });
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/isOrContainsNode.js
function isOrContainsNode(parent, child) {
  return parent === child || parent.contains(child);
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/isSamsung.js
var regex = /((gt|sm)-|galaxy nexus)|samsung[- ]/i;
function isSamsung(userAgent) {
  return Boolean(userAgent && userAgent.match(regex));
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/getPropGetters.js
var getPropGetters_excluded = ["props", "refresh", "store"],
    _excluded2 = ["inputElement", "formElement", "panelElement"],
    _excluded3 = ["inputElement"],
    _excluded4 = ["inputElement", "maxLength"],
    _excluded5 = ["sourceIndex"],
    _excluded6 = ["sourceIndex"],
    _excluded7 = ["item", "source", "sourceIndex"];

function getPropGetters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getPropGetters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getPropGetters_ownKeys(Object(source), !0).forEach(function (key) { getPropGetters_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getPropGetters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getPropGetters_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getPropGetters_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = getPropGetters_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function getPropGetters_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function getPropGetters(_ref) {
  var props = _ref.props,
      refresh = _ref.refresh,
      store = _ref.store,
      setters = getPropGetters_objectWithoutProperties(_ref, getPropGetters_excluded);

  var getEnvironmentProps = function getEnvironmentProps(providedProps) {
    var inputElement = providedProps.inputElement,
        formElement = providedProps.formElement,
        panelElement = providedProps.panelElement,
        rest = getPropGetters_objectWithoutProperties(providedProps, _excluded2);

    function onMouseDownOrTouchStart(event) {
      // The `onTouchStart`/`onMouseDown` events shouldn't trigger the `blur`
      // handler when it's not an interaction with Autocomplete.
      // We detect it with the following heuristics:
      // - the panel is closed AND there are no pending requests
      //   (no interaction with the autocomplete, no future state updates)
      // - OR the touched target is the input element (should open the panel)
      var isAutocompleteInteraction = store.getState().isOpen || !store.pendingRequests.isEmpty();

      if (!isAutocompleteInteraction || event.target === inputElement) {
        return;
      } // @TODO: support cases where there are multiple Autocomplete instances.
      // Right now, a second instance makes this computation return false.


      var isTargetWithinAutocomplete = [formElement, panelElement].some(function (contextNode) {
        return isOrContainsNode(contextNode, event.target);
      });

      if (isTargetWithinAutocomplete === false) {
        store.dispatch('blur', null); // If requests are still pending when the user closes the panel, they
        // could reopen the panel once they resolve.
        // We want to prevent any subsequent query from reopening the panel
        // because it would result in an unsolicited UI behavior.

        if (!props.debug) {
          store.pendingRequests.cancelAll();
        }
      }
    }

    return getPropGetters_objectSpread({
      // We do not rely on the native `blur` event of the input to close the
      // panel, but rather on a custom `touchstart`/`mousedown` event outside
      // of the autocomplete elements.
      // This ensures we don't mistakenly interpret interactions within the
      // autocomplete (but outside of the input) as a signal to close the panel.
      // For example, clicking reset button causes an input blur, but if
      // `openOnFocus=true`, it shouldn't close the panel.
      // On touch devices, scrolling results (`touchmove`) causes an input blur
      // but shouldn't close the panel.
      onTouchStart: onMouseDownOrTouchStart,
      onMouseDown: onMouseDownOrTouchStart,
      // When scrolling on touch devices (mobiles, tablets, etc.), we want to
      // mimic the native platform behavior where the input is blurred to
      // hide the virtual keyboard. This gives more vertical space to
      // discover all the suggestions showing up in the panel.
      onTouchMove: function onTouchMove(event) {
        if (store.getState().isOpen === false || inputElement !== props.environment.document.activeElement || event.target === inputElement) {
          return;
        }

        inputElement.blur();
      }
    }, rest);
  };

  var getRootProps = function getRootProps(rest) {
    return getPropGetters_objectSpread({
      role: 'combobox',
      'aria-expanded': store.getState().isOpen,
      'aria-haspopup': 'listbox',
      'aria-owns': store.getState().isOpen ? "".concat(props.id, "-list") : undefined,
      'aria-labelledby': "".concat(props.id, "-label")
    }, rest);
  };

  var getFormProps = function getFormProps(providedProps) {
    var inputElement = providedProps.inputElement,
        rest = getPropGetters_objectWithoutProperties(providedProps, _excluded3);

    return getPropGetters_objectSpread({
      action: '',
      noValidate: true,
      role: 'search',
      onSubmit: function onSubmit(event) {
        var _providedProps$inputE;

        event.preventDefault();
        props.onSubmit(getPropGetters_objectSpread({
          event: event,
          refresh: refresh,
          state: store.getState()
        }, setters));
        store.dispatch('submit', null);
        (_providedProps$inputE = providedProps.inputElement) === null || _providedProps$inputE === void 0 ? void 0 : _providedProps$inputE.blur();
      },
      onReset: function onReset(event) {
        var _providedProps$inputE2;

        event.preventDefault();
        props.onReset(getPropGetters_objectSpread({
          event: event,
          refresh: refresh,
          state: store.getState()
        }, setters));
        store.dispatch('reset', null);
        (_providedProps$inputE2 = providedProps.inputElement) === null || _providedProps$inputE2 === void 0 ? void 0 : _providedProps$inputE2.focus();
      }
    }, rest);
  };

  var getInputProps = function getInputProps(providedProps) {
    var _props$environment$na;

    function onFocus(event) {
      // We want to trigger a query when `openOnFocus` is true
      // because the panel should open with the current query.
      if (props.openOnFocus || Boolean(store.getState().query)) {
        onInput(getPropGetters_objectSpread({
          event: event,
          props: props,
          query: store.getState().completion || store.getState().query,
          refresh: refresh,
          store: store
        }, setters));
      }

      store.dispatch('focus', null);
    }

    var _ref2 = providedProps || {},
        inputElement = _ref2.inputElement,
        _ref2$maxLength = _ref2.maxLength,
        maxLength = _ref2$maxLength === void 0 ? 512 : _ref2$maxLength,
        rest = getPropGetters_objectWithoutProperties(_ref2, _excluded4);

    var activeItem = getActiveItem(store.getState());
    var userAgent = ((_props$environment$na = props.environment.navigator) === null || _props$environment$na === void 0 ? void 0 : _props$environment$na.userAgent) || '';
    var shouldFallbackKeyHint = isSamsung(userAgent);
    var enterKeyHint = activeItem !== null && activeItem !== void 0 && activeItem.itemUrl && !shouldFallbackKeyHint ? 'go' : 'search';
    return getPropGetters_objectSpread({
      'aria-autocomplete': 'both',
      'aria-activedescendant': store.getState().isOpen && store.getState().activeItemId !== null ? "".concat(props.id, "-item-").concat(store.getState().activeItemId) : undefined,
      'aria-controls': store.getState().isOpen ? "".concat(props.id, "-list") : undefined,
      'aria-labelledby': "".concat(props.id, "-label"),
      value: store.getState().completion || store.getState().query,
      id: "".concat(props.id, "-input"),
      autoComplete: 'off',
      autoCorrect: 'off',
      autoCapitalize: 'off',
      enterKeyHint: enterKeyHint,
      spellCheck: 'false',
      autoFocus: props.autoFocus,
      placeholder: props.placeholder,
      maxLength: maxLength,
      type: 'search',
      onChange: function onChange(event) {
        onInput(getPropGetters_objectSpread({
          event: event,
          props: props,
          query: event.currentTarget.value.slice(0, maxLength),
          refresh: refresh,
          store: store
        }, setters));
      },
      onKeyDown: function onKeyDown(event) {
        onKeyDown_onKeyDown(getPropGetters_objectSpread({
          event: event,
          props: props,
          refresh: refresh,
          store: store
        }, setters));
      },
      onFocus: onFocus,
      // We don't rely on the `blur` event.
      // See explanation in `onTouchStart`/`onMouseDown`.
      // @MAJOR See if we need to keep this handler.
      onBlur: noop,
      onClick: function onClick(event) {
        // When the panel is closed and you click on the input while
        // the input is focused, the `onFocus` event is not triggered
        // (default browser behavior).
        // In an autocomplete context, it makes sense to open the panel in this
        // case.
        // We mimic this event by catching the `onClick` event which
        // triggers the `onFocus` for the panel to open.
        if (providedProps.inputElement === props.environment.document.activeElement && !store.getState().isOpen) {
          onFocus(event);
        }
      }
    }, rest);
  };

  var getAutocompleteId = function getAutocompleteId(instanceId, sourceId) {
    return typeof sourceId !== 'undefined' ? "".concat(instanceId, "-").concat(sourceId) : instanceId;
  };

  var getLabelProps = function getLabelProps(providedProps) {
    var _ref3 = providedProps || {},
        sourceIndex = _ref3.sourceIndex,
        rest = getPropGetters_objectWithoutProperties(_ref3, _excluded5);

    return getPropGetters_objectSpread({
      htmlFor: "".concat(getAutocompleteId(props.id, sourceIndex), "-input"),
      id: "".concat(getAutocompleteId(props.id, sourceIndex), "-label")
    }, rest);
  };

  var getListProps = function getListProps(providedProps) {
    var _ref4 = providedProps || {},
        sourceIndex = _ref4.sourceIndex,
        rest = getPropGetters_objectWithoutProperties(_ref4, _excluded6);

    return getPropGetters_objectSpread({
      role: 'listbox',
      'aria-labelledby': "".concat(getAutocompleteId(props.id, sourceIndex), "-label"),
      id: "".concat(getAutocompleteId(props.id, sourceIndex), "-list")
    }, rest);
  };

  var getPanelProps = function getPanelProps(rest) {
    return getPropGetters_objectSpread({
      onMouseDown: function onMouseDown(event) {
        // Prevents the `activeElement` from being changed to the panel so
        // that the blur event is not triggered, otherwise it closes the
        // panel.
        event.preventDefault();
      },
      onMouseLeave: function onMouseLeave() {
        store.dispatch('mouseleave', null);
      }
    }, rest);
  };

  var getItemProps = function getItemProps(providedProps) {
    var item = providedProps.item,
        source = providedProps.source,
        sourceIndex = providedProps.sourceIndex,
        rest = getPropGetters_objectWithoutProperties(providedProps, _excluded7);

    return getPropGetters_objectSpread({
      id: "".concat(getAutocompleteId(props.id, sourceIndex), "-item-").concat(item.__autocomplete_id),
      role: 'option',
      'aria-selected': store.getState().activeItemId === item.__autocomplete_id,
      onMouseMove: function onMouseMove(event) {
        if (item.__autocomplete_id === store.getState().activeItemId) {
          return;
        }

        store.dispatch('mousemove', item.__autocomplete_id);
        var activeItem = getActiveItem(store.getState());

        if (store.getState().activeItemId !== null && activeItem) {
          var _item = activeItem.item,
              itemInputValue = activeItem.itemInputValue,
              itemUrl = activeItem.itemUrl,
              _source = activeItem.source;

          _source.onActive(getPropGetters_objectSpread({
            event: event,
            item: _item,
            itemInputValue: itemInputValue,
            itemUrl: itemUrl,
            refresh: refresh,
            source: _source,
            state: store.getState()
          }, setters));
        }
      },
      onMouseDown: function onMouseDown(event) {
        // Prevents the `activeElement` from being changed to the item so it
        // can remain with the current `activeElement`.
        event.preventDefault();
      },
      onClick: function onClick(event) {
        var itemInputValue = source.getItemInputValue({
          item: item,
          state: store.getState()
        });
        var itemUrl = source.getItemUrl({
          item: item,
          state: store.getState()
        }); // If `getItemUrl` is provided, it means that the suggestion
        // is a link, not plain text that aims at updating the query.
        // We can therefore skip the state change because it will update
        // the `activeItemId`, resulting in a UI flash, especially
        // noticeable on mobile.

        var runPreCommand = itemUrl ? Promise.resolve() : onInput(getPropGetters_objectSpread({
          event: event,
          nextState: {
            isOpen: false
          },
          props: props,
          query: itemInputValue,
          refresh: refresh,
          store: store
        }, setters));
        runPreCommand.then(function () {
          source.onSelect(getPropGetters_objectSpread({
            event: event,
            item: item,
            itemInputValue: itemInputValue,
            itemUrl: itemUrl,
            refresh: refresh,
            source: source,
            state: store.getState()
          }, setters));
        });
      }
    }, rest);
  };

  return {
    getEnvironmentProps: getEnvironmentProps,
    getRootProps: getRootProps,
    getFormProps: getFormProps,
    getLabelProps: getLabelProps,
    getInputProps: getInputProps,
    getPanelProps: getPanelProps,
    getListProps: getListProps,
    getItemProps: getItemProps
  };
}
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/userAgents.js
var userAgents = __webpack_require__(3448);
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/metadata.js
function metadata_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function metadata_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? metadata_ownKeys(Object(source), !0).forEach(function (key) { metadata_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : metadata_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function metadata_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function getMetadata(_ref) {
  var _, _options$__autocomple, _options$__autocomple2, _options$__autocomple3;

  var plugins = _ref.plugins,
      options = _ref.options;
  var optionsKey = (_ = (((_options$__autocomple = options.__autocomplete_metadata) === null || _options$__autocomple === void 0 ? void 0 : _options$__autocomple.userAgents) || [])[0]) === null || _ === void 0 ? void 0 : _.segment;
  var extraOptions = optionsKey ? metadata_defineProperty({}, optionsKey, Object.keys(((_options$__autocomple2 = options.__autocomplete_metadata) === null || _options$__autocomple2 === void 0 ? void 0 : _options$__autocomple2.options) || {})) : {};
  return {
    plugins: plugins.map(function (plugin) {
      return {
        name: plugin.name,
        options: Object.keys(plugin.__autocomplete_pluginOptions || [])
      };
    }),
    options: metadata_objectSpread({
      'autocomplete-core': Object.keys(options)
    }, extraOptions),
    ua: userAgents/* userAgents.concat */.R.concat(((_options$__autocomple3 = options.__autocomplete_metadata) === null || _options$__autocomple3 === void 0 ? void 0 : _options$__autocomple3.userAgents) || [])
  };
}
function injectMetadata(_ref3) {
  var _environment$navigato, _environment$navigato2;

  var metadata = _ref3.metadata,
      environment = _ref3.environment;
  var isMetadataEnabled = (_environment$navigato = environment.navigator) === null || _environment$navigato === void 0 ? void 0 : (_environment$navigato2 = _environment$navigato.userAgent) === null || _environment$navigato2 === void 0 ? void 0 : _environment$navigato2.includes('Algolia Crawler');

  if (isMetadataEnabled) {
    var metadataContainer = environment.document.createElement('meta');
    var headRef = environment.document.querySelector('head');
    metadataContainer.name = 'algolia:metadata';
    setTimeout(function () {
      metadataContainer.content = JSON.stringify(metadata);
      headRef.appendChild(metadataContainer);
    }, 0);
  }
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/getCompletion.js

function getCompletion(_ref) {
  var _getActiveItem;

  var state = _ref.state;

  if (state.isOpen === false || state.activeItemId === null) {
    return null;
  }

  return ((_getActiveItem = getActiveItem(state)) === null || _getActiveItem === void 0 ? void 0 : _getActiveItem.itemInputValue) || null;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/utils/getNextActiveItemId.js
/**
 * Returns the next active item ID from the current state.
 *
 * We allow circular keyboard navigation from the base index.
 * The base index can either be `null` (nothing is highlighted) or `0`
 * (the first item is highlighted).
 * The base index is allowed to get assigned `null` only if
 * `props.defaultActiveItemId` is `null`. This pattern allows to "stop"
 * by the actual query before navigating to other suggestions as seen on
 * Google or Amazon.
 *
 * @param moveAmount The offset to increment (or decrement) the last index
 * @param baseIndex The current index to compute the next index from
 * @param itemCount The number of items
 * @param defaultActiveItemId The default active index to fallback to
 */
function getNextActiveItemId(moveAmount, baseIndex, itemCount, defaultActiveItemId) {
  if (!itemCount) {
    return null;
  }

  if (moveAmount < 0 && (baseIndex === null || defaultActiveItemId !== null && baseIndex === 0)) {
    return itemCount + moveAmount;
  }

  var numericIndex = (baseIndex === null ? -1 : baseIndex) + moveAmount;

  if (numericIndex <= -1 || numericIndex >= itemCount) {
    return defaultActiveItemId === null ? null : 0;
  }

  return numericIndex;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/stateReducer.js
function stateReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function stateReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? stateReducer_ownKeys(Object(source), !0).forEach(function (key) { stateReducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : stateReducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function stateReducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var stateReducer = function stateReducer(state, action) {
  switch (action.type) {
    case 'setActiveItemId':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: action.payload
        });
      }

    case 'setQuery':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          query: action.payload,
          completion: null
        });
      }

    case 'setCollections':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          collections: action.payload
        });
      }

    case 'setIsOpen':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          isOpen: action.payload
        });
      }

    case 'setStatus':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          status: action.payload
        });
      }

    case 'setContext':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          context: stateReducer_objectSpread(stateReducer_objectSpread({}, state.context), action.payload)
        });
      }

    case 'ArrowDown':
      {
        var nextState = stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: action.payload.hasOwnProperty('nextActiveItemId') ? action.payload.nextActiveItemId : getNextActiveItemId(1, state.activeItemId, getItemsCount(state), action.props.defaultActiveItemId)
        });

        return stateReducer_objectSpread(stateReducer_objectSpread({}, nextState), {}, {
          completion: getCompletion({
            state: nextState
          })
        });
      }

    case 'ArrowUp':
      {
        var _nextState = stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: getNextActiveItemId(-1, state.activeItemId, getItemsCount(state), action.props.defaultActiveItemId)
        });

        return stateReducer_objectSpread(stateReducer_objectSpread({}, _nextState), {}, {
          completion: getCompletion({
            state: _nextState
          })
        });
      }

    case 'Escape':
      {
        if (state.isOpen) {
          return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
            activeItemId: null,
            isOpen: false,
            completion: null
          });
        }

        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: null,
          query: '',
          status: 'idle',
          collections: []
        });
      }

    case 'submit':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: null,
          isOpen: false,
          status: 'idle'
        });
      }

    case 'reset':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: // Since we open the panel on reset when openOnFocus=true
          // we need to restore the highlighted index to the defaultActiveItemId. (DocSearch use-case)
          // Since we close the panel when openOnFocus=false
          // we lose track of the highlighted index. (Query-suggestions use-case)
          action.props.openOnFocus === true ? action.props.defaultActiveItemId : null,
          status: 'idle',
          query: ''
        });
      }

    case 'focus':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: action.props.defaultActiveItemId,
          isOpen: (action.props.openOnFocus || Boolean(state.query)) && action.props.shouldPanelOpen({
            state: state
          })
        });
      }

    case 'blur':
      {
        if (action.props.debug) {
          return state;
        }

        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          isOpen: false,
          activeItemId: null
        });
      }

    case 'mousemove':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: action.payload
        });
      }

    case 'mouseleave':
      {
        return stateReducer_objectSpread(stateReducer_objectSpread({}, state), {}, {
          activeItemId: action.props.defaultActiveItemId
        });
      }

    default:
      invariant(false, "The reducer action ".concat(JSON.stringify(action.type), " is not supported."));
      return state;
  }
};
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-core/dist/esm/createAutocomplete.js
function createAutocomplete_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createAutocomplete_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createAutocomplete_ownKeys(Object(source), !0).forEach(function (key) { createAutocomplete_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createAutocomplete_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function createAutocomplete_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function createAutocomplete(options) {
  checkOptions(options);
  var subscribers = [];
  var props = getDefaultProps(options, subscribers);
  var store = createStore(stateReducer, props, onStoreStateChange);
  var setters = getAutocompleteSetters({
    store: store
  });
  var propGetters = getPropGetters(createAutocomplete_objectSpread({
    props: props,
    refresh: refresh,
    store: store,
    navigator: props.navigator
  }, setters));

  function onStoreStateChange(_ref) {
    var prevState = _ref.prevState,
        state = _ref.state;
    props.onStateChange(createAutocomplete_objectSpread({
      prevState: prevState,
      state: state,
      refresh: refresh,
      navigator: props.navigator
    }, setters));
  }

  function refresh() {
    return onInput(createAutocomplete_objectSpread({
      event: new Event('input'),
      nextState: {
        isOpen: store.getState().isOpen
      },
      props: props,
      navigator: props.navigator,
      query: store.getState().query,
      refresh: refresh,
      store: store
    }, setters));
  }

  props.plugins.forEach(function (plugin) {
    var _plugin$subscribe;

    return (_plugin$subscribe = plugin.subscribe) === null || _plugin$subscribe === void 0 ? void 0 : _plugin$subscribe.call(plugin, createAutocomplete_objectSpread(createAutocomplete_objectSpread({}, setters), {}, {
      navigator: props.navigator,
      refresh: refresh,
      onSelect: function onSelect(fn) {
        subscribers.push({
          onSelect: fn
        });
      },
      onActive: function onActive(fn) {
        subscribers.push({
          onActive: fn
        });
      },
      onResolve: function onResolve(fn) {
        subscribers.push({
          onResolve: fn
        });
      }
    }));
  });
  injectMetadata({
    metadata: getMetadata({
      plugins: props.plugins,
      options: options
    }),
    environment: props.environment
  });
  return createAutocomplete_objectSpread(createAutocomplete_objectSpread({
    refresh: refresh,
    navigator: props.navigator
  }, propGetters), setters);
}
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/createRef.js
var createRef = __webpack_require__(5236);
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/debounce.js
function debounce(fn, time) {
  var timerId = undefined;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(function () {
      return fn.apply(void 0, args);
    }, time);
  };
}
;// CONCATENATED MODULE: ./node_modules/htm/dist/htm.module.js
var n=function(t,s,r,e){var u;s[0]=0;for(var h=1;h<s.length;h++){var p=s[h++],a=s[h]?(s[0]|=p?1:2,r[s[h++]]):s[++h];3===p?e[0]=a:4===p?e[1]=Object.assign(e[1]||{},a):5===p?(e[1]=e[1]||{})[s[++h]]=a:6===p?e[1][s[++h]]+=a+"":p?(u=t.apply(a,n(t,a,r,["",null])),e.push(u),a[0]?s[0]|=2:(s[h-2]=0,s[h]=u)):e.push(a)}return e},t=new Map;/* harmony default export */ function htm_module(s){var r=t.get(this);return r||(r=new Map,t.set(this,r)),(r=n(this,r.get(s)||(r.set(s,r=function(n){for(var t,s,r=1,e="",u="",h=[0],p=function(n){1===r&&(n||(e=e.replace(/^\s*\n\s*|\s*\n\s*$/g,"")))?h.push(0,n,e):3===r&&(n||e)?(h.push(3,n,e),r=2):2===r&&"..."===e&&n?h.push(4,n,0):2===r&&e&&!n?h.push(5,0,!0,e):r>=5&&((e||!n&&5===r)&&(h.push(r,0,e,s),r=6),n&&(h.push(r,n,0,s),r=6)),e=""},a=0;a<n.length;a++){a&&(1===r&&p(),p(a));for(var l=0;l<n[a].length;l++)t=n[a][l],1===r?"<"===t?(p(),h=[h],r=3):e+=t:4===r?"--"===e&&">"===t?(r=1,e=""):e=t+e[0]:u?t===u?u="":e+=t:'"'===t||"'"===t?u=t:">"===t?(p(),r=1):r&&("="===t?(r=5,s=e,e=""):"/"===t&&(r<5||">"===n[a][l+1])?(p(),3===r&&(h=h[0]),r=h,(h=h[0]).push(2,0,r),r=0):" "===t||"\t"===t||"\n"===t||"\r"===t?(p(),r=2):e+=t),3===r&&"!--"===e&&(r=4,h=h[0])}return p(),h}(s)),r),arguments,[])).length>1?r:r[0]}

;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/elements/SearchIcon.js
var SearchIcon = function SearchIcon(_ref) {
  var environment = _ref.environment;
  var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  element.setAttribute('class', 'aa-SubmitIcon');
  element.setAttribute('viewBox', '0 0 24 24');
  element.setAttribute('width', '20');
  element.setAttribute('height', '20');
  element.setAttribute('fill', 'currentColor');
  var path = environment.document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', 'M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z');
  element.appendChild(path);
  return element;
};
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/elements/ClearIcon.js
var ClearIcon = function ClearIcon(_ref) {
  var environment = _ref.environment;
  var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  element.setAttribute('class', 'aa-ClearIcon');
  element.setAttribute('viewBox', '0 0 24 24');
  element.setAttribute('width', '18');
  element.setAttribute('height', '18');
  element.setAttribute('fill', 'currentColor');
  var path = environment.document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', 'M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z');
  element.appendChild(path);
  return element;
};
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/elements/LoadingIcon.js
var LoadingIcon = function LoadingIcon(_ref) {
  var environment = _ref.environment;
  var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  element.setAttribute('class', 'aa-LoadingIcon');
  element.setAttribute('viewBox', '0 0 100 100');
  element.setAttribute('width', '20');
  element.setAttribute('height', '20');
  element.innerHTML = "<circle\n  cx=\"50\"\n  cy=\"50\"\n  fill=\"none\"\n  r=\"35\"\n  stroke=\"currentColor\"\n  stroke-dasharray=\"164.93361431346415 56.97787143782138\"\n  stroke-width=\"6\"\n>\n  <animateTransform\n    attributeName=\"transform\"\n    type=\"rotate\"\n    repeatCount=\"indefinite\"\n    dur=\"1s\"\n    values=\"0 50 50;90 50 50;180 50 50;360 50 50\"\n    keyTimes=\"0;0.40;0.65;1\"\n  />\n</circle>";
  return element;
};
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/utils/setProperties.js
/* eslint-disable */

/**
 * Touch-specific event aliases
 *
 * See https://w3c.github.io/touch-events/#extensions-to-the-globaleventhandlers-mixin
 */
var TOUCH_EVENTS_ALIASES = ['ontouchstart', 'ontouchend', 'ontouchmove', 'ontouchcancel'];
/*
 * Taken from Preact
 *
 * See https://github.com/preactjs/preact/blob/6ab49d9020740127577bf4af66bf63f4af7f9fee/src/diff/props.js#L58-L151
 */

function setStyle(style, key, value) {
  if (value === null) {
    style[key] = '';
  } else if (typeof value !== 'number') {
    style[key] = value;
  } else {
    style[key] = value + 'px';
  }
}
/**
 * Proxy an event to hooked event handlers
 */


function eventProxy(event) {
  this._listeners[event.type](event);
}
/**
 * Set a property value on a DOM node
 */


function setProperty(dom, name, value) {
  var useCapture;
  var nameLower;
  var oldValue = dom[name];

  if (name === 'style') {
    if (typeof value == 'string') {
      dom.style = value;
    } else {
      if (value === null) {
        dom.style = '';
      } else {
        for (name in value) {
          if (!oldValue || value[name] !== oldValue[name]) {
            setStyle(dom.style, name, value[name]);
          }
        }
      }
    }
  } // Benchmark for comparison: https://esbench.com/bench/574c954bdb965b9a00965ac6
  else if (name[0] === 'o' && name[1] === 'n') {
    useCapture = name !== (name = name.replace(/Capture$/, ''));
    nameLower = name.toLowerCase();
    if (nameLower in dom || TOUCH_EVENTS_ALIASES.includes(nameLower)) name = nameLower;
    name = name.slice(2);
    if (!dom._listeners) dom._listeners = {};
    dom._listeners[name] = value;

    if (value) {
      if (!oldValue) dom.addEventListener(name, eventProxy, useCapture);
    } else {
      dom.removeEventListener(name, eventProxy, useCapture);
    }
  } else if (name !== 'list' && name !== 'tagName' && // HTMLButtonElement.form and HTMLInputElement.form are read-only but can be set using
  // setAttribute
  name !== 'form' && name !== 'type' && name !== 'size' && name !== 'download' && name !== 'href' && name in dom) {
    dom[name] = value == null ? '' : value;
  } else if (typeof value != 'function' && name !== 'dangerouslySetInnerHTML') {
    if (value == null || value === false && // ARIA-attributes have a different notion of boolean values.
    // The value `false` is different from the attribute not
    // existing on the DOM, so we can't remove it. For non-boolean
    // ARIA-attributes we could treat false as a removal, but the
    // amount of exceptions would cost us too many bytes. On top of
    // that other VDOM frameworks also always stringify `false`.
    !/^ar/.test(name)) {
      dom.removeAttribute(name);
    } else {
      dom.setAttribute(name, value);
    }
  }
}

function getNormalizedName(name) {
  switch (name) {
    case 'onChange':
      return 'onInput';

    default:
      return name;
  }
}

function setProperties(dom, props) {
  for (var name in props) {
    setProperty(dom, getNormalizedName(name), props[name]);
  }
}
function setPropertiesWithoutEvents(dom, props) {
  for (var name in props) {
    if (!(name[0] === 'o' && name[1] === 'n')) {
      setProperty(dom, getNormalizedName(name), props[name]);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/getCreateDomElement.js
var getCreateDomElement_excluded = ["children"];

function getCreateDomElement_toConsumableArray(arr) { return getCreateDomElement_arrayWithoutHoles(arr) || getCreateDomElement_iterableToArray(arr) || getCreateDomElement_unsupportedIterableToArray(arr) || getCreateDomElement_nonIterableSpread(); }

function getCreateDomElement_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getCreateDomElement_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getCreateDomElement_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getCreateDomElement_arrayLikeToArray(o, minLen); }

function getCreateDomElement_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function getCreateDomElement_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return getCreateDomElement_arrayLikeToArray(arr); }

function getCreateDomElement_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function getCreateDomElement_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = getCreateDomElement_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function getCreateDomElement_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function getCreateDomElement(environment) {
  return function createDomElement(tagName, _ref) {
    var _ref$children = _ref.children,
        children = _ref$children === void 0 ? [] : _ref$children,
        props = getCreateDomElement_objectWithoutProperties(_ref, getCreateDomElement_excluded);

    var element = environment.document.createElement(tagName);
    setProperties(element, props);
    element.append.apply(element, getCreateDomElement_toConsumableArray(children));
    return element;
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/elements/Input.js
var Input_excluded = ["autocompleteScopeApi", "environment", "classNames", "getInputProps", "getInputPropsCore", "isDetached", "state"];

function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Input_ownKeys(Object(source), !0).forEach(function (key) { Input_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Input_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Input_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Input_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Input_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Input = function Input(_ref) {
  var autocompleteScopeApi = _ref.autocompleteScopeApi,
      environment = _ref.environment,
      classNames = _ref.classNames,
      getInputProps = _ref.getInputProps,
      getInputPropsCore = _ref.getInputPropsCore,
      isDetached = _ref.isDetached,
      state = _ref.state,
      props = Input_objectWithoutProperties(_ref, Input_excluded);

  var createDomElement = getCreateDomElement(environment);
  var element = createDomElement('input', props);
  var inputProps = getInputProps(Input_objectSpread({
    state: state,
    props: getInputPropsCore({
      inputElement: element
    }),
    inputElement: element
  }, autocompleteScopeApi));
  setProperties(element, Input_objectSpread(Input_objectSpread({}, inputProps), {}, {
    onKeyDown: function onKeyDown(event) {
      // In detached mode we don't want to close the panel when hitting `Tab`.
      if (isDetached && event.key === 'Tab') {
        return;
      }

      inputProps.onKeyDown(event);
    }
  }));
  return element;
};
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/createAutocompleteDom.js
function createAutocompleteDom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createAutocompleteDom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createAutocompleteDom_ownKeys(Object(source), !0).forEach(function (key) { createAutocompleteDom_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createAutocompleteDom_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function createAutocompleteDom_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function createAutocompleteDom(_ref) {
  var autocomplete = _ref.autocomplete,
      autocompleteScopeApi = _ref.autocompleteScopeApi,
      classNames = _ref.classNames,
      environment = _ref.environment,
      isDetached = _ref.isDetached,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder,
      propGetters = _ref.propGetters,
      setIsModalOpen = _ref.setIsModalOpen,
      state = _ref.state,
      translations = _ref.translations;
  var createDomElement = getCreateDomElement(environment);
  var rootProps = propGetters.getRootProps(createAutocompleteDom_objectSpread({
    state: state,
    props: autocomplete.getRootProps({})
  }, autocompleteScopeApi));
  var root = createDomElement('div', createAutocompleteDom_objectSpread({
    class: classNames.root
  }, rootProps));
  var detachedContainer = createDomElement('div', {
    class: classNames.detachedContainer,
    onMouseDown: function onMouseDown(event) {
      event.stopPropagation();
    }
  });
  var detachedOverlay = createDomElement('div', {
    class: classNames.detachedOverlay,
    children: [detachedContainer],
    onMouseDown: function onMouseDown() {
      setIsModalOpen(false);
      autocomplete.setIsOpen(false);
    }
  });
  var labelProps = propGetters.getLabelProps(createAutocompleteDom_objectSpread({
    state: state,
    props: autocomplete.getLabelProps({})
  }, autocompleteScopeApi));
  var submitButton = createDomElement('button', {
    class: classNames.submitButton,
    type: 'submit',
    title: translations.submitButtonTitle,
    children: [SearchIcon({
      environment: environment
    })]
  });
  var label = createDomElement('label', createAutocompleteDom_objectSpread({
    class: classNames.label,
    children: [submitButton]
  }, labelProps));
  var clearButton = createDomElement('button', {
    class: classNames.clearButton,
    type: 'reset',
    title: translations.clearButtonTitle,
    children: [ClearIcon({
      environment: environment
    })]
  });
  var loadingIndicator = createDomElement('div', {
    class: classNames.loadingIndicator,
    children: [LoadingIcon({
      environment: environment
    })]
  });
  var input = Input({
    class: classNames.input,
    environment: environment,
    state: state,
    getInputProps: propGetters.getInputProps,
    getInputPropsCore: autocomplete.getInputProps,
    autocompleteScopeApi: autocompleteScopeApi,
    isDetached: isDetached
  });
  var inputWrapperPrefix = createDomElement('div', {
    class: classNames.inputWrapperPrefix,
    children: [label, loadingIndicator]
  });
  var inputWrapperSuffix = createDomElement('div', {
    class: classNames.inputWrapperSuffix,
    children: [clearButton]
  });
  var inputWrapper = createDomElement('div', {
    class: classNames.inputWrapper,
    children: [input]
  });
  var formProps = propGetters.getFormProps(createAutocompleteDom_objectSpread({
    state: state,
    props: autocomplete.getFormProps({
      inputElement: input
    })
  }, autocompleteScopeApi));
  var form = createDomElement('form', createAutocompleteDom_objectSpread({
    class: classNames.form,
    children: [inputWrapperPrefix, inputWrapper, inputWrapperSuffix]
  }, formProps));
  var panelProps = propGetters.getPanelProps(createAutocompleteDom_objectSpread({
    state: state,
    props: autocomplete.getPanelProps({})
  }, autocompleteScopeApi));
  var panel = createDomElement('div', createAutocompleteDom_objectSpread({
    class: classNames.panel
  }, panelProps));
  var detachedSearchButtonQuery = createDomElement('div', {
    class: classNames.detachedSearchButtonQuery,
    textContent: state.query
  });
  var detachedSearchButtonPlaceholder = createDomElement('div', {
    class: classNames.detachedSearchButtonPlaceholder,
    hidden: Boolean(state.query),
    textContent: placeholder
  });

  if (false) {}

  if (isDetached) {
    var detachedSearchButtonIcon = createDomElement('div', {
      class: classNames.detachedSearchButtonIcon,
      children: [SearchIcon({
        environment: environment
      })]
    });
    var detachedSearchButton = createDomElement('button', {
      type: 'button',
      class: classNames.detachedSearchButton,
      onClick: function onClick() {
        setIsModalOpen(true);
      },
      children: [detachedSearchButtonIcon, detachedSearchButtonPlaceholder, detachedSearchButtonQuery]
    });
    var detachedCancelButton = createDomElement('button', {
      type: 'button',
      class: classNames.detachedCancelButton,
      textContent: translations.detachedCancelButtonText,
      // Prevent `onTouchStart` from closing the panel
      // since it should be initiated by `onClick` only
      onTouchStart: function onTouchStart(event) {
        event.stopPropagation();
      },
      onClick: function onClick() {
        autocomplete.setIsOpen(false);
        setIsModalOpen(false);
      }
    });
    var detachedFormContainer = createDomElement('div', {
      class: classNames.detachedFormContainer,
      children: [form, detachedCancelButton]
    });
    detachedContainer.appendChild(detachedFormContainer);
    root.appendChild(detachedSearchButton);
  } else {
    root.appendChild(form);
  }

  return {
    detachedContainer: detachedContainer,
    detachedOverlay: detachedOverlay,
    detachedSearchButtonQuery: detachedSearchButtonQuery,
    detachedSearchButtonPlaceholder: detachedSearchButtonPlaceholder,
    inputWrapper: inputWrapper,
    input: input,
    root: root,
    form: form,
    label: label,
    submitButton: submitButton,
    clearButton: clearButton,
    loadingIndicator: loadingIndicator,
    panel: panel
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/createEffectWrapper.js
function createEffectWrapper() {
  var effects = [];
  var cleanups = [];

  function runEffect(fn) {
    effects.push(fn);
    var effectCleanup = fn();
    cleanups.push(effectCleanup);
  }

  return {
    runEffect: runEffect,
    cleanupEffects: function cleanupEffects() {
      var currentCleanups = cleanups;
      cleanups = [];
      currentCleanups.forEach(function (cleanup) {
        cleanup();
      });
    },
    runEffects: function runEffects() {
      var currentEffects = effects;
      effects = [];
      currentEffects.forEach(function (effect) {
        runEffect(effect);
      });
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/createReactiveWrapper.js
function createReactiveWrapper() {
  var reactives = [];
  return {
    reactive: function reactive(value) {
      var current = value();
      var reactive = {
        _fn: value,
        _ref: {
          current: current
        },

        get value() {
          return this._ref.current;
        },

        set value(value) {
          this._ref.current = value;
        }

      };
      reactives.push(reactive);
      return reactive;
    },
    runReactives: function runReactives() {
      reactives.forEach(function (value) {
        value._ref.current = value._fn();
      });
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module_n,l,u,preact_module_t,i,o,r,f,e,c,s,a,h={},v=[],p=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,y=Array.isArray;function d(n,l){for(var u in l)n[u]=l[u];return n}function _(n){var l=n.parentNode;l&&l.removeChild(n)}function g(l,u,t){var i,o,r,f={};for(r in u)"key"==r?i=u[r]:"ref"==r?o=u[r]:f[r]=u[r];if(arguments.length>2&&(f.children=arguments.length>3?preact_module_n.call(arguments,2):t),"function"==typeof l&&null!=l.defaultProps)for(r in l.defaultProps)void 0===f[r]&&(f[r]=l.defaultProps[r]);return b(l,f,i,o,null)}function b(n,t,i,o,r){var f={type:n,props:t,key:i,ref:o,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,constructor:void 0,__v:null==r?++u:r,__i:-1,__u:0};return null==r&&null!=l.vnode&&l.vnode(f),f}function m(){return{current:null}}function w(n){return n.children}function k(n,l){this.props=n,this.context=l}function x(n,l){if(null==l)return n.__?x(n.__,n.__i+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return"function"==typeof n.type?x(n):null}function C(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return C(n)}}function P(n){(!n.__d&&(n.__d=!0)&&i.push(n)&&!S.__r++||o!==l.debounceRendering)&&((o=l.debounceRendering)||r)(S)}function S(){var n,u,t,o,r,e,c,s;for(i.sort(f);n=i.shift();)n.__d&&(u=i.length,o=void 0,e=(r=(t=n).__v).__e,c=[],s=[],t.__P&&((o=d({},r)).__v=r.__v+1,l.vnode&&l.vnode(o),O(t.__P,o,r,t.__n,void 0!==t.__P.ownerSVGElement,32&r.__u?[e]:null,c,null==e?x(r):e,!!(32&r.__u),s),o.__v=r.__v,o.__.__k[o.__i]=o,j(c,o,s),o.__e!=e&&C(o)),i.length>u&&i.sort(f));S.__r=0}function $(n,l,u,t,i,o,r,f,e,c,s){var a,p,y,d,_,g=t&&t.__k||v,b=l.length;for(u.__d=e,I(u,l,g),e=u.__d,a=0;a<b;a++)null!=(y=u.__k[a])&&"boolean"!=typeof y&&"function"!=typeof y&&(p=-1===y.__i?h:g[y.__i]||h,y.__i=a,O(n,y,p,i,o,r,f,e,c,s),d=y.__e,y.ref&&p.ref!=y.ref&&(p.ref&&N(p.ref,null,y),s.push(y.ref,y.__c||d,y)),null==_&&null!=d&&(_=d),65536&y.__u||p.__k===y.__k?(e&&!e.isConnected&&(e=x(p)),e=H(y,e,n)):"function"==typeof y.type&&void 0!==y.__d?e=y.__d:d&&(e=d.nextSibling),y.__d=void 0,y.__u&=-196609);u.__d=e,u.__e=_}function I(n,l,u){var t,i,o,r,f,e=l.length,c=u.length,s=c,a=0;for(n.__k=[],t=0;t<e;t++)r=t+a,null!=(i=n.__k[t]=null==(i=l[t])||"boolean"==typeof i||"function"==typeof i?null:"string"==typeof i||"number"==typeof i||"bigint"==typeof i||i.constructor==String?b(null,i,null,null,null):y(i)?b(w,{children:i},null,null,null):void 0===i.constructor&&i.__b>0?b(i.type,i.props,i.key,i.ref?i.ref:null,i.__v):i)?(i.__=n,i.__b=n.__b+1,f=A(i,u,r,s),i.__i=f,o=null,-1!==f&&(s--,(o=u[f])&&(o.__u|=131072)),null==o||null===o.__v?(-1==f&&a--,"function"!=typeof i.type&&(i.__u|=65536)):f!==r&&(f===r+1?a++:f>r?s>e-r?a+=f-r:a--:f<r?f==r-1&&(a=f-r):a=0,f!==t+a&&(i.__u|=65536))):(o=u[r])&&null==o.key&&o.__e&&0==(131072&o.__u)&&(o.__e==n.__d&&(n.__d=x(o)),q(o,o,!1),u[r]=null,s--);if(s)for(t=0;t<c;t++)null!=(o=u[t])&&0==(131072&o.__u)&&(o.__e==n.__d&&(n.__d=x(o)),q(o,o))}function H(n,l,u){var t,i;if("function"==typeof n.type){for(t=n.__k,i=0;t&&i<t.length;i++)t[i]&&(t[i].__=n,l=H(t[i],l,u));return l}n.__e!=l&&(u.insertBefore(n.__e,l||null),l=n.__e);do{l=l&&l.nextSibling}while(null!=l&&8===l.nodeType);return l}function T(n,l){return l=l||[],null==n||"boolean"==typeof n||(y(n)?n.some(function(n){T(n,l)}):l.push(n)),l}function A(n,l,u,t){var i=n.key,o=n.type,r=u-1,f=u+1,e=l[u];if(null===e||e&&i==e.key&&o===e.type&&0==(131072&e.__u))return u;if(t>(null!=e&&0==(131072&e.__u)?1:0))for(;r>=0||f<l.length;){if(r>=0){if((e=l[r])&&0==(131072&e.__u)&&i==e.key&&o===e.type)return r;r--}if(f<l.length){if((e=l[f])&&0==(131072&e.__u)&&i==e.key&&o===e.type)return f;f++}}return-1}function F(n,l,u){"-"===l[0]?n.setProperty(l,null==u?"":u):n[l]=null==u?"":"number"!=typeof u||p.test(l)?u:u+"px"}function L(n,l,u,t,i){var o;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else{if("string"==typeof t&&(n.style.cssText=t=""),t)for(l in t)u&&l in u||F(n.style,l,"");if(u)for(l in u)t&&u[l]===t[l]||F(n.style,l,u[l])}else if("o"===l[0]&&"n"===l[1])o=l!==(l=l.replace(/(PointerCapture)$|Capture$/i,"$1")),l=l.toLowerCase()in n||"onFocusOut"===l||"onFocusIn"===l?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+o]=u,u?t?u.u=t.u:(u.u=e,n.addEventListener(l,o?s:c,o)):n.removeEventListener(l,o?s:c,o);else{if(i)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!=l&&"height"!=l&&"href"!=l&&"list"!=l&&"form"!=l&&"tabIndex"!=l&&"download"!=l&&"rowSpan"!=l&&"colSpan"!=l&&"role"!=l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null==u||!1===u&&"-"!==l[4]?n.removeAttribute(l):n.setAttribute(l,u))}}function M(n){return function(u){if(this.l){var t=this.l[u.type+n];if(null==u.t)u.t=e++;else if(u.t<t.u)return;return t(l.event?l.event(u):u)}}}function O(n,u,t,i,o,r,f,e,c,s){var a,h,v,p,_,g,b,m,x,C,P,S,I,H,T,A=u.type;if(void 0!==u.constructor)return null;128&t.__u&&(c=!!(32&t.__u),r=[e=u.__e=t.__e]),(a=l.__b)&&a(u);n:if("function"==typeof A)try{if(m=u.props,x=(a=A.contextType)&&i[a.__c],C=a?x?x.props.value:a.__:i,t.__c?b=(h=u.__c=t.__c).__=h.__E:("prototype"in A&&A.prototype.render?u.__c=h=new A(m,C):(u.__c=h=new k(m,C),h.constructor=A,h.render=B),x&&x.sub(h),h.props=m,h.state||(h.state={}),h.context=C,h.__n=i,v=h.__d=!0,h.__h=[],h._sb=[]),null==h.__s&&(h.__s=h.state),null!=A.getDerivedStateFromProps&&(h.__s==h.state&&(h.__s=d({},h.__s)),d(h.__s,A.getDerivedStateFromProps(m,h.__s))),p=h.props,_=h.state,h.__v=u,v)null==A.getDerivedStateFromProps&&null!=h.componentWillMount&&h.componentWillMount(),null!=h.componentDidMount&&h.__h.push(h.componentDidMount);else{if(null==A.getDerivedStateFromProps&&m!==p&&null!=h.componentWillReceiveProps&&h.componentWillReceiveProps(m,C),!h.__e&&(null!=h.shouldComponentUpdate&&!1===h.shouldComponentUpdate(m,h.__s,C)||u.__v===t.__v)){for(u.__v!==t.__v&&(h.props=m,h.state=h.__s,h.__d=!1),u.__e=t.__e,u.__k=t.__k,u.__k.forEach(function(n){n&&(n.__=u)}),P=0;P<h._sb.length;P++)h.__h.push(h._sb[P]);h._sb=[],h.__h.length&&f.push(h);break n}null!=h.componentWillUpdate&&h.componentWillUpdate(m,h.__s,C),null!=h.componentDidUpdate&&h.__h.push(function(){h.componentDidUpdate(p,_,g)})}if(h.context=C,h.props=m,h.__P=n,h.__e=!1,S=l.__r,I=0,"prototype"in A&&A.prototype.render){for(h.state=h.__s,h.__d=!1,S&&S(u),a=h.render(h.props,h.state,h.context),H=0;H<h._sb.length;H++)h.__h.push(h._sb[H]);h._sb=[]}else do{h.__d=!1,S&&S(u),a=h.render(h.props,h.state,h.context),h.state=h.__s}while(h.__d&&++I<25);h.state=h.__s,null!=h.getChildContext&&(i=d(d({},i),h.getChildContext())),v||null==h.getSnapshotBeforeUpdate||(g=h.getSnapshotBeforeUpdate(p,_)),$(n,y(T=null!=a&&a.type===w&&null==a.key?a.props.children:a)?T:[T],u,t,i,o,r,f,e,c,s),h.base=u.__e,u.__u&=-161,h.__h.length&&f.push(h),b&&(h.__E=h.__=null)}catch(n){u.__v=null,c||null!=r?(u.__e=e,u.__u|=c?160:32,r[r.indexOf(e)]=null):(u.__e=t.__e,u.__k=t.__k),l.__e(n,u,t)}else null==r&&u.__v===t.__v?(u.__k=t.__k,u.__e=t.__e):u.__e=z(t.__e,u,t,i,o,r,f,c,s);(a=l.diffed)&&a(u)}function j(n,u,t){u.__d=void 0;for(var i=0;i<t.length;i++)N(t[i],t[++i],t[++i]);l.__c&&l.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u)})}catch(n){l.__e(n,u.__v)}})}function z(l,u,t,i,o,r,f,e,c){var s,a,v,p,d,g,b,m=t.props,w=u.props,k=u.type;if("svg"===k&&(o=!0),null!=r)for(s=0;s<r.length;s++)if((d=r[s])&&"setAttribute"in d==!!k&&(k?d.localName===k:3===d.nodeType)){l=d,r[s]=null;break}if(null==l){if(null===k)return document.createTextNode(w);l=o?document.createElementNS("http://www.w3.org/2000/svg",k):document.createElement(k,w.is&&w),r=null,e=!1}if(null===k)m===w||e&&l.data===w||(l.data=w);else{if(r=r&&preact_module_n.call(l.childNodes),m=t.props||h,!e&&null!=r)for(m={},s=0;s<l.attributes.length;s++)m[(d=l.attributes[s]).name]=d.value;for(s in m)d=m[s],"children"==s||("dangerouslySetInnerHTML"==s?v=d:"key"===s||s in w||L(l,s,null,d,o));for(s in w)d=w[s],"children"==s?p=d:"dangerouslySetInnerHTML"==s?a=d:"value"==s?g=d:"checked"==s?b=d:"key"===s||e&&"function"!=typeof d||m[s]===d||L(l,s,d,m[s],o);if(a)e||v&&(a.__html===v.__html||a.__html===l.innerHTML)||(l.innerHTML=a.__html),u.__k=[];else if(v&&(l.innerHTML=""),$(l,y(p)?p:[p],u,t,i,o&&"foreignObject"!==k,r,f,r?r[0]:t.__k&&x(t,0),e,c),null!=r)for(s=r.length;s--;)null!=r[s]&&_(r[s]);e||(s="value",void 0!==g&&(g!==l[s]||"progress"===k&&!g||"option"===k&&g!==m[s])&&L(l,s,g,m[s],!1),s="checked",void 0!==b&&b!==l[s]&&L(l,s,b,m[s],!1))}return l}function N(n,u,t){try{"function"==typeof n?n(u):n.current=u}catch(n){l.__e(n,t)}}function q(n,u,t){var i,o;if(l.unmount&&l.unmount(n),(i=n.ref)&&(i.current&&i.current!==n.__e||N(i,null,u)),null!=(i=n.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount()}catch(n){l.__e(n,u)}i.base=i.__P=null}if(i=n.__k)for(o=0;o<i.length;o++)i[o]&&q(i[o],u,t||"function"!=typeof n.type);t||null==n.__e||_(n.__e),n.__c=n.__=n.__e=n.__d=void 0}function B(n,l,u){return this.constructor(n,u)}function D(u,t,i){var o,r,f,e;l.__&&l.__(u,t),r=(o="function"==typeof i)?null:i&&i.__k||t.__k,f=[],e=[],O(t,u=(!o&&i||t).__k=g(w,null,[u]),r||h,h,void 0!==t.ownerSVGElement,!o&&i?[i]:r?null:t.firstChild?preact_module_n.call(t.childNodes):null,f,!o&&i?i:r?r.__e:t.firstChild,o,e),j(f,u,e)}function E(n,l){D(n,l,E)}function G(l,u,t){var i,o,r,f,e=d({},l.props);for(r in l.type&&l.type.defaultProps&&(f=l.type.defaultProps),u)"key"==r?i=u[r]:"ref"==r?o=u[r]:e[r]=void 0===u[r]&&void 0!==f?f[r]:u[r];return arguments.length>2&&(e.children=arguments.length>3?preact_module_n.call(arguments,2):t),b(l.type,e,i||l.key,o||l.ref,null)}function J(n,l){var u={__c:l="__cC"+a++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var u,t;return this.getChildContext||(u=[],(t={})[l]=this,this.getChildContext=function(){return t},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&u.some(function(n){n.__e=!0,P(n)})},this.sub=function(n){u.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){u.splice(u.indexOf(n),1),l&&l.call(n)}}),n.children}};return u.Provider.__=u.Consumer.contextType=u}preact_module_n=v.slice,l={__e:function(n,l,u,t){for(var i,o,r;l=l.__;)if((i=l.__c)&&!i.__)try{if((o=i.constructor)&&null!=o.getDerivedStateFromError&&(i.setState(o.getDerivedStateFromError(n)),r=i.__d),null!=i.componentDidCatch&&(i.componentDidCatch(n,t||{}),r=i.__d),r)return i.__E=i}catch(l){n=l}throw n}},u=0,preact_module_t=function(n){return null!=n&&null==n.constructor},k.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=d({},this.state),"function"==typeof n&&(n=n(d({},u),this.props)),n&&d(u,n),null!=n&&this.__v&&(l&&this._sb.push(l),P(this))},k.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),P(this))},k.prototype.render=w,i=[],r="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,f=function(n,l){return n.__v.__b-l.__v.__b},S.__r=0,e=0,c=M(!1),s=M(!0),a=0;
//# sourceMappingURL=preact.module.js.map

;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/getAttributeValueByPath.js
function getAttributeValueByPath(record, path) {
  return path.reduce(function (current, key) {
    return current && current[key];
  }, record);
}
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/constants/index.js
var constants = __webpack_require__(8786);
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAttribute.js


/**
 * Creates a data structure that allows to concatenate similar highlighting
 * parts in a single value.
 */
function createAttributeSet() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = initialValue;
  return {
    get: function get() {
      return value;
    },
    add: function add(part) {
      var lastPart = value[value.length - 1];

      if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.isHighlighted) === part.isHighlighted) {
        value[value.length - 1] = {
          value: lastPart.value + part.value,
          isHighlighted: lastPart.isHighlighted
        };
      } else {
        value.push(part);
      }
    }
  };
}

function parseAttribute(_ref) {
  var highlightedValue = _ref.highlightedValue;
  var preTagParts = highlightedValue.split(constants/* HIGHLIGHT_PRE_TAG */.S);
  var firstValue = preTagParts.shift();
  var parts = createAttributeSet(firstValue ? [{
    value: firstValue,
    isHighlighted: false
  }] : []);
  preTagParts.forEach(function (part) {
    var postTagParts = part.split(constants/* HIGHLIGHT_POST_TAG */.Z);
    parts.add({
      value: postTagParts[0],
      isHighlighted: true
    });

    if (postTagParts[1] !== '') {
      parts.add({
        value: postTagParts[1],
        isHighlighted: false
      });
    }
  });
  return parts.get();
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitHighlight.js
function parseAlgoliaHitHighlight_toConsumableArray(arr) { return parseAlgoliaHitHighlight_arrayWithoutHoles(arr) || parseAlgoliaHitHighlight_iterableToArray(arr) || parseAlgoliaHitHighlight_unsupportedIterableToArray(arr) || parseAlgoliaHitHighlight_nonIterableSpread(); }

function parseAlgoliaHitHighlight_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseAlgoliaHitHighlight_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseAlgoliaHitHighlight_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseAlgoliaHitHighlight_arrayLikeToArray(o, minLen); }

function parseAlgoliaHitHighlight_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function parseAlgoliaHitHighlight_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return parseAlgoliaHitHighlight_arrayLikeToArray(arr); }

function parseAlgoliaHitHighlight_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function parseAlgoliaHitHighlight(_ref) {
  var hit = _ref.hit,
      attribute = _ref.attribute;
  var path = Array.isArray(attribute) ? attribute : [attribute];
  var highlightedValue = getAttributeValueByPath(hit, ['_highlightResult'].concat(parseAlgoliaHitHighlight_toConsumableArray(path), ['value']));

  if (typeof highlightedValue !== 'string') {
     false ? 0 : void 0;
    highlightedValue = getAttributeValueByPath(hit, path) || '';
  }

  return parseAttribute({
    highlightedValue: highlightedValue
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/components/Highlight.js

function createHighlightComponent(_ref) {
  var createElement = _ref.createElement,
      Fragment = _ref.Fragment;

  function Highlight(_ref2) {
    var hit = _ref2.hit,
        attribute = _ref2.attribute,
        _ref2$tagName = _ref2.tagName,
        tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
    return createElement(Fragment, {}, parseAlgoliaHitHighlight({
      hit: hit,
      attribute: attribute
    }).map(function (x, index) {
      return x.isHighlighted ? createElement(tagName, {
        key: index
      }, x.value) : x.value;
    }));
  }

  Highlight.__autocomplete_componentName = 'Highlight';
  return Highlight;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/isPartHighlighted.js
var htmlEscapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};
var hasAlphanumeric = new RegExp(/\w/i);
var regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var regexHasEscapedHtml = RegExp(regexEscapedHtml.source);

function isPartHighlighted_unescape(value) {
  return value && regexHasEscapedHtml.test(value) ? value.replace(regexEscapedHtml, function (character) {
    return htmlEscapes[character];
  }) : value;
}

function isPartHighlighted(parts, i) {
  var _parts, _parts2;

  var current = parts[i];
  var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
  var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;

  if (!hasAlphanumeric.test(isPartHighlighted_unescape(current.value)) && isPreviousHighlighted === isNextHighlighted) {
    return isPreviousHighlighted;
  }

  return current.isHighlighted;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/reverseHighlightedParts.js
function reverseHighlightedParts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function reverseHighlightedParts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? reverseHighlightedParts_ownKeys(Object(source), !0).forEach(function (key) { reverseHighlightedParts_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : reverseHighlightedParts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function reverseHighlightedParts_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function reverseHighlightedParts(parts) {
  // We don't want to highlight the whole word when no parts match.
  if (!parts.some(function (part) {
    return part.isHighlighted;
  })) {
    return parts.map(function (part) {
      return reverseHighlightedParts_objectSpread(reverseHighlightedParts_objectSpread({}, part), {}, {
        isHighlighted: false
      });
    });
  }

  return parts.map(function (part, i) {
    return reverseHighlightedParts_objectSpread(reverseHighlightedParts_objectSpread({}, part), {}, {
      isHighlighted: !isPartHighlighted(parts, i)
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitReverseHighlight.js


function parseAlgoliaHitReverseHighlight(props) {
  return reverseHighlightedParts(parseAlgoliaHitHighlight(props));
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/components/ReverseHighlight.js

function createReverseHighlightComponent(_ref) {
  var createElement = _ref.createElement,
      Fragment = _ref.Fragment;

  function ReverseHighlight(_ref2) {
    var hit = _ref2.hit,
        attribute = _ref2.attribute,
        _ref2$tagName = _ref2.tagName,
        tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
    return createElement(Fragment, {}, parseAlgoliaHitReverseHighlight({
      hit: hit,
      attribute: attribute
    }).map(function (x, index) {
      return x.isHighlighted ? createElement(tagName, {
        key: index
      }, x.value) : x.value;
    }));
  }

  ReverseHighlight.__autocomplete_componentName = 'ReverseHighlight';
  return ReverseHighlight;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitSnippet.js
function parseAlgoliaHitSnippet_toConsumableArray(arr) { return parseAlgoliaHitSnippet_arrayWithoutHoles(arr) || parseAlgoliaHitSnippet_iterableToArray(arr) || parseAlgoliaHitSnippet_unsupportedIterableToArray(arr) || parseAlgoliaHitSnippet_nonIterableSpread(); }

function parseAlgoliaHitSnippet_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseAlgoliaHitSnippet_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseAlgoliaHitSnippet_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseAlgoliaHitSnippet_arrayLikeToArray(o, minLen); }

function parseAlgoliaHitSnippet_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function parseAlgoliaHitSnippet_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return parseAlgoliaHitSnippet_arrayLikeToArray(arr); }

function parseAlgoliaHitSnippet_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function parseAlgoliaHitSnippet(_ref) {
  var hit = _ref.hit,
      attribute = _ref.attribute;
  var path = Array.isArray(attribute) ? attribute : [attribute];
  var highlightedValue = getAttributeValueByPath(hit, ['_snippetResult'].concat(parseAlgoliaHitSnippet_toConsumableArray(path), ['value']));

  if (typeof highlightedValue !== 'string') {
     false ? 0 : void 0;
    highlightedValue = getAttributeValueByPath(hit, path) || '';
  }

  return parseAttribute({
    highlightedValue: highlightedValue
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitReverseSnippet.js


function parseAlgoliaHitReverseSnippet(props) {
  return reverseHighlightedParts(parseAlgoliaHitSnippet(props));
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/components/ReverseSnippet.js

function createReverseSnippetComponent(_ref) {
  var createElement = _ref.createElement,
      Fragment = _ref.Fragment;

  function ReverseSnippet(_ref2) {
    var hit = _ref2.hit,
        attribute = _ref2.attribute,
        _ref2$tagName = _ref2.tagName,
        tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
    return createElement(Fragment, {}, parseAlgoliaHitReverseSnippet({
      hit: hit,
      attribute: attribute
    }).map(function (x, index) {
      return x.isHighlighted ? createElement(tagName, {
        key: index
      }, x.value) : x.value;
    }));
  }

  ReverseSnippet.__autocomplete_componentName = 'ReverseSnippet';
  return ReverseSnippet;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/components/Snippet.js

function createSnippetComponent(_ref) {
  var createElement = _ref.createElement,
      Fragment = _ref.Fragment;

  function Snippet(_ref2) {
    var hit = _ref2.hit,
        attribute = _ref2.attribute,
        _ref2$tagName = _ref2.tagName,
        tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
    return createElement(Fragment, {}, parseAlgoliaHitSnippet({
      hit: hit,
      attribute: attribute
    }).map(function (x, index) {
      return x.isHighlighted ? createElement(tagName, {
        key: index
      }, x.value) : x.value;
    }));
  }

  Snippet.__autocomplete_componentName = 'Snippet';
  return Snippet;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/utils/getHTMLElement.js

function getHTMLElement(environment, value) {
  if (typeof value === 'string') {
    var element = environment.document.querySelector(value);
    invariant(element !== null, "The element ".concat(JSON.stringify(value), " is not in the document."));
    return element;
  }

  return value;
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/utils/mergeClassNames.js
function mergeClassNames() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.reduce(function (acc, current) {
    Object.keys(current).forEach(function (key) {
      var accValue = acc[key];
      var currentValue = current[key];

      if (accValue !== currentValue) {
        acc[key] = [accValue, currentValue].filter(Boolean).join(' ');
      }
    });
    return acc;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/getDefaultOptions.js
var getDefaultOptions_excluded = ["classNames", "container", "getEnvironmentProps", "getFormProps", "getInputProps", "getItemProps", "getLabelProps", "getListProps", "getPanelProps", "getRootProps", "panelContainer", "panelPlacement", "render", "renderNoResults", "renderer", "detachedMediaQuery", "components", "translations"];

function getDefaultOptions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getDefaultOptions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getDefaultOptions_ownKeys(Object(source), !0).forEach(function (key) { getDefaultOptions_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getDefaultOptions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getDefaultOptions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDefaultOptions_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = getDefaultOptions_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function getDefaultOptions_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var defaultClassNames = {
  clearButton: 'aa-ClearButton',
  detachedCancelButton: 'aa-DetachedCancelButton',
  detachedContainer: 'aa-DetachedContainer',
  detachedFormContainer: 'aa-DetachedFormContainer',
  detachedOverlay: 'aa-DetachedOverlay',
  detachedSearchButton: 'aa-DetachedSearchButton',
  detachedSearchButtonIcon: 'aa-DetachedSearchButtonIcon',
  detachedSearchButtonPlaceholder: 'aa-DetachedSearchButtonPlaceholder',
  detachedSearchButtonQuery: 'aa-DetachedSearchButtonQuery',
  form: 'aa-Form',
  input: 'aa-Input',
  inputWrapper: 'aa-InputWrapper',
  inputWrapperPrefix: 'aa-InputWrapperPrefix',
  inputWrapperSuffix: 'aa-InputWrapperSuffix',
  item: 'aa-Item',
  label: 'aa-Label',
  list: 'aa-List',
  loadingIndicator: 'aa-LoadingIndicator',
  panel: 'aa-Panel',
  panelLayout: 'aa-PanelLayout aa-Panel--scrollable',
  root: 'aa-Autocomplete',
  source: 'aa-Source',
  sourceFooter: 'aa-SourceFooter',
  sourceHeader: 'aa-SourceHeader',
  sourceNoResults: 'aa-SourceNoResults',
  submitButton: 'aa-SubmitButton'
};

var defaultRender = function defaultRender(_ref, root) {
  var children = _ref.children,
      render = _ref.render;
  render(children, root);
};

var defaultRenderer = {
  createElement: g,
  Fragment: w,
  render: D
};
function getDefaultOptions(options) {
  var _core$id;

  var classNames = options.classNames,
      container = options.container,
      getEnvironmentProps = options.getEnvironmentProps,
      getFormProps = options.getFormProps,
      getInputProps = options.getInputProps,
      getItemProps = options.getItemProps,
      getLabelProps = options.getLabelProps,
      getListProps = options.getListProps,
      getPanelProps = options.getPanelProps,
      getRootProps = options.getRootProps,
      panelContainer = options.panelContainer,
      panelPlacement = options.panelPlacement,
      render = options.render,
      renderNoResults = options.renderNoResults,
      renderer = options.renderer,
      detachedMediaQuery = options.detachedMediaQuery,
      components = options.components,
      translations = options.translations,
      core = getDefaultOptions_objectWithoutProperties(options, getDefaultOptions_excluded);
  /* eslint-disable no-restricted-globals */


  var environment = typeof window !== 'undefined' ? window : {};
  /* eslint-enable no-restricted-globals */

  var containerElement = getHTMLElement(environment, container);
  invariant(containerElement.tagName !== 'INPUT', 'The `container` option does not support `input` elements. You need to change the container to a `div`.');
   false ? 0 : void 0;
   false ? 0 : void 0;

  var defaultedRenderer = getDefaultOptions_objectSpread(getDefaultOptions_objectSpread({}, defaultRenderer), renderer);

  var defaultComponents = {
    Highlight: createHighlightComponent(defaultedRenderer),
    ReverseHighlight: createReverseHighlightComponent(defaultedRenderer),
    ReverseSnippet: createReverseSnippetComponent(defaultedRenderer),
    Snippet: createSnippetComponent(defaultedRenderer)
  };
  var defaultTranslations = {
    clearButtonTitle: 'Clear',
    detachedCancelButtonText: 'Cancel',
    submitButtonTitle: 'Submit'
  };
  return {
    renderer: {
      classNames: mergeClassNames(defaultClassNames, classNames !== null && classNames !== void 0 ? classNames : {}),
      container: containerElement,
      getEnvironmentProps: getEnvironmentProps !== null && getEnvironmentProps !== void 0 ? getEnvironmentProps : function (_ref2) {
        var props = _ref2.props;
        return props;
      },
      getFormProps: getFormProps !== null && getFormProps !== void 0 ? getFormProps : function (_ref3) {
        var props = _ref3.props;
        return props;
      },
      getInputProps: getInputProps !== null && getInputProps !== void 0 ? getInputProps : function (_ref4) {
        var props = _ref4.props;
        return props;
      },
      getItemProps: getItemProps !== null && getItemProps !== void 0 ? getItemProps : function (_ref5) {
        var props = _ref5.props;
        return props;
      },
      getLabelProps: getLabelProps !== null && getLabelProps !== void 0 ? getLabelProps : function (_ref6) {
        var props = _ref6.props;
        return props;
      },
      getListProps: getListProps !== null && getListProps !== void 0 ? getListProps : function (_ref7) {
        var props = _ref7.props;
        return props;
      },
      getPanelProps: getPanelProps !== null && getPanelProps !== void 0 ? getPanelProps : function (_ref8) {
        var props = _ref8.props;
        return props;
      },
      getRootProps: getRootProps !== null && getRootProps !== void 0 ? getRootProps : function (_ref9) {
        var props = _ref9.props;
        return props;
      },
      panelContainer: panelContainer ? getHTMLElement(environment, panelContainer) : environment.document.body,
      panelPlacement: panelPlacement !== null && panelPlacement !== void 0 ? panelPlacement : 'input-wrapper-width',
      render: render !== null && render !== void 0 ? render : defaultRender,
      renderNoResults: renderNoResults,
      renderer: defaultedRenderer,
      detachedMediaQuery: detachedMediaQuery !== null && detachedMediaQuery !== void 0 ? detachedMediaQuery : getComputedStyle(environment.document.documentElement).getPropertyValue('--aa-detached-media-query'),
      components: getDefaultOptions_objectSpread(getDefaultOptions_objectSpread({}, defaultComponents), components),
      translations: getDefaultOptions_objectSpread(getDefaultOptions_objectSpread({}, defaultTranslations), translations)
    },
    core: getDefaultOptions_objectSpread(getDefaultOptions_objectSpread({}, core), {}, {
      id: (_core$id = core.id) !== null && _core$id !== void 0 ? _core$id : generateAutocompleteId(),
      environment: environment
    })
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/getPanelPlacementStyle.js
function getPanelPlacementStyle(_ref) {
  var panelPlacement = _ref.panelPlacement,
      container = _ref.container,
      form = _ref.form,
      environment = _ref.environment;
  var containerRect = container.getBoundingClientRect(); // Some browsers have specificities to retrieve the document scroll position.
  // See https://stackoverflow.com/a/28633515/9940315

  var scrollTop = environment.pageYOffset || environment.document.documentElement.scrollTop || environment.document.body.scrollTop || 0;
  var top = scrollTop + containerRect.top + containerRect.height;

  switch (panelPlacement) {
    case 'start':
      {
        return {
          top: top,
          left: containerRect.left
        };
      }

    case 'end':
      {
        return {
          top: top,
          right: environment.document.documentElement.clientWidth - (containerRect.left + containerRect.width)
        };
      }

    case 'full-width':
      {
        return {
          top: top,
          left: 0,
          right: 0,
          width: 'unset',
          maxWidth: 'unset'
        };
      }

    case 'input-wrapper-width':
      {
        var formRect = form.getBoundingClientRect();
        return {
          top: top,
          left: formRect.left,
          right: environment.document.documentElement.clientWidth - (formRect.left + formRect.width),
          width: 'unset',
          maxWidth: 'unset'
        };
      }

    default:
      {
        throw new Error("[Autocomplete] The `panelPlacement` value ".concat(JSON.stringify(panelPlacement), " is not valid."));
      }
  }
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/render.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function render_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function render_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? render_ownKeys(Object(source), !0).forEach(function (key) { render_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : render_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function render_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** @jsxRuntime classic */

/** @jsx renderer.createElement */

function renderSearchBox(_ref) {
  var autocomplete = _ref.autocomplete,
      autocompleteScopeApi = _ref.autocompleteScopeApi,
      dom = _ref.dom,
      propGetters = _ref.propGetters,
      state = _ref.state;
  setPropertiesWithoutEvents(dom.root, propGetters.getRootProps(render_objectSpread({
    state: state,
    props: autocomplete.getRootProps({})
  }, autocompleteScopeApi)));
  setPropertiesWithoutEvents(dom.input, propGetters.getInputProps(render_objectSpread({
    state: state,
    props: autocomplete.getInputProps({
      inputElement: dom.input
    }),
    inputElement: dom.input
  }, autocompleteScopeApi)));
  setProperties(dom.label, {
    hidden: state.status === 'stalled'
  });
  setProperties(dom.loadingIndicator, {
    hidden: state.status !== 'stalled'
  });
  setProperties(dom.clearButton, {
    hidden: !state.query
  });
  setProperties(dom.detachedSearchButtonQuery, {
    textContent: state.query
  });
  setProperties(dom.detachedSearchButtonPlaceholder, {
    hidden: Boolean(state.query)
  });
}
function renderPanel(render, _ref2) {
  var autocomplete = _ref2.autocomplete,
      autocompleteScopeApi = _ref2.autocompleteScopeApi,
      classNames = _ref2.classNames,
      html = _ref2.html,
      dom = _ref2.dom,
      panelContainer = _ref2.panelContainer,
      propGetters = _ref2.propGetters,
      state = _ref2.state,
      components = _ref2.components,
      renderer = _ref2.renderer;

  if (!state.isOpen) {
    if (panelContainer.contains(dom.panel)) {
      panelContainer.removeChild(dom.panel);
    }

    return;
  } // We add the panel element to the DOM when it's not yet appended and that the
  // items are fetched.


  if (!panelContainer.contains(dom.panel) && state.status !== 'loading') {
    panelContainer.appendChild(dom.panel);
  }

  dom.panel.classList.toggle('aa-Panel--stalled', state.status === 'stalled');
  var sections = state.collections.filter(function (_ref3) {
    var source = _ref3.source,
        items = _ref3.items;
    return source.templates.noResults || items.length > 0;
  }).map(function (_ref4, sourceIndex) {
    var source = _ref4.source,
        items = _ref4.items;
    return renderer.createElement("section", {
      key: sourceIndex,
      className: classNames.source,
      "data-autocomplete-source-id": source.sourceId
    }, source.templates.header && renderer.createElement("div", {
      className: classNames.sourceHeader
    }, source.templates.header({
      components: components,
      createElement: renderer.createElement,
      Fragment: renderer.Fragment,
      items: items,
      source: source,
      state: state,
      html: html
    })), source.templates.noResults && items.length === 0 ? renderer.createElement("div", {
      className: classNames.sourceNoResults
    }, source.templates.noResults({
      components: components,
      createElement: renderer.createElement,
      Fragment: renderer.Fragment,
      source: source,
      state: state,
      html: html
    })) : renderer.createElement("ul", _extends({
      className: classNames.list
    }, propGetters.getListProps(render_objectSpread({
      state: state,
      props: autocomplete.getListProps({
        sourceIndex: sourceIndex
      })
    }, autocompleteScopeApi))), items.map(function (item) {
      var itemProps = autocomplete.getItemProps({
        item: item,
        source: source,
        sourceIndex: sourceIndex
      });
      return renderer.createElement("li", _extends({
        key: itemProps.id,
        className: classNames.item
      }, propGetters.getItemProps(render_objectSpread({
        state: state,
        props: itemProps
      }, autocompleteScopeApi))), source.templates.item({
        components: components,
        createElement: renderer.createElement,
        Fragment: renderer.Fragment,
        item: item,
        state: state,
        html: html
      }));
    })), source.templates.footer && renderer.createElement("div", {
      className: classNames.sourceFooter
    }, source.templates.footer({
      components: components,
      createElement: renderer.createElement,
      Fragment: renderer.Fragment,
      items: items,
      source: source,
      state: state,
      html: html
    })));
  });
  var children = renderer.createElement(renderer.Fragment, null, renderer.createElement("div", {
    className: classNames.panelLayout
  }, sections), renderer.createElement("div", {
    className: "aa-GradientBottom"
  }));
  var elements = sections.reduce(function (acc, current) {
    acc[current.props['data-autocomplete-source-id']] = current;
    return acc;
  }, {});
  render(render_objectSpread(render_objectSpread({
    children: children,
    state: state,
    sections: sections,
    elements: elements
  }, renderer), {}, {
    components: components,
    html: html
  }, autocompleteScopeApi), dom.panel);
}
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/userAgents.js
var esm_userAgents = __webpack_require__(500);
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/utils/mergeDeep.js
function mergeDeep_toConsumableArray(arr) { return mergeDeep_arrayWithoutHoles(arr) || mergeDeep_iterableToArray(arr) || mergeDeep_unsupportedIterableToArray(arr) || mergeDeep_nonIterableSpread(); }

function mergeDeep_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mergeDeep_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mergeDeep_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mergeDeep_arrayLikeToArray(o, minLen); }

function mergeDeep_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function mergeDeep_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return mergeDeep_arrayLikeToArray(arr); }

function mergeDeep_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function mergeDeep_typeof(obj) { "@babel/helpers - typeof"; return mergeDeep_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, mergeDeep_typeof(obj); }

var isPlainObject = function isPlainObject(value) {
  return value && mergeDeep_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Object]';
};

function mergeDeep() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.reduce(function (acc, current) {
    Object.keys(current).forEach(function (key) {
      var accValue = acc[key];
      var currentValue = current[key];

      if (Array.isArray(accValue) && Array.isArray(currentValue)) {
        acc[key] = accValue.concat.apply(accValue, mergeDeep_toConsumableArray(currentValue));
      } else if (isPlainObject(accValue) && isPlainObject(currentValue)) {
        acc[key] = mergeDeep(accValue, currentValue);
      } else {
        acc[key] = currentValue;
      }
    });
    return acc;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/utils/pickBy.js
function pickBy_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function pickBy_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? pickBy_ownKeys(Object(source), !0).forEach(function (key) { pickBy_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : pickBy_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function pickBy_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function pickBy_slicedToArray(arr, i) { return pickBy_arrayWithHoles(arr) || pickBy_iterableToArrayLimit(arr, i) || pickBy_unsupportedIterableToArray(arr, i) || pickBy_nonIterableRest(); }

function pickBy_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function pickBy_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pickBy_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pickBy_arrayLikeToArray(o, minLen); }

function pickBy_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function pickBy_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function pickBy_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function pickBy(obj, predicate) {
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = pickBy_slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (predicate({
      key: key,
      value: value
    })) {
      return pickBy_objectSpread(pickBy_objectSpread({}, acc), {}, pickBy_defineProperty({}, key, value));
    }

    return acc;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/autocomplete.js
var autocomplete_excluded = ["components"];

function autocomplete_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = autocomplete_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function autocomplete_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function autocomplete_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function autocomplete_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? autocomplete_ownKeys(Object(source), !0).forEach(function (key) { autocomplete_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : autocomplete_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function autocomplete_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












function autocomplete(options) {
  var _createEffectWrapper = createEffectWrapper(),
      runEffect = _createEffectWrapper.runEffect,
      cleanupEffects = _createEffectWrapper.cleanupEffects,
      runEffects = _createEffectWrapper.runEffects;

  var _createReactiveWrappe = createReactiveWrapper(),
      reactive = _createReactiveWrappe.reactive,
      runReactives = _createReactiveWrappe.runReactives;

  var hasNoResultsSourceTemplateRef = (0,createRef/* createRef */.V)(false);
  var optionsRef = (0,createRef/* createRef */.V)(options);
  var onStateChangeRef = (0,createRef/* createRef */.V)(undefined);
  var props = reactive(function () {
    return getDefaultOptions(optionsRef.current);
  });
  var isDetached = reactive(function () {
    return props.value.core.environment.matchMedia(props.value.renderer.detachedMediaQuery).matches;
  });
  var autocomplete = reactive(function () {
    return createAutocomplete(autocomplete_objectSpread(autocomplete_objectSpread({}, props.value.core), {}, {
      onStateChange: function onStateChange(params) {
        var _onStateChangeRef$cur, _props$value$core$onS, _props$value$core;

        hasNoResultsSourceTemplateRef.current = params.state.collections.some(function (collection) {
          return collection.source.templates.noResults;
        });
        (_onStateChangeRef$cur = onStateChangeRef.current) === null || _onStateChangeRef$cur === void 0 ? void 0 : _onStateChangeRef$cur.call(onStateChangeRef, params);
        (_props$value$core$onS = (_props$value$core = props.value.core).onStateChange) === null || _props$value$core$onS === void 0 ? void 0 : _props$value$core$onS.call(_props$value$core, params);
      },
      shouldPanelOpen: optionsRef.current.shouldPanelOpen || function (_ref) {
        var state = _ref.state;

        if (isDetached.value) {
          return true;
        }

        var hasItems = getItemsCount(state) > 0;

        if (!props.value.core.openOnFocus && !state.query) {
          return hasItems;
        }

        var hasNoResultsTemplate = Boolean(hasNoResultsSourceTemplateRef.current || props.value.renderer.renderNoResults);
        return !hasItems && hasNoResultsTemplate || hasItems;
      },
      __autocomplete_metadata: {
        userAgents: esm_userAgents/* userAgents */.R,
        options: options
      }
    }));
  });
  var lastStateRef = (0,createRef/* createRef */.V)(autocomplete_objectSpread({
    collections: [],
    completion: null,
    context: {},
    isOpen: false,
    query: '',
    activeItemId: null,
    status: 'idle'
  }, props.value.core.initialState));
  var propGetters = {
    getEnvironmentProps: props.value.renderer.getEnvironmentProps,
    getFormProps: props.value.renderer.getFormProps,
    getInputProps: props.value.renderer.getInputProps,
    getItemProps: props.value.renderer.getItemProps,
    getLabelProps: props.value.renderer.getLabelProps,
    getListProps: props.value.renderer.getListProps,
    getPanelProps: props.value.renderer.getPanelProps,
    getRootProps: props.value.renderer.getRootProps
  };
  var autocompleteScopeApi = {
    setActiveItemId: autocomplete.value.setActiveItemId,
    setQuery: autocomplete.value.setQuery,
    setCollections: autocomplete.value.setCollections,
    setIsOpen: autocomplete.value.setIsOpen,
    setStatus: autocomplete.value.setStatus,
    setContext: autocomplete.value.setContext,
    refresh: autocomplete.value.refresh,
    navigator: autocomplete.value.navigator
  };
  var html = reactive(function () {
    return htm_module.bind(props.value.renderer.renderer.createElement);
  });
  var dom = reactive(function () {
    return createAutocompleteDom({
      autocomplete: autocomplete.value,
      autocompleteScopeApi: autocompleteScopeApi,
      classNames: props.value.renderer.classNames,
      environment: props.value.core.environment,
      isDetached: isDetached.value,
      placeholder: props.value.core.placeholder,
      propGetters: propGetters,
      setIsModalOpen: setIsModalOpen,
      state: lastStateRef.current,
      translations: props.value.renderer.translations
    });
  });

  function setPanelPosition() {
    setProperties(dom.value.panel, {
      style: isDetached.value ? {} : getPanelPlacementStyle({
        panelPlacement: props.value.renderer.panelPlacement,
        container: dom.value.root,
        form: dom.value.form,
        environment: props.value.core.environment
      })
    });
  }

  function scheduleRender(state) {
    lastStateRef.current = state;
    var renderProps = {
      autocomplete: autocomplete.value,
      autocompleteScopeApi: autocompleteScopeApi,
      classNames: props.value.renderer.classNames,
      components: props.value.renderer.components,
      container: props.value.renderer.container,
      html: html.value,
      dom: dom.value,
      panelContainer: isDetached.value ? dom.value.detachedContainer : props.value.renderer.panelContainer,
      propGetters: propGetters,
      state: lastStateRef.current,
      renderer: props.value.renderer.renderer
    };
    var render = !getItemsCount(state) && !hasNoResultsSourceTemplateRef.current && props.value.renderer.renderNoResults || props.value.renderer.render;
    renderSearchBox(renderProps);
    renderPanel(render, renderProps);
  }

  runEffect(function () {
    var environmentProps = autocomplete.value.getEnvironmentProps({
      formElement: dom.value.form,
      panelElement: dom.value.panel,
      inputElement: dom.value.input
    });
    setProperties(props.value.core.environment, environmentProps);
    return function () {
      setProperties(props.value.core.environment, Object.keys(environmentProps).reduce(function (acc, key) {
        return autocomplete_objectSpread(autocomplete_objectSpread({}, acc), {}, autocomplete_defineProperty({}, key, undefined));
      }, {}));
    };
  });
  runEffect(function () {
    var panelContainerElement = isDetached.value ? props.value.core.environment.document.body : props.value.renderer.panelContainer;
    var panelElement = isDetached.value ? dom.value.detachedOverlay : dom.value.panel;

    if (isDetached.value && lastStateRef.current.isOpen) {
      setIsModalOpen(true);
    }

    scheduleRender(lastStateRef.current);
    return function () {
      if (panelContainerElement.contains(panelElement)) {
        panelContainerElement.removeChild(panelElement);
      }
    };
  });
  runEffect(function () {
    var containerElement = props.value.renderer.container;
    containerElement.appendChild(dom.value.root);
    return function () {
      containerElement.removeChild(dom.value.root);
    };
  });
  runEffect(function () {
    var debouncedRender = debounce(function (_ref2) {
      var state = _ref2.state;
      scheduleRender(state);
    }, 0);

    onStateChangeRef.current = function (_ref3) {
      var state = _ref3.state,
          prevState = _ref3.prevState;

      if (isDetached.value && prevState.isOpen !== state.isOpen) {
        setIsModalOpen(state.isOpen);
      } // The outer DOM might have changed since the last time the panel was
      // positioned. The layout might have shifted vertically for instance.
      // It's therefore safer to re-calculate the panel position before opening
      // it again.


      if (!isDetached.value && state.isOpen && !prevState.isOpen) {
        setPanelPosition();
      } // We scroll to the top of the panel whenever the query changes (i.e. new
      // results come in) so that users don't have to.


      if (state.query !== prevState.query) {
        var scrollablePanels = props.value.core.environment.document.querySelectorAll('.aa-Panel--scrollable');
        scrollablePanels.forEach(function (scrollablePanel) {
          if (scrollablePanel.scrollTop !== 0) {
            scrollablePanel.scrollTop = 0;
          }
        });
      }

      debouncedRender({
        state: state
      });
    };

    return function () {
      onStateChangeRef.current = undefined;
    };
  });
  runEffect(function () {
    var onResize = debounce(function () {
      var previousIsDetached = isDetached.value;
      isDetached.value = props.value.core.environment.matchMedia(props.value.renderer.detachedMediaQuery).matches;

      if (previousIsDetached !== isDetached.value) {
        update({});
      } else {
        requestAnimationFrame(setPanelPosition);
      }
    }, 20);
    props.value.core.environment.addEventListener('resize', onResize);
    return function () {
      props.value.core.environment.removeEventListener('resize', onResize);
    };
  });
  runEffect(function () {
    if (!isDetached.value) {
      return function () {};
    }

    function toggleModalClassname(isActive) {
      dom.value.detachedContainer.classList.toggle('aa-DetachedContainer--modal', isActive);
    }

    function onChange(event) {
      toggleModalClassname(event.matches);
    }

    var isModalDetachedMql = props.value.core.environment.matchMedia(getComputedStyle(props.value.core.environment.document.documentElement).getPropertyValue('--aa-detached-modal-media-query'));
    toggleModalClassname(isModalDetachedMql.matches); // Prior to Safari 14, `MediaQueryList` isn't based on `EventTarget`,
    // so we must use `addListener` and `removeListener` to observe media query lists.
    // See https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener

    var hasModernEventListener = Boolean(isModalDetachedMql.addEventListener);
    hasModernEventListener ? isModalDetachedMql.addEventListener('change', onChange) : isModalDetachedMql.addListener(onChange);
    return function () {
      hasModernEventListener ? isModalDetachedMql.removeEventListener('change', onChange) : isModalDetachedMql.removeListener(onChange);
    };
  });
  runEffect(function () {
    requestAnimationFrame(setPanelPosition);
    return function () {};
  });

  function destroy() {
    cleanupEffects();
  }

  function update() {
    var updatedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    cleanupEffects();

    var _props$value$renderer = props.value.renderer,
        components = _props$value$renderer.components,
        rendererProps = autocomplete_objectWithoutProperties(_props$value$renderer, autocomplete_excluded);

    optionsRef.current = mergeDeep(rendererProps, props.value.core, {
      // We need to filter out default components so they can be replaced with
      // a new `renderer`, without getting rid of user components.
      // @MAJOR Deal with registering components with the same name as the
      // default ones. If we disallow overriding default components, we'd just
      // need to pass all `components` here.
      components: pickBy(components, function (_ref4) {
        var value = _ref4.value;
        return !value.hasOwnProperty('__autocomplete_componentName');
      }),
      initialState: lastStateRef.current
    }, updatedOptions);
    runReactives();
    runEffects();
    autocomplete.value.refresh().then(function () {
      scheduleRender(lastStateRef.current);
    });
  }

  function setIsModalOpen(value) {
    requestAnimationFrame(function () {
      var prevValue = props.value.core.environment.document.body.contains(dom.value.detachedOverlay);

      if (value === prevValue) {
        return;
      }

      if (value) {
        props.value.core.environment.document.body.appendChild(dom.value.detachedOverlay);
        props.value.core.environment.document.body.classList.add('aa-Detached');
        dom.value.input.focus();
      } else {
        props.value.core.environment.document.body.removeChild(dom.value.detachedOverlay);
        props.value.core.environment.document.body.classList.remove('aa-Detached');
      }
    });
  }

  return autocomplete_objectSpread(autocomplete_objectSpread({}, autocompleteScopeApi), {}, {
    update: update,
    destroy: destroy
  });
}

/***/ }),

/***/ 7358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ getAlgoliaResults; }
});

;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/requester/createRequester.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createRequester(fetcher, requesterId) {
  function execute(fetcherParams) {
    return fetcher({
      searchClient: fetcherParams.searchClient,
      queries: fetcherParams.requests.map(function (x) {
        return x.query;
      })
    }).then(function (responses) {
      return responses.map(function (response, index) {
        var _fetcherParams$reques = fetcherParams.requests[index],
            sourceId = _fetcherParams$reques.sourceId,
            transformResponse = _fetcherParams$reques.transformResponse;
        return {
          items: response,
          sourceId: sourceId,
          transformResponse: transformResponse
        };
      });
    });
  }

  return function createSpecifiedRequester(requesterParams) {
    return function requester(requestParams) {
      return _objectSpread(_objectSpread({
        requesterId: requesterId,
        execute: execute
      }, requesterParams), requestParams);
    };
  };
}
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/userAgents.js
var esm_userAgents = __webpack_require__(3448);
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/constants/index.js
var constants = __webpack_require__(8786);
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-preset-algolia/dist/esm/search/fetchAlgoliaResults.js
var _excluded = ["params"];

function fetchAlgoliaResults_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function fetchAlgoliaResults_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? fetchAlgoliaResults_ownKeys(Object(source), !0).forEach(function (key) { fetchAlgoliaResults_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : fetchAlgoliaResults_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function fetchAlgoliaResults_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function fetchAlgoliaResults(_ref) {
  var searchClient = _ref.searchClient,
      queries = _ref.queries,
      _ref$userAgents = _ref.userAgents,
      userAgents = _ref$userAgents === void 0 ? [] : _ref$userAgents;

  if (typeof searchClient.addAlgoliaAgent === 'function') {
    var algoliaAgents = [].concat(_toConsumableArray(esm_userAgents/* userAgents */.R), _toConsumableArray(userAgents));
    algoliaAgents.forEach(function (_ref2) {
      var segment = _ref2.segment,
          version = _ref2.version;
      searchClient.addAlgoliaAgent(segment, version);
    });
  }

  return searchClient.search(queries.map(function (searchParameters) {
    var params = searchParameters.params,
        headers = _objectWithoutProperties(searchParameters, _excluded);

    return fetchAlgoliaResults_objectSpread(fetchAlgoliaResults_objectSpread({}, headers), {}, {
      params: fetchAlgoliaResults_objectSpread({
        hitsPerPage: 5,
        highlightPreTag: constants/* HIGHLIGHT_PRE_TAG */.S,
        highlightPostTag: constants/* HIGHLIGHT_POST_TAG */.Z
      }, params)
    });
  })).then(function (response) {
    return response.results;
  });
}
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/userAgents.js
var userAgents = __webpack_require__(500);
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/requesters/createAlgoliaRequester.js
function createAlgoliaRequester_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createAlgoliaRequester_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createAlgoliaRequester_ownKeys(Object(source), !0).forEach(function (key) { createAlgoliaRequester_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createAlgoliaRequester_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function createAlgoliaRequester_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var createAlgoliaRequester = createRequester(function (params) {
  return fetchAlgoliaResults(createAlgoliaRequester_objectSpread(createAlgoliaRequester_objectSpread({}, params), {}, {
    userAgents: userAgents/* userAgents */.R
  }));
}, 'algolia');
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-js/dist/esm/requesters/getAlgoliaResults.js

/**
 * Retrieves Algolia results from multiple indices.
 */

var getAlgoliaResults = createAlgoliaRequester({
  transformResponse: function transformResponse(response) {
    return response.hits;
  }
});

/***/ }),

/***/ 500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ userAgents; }
/* harmony export */ });
/* harmony import */ var _algolia_autocomplete_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3269);

var userAgents = [{
  segment: 'autocomplete-js',
  version: _algolia_autocomplete_shared__WEBPACK_IMPORTED_MODULE_0__/* .version */ .i
}];

/***/ }),

/***/ 323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ createLocalStorageRecentSearchesPlugin; }
});

;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/constants.js
var LOCAL_STORAGE_KEY = 'AUTOCOMPLETE_RECENT_SEARCHES';
var LOCAL_STORAGE_KEY_TEST = '__AUTOCOMPLETE_RECENT_SEARCHES_PLUGIN_TEST_KEY__';
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/getLocalStorage.js


function isLocalStorageSupported() {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY_TEST, '');
    localStorage.removeItem(LOCAL_STORAGE_KEY_TEST);
    return true;
  } catch (error) {
    return false;
  }
}

function getLocalStorage(_ref) {
  var key = _ref.key;

  if (!isLocalStorageSupported()) {
    return {
      setItem: function setItem() {},
      getItem: function getItem() {
        return [];
      }
    };
  }

  return {
    setItem: function setItem(items) {
      return window.localStorage.setItem(key, JSON.stringify(items));
    },
    getItem: function getItem() {
      var items = window.localStorage.getItem(key);
      return items ? JSON.parse(items) : [];
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/createLocalStorage.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


function createLocalStorage(_ref) {
  var key = _ref.key,
      limit = _ref.limit,
      search = _ref.search;
  var storage = getLocalStorage({
    key: key
  });
  return {
    onAdd: function onAdd(item) {
      storage.setItem([item].concat(_toConsumableArray(storage.getItem())));
    },
    onRemove: function onRemove(id) {
      storage.setItem(storage.getItem().filter(function (x) {
        return x.id !== id;
      }));
    },
    getAll: function getAll() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return search({
        query: query,
        items: storage.getItem(),
        limit: limit
      }).slice(0, limit);
    }
  };
}
// EXTERNAL MODULE: ./node_modules/@algolia/autocomplete-shared/dist/esm/createRef.js
var createRef = __webpack_require__(5236);
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/createStorageApi.js
function createStorageApi(storage) {
  return {
    addItem: function addItem(item) {
      storage.onRemove(item.id);
      storage.onAdd(item);
    },
    removeItem: function removeItem(id) {
      storage.onRemove(id);
    },
    getAll: function getAll(query) {
      return storage.getAll(query);
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/getTemplates.js
/** @jsxRuntime classic */

/** @jsx createElement */
function getTemplates(_ref) {
  var onRemove = _ref.onRemove,
      onTapAhead = _ref.onTapAhead;
  return {
    item: function item(_ref2) {
      var item = _ref2.item,
          createElement = _ref2.createElement,
          components = _ref2.components;
      return createElement("div", {
        className: "aa-ItemWrapper"
      }, createElement("div", {
        className: "aa-ItemContent"
      }, createElement("div", {
        className: "aa-ItemIcon aa-ItemIcon--noBorder"
      }, createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, createElement("path", {
        d: "M12.516 6.984v5.25l4.5 2.672-0.75 1.266-5.25-3.188v-6h1.5zM12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93z"
      }))), createElement("div", {
        className: "aa-ItemContentBody"
      }, createElement("div", {
        className: "aa-ItemContentTitle"
      }, createElement(components.ReverseHighlight, {
        hit: item,
        attribute: "label"
      }), item.category && createElement("span", {
        className: "aa-ItemContentSubtitle aa-ItemContentSubtitle--inline"
      }, createElement("span", {
        className: "aa-ItemContentSubtitleIcon"
      }), " in", ' ', createElement("span", {
        className: "aa-ItemContentSubtitleCategory"
      }, item.category))))), createElement("div", {
        className: "aa-ItemActions"
      }, createElement("button", {
        className: "aa-ItemActionButton",
        title: "Remove this search",
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onRemove(item.id);
        }
      }, createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, createElement("path", {
        d: "M18 7v13c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-10c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-13zM17 5v-1c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-4c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v1h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v13c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h10c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-13h1c0.552 0 1-0.448 1-1s-0.448-1-1-1zM9 5v-1c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h4c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v1zM9 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1zM13 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1z"
      }))), createElement("button", {
        className: "aa-ItemActionButton",
        title: "Fill query with \"".concat(item.label, "\""),
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onTapAhead(item);
        }
      }, createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, createElement("path", {
        d: "M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z"
      })))));
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/createRecentSearchesPlugin.js
function createRecentSearchesPlugin_toConsumableArray(arr) { return createRecentSearchesPlugin_arrayWithoutHoles(arr) || createRecentSearchesPlugin_iterableToArray(arr) || createRecentSearchesPlugin_unsupportedIterableToArray(arr) || createRecentSearchesPlugin_nonIterableSpread(); }

function createRecentSearchesPlugin_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function createRecentSearchesPlugin_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return createRecentSearchesPlugin_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createRecentSearchesPlugin_arrayLikeToArray(o, minLen); }

function createRecentSearchesPlugin_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function createRecentSearchesPlugin_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return createRecentSearchesPlugin_arrayLikeToArray(arr); }

function createRecentSearchesPlugin_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function getDefaultSubscribe(store) {
  return function subscribe(_ref) {
    var onSelect = _ref.onSelect;
    onSelect(function (_ref2) {
      var item = _ref2.item,
          state = _ref2.state,
          source = _ref2.source;
      var inputValue = source.getItemInputValue({
        item: item,
        state: state
      });

      if (source.sourceId === 'querySuggestionsPlugin' && inputValue) {
        var recentItem = {
          id: inputValue,
          label: inputValue,
          category: item.__autocomplete_qsCategory
        };
        store.addItem(recentItem);
      }
    });
  };
}

function createRecentSearchesPlugin(options) {
  var _getOptions = getOptions(options),
      storage = _getOptions.storage,
      transformSource = _getOptions.transformSource,
      subscribe = _getOptions.subscribe;

  var store = createStorageApi(storage);
  var lastItemsRef = (0,createRef/* createRef */.V)([]);
  return {
    name: 'aa.recentSearchesPlugin',
    subscribe: subscribe !== null && subscribe !== void 0 ? subscribe : getDefaultSubscribe(store),
    onSubmit: function onSubmit(_ref3) {
      var state = _ref3.state;
      var query = state.query;

      if (query) {
        var recentItem = {
          id: query,
          label: query
        };
        store.addItem(recentItem);
      }
    },
    getSources: function getSources(_ref4) {
      var query = _ref4.query,
          setQuery = _ref4.setQuery,
          refresh = _ref4.refresh,
          state = _ref4.state;
      lastItemsRef.current = store.getAll(query);

      function onRemove(id) {
        store.removeItem(id);
        refresh();
      }

      function onTapAhead(item) {
        setQuery(item.label);
        refresh();
      }

      return Promise.resolve(lastItemsRef.current).then(function (items) {
        if (items.length === 0) {
          return [];
        }

        return [transformSource({
          source: {
            sourceId: 'recentSearchesPlugin',
            getItemInputValue: function getItemInputValue(_ref5) {
              var item = _ref5.item;
              return item.label;
            },
            getItems: function getItems() {
              return items;
            },
            templates: getTemplates({
              onRemove: onRemove,
              onTapAhead: onTapAhead
            })
          },
          onRemove: onRemove,
          onTapAhead: onTapAhead,
          state: state
        })];
      });
    },
    data: _objectSpread(_objectSpread({}, store), {}, {
      // @ts-ignore SearchOptions `facetFilters` is ReadonlyArray
      getAlgoliaSearchParams: function getAlgoliaSearchParams() {
        var _params$facetFilters, _params$hitsPerPage;

        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        // If the items returned by `store.getAll` are contained in a Promise,
        // we cannot provide the search params in time when this function is called
        // because we need to resolve the promise before getting the value.
        if (!Array.isArray(lastItemsRef.current)) {
           false ? 0 : void 0;
          return params;
        }

        return _objectSpread(_objectSpread({}, params), {}, {
          facetFilters: [].concat(createRecentSearchesPlugin_toConsumableArray((_params$facetFilters = params.facetFilters) !== null && _params$facetFilters !== void 0 ? _params$facetFilters : []), createRecentSearchesPlugin_toConsumableArray(lastItemsRef.current.map(function (item) {
            return ["objectID:-".concat(item.label)];
          }))),
          hitsPerPage: Math.max(1, ((_params$hitsPerPage = params.hitsPerPage) !== null && _params$hitsPerPage !== void 0 ? _params$hitsPerPage : 10) - lastItemsRef.current.length)
        });
      }
    }),
    __autocomplete_pluginOptions: options
  };
}

function getOptions(options) {
  return _objectSpread({
    transformSource: function transformSource(_ref6) {
      var source = _ref6.source;
      return source;
    }
  }, options);
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/addHighlightedAttribute.js
function addHighlightedAttribute_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function addHighlightedAttribute_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? addHighlightedAttribute_ownKeys(Object(source), !0).forEach(function (key) { addHighlightedAttribute_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : addHighlightedAttribute_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function addHighlightedAttribute_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function addHighlightedAttribute(_ref) {
  var item = _ref.item,
      query = _ref.query;
  return addHighlightedAttribute_objectSpread(addHighlightedAttribute_objectSpread({}, item), {}, {
    _highlightResult: {
      label: {
        value: query ? item.label.replace(new RegExp(query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'), function (match) {
          return "__aa-highlight__".concat(match, "__/aa-highlight__");
        }) : item.label
      }
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/search.js

function search(_ref) {
  var query = _ref.query,
      items = _ref.items,
      limit = _ref.limit;

  if (!query) {
    return items.slice(0, limit).map(function (item) {
      return addHighlightedAttribute({
        item: item,
        query: query
      });
    });
  }

  return items.filter(function (item) {
    return item.label.toLowerCase().includes(query.toLowerCase());
  }).slice(0, limit).map(function (item) {
    return addHighlightedAttribute({
      item: item,
      query: query
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/@algolia/autocomplete-plugin-recent-searches/dist/esm/createLocalStorageRecentSearchesPlugin.js
function createLocalStorageRecentSearchesPlugin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createLocalStorageRecentSearchesPlugin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createLocalStorageRecentSearchesPlugin_ownKeys(Object(source), !0).forEach(function (key) { createLocalStorageRecentSearchesPlugin_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createLocalStorageRecentSearchesPlugin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function createLocalStorageRecentSearchesPlugin_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function createLocalStorageRecentSearchesPlugin(options) {
  var _getOptions = createLocalStorageRecentSearchesPlugin_getOptions(options),
      key = _getOptions.key,
      limit = _getOptions.limit,
      transformSource = _getOptions.transformSource,
      search = _getOptions.search,
      subscribe = _getOptions.subscribe;

  var storage = createLocalStorage({
    key: [LOCAL_STORAGE_KEY, key].join(':'),
    limit: limit,
    search: search
  });
  var recentSearchesPlugin = createRecentSearchesPlugin({
    transformSource: transformSource,
    storage: storage,
    subscribe: subscribe
  });
  return createLocalStorageRecentSearchesPlugin_objectSpread(createLocalStorageRecentSearchesPlugin_objectSpread({}, recentSearchesPlugin), {}, {
    name: 'aa.localStorageRecentSearchesPlugin',
    __autocomplete_pluginOptions: options
  });
}

function createLocalStorageRecentSearchesPlugin_getOptions(options) {
  return createLocalStorageRecentSearchesPlugin_objectSpread({
    limit: 5,
    search: search,
    transformSource: function transformSource(_ref) {
      var source = _ref.source;
      return source;
    }
  }, options);
}

/***/ }),

/***/ 8786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ HIGHLIGHT_PRE_TAG; },
/* harmony export */   "Z": function() { return /* binding */ HIGHLIGHT_POST_TAG; }
/* harmony export */ });
var HIGHLIGHT_PRE_TAG = '__aa-highlight__';
var HIGHLIGHT_POST_TAG = '__/aa-highlight__';

/***/ }),

/***/ 5236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ createRef; }
/* harmony export */ });
function createRef(initialValue) {
  return {
    current: initialValue
  };
}

/***/ }),

/***/ 3448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ userAgents; }
/* harmony export */ });
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3269);

var userAgents = [{
  segment: 'autocomplete-core',
  version: _version__WEBPACK_IMPORTED_MODULE_0__/* .version */ .i
}];

/***/ }),

/***/ 3269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ version; }
/* harmony export */ });
var version = '1.8.3';

/***/ }),

/***/ 2814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ FontAwesomeIcon; }
});

;// CONCATENATED MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
/*!
 * Font Awesome Free 6.1.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit',
  'fa': 'solid'
};
var STYLE_TO_PREFIX = {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
};
var PREFIX_TO_LONG_STYLE = {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
};
var LONG_STYLE_TO_PREFIX = {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk]?[\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var RESERVED_CLASSES = [].concat(_toConsumableArray(Object.keys(STYLE_TO_PREFIX)), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: 'solid',
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.1.2\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);

  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }

  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var index_es_layer = api.layer;
var index_es_text = api.text;
var counter = api.counter;



// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js




function index_es_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function index_es_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? index_es_ownKeys(Object(source), !0).forEach(function (key) {
      index_es_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : index_es_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function index_es_typeof(obj) {
  "@babel/helpers - typeof";

  return index_es_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, index_es_typeof(obj);
}

function index_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function index_es_toConsumableArray(arr) {
  return index_es_arrayWithoutHoles(arr) || index_es_iterableToArray(arr) || index_es_unsupportedIterableToArray(arr) || index_es_nonIterableSpread();
}

function index_es_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return index_es_arrayLikeToArray(arr);
}

function index_es_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function index_es_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return index_es_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return index_es_arrayLikeToArray(o, minLen);
}

function index_es_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function index_es_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, index_es_defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), index_es_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), index_es_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), index_es_defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded);

  mixins.attrs['style'] = index_es_objectSpread2(index_es_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, index_es_objectSpread2(index_es_objectSpread2({}, mixins.attrs), remaining)].concat(index_es_toConsumableArray(children)));
}

var index_es_PRODUCTION = false;

try {
  index_es_PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!index_es_PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && index_es_typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (parse$1.icon) {
    return parse$1.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && index_es_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? index_es_defineProperty({}, key, value) : {};
}

var FontAwesomeIcon = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(index_es_toConsumableArray(classList(props)), index_es_toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse$1.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, index_es_objectSpread2(index_es_objectSpread2(index_es_objectSpread2(index_es_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: ref
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: (prop_types_default()).bool,
  border: (prop_types_default()).bool,
  beatFade: (prop_types_default()).bool,
  bounce: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  fade: (prop_types_default()).bool,
  flash: (prop_types_default()).bool,
  mask: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).array, (prop_types_default()).string]),
  maskId: (prop_types_default()).string,
  fixedWidth: (prop_types_default()).bool,
  inverse: (prop_types_default()).bool,
  flip: prop_types_default().oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).array, (prop_types_default()).string]),
  listItem: (prop_types_default()).bool,
  pull: prop_types_default().oneOf(['right', 'left']),
  pulse: (prop_types_default()).bool,
  rotation: prop_types_default().oneOf([0, 90, 180, 270]),
  shake: (prop_types_default()).bool,
  size: prop_types_default().oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: (prop_types_default()).bool,
  spinPulse: (prop_types_default()).bool,
  spinReverse: (prop_types_default()).bool,
  symbol: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  title: (prop_types_default()).string,
  titleId: (prop_types_default()).string,
  transform: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).object]),
  swapOpacity: (prop_types_default()).bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, react.createElement);




/***/ }),

/***/ 9816:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 3866:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else{var i=t.name;v[i]=t,r=i}return!n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));

/***/ }),

/***/ 6239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,o){ true?module.exports=o(__webpack_require__(3866)):0}(this,(function(e){"use strict";function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(e),d={name:"es",monthsShort:"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),weekStart:1,formats:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinal:function(e){return e+"º"}};return s.default.locale(d,null,!0),d}));

/***/ }),

/***/ 850:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e="day";return function(t,i,s){var a=function(t){return t.add(4-t.isoWeekday(),e)},d=i.prototype;d.isoWeekYear=function(){return a(this).year()},d.isoWeek=function(t){if(!this.$utils().u(t))return this.add(7*(t-this.isoWeek()),e);var i,d,n,o,r=a(this),u=(i=this.isoWeekYear(),d=this.$u,n=(d?s.utc:s)().year(i).startOf("year"),o=4-n.isoWeekday(),n.isoWeekday()>4&&(o+=7),n.add(o,e));return r.diff(u,"week")+1},d.isoWeekday=function(e){return this.$utils().u(e)?this.day()||7:this.day(this.day()%7?e:e-7)};var n=d.startOf;d.startOf=function(e,t){var i=this.$utils(),s=!!i.u(t)||t;return"isoweek"===i.p(e)?s?this.date(this.date()-(this.isoWeekday()-1)).startOf("day"):this.date(this.date()-1-(this.isoWeekday()-1)+7).endOf("day"):n.bind(this)(e,t)}}}));

/***/ }),

/***/ 1246:
/***/ (function(module) {

!function(r,e){ true?module.exports=e():0}(this,(function(){"use strict";return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return"function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)}}}));

/***/ }),

/***/ 160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": function() { return /* binding */ f; },
/* harmony export */   "Zb": function() { return /* binding */ h; },
/* harmony export */   "lE": function() { return /* binding */ t; },
/* harmony export */   "qY": function() { return /* binding */ r; }
/* harmony export */ });
/* unused harmony exports ACADEMY, B2B, B2B_TYPE, EXPERT, EXPERT_PLUS, LG_BREAKPOINT, PAYMENT_METHOD_IMG, PAYMENT_METHOD_IMG_LIGHT, PLAN_ACADEMY, PLAN_BASIC, PLAN_ENTERPRISE, PLAN_EXPERT, PLAN_EXPERT_DUO, PLAN_FAMILY, PLAN_FREE, USER_TYPE, XS_BREAKPOINT, b2bEmailRegex, nameRegex */
const a={amex:"https://static.platzi.com/commons/assets/images/amex8c702aae174e8d5b.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty91f6cb277fa29fea.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivod8f46b2bdaf56e7f.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil5df441661803d43a.png",paypal:"https://static.platzi.com/commons/assets/images/paypalbc538ab7210a384a.png",pse:"https://static.platzi.com/commons/assets/images/psebb0ce4c4463aa51b.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago1001d95e1020bdf8.png",visa:"https://static.platzi.com/commons/assets/images/visa52d765334f273be7.png",sencillito:"https://static.platzi.com/commons/assets/images/sencillitof1aa0eb82ecec56d.png",servipag:"https://static.platzi.com/commons/assets/images/servipage7972ff9af0f8a91.png"};const s={amex:"https://static.platzi.com/commons/assets/images/amexda647adf95f30924.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty22311be7d0475e8f.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivo39a4341bf1f15d31.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil632781fca2af5541.png",paypal:"https://static.platzi.com/commons/assets/images/paypal03ae8e5a43fc2f23.png",pse:"https://static.platzi.com/commons/assets/images/pse3962764fe3faa4ea.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago3cefa48fe3375a12.png",visa:"https://static.platzi.com/commons/assets/images/visa91625977f7206bc0.png"},t={SPANISH_CO:"es-CO",SPANISH_ES:"es-ES",PORTUGUESE:"pt",ENGLISH:"en"},e="monthly_plan",o="expert_plan",i="annual_plan",m="platzi_academy",p="family_plan",c="free_plan",n="enterprise",g="user",l="b2b",f=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,b=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?!(?:hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|live))((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,d=/^[a-zA-Z\s]*$/,z=480,h=768,r=1024,v=1200,x="Platzi Expert",_="Platzi Expert+",y="Plan Empresarial",A="Platzi English Academy";


/***/ }),

/***/ 3099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ index_e9a6ce7d_m; },
  "c": function() { return /* binding */ R; }
});

// UNUSED EXPORTS: S, b, d, i, v

// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/axiosInstance-6d2f1e6e.js
var axiosInstance_6d2f1e6e = __webpack_require__(6905);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 7 modules
var i18next = __webpack_require__(5751);
;// CONCATENATED MODULE: ./node_modules/@platzi/commons/dist/es/apiCalls-c0fe2c19.js
const e={middlewares:{verifyUser:"/api/v3/users/is-authenticated/",studentHomeAccess:"/api/v3/users/has-new-home-stundents/",isBetaTester:"/api/v3/users/is-organizer-beta-tester/",enterpriseActivationsAccess:e=>`/api/v3/enterprise/${e}/permissions/can-access-enterprise-activations/`,orgCanAccess:"/api/v3/users/is-es-organization/"},header:"/api/bff/org/header/",home:"/api/bff/web/home/",conf:e=>`/api/v4/conferences/${e}/`,contact:"/api/bff/web/contact-info/",metatags:e=>`/api/bff/org/meta-tags/${e}/`,userLp:"/api/v3/users-learning-paths/",categories:"/api/v3/categories/",b2bDashboard:e=>`/api/v3/companies/${e}/dashboard/overview/`,studentLearningPaths:"/api/v4/user-learning-paths/",studentCategories:"/api/v3/home-user-custom-catalog/",enterpriseActivationsMenu:e=>`/api/v3/enterprise/${e}/menu/`,deals:"/entrenamiento-google/code/",recentLaunches:"/api/v4/recent-launches/",getSchools:"/api/v4/schools-list/",promos:e=>`/api/v4/promo/${e}/`},apiCalls_c0fe2c19_s={auth:{credentials:"/api/v3/users/credentials/",liveCredentials:e=>`/api/v4/live-credentials/${e}/`},preRegister:"/api/v4/preregister-countdown/",registerB2B:"/empresas/",courses:{manualCourses:"/api/v3/courses/user-manual-courses/",privateCourses:"/api/v3/courses/user-private-courses/",bougthCourses:"/api/v3/courses/user-purchased-courses/",getNewCourses:"/api/v3/courses/new-courses/"},users:{statsUrl:"/api/v3/users/stats/",getAlerts:"/api/v3/users/notifications/",mailVerified:"/api/v3/users/mail-verified/"},materials:{getMaterialProgress:"/api/v3/materials/progress/",removeLatestMaterial:e=>`/api/v3/materials/${e}/remove-latest/`},categories:{getCategories:"/api/v3/categories/"},learningPaths:{getUserLp:"/api/v3/learning-paths/",deleteLp:e=>`/api/v3/users-learning-paths/${e}/`,addLp:e=>`/api/v3/users-learning-paths/${e}/assign/`,availableForAdition:e=>`/api/v4/user-learning-paths/get-lps-available/${e}/`},live:{checkLive:"api/v1/lives/"},notifications:{getHomeFeed:e=>`/api/v3/home-feed/?page=${e}`},recommendations:{courses:"/api/v3/users/recommendations/"},discussions:{like:"/api/v3/home-feed/toggle-star/"},homeCatalog:{categoryDetail:e=>`/api/v3/home-catalog/?category=${e}`,categoryLearningPathDetail:e=>`/api/v3/home-catalog/${e}/`},homeUserCatalog:{studentLearningPathDetail:e=>`/api/v3/home-user-catalog/${e}/`,deleteCourse:()=>"/api/v3/home-user-custom-catalog/course/",addCourse:()=>"/api/v3/home-user-custom-catalog/course/"},globalSearch:e=>`/global-search/?search=${e}`,billing:{getInfo:()=>"/api/v3/payment-data/",saveInfo:()=>"/api/v3/billing-data/"},geo:{getStates:()=>"/api/bff/geo/states/",getCities:e=>`/api/bff/geo/municipalities/${e}/`},conf:{registration:(e,s)=>`/api/v4/conferences/${e}/register/?ticket_type=${s}`},deals:{submitCode:()=>"/entrenamiento-google/code/",registerData:()=>"/entrenamiento-google/data/"},platziDay:()=>"/api/v4/progress/courses/get_progress_platzi_day/",getBenefitiaryProgress:e=>`/api/v4/progress/courses/beneficiary-progress/${e}/`,sif:{tracking:"/api/v1/tracking/"},user:{getUserInfo:"/api/v1/components/headerv2/user/",isAccountless:"/api/v3/users/accountless/"}};

;// CONCATENATED MODULE: ./node_modules/@platzi/commons/dist/es/index-8d56a83f.js
var index_8d56a83f_e,n,r,t,o,a,i,u,c,f,s,l,index_8d56a83f_p={exports:{}},y={exports:{}},d={};function m(){return n?y.exports:(n=1,y.exports=(index_8d56a83f_e||(index_8d56a83f_e=1,function(){var e="function"==typeof Symbol&&Symbol.for,n=e?Symbol.for("react.element"):60103,r=e?Symbol.for("react.portal"):60106,t=e?Symbol.for("react.fragment"):60107,o=e?Symbol.for("react.strict_mode"):60108,a=e?Symbol.for("react.profiler"):60114,i=e?Symbol.for("react.provider"):60109,u=e?Symbol.for("react.context"):60110,c=e?Symbol.for("react.async_mode"):60111,f=e?Symbol.for("react.concurrent_mode"):60111,s=e?Symbol.for("react.forward_ref"):60112,l=e?Symbol.for("react.suspense"):60113,p=e?Symbol.for("react.suspense_list"):60120,y=e?Symbol.for("react.memo"):60115,m=e?Symbol.for("react.lazy"):60116,b=e?Symbol.for("react.block"):60121,v=e?Symbol.for("react.fundamental"):60117,h=e?Symbol.for("react.responder"):60118,g=e?Symbol.for("react.scope"):60119;function w(e){if("object"==typeof e&&null!==e){var p=e.$$typeof;switch(p){case n:var d=e.type;switch(d){case c:case f:case t:case a:case o:case l:return d;default:var b=d&&d.$$typeof;switch(b){case u:case s:case m:case y:case i:return b;default:return p}}case r:return p}}}var O=c,S=f,x=u,j=i,T=n,E=s,I=t,P=m,$=y,k=r,R=a,A=o,C=l,_=!1;function M(e){return w(e)===f}d.AsyncMode=O,d.ConcurrentMode=S,d.ContextConsumer=x,d.ContextProvider=j,d.Element=T,d.ForwardRef=E,d.Fragment=I,d.Lazy=P,d.Memo=$,d.Portal=k,d.Profiler=R,d.StrictMode=A,d.Suspense=C,d.isAsyncMode=function(e){return _||(_=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),M(e)||w(e)===c},d.isConcurrentMode=M,d.isContextConsumer=function(e){return w(e)===u},d.isContextProvider=function(e){return w(e)===i},d.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===n},d.isForwardRef=function(e){return w(e)===s},d.isFragment=function(e){return w(e)===t},d.isLazy=function(e){return w(e)===m},d.isMemo=function(e){return w(e)===y},d.isPortal=function(e){return w(e)===r},d.isProfiler=function(e){return w(e)===a},d.isStrictMode=function(e){return w(e)===o},d.isSuspense=function(e){return w(e)===l},d.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===t||e===f||e===a||e===o||e===l||e===p||"object"==typeof e&&null!==e&&(e.$$typeof===m||e.$$typeof===y||e.$$typeof===i||e.$$typeof===u||e.$$typeof===s||e.$$typeof===v||e.$$typeof===h||e.$$typeof===g||e.$$typeof===b)},d.typeOf=w}()),d))}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/function b(){if(a)return o;a=1;return o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function v(){return u?i:(u=1,i=Function.call.bind(Object.prototype.hasOwnProperty))}var h=m();index_8d56a83f_p.exports=function(){if(l)return s;l=1;var e,n=m(),o=function(){if(t)return r;t=1;var e=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;function a(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}return r=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var n={},r=0;r<10;r++)n["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(n).map((function(e){return n[e]})).join(""))return!1;var t={};return"abcdefghijklmnopqrst".split("").forEach((function(e){t[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},t)).join("")}catch(e){return!1}}()?Object.assign:function(r,t){for(var i,u,c=a(r),f=1;f<arguments.length;f++){for(var s in i=Object(arguments[f]))n.call(i,s)&&(c[s]=i[s]);if(e){u=e(i);for(var l=0;l<u.length;l++)o.call(i,u[l])&&(c[u[l]]=i[u[l]])}}return c},r}(),a=b(),i=v(),u=function(){if(f)return c;f=1;var e,n=b(),r={},t=v();function o(o,a,i,u,c){for(var f in o)if(t(o,f)){var s;try{if("function"!=typeof o[f]){var l=Error((u||"React class")+": "+i+" type `"+f+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof o[f]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw l.name="Invariant Violation",l}s=o[f](a,f,u,i,null,n)}catch(e){s=e}if(!s||s instanceof Error||e((u||"React class")+": type specification of "+i+" `"+f+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof s+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),s instanceof Error&&!(s.message in r)){r[s.message]=!0;var p=c?c():"";e("Failed "+i+" type: "+s.message+(null!=p?p:""))}}}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},o.resetWarningCache=function(){r={}},c=o}();function p(){return null}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},s=function(r,t){var c="function"==typeof Symbol&&Symbol.iterator,f="<<anonymous>>",s={array:m("array"),bigint:m("bigint"),bool:m("boolean"),func:m("function"),number:m("number"),object:m("object"),string:m("string"),symbol:m("symbol"),any:d(p),arrayOf:function(e){return d((function(n,r,t,o,i){if("function"!=typeof e)return new y("Property `"+i+"` of component `"+t+"` has invalid PropType notation inside arrayOf.");var u=n[r];if(!Array.isArray(u))return new y("Invalid "+o+" `"+i+"` of type `"+h(u)+"` supplied to `"+t+"`, expected an array.");for(var c=0;c<u.length;c++){var f=e(u,c,t,o,i+"["+c+"]",a);if(f instanceof Error)return f}return null}))},element:d((function(e,n,t,o,a){var i=e[n];return r(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement.")})),elementType:d((function(e,r,t,o,a){var i=e[r];return n.isValidElementType(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement type.")})),instanceOf:function(e){return d((function(n,r,t,o,a){if(!(n[r]instanceof e)){var i=e.name||f;return new y("Invalid "+o+" `"+a+"` of type `"+((u=n[r]).constructor&&u.constructor.name?u.constructor.name:f)+"` supplied to `"+t+"`, expected instance of `"+i+"`.")}var u;return null}))},node:d((function(e,n,r,t,o){return v(e[n])?null:new y("Invalid "+t+" `"+o+"` supplied to `"+r+"`, expected a ReactNode.")})),objectOf:function(e){return d((function(n,r,t,o,u){if("function"!=typeof e)return new y("Property `"+u+"` of component `"+t+"` has invalid PropType notation inside objectOf.");var c=n[r],f=h(c);if("object"!==f)return new y("Invalid "+o+" `"+u+"` of type `"+f+"` supplied to `"+t+"`, expected an object.");for(var s in c)if(i(c,s)){var l=e(c,s,t,o,u+"."+s,a);if(l instanceof Error)return l}return null}))},oneOf:function(n){if(!Array.isArray(n))return e(arguments.length>1?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array."),p;function r(e,r,t,o,a){for(var i=e[r],u=0;u<n.length;u++)if(l(i,n[u]))return null;var c=JSON.stringify(n,(function(e,n){return"symbol"===g(n)?String(n):n}));return new y("Invalid "+o+" `"+a+"` of value `"+String(i)+"` supplied to `"+t+"`, expected one of "+c+".")}return d(r)},oneOfType:function(n){if(!Array.isArray(n))return e("Invalid argument supplied to oneOfType, expected an instance of array."),p;for(var r=0;r<n.length;r++){var t=n[r];if("function"!=typeof t)return e("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+w(t)+" at index "+r+"."),p}return d((function(e,r,t,o,u){for(var c=[],f=0;f<n.length;f++){var s=(0,n[f])(e,r,t,o,u,a);if(null==s)return null;s.data&&i(s.data,"expectedType")&&c.push(s.data.expectedType)}return new y("Invalid "+o+" `"+u+"` supplied to `"+t+"`"+(c.length>0?", expected one of type ["+c.join(", ")+"]":"")+".")}))},shape:function(e){return d((function(n,r,t,o,i){var u=n[r],c=h(u);if("object"!==c)return new y("Invalid "+o+" `"+i+"` of type `"+c+"` supplied to `"+t+"`, expected `object`.");for(var f in e){var s=e[f];if("function"!=typeof s)return b(t,o,i,f,g(s));var l=s(u,f,t,o,i+"."+f,a);if(l)return l}return null}))},exact:function(e){return d((function(n,r,t,u,c){var f=n[r],s=h(f);if("object"!==s)return new y("Invalid "+u+" `"+c+"` of type `"+s+"` supplied to `"+t+"`, expected `object`.");var l=o({},n[r],e);for(var p in l){var d=e[p];if(i(e,p)&&"function"!=typeof d)return b(t,u,c,p,g(d));if(!d)return new y("Invalid "+u+" `"+c+"` key `"+p+"` supplied to `"+t+"`.\nBad object: "+JSON.stringify(n[r],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var m=d(f,p,t,u,c+"."+p,a);if(m)return m}return null}))}};function l(e,n){return e===n?0!==e||1/e==1/n:e!=e&&n!=n}function y(e,n){this.message=e,this.data=n&&"object"==typeof n?n:{},this.stack=""}function d(n){var r={},o=0;function i(i,u,c,s,l,p,d){if(s=s||f,p=p||c,d!==a){if(t){var m=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw m.name="Invariant Violation",m}if("undefined"!=typeof console){var b=s+":"+c;!r[b]&&o<3&&(e("You are manually calling a React.PropTypes validation function for the `"+p+"` prop on `"+s+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),r[b]=!0,o++)}}return null==u[c]?i?null===u[c]?new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `null`."):new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `undefined`."):null:n(u,c,s,l,p)}var u=i.bind(null,!1);return u.isRequired=i.bind(null,!0),u}function m(e){return d((function(n,r,t,o,a,i){var u=n[r];return h(u)!==e?new y("Invalid "+o+" `"+a+"` of type `"+g(u)+"` supplied to `"+t+"`, expected `"+e+"`.",{expectedType:e}):null}))}function b(e,n,r,t,o){return new y((e||"React class")+": "+n+" type `"+r+"."+t+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+o+"`.")}function v(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(v);if(null===e||r(e))return!0;var n=function(e){var n=e&&(c&&e[c]||e["@@iterator"]);if("function"==typeof n)return n}(e);if(!n)return!1;var t,o=n.call(e);if(n!==e.entries){for(;!(t=o.next()).done;)if(!v(t.value))return!1}else for(;!(t=o.next()).done;){var a=t.value;if(a&&!v(a[1]))return!1}return!0;default:return!1}}function h(e){var n=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":function(e,n){return"symbol"===e||!!n&&("Symbol"===n["@@toStringTag"]||"function"==typeof Symbol&&n instanceof Symbol)}(n,e)?"symbol":n}function g(e){if(null==e)return""+e;var n=h(e);if("object"===n){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return n}function w(e){var n=g(e);switch(n){case"array":case"object":return"an "+n;case"boolean":case"date":case"regexp":return"a "+n;default:return n}}return y.prototype=Error.prototype,s.checkPropTypes=u,s.resetWarningCache=u.resetWarningCache,s.PropTypes=s,s},s}()(h.isElement,!0);

// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(6245);
;// CONCATENATED MODULE: ./node_modules/@platzi/commons/dist/es/index-e9a6ce7d.js
var index_e9a6ce7d_h=Object.freeze({__proto__:null,ReactTranslationsHOC:t=>r=>{const{t:s,i18n:o}=(0,useTranslation/* useTranslation */.$)();return react.createElement(t,(0,axiosInstance_6d2f1e6e._)({},r,{t:s,i18n:o}))},translationsConfig:({messages:e,locale:t})=>{const r={[t]:{translations:e}};i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({resources:r,lng:t,fallbackLng:t,debug:!1,ns:["translations"],defaultNS:"translations",keySeparator:!1,interpolation:{escapeValue:!1}})}}),index_e9a6ce7d_m=Object.freeze({__proto__:null,serverApi:e,clientApi:apiCalls_c0fe2c19_s,axiosInstance:axiosInstance_6d2f1e6e.a,axiosServerInstance:axiosInstance_6d2f1e6e.b});const _=(0,react.createContext)(),E=(e,t)=>{switch(t.type){case"init":return{...e,token:t.payload.token,url:t.payload.url,headers:t.payload.headers||{}};case"track":case"visit":return{...e,lastEvent:t.payload.event}}return e},w={token:null,url:null,lastEvent:null},index_e9a6ce7d_v=({children:e})=>{const[r,s]=(0,react.useReducer)(E,w),n={init:async()=>{const e=await (0,axiosInstance_6d2f1e6e.a)(!0).get(apiCalls_c0fe2c19_s.auth.credentials),{token:r}=null==e?void 0:e.data,a={token:r.access,url:r.microservices.sif_url,headers:r.headers?r.headers:{}};s({type:"init",payload:a})},trackVisit:async(e,a)=>{const o={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},n={source:"web","user-agent":navigator.userAgent,properties:a},i={event:{...n,event:e}};await (0,axiosInstance_6d2f1e6e.a)(!1,o).post(apiCalls_c0fe2c19_s.sif.tracking,{...n,event:e}),s({type:"visit",payload:i})},track:async(e,a)=>{const o={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},n={source:"web",properties:a},i={event:{...n,event:e}};await (0,axiosInstance_6d2f1e6e.a)(!1,o).post(apiCalls_c0fe2c19_s.sif.tracking,{...n,event:e}),s({type:"track",payload:i})}};return react.createElement(_.Provider,{value:{sif:r,sifActions:n}},e)};index_e9a6ce7d_v.propTypes={children:index_8d56a83f_p.exports.node};const index_e9a6ce7d_f=async(e="credentials")=>{const t=localStorage.getItem(`${e}_token`),r=localStorage.getItem(`${e}_headers`),a=localStorage.getItem(`${e}_microservicesUrl`);return t&&a?{token:t,headers:JSON.parse(r),microservicesUrl:JSON.parse(a)}:await index_e9a6ce7d_y(e)},index_e9a6ce7d_y=async(e="credentials")=>{try{const r=await (0,axiosInstance_6d2f1e6e.a)(!0).get("credentials"===e?apiCalls_c0fe2c19_s.auth.credentials:apiCalls_c0fe2c19_s.auth.liveCredentials(e)),{token:{access:a,headers:s,microservices:o}}=r.data;return await localStorage.setItem(`${e}_token`,a),await localStorage.setItem(`${e}_headers`,JSON.stringify(r.data.token.headers?s:{})),await localStorage.setItem(`${e}_microservicesUrl`,JSON.stringify(r.data.token.microservices?r.data.token.microservices:{})),await{token:a,headers:s,microservicesUrl:o}}catch(e){throw new Error({type:"::ERROR::CLIENT_REQUEST_CREDENTIALS_REFRESH_TOKEN",error:e})}},g=async(e="credentials")=>{const t=localStorage.getItem(`${e}_token`);if(!t)return await index_e9a6ce7d_f(e);const{exp:r}=p(t);return Date.now()>=1e3*r?await index_e9a6ce7d_y(e):void 0},R=async(e,t,r="credentials")=>{let a=await index_e9a6ce7d_f(r);void 0===a.microservicesUrl[`${e}_url`]&&(a=await index_e9a6ce7d_y(r));const s={baseURL:`${a.microservicesUrl[`${e}_url`]}`,headers:k(a.token,a.headers)};return await S(0,s,t,r,e)},S=async(e,r,a,s="credentials",o)=>{if(e>=3)return new Promise(((e,t)=>{e({})}));{const{requestURL:i,payload:c,method:l}=a;try{const e=await (0,axiosInstance_6d2f1e6e.a)(!1,r)[l](i,c);return await e.data}catch(t){var n;if(401===(null==t||null===(n=t.response)||void 0===n?void 0:n.status))return index_e9a6ce7d_y(s).then((t=>S(e+1,{...r,headers:k(t.token,t.headers),baseURL:`${t.microservicesUrl[`${o}_url`]}`},a,s,o).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_SEND_REQUEST",error:e})})))).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_REFRESH_TOKEN",error:e})}));throw new Error({type:"::ERROR::CLIENT_REQUEST_REQUEST",err:t})}}},k=(e,t)=>t==={}?{"API-Authorization":`Bearer ${e}`}:{"API-Authorization":`Bearer ${e}`,...t};var I=Object.freeze({__proto__:null,SIF:(e,t={},r=!1)=>{let a={source:"web",event:e,properties:t};if(r){const e=(()=>{let e={landing:window.location.href,meta_request_method:"GET",meta_path_info:location.pathname};document.referrer.length&&(e={...e,meta_http_referer:document.referrer}),location.search.length&&(e={...e,meta_query_string:location.search});const t=new URLSearchParams(window.location.search);for(const r of t)r[0].includes("utm_")&&(e={...e,[r[0]]:r[1]});return e})();a={...a,properties:{...t,...e},"user-agent":navigator.userAgent}}return a},GOSSIP:()=>{throw new Error("Not implemente yet!")},ENIGMA:()=>{throw new Error("Not implemente yet!")}});


/***/ }),

/***/ 9998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ d; },
/* harmony export */   "b": function() { return /* binding */ r; }
/* harmony export */ });
/* unused harmony exports c, d, g, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
const n=o=>{const[n,t]=e(o);return{value:n,onChange:e=>t(e.target.value)}},t="undefined"!=typeof window,i=()=>({width:t?window.innerWidth:void 0,height:t?window.innerHeight:void 0}),d=()=>{const[n,d]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(i());return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{const e=()=>{d(i())};return t?(window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}):null}),[]),n},r=(n,t)=>{if("undefined"==typeof window)return[t,null];const[i,d]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((()=>window.localStorage.getItem(n)||t));return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{window.localStorage.setItem(n,i)}),[n,i]),[i,d]},a=e=>"undefined"!=typeof document&&document.cookie.split(";").some((o=>o.trim().startsWith(`${e}=`))),c=(e,o,n)=>document.cookie=`${e}=${o}; max-age=${n}`,s=e=>{const o="undefined"!=typeof document&&document.cookie.match(new RegExp("(?:^|; )"+e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g,"\\$1")+"=([^;]*)"));return o?decodeURIComponent(o[1]):void 0},w=()=>({checkCookie:a,setCookie:c,getCookie:s}),u=n=>{const[t,i]=e("");return o((()=>{if("undefined"!=typeof window){const e=new URLSearchParams(window.location.search);i(e.get(n))}}),[]),{variable:t}};


/***/ }),

/***/ 9122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vZ": function() { return /* binding */ es_oa; }
});

// UNUSED EXPORTS: BenefitsTable, BenefitsTableContainer, ExtraBenefits, Plan, PlanCard, PlanResponsive, PlanUtils, StudentSelector, default

// NAMESPACE OBJECT: ./node_modules/@platzi/icons/dist/esm/index.js
var esm_namespaceObject = {};
__webpack_require__.r(esm_namespaceObject);
__webpack_require__.d(esm_namespaceObject, {
  "K5": function() { return esm_m; },
  "a7": function() { return esm_w; },
  "_M": function() { return esm_x; },
  "x8": function() { return esm_R; },
  "A": function() { return H; },
  "mq": function() { return U; },
  "EI": function() { return T; },
  "w2": function() { return esm_I; },
  "fp": function() { return Y; },
  "Xq": function() { return esm_X; },
  "OV": function() { return esm_Z; },
  "BE": function() { return esm_ce; },
  "v0": function() { return ve; },
  "WF": function() { return esm_oe; },
  "j1": function() { return Ee; },
  "uM": function() { return Re; },
  "ol": function() { return esm_e; },
  "uj": function() { return ye; },
  "Mz": function() { return We; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.plans/node_modules/@platzi/commons/dist/es/constants.js
var constants_e={amex:"undefinedimages/amex8c702aae174e8d5b.png",baloto:"undefinedimages/baloto7621e7f822d4583d.png",banorte:"undefinedimages/banorte87e6a5073635d557.png",bitcoin:"undefinedimages/bitcoinadad1b8d54a97811.png",davivienda:"undefinedimages/davivienda5f0ce9d108e6b1ee.png",efecty:"undefinedimages/efecty91f6cb277fa29fea.png",mastercard:"undefinedimages/mastercardbf4ad752b3fb3d0e.png",oxxo:"undefinedimages/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"undefinedimages/pago_efectivod8f46b2bdaf56e7f.png",pago_facil:"undefinedimages/pago_facil5df441661803d43a.png",paypal:"undefinedimages/paypalbc538ab7210a384a.png",pse:"undefinedimages/psebb0ce4c4463aa51b.png",rapipago:"undefinedimages/rapipago1001d95e1020bdf8.png",visa:"undefinedimages/visa52d765334f273be7.png",sencillito:"undefinedimages/sencillitof1aa0eb82ecec56d.png",servipag:"undefinedimages/servipage7972ff9af0f8a91.png"};var constants_a={amex:"undefinedimages/amexda647adf95f30924.png",baloto:"undefinedimages/baloto7621e7f822d4583d.png",banorte:"undefinedimages/banorte87e6a5073635d557.png",bitcoin:"undefinedimages/bitcoinadad1b8d54a97811.png",davivienda:"undefinedimages/davivienda5f0ce9d108e6b1ee.png",efecty:"undefinedimages/efecty22311be7d0475e8f.png",mastercard:"undefinedimages/mastercardbf4ad752b3fb3d0e.png",oxxo:"undefinedimages/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"undefinedimages/pago_efectivo39a4341bf1f15d31.png",pago_facil:"undefinedimages/pago_facil632781fca2af5541.png",paypal:"undefinedimages/paypal03ae8e5a43fc2f23.png",pse:"undefinedimages/pse3962764fe3faa4ea.png",rapipago:"undefinedimages/rapipago3cefa48fe3375a12.png",visa:"undefinedimages/visa91625977f7206bc0.png"};var constants_n={SPANISH_CO:"es-CO",SPANISH_ES:"es-ES",PORTUGUESE:"pt",ENGLISH:"en"};const constants_i="monthly_plan",constants_d="expert_plan",f="annual_plan",g="platzi_academy",constants_p="family_plan",constants_s="free_plan",constants_o="enterprise",constants_m="user",b="b2b",constants_c=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,constants_t=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?!(?:hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|live))((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,l=/^[a-zA-Z\s]*$/,constants_r=480,constants_u=768,v=1024,_=1200,constants_x="Platzi Expert",y="Platzi Expert+",E="Plan Empresarial",constants_A="Platzi English Academy";

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(6110);
;// CONCATENATED MODULE: ./node_modules/@platzi/hooks/dist/esm/bundle.mjs
const bundle_o="change";const bundle_r=n=>{const[r,a]=e({media:{},metadata:{}});return t((()=>{const e={},t={width:window.innerWidth},r=[];return n.forEach((t=>{const n=window.matchMedia(t.query),i=e=>{const{matches:n}=e;a((e=>({...e,media:{...e.media,[t.key]:n},metadata:{...e.metadata,width:window.innerWidth}})))};!function(e,t){Object.prototype.hasOwnProperty.call(e,"addEventListener")?e.addEventListener(bundle_o,t):e.addListener(t)}(n,i),r.push({matchMedia:n,matchMediaListener:i}),e[t.key]=n.matches})),a({media:e,metadata:t}),()=>{r.forEach((({matchMedia:e,matchMediaListener:t})=>{!function(e,t){Object.prototype.hasOwnProperty.call(e,"removeEventListener")?e.removeEventListener(bundle_o,t):e.removeListener(t)}(e,t)}))}}),[n]),r};function bundle_a(){return"undefined"!=typeof window}const bundle_i=(n,o)=>{const[r,i]=e((()=>function(e){return bundle_a()?window.localStorage.getItem(e):null}(n)||o));return t((()=>{bundle_a()&&window.localStorage.setItem(n,`${r}`)}),[n,r]),[r,i]},bundle_c=n=>{const[o,r]=e("");return t((()=>{if("undefined"!=typeof window&&n){const e=new URLSearchParams(window.location.search).get(n)??"";r(e)}}),[n]),o};function bundle_d(e){const o=void 0!==e,r=n(o);return t((()=>{if(r.current!==o)throw new Error("Cannot use controlled and uncontrolled props at the same time.")}),[o]),o}
//# sourceMappingURL=bundle.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.plans/node_modules/@platzi/commons/dist/es/index-89705ca0.js
const index_89705ca0_c=t=>{const[n,o]=e(t);return{value:n,onChange:e=>o(e.target.value)}},index_89705ca0_u="undefined"!=typeof window,index_89705ca0_m=()=>({width:index_89705ca0_u?window.innerWidth:void 0,height:index_89705ca0_u?window.innerHeight:void 0}),index_89705ca0_l=()=>{const[n,o]=(0,react.useState)(index_89705ca0_m());return (0,react.useEffect)((()=>{const e=()=>{o(index_89705ca0_m())};return index_89705ca0_u?(window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}):null}),[]),n},index_89705ca0_p=(n,o)=>{if("undefined"==typeof window)return[o,null];const[i,r]=e((()=>window.localStorage.getItem(n)||o));return t((()=>{window.localStorage.setItem(n,i)}),[n,i]),[i,r]},index_89705ca0_w=e=>"undefined"!=typeof document&&document.cookie.split(";").some((t=>t.trim().startsWith(`${e}=`))),index_89705ca0_g=(e,t,n)=>document.cookie=`${e}=${t}; max-age=${n}`,index_89705ca0_f=e=>{const t="undefined"!=typeof document&&document.cookie.match(new RegExp("(?:^|; )"+e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g,"\\$1")+"=([^;]*)"));return t?decodeURIComponent(t[1]):void 0},h=()=>({checkCookie:index_89705ca0_w,setCookie:index_89705ca0_g,getCookie:index_89705ca0_f}),index_89705ca0_v=n=>{const[o,i]=e("");return t((()=>{if("undefined"!=typeof window){const e=new URLSearchParams(window.location.search);i(e.get(n))}}),[]),{variable:o}},index_89705ca0_y=()=>{var e;const t=i(),n=(null===(e=r((e=>e.get("header").get("register_modal"))))||void 0===e?void 0:e.toJS())||{},o=e=>{var o;t((o={...n,...e},{type:s,payload:o}))};return{isRegisterModalOpen:(null==n?void 0:n.isOpen)||!1,openRegisterModal:(e={})=>{a.send({event:"register_modal_impression",...e}),o({isOpen:!0})},closeRegisterModal:(e={})=>{a.send({event:"register_modal_close",...e}),o({isOpen:!1})},setModalConfig:o,configRegisterModal:n}};function index_89705ca0_x(e,t){return r((n=>{try{return e(n)}catch(e){return t}}))}const index_89705ca0_k=i=>{const[r,s]=e(),[a,d]=e(null),c=n(),u=n(null);c.current=r,u.current=a;const m=o((({origin:e,source:t,data:n})=>{const{type:o}=n;"chat_event"===o&&(d(t),s(e),i({origin:e,source:t,data:n}))}),[i,d,s]);t((()=>(window.addEventListener("message",m),()=>window.removeEventListener("message",m))),[a,r,m])},index_89705ca0_b=[{key:"mobile",query:"(max-width: 767px)"},{key:"tablet",query:"(min-width: 768px) and (max-width: 1023px)"},{key:"desktop",query:"(min-width: 1024px) and (max-width: 1279px)"},{key:"extra-large",query:"(min-width: 1280px)"}],index_89705ca0_R=()=>{const{media:e}=d(index_89705ca0_b);return e};

;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.plans/node_modules/@platzi/commons/dist/es/index-754db556.js
var index_754db556_a={send:function(a){"undefined"!=typeof window&&window.dataLayer&&window.dataLayer.push(a)}};

;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.image/dist/es/index.js
function es_n(t=""){return null===t?"":t}function es_a(t){try{return new URL(t),!0}catch(t){return!1}}const es_i="static.platzi.com";function es_r({src:t,width:a=1024,quality:r=85,format:s="auto"}){const c=[`width=${a}`,`quality=${r}`,`format=${s}`].join(","),e=new URL(t);if(e.hostname===es_i){const t=es_n(e.pathname);return`https://${es_i}/cdn-cgi/image/${c}${t}`}return`https://${es_i}/cdn-cgi/image/${c}/${t}`}function es_s(t,i){return null===t?"":es_a(t)?es_r({src:t,quality:i}):function({src:t}){return es_n(t)}({src:t})}function es_c(t,n,i=[]){return t&&es_a(t)?function(t,n,a=[]){return 0===a.length?"":a.map((a=>`${es_r({src:t,width:a,quality:n})} ${a}w`)).join(", ")}(t,n,i):""}const es_e=[480,768,1024,1200];function es_o(t){return t.width?(t=>{const{src:n,customClass:a,quality:i,loading:r,width:c,height:e,dataTrans:o}=t,u={};return u.src=n?es_s(n,i):void 0,u.loading=r,u.width=c,u.height=e,a&&(u.className=a),o&&(u["data-trans"]=o),u})(t):(t=>{const{src:n,customClass:a,quality:i,sizes:r,loading:o,dataTrans:u}=t,d={};return d.src=n?es_s(n,i):void 0,d.srcSet=n?es_c(n,i,es_e):void 0,d.loading=o,a&&(d.className=a),r&&(d.sizes=r),u&&(d["data-trans"]=u),d})(t)}const es_u=({alt:n,decoding:a,...i})=>{const r=es_o(i);return react.createElement("img",{...r,alt:n,decoding:a})};es_u.defaultProps={quality:85,sizes:"50vw",loading:"lazy",decoding:"async"},es_u.displayName="Image";
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.button/dist/es/index.js
var dist_es_e,dist_es_r={exports:{}};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/dist_es_e=dist_es_r,function(){var t={}.hasOwnProperty;function o(){for(var e=[],r=0;r<arguments.length;r++){var n=arguments[r];if(n){var u=typeof n;if("string"===u||"number"===u)e.push(n);else if(Array.isArray(n)){if(n.length){var d=o.apply(null,n);d&&e.push(d)}}else if("object"===u){if(n.toString!==Object.prototype.toString&&!n.toString.toString().includes("[native code]")){e.push(n.toString());continue}for(var l in n)t.call(n,l)&&n[l]&&e.push(l)}}}return e.join(" ")}dist_es_e.exports?(o.default=o,dist_es_e.exports=o):window.classNames=o}();var dist_es_n=dist_es_r.exports;var dist_es_u={Button:"Button-module_Button__Y5dbR","Button-label":"Button-module_Button-label__hlOeK","Button-icon":"Button-module_Button-icon__uzyV2","Button--primary":"Button-module_Button--primary__SbvXN","Button--secondary":"Button-module_Button--secondary__v4MCN","Button--tertiary":"Button-module_Button--tertiary__KCOfT","Button--ghost":"Button-module_Button--ghost__VTPzx","Button--danger":"Button-module_Button--danger__0AQ5O","Button--fullWidth":"Button-module_Button--fullWidth__0RIt-"};!function(t,o){void 0===o&&(o={});var e=o.insertAt;if(t&&"undefined"!=typeof document){var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");n.type="text/css","top"===e&&r.firstChild?r.insertBefore(n,r.firstChild):r.appendChild(n),n.styleSheet?n.styleSheet.cssText=t:n.appendChild(document.createTextNode(t))}}(".Button-module_Button__Y5dbR{align-items:center;background-color:transparent;border:solid #fff;border-radius:.5rem;border-width:1px 1px 2px;box-sizing:border-box;color:inherit;cursor:pointer;display:flex;font:inherit;font-size:.875rem;font-weight:500;gap:.5rem;justify-content:center;letter-spacing:.019rem;padding:.5rem .75rem;text-decoration:none;text-transform:none;transition:all .1s ease}.Button-module_Button__Y5dbR:active,.Button-module_Button__Y5dbR:hover{border-width:1px;margin-bottom:1px}.Button-module_Button__Y5dbR:disabled{border-width:1px 1px 2px;cursor:not-allowed}.Button-module_Button-label__hlOeK:has(svg) svg{height:1.5rem;width:1.5rem}.Button-module_Button-icon__uzyV2 svg{height:1rem;vertical-align:middle;width:1rem}.Button-module_Button--primary__SbvXN{background-color:#fff;border-color:#555c68;color:#13161c}.Button-module_Button--primary__SbvXN:active,.Button-module_Button--primary__SbvXN:hover{background-color:#f0f1f2;border-color:#dee1e4}.Button-module_Button--primary__SbvXN:disabled{background-color:#fff;border-color:#dee1e4;color:#a5acb6}.Button-module_Button--secondary__v4MCN{background-color:#2d323a;border-color:#555c68;color:#fff}.Button-module_Button--secondary__v4MCN:active{background-color:#555c68}.Button-module_Button--secondary__v4MCN:disabled{color:#6c7583}.Button-module_Button--tertiary__KCOfT{background-color:#13161c;border-color:#404650;color:#fff}.Button-module_Button--tertiary__KCOfT:active{border-color:#555c68}.Button-module_Button--tertiary__KCOfT:disabled{border-color:#404650;color:#6c7583}.Button-module_Button--ghost__VTPzx{appearance:none;border:0;box-sizing:border-box;font-size:1rem;padding:0;text-align:left;text-decoration:none}.Button-module_Button--danger__0AQ5O{background-color:#d8392f;border-color:#b72b23;color:#fff}.Button-module_Button--danger__0AQ5O:active{background:#b72b23;border-color:#94231c}.Button-module_Button--danger__0AQ5O:disabled{background-color:#b72b23;border-color:#94231c;color:#e26a63}.Button-module_Button--fullWidth__0RIt-{width:100%}");const es_d=(0,react.forwardRef)(((o,e)=>{const{children:r,variant:d,size:l,fullWidth:a,leftIcon:i,rightIcon:c,className:_,...s}=o,B=dist_es_n(dist_es_u.Button,dist_es_u[`Button--${d}`],dist_es_u[`Button--${l}`],_,{[dist_es_u["Button--fullWidth"]]:a}),m=t=>dist_es_n(dist_es_u["Button-icon"],{[dist_es_u[`Button-icon--${t}`]]:!0});if(!o.as)return null;const f=o.as;return react.createElement(f,{ref:e,className:B,...s},i&&react.createElement("span",{className:m("left")},i),react.createElement("span",{className:dist_es_u["Button-label"]},r),c&&react.createElement("span",{className:m("right")},c))}));es_d.defaultProps={as:"button",variant:"primary",size:"md",fullWidth:!1},es_d.displayName="Button";
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/node_modules/@radix-ui/react-compose-refs/dist/index.mjs



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/node_modules/@radix-ui/react-context/dist/index.mjs



function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ $3bkAK$createContext(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = $3bkAK$useMemo(()=>context
        , Object.values(context));
        return /*#__PURE__*/ $3bkAK$createElement(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = $3bkAK$useContext(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/node_modules/@radix-ui/primitive/dist/index.mjs
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react.useRef)(callback);
    (0,react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs





function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    const setValue = (0,react.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0,react.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0,react.useRef)(value);
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    (0,react.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-use-previous/dist/index.mjs



function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
    const ref = (0,react.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0,react.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs



/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? react.useLayoutEffect : ()=>{};





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-use-size/dist/index.mjs





function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0,react.useState)(undefined);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                 // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ('borderBoxSize' in entry) {
                    const borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize['inlineSize'];
                    height = borderSize['blockSize'];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: 'border-box'
            });
            return ()=>resizeObserver.unobserve(element)
            ;
        } else // We only want to reset to `undefined` when the element becomes `null`,
        // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/node_modules/@radix-ui/react-presence/dist/index.mjs










function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react.Children.only(children);
    const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react.cloneElement)(child, {
        ref: ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react.useState)();
    const stylesRef = (0,react.useRef)({});
    const prevPresentRef = (0,react.useRef)(present);
    const prevAnimationNameRef = (0,react.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react.useEffect)(()=>{
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/node_modules/@radix-ui/react-slot/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)($5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/node_modules/@radix-ui/react-primitive/dist/index.mjs









const $8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) $4q5Fq$flushSync(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-checkbox/dist/index.mjs





















/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$CHECKBOX_NAME = 'Checkbox';
const [$e698a72e93240346$var$createCheckboxContext, $e698a72e93240346$export$b566c4ff5488ea01] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($e698a72e93240346$var$CHECKBOX_NAME);
const [$e698a72e93240346$var$CheckboxProvider, $e698a72e93240346$var$useCheckboxContext] = $e698a72e93240346$var$createCheckboxContext($e698a72e93240346$var$CHECKBOX_NAME);
const $e698a72e93240346$export$48513f6b9f8ce62d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , name: name , checked: checkedProp , defaultChecked: defaultChecked , required: required , disabled: disabled , value: value = 'on' , onCheckedChange: onCheckedChange , ...checkboxProps } = props;
    const [button, setButton] = (0,react.useState)(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setButton(node)
    );
    const hasConsumerStoppedPropagationRef = (0,react.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest('form')) : true;
    const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = (0,react.useRef)(checked);
    (0,react.useEffect)(()=>{
        const form = button === null || button === void 0 ? void 0 : button.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current)
            ;
            form.addEventListener('reset', reset);
            return ()=>form.removeEventListener('reset', reset)
            ;
        }
    }, [
        button,
        setChecked
    ]);
    return /*#__PURE__*/ (0,react.createElement)($e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.button, (0,esm_extends/* default */.Z)({
        type: "button",
        role: "checkbox",
        "aria-checked": $e698a72e93240346$var$isIndeterminate(checked) ? 'mixed' : checked,
        "aria-required": required,
        "data-state": $e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === 'Enter') event.preventDefault();
        }),
        onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, (event)=>{
            setChecked((prevChecked)=>$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked
            );
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0,react.createElement)($e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: 'translateX(-100%)'
        }
    }));
});
/*#__PURE__*/ Object.assign($e698a72e93240346$export$48513f6b9f8ce62d, {
    displayName: $e698a72e93240346$var$CHECKBOX_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$INDICATOR_NAME = 'CheckboxIndicator';
const $e698a72e93240346$export$59aad738f51d1c05 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , forceMount: forceMount , ...indicatorProps } = props;
    const context = $e698a72e93240346$var$useCheckboxContext($e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ (0,react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || $e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ (0,react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.span, (0,esm_extends/* default */.Z)({
        "data-state": $e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? '' : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: 'none',
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($e698a72e93240346$export$59aad738f51d1c05, {
    displayName: $e698a72e93240346$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control , checked: checked , bubbles: bubbles = true , ...inputProps } = props;
    const ref = (0,react.useRef)(null);
    const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
    const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control); // Bubble checked change to parents (e.g form change event)
    (0,react.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event('click', {
                bubbles: bubbles
            });
            input.indeterminate = $e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0,react.createElement)("input", (0,esm_extends/* default */.Z)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: 'absolute',
            pointerEvents: 'none',
            opacity: 0,
            margin: 0
        }
    }));
};
function $e698a72e93240346$var$isIndeterminate(checked) {
    return checked === 'indeterminate';
}
function $e698a72e93240346$var$getState(checked) {
    return $e698a72e93240346$var$isIndeterminate(checked) ? 'indeterminate' : checked ? 'checked' : 'unchecked';
}
const $e698a72e93240346$export$be92b6f5f03c0fe9 = $e698a72e93240346$export$48513f6b9f8ce62d;
const $e698a72e93240346$export$adb584737d712b70 = $e698a72e93240346$export$59aad738f51d1c05;





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/icons/dist/esm/index.js
const esm_l=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M6.166 6.166a8.25 8.25 0 1 1 11.667 11.667A8.25 8.25 0 0 1 6.166 6.167m12.728 12.728c3.808-3.807 3.808-9.98 0-13.788s-9.98-3.808-13.788 0-3.808 9.98 0 13.788 9.98 3.808 13.788 0M12.47 6.736a.75.75 0 0 0-1.5 0v6.328a.75.75 0 0 0 .366.644l4.922 2.936a.75.75 0 0 0 .768-1.288l-4.556-2.718z",clipRule:"evenodd"})),esm_t=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 74 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{d:"M-24-23h768v68H-24z",className:"Platzi_svg__background"}),e.createElement("g",{fill:"#fff"},e.createElement("path",{fillRule:"evenodd",d:"M8.314 1.276 1.01 8.64a3.49 3.49 0 0 0 0 4.908l7.305 7.363a3.424 3.424 0 0 0 4.87 0l2.435-2.454L13.184 16l-2.435 2.454-7.305-7.362 7.305-7.362 4.87 4.908-4.87 4.908L13.184 16l4.87-4.908a3.49 3.49 0 0 0 0-4.908l-4.87-4.909a3.424 3.424 0 0 0-4.87 0",className:"Platzi_svg__isotipo",clipRule:"evenodd"}),e.createElement("path",{d:"M22.456 18.376V3.567h6.087c3.274 0 5.184 2.412 5.184 5.225 0 2.814-1.952 5.141-5.184 5.141H24.91v4.443zm6.087-6.6c1.658 0 2.834-1.333 2.834-3.046 0-1.714-1.134-3.025-2.834-3.025H24.87v6.07zm8.997-8.209v11.15c0 1.692.44 2.22 2.183 1.945l.084 1.778c-3.107.507-4.534-.297-4.534-3.702V3.568zM50.277 15.33c0 .93-.021 1.523 1.092 1.417v1.565c-1.449.275-2.939.106-2.939-1.586v-.423c-.566 1.417-1.994 2.221-3.484 2.221-3.086 0-4.576-2.496-4.576-5.373.063-3.385 2.456-5.246 5.752-5.183 1.448 0 2.834.36 4.156.952zm-2.204-5.077c-.693-.318-1.47-.423-2.12-.423-1.931 0-3.233 1.12-3.295 3.321 0 1.862.902 3.321 2.77 3.321 1.7 0 2.582-1.333 2.645-3.216zM56.169 8.2h3.506v1.862h-3.506v4.38c0 2.602 1.617 2.771 3.695 2.03l.23 1.735c-3.463 1.079-6.17.275-6.17-3.723v-4.422h-2.058V8.2h2.057V5.704h2.246zm4.943 9.71 2.939-4.632 2.204-3.216h-4.828V8.179h8.124v.296l-3.128 4.887-2.057 3.025h5.164v1.99h-8.418zm11.19-14.367c.693 0 1.365.465 1.365 1.353 0 .889-.672 1.376-1.344 1.376s-1.406-.445-1.406-1.376.692-1.353 1.385-1.353m1.134 14.833h-2.288V8.2h2.288z",className:"Platzi_svg__letter"})),e.createElement("path",{fill:"#2D323A",d:"M744 44H-24v2h768z",mask:"url(#Platzi_svg__path-3-inside-1_1521_29282)"}),e.createElement("rect",{width:1263,height:431,x:-55.5,y:-254.5,stroke:"#9747FF",strokeDasharray:"10 5",rx:31.5})),esm_a=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M10.75 6a.75.75 0 0 0-1.5 0v3.25H6a.75.75 0 0 0 0 1.5h3.25V14a.75.75 0 0 0 1.5 0v-3.25H14a.75.75 0 0 0 0-1.5h-3.25zM.25 10A9.75 9.75 0 0 1 10 .25 9.75 9.75 0 0 1 19.75 10 9.75 9.75 0 0 1 10 19.75 9.75 9.75 0 0 1 .25 10",clipRule:"evenodd"})),esm_i=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#13161C",fillRule:"evenodd",d:"M12 7.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75",clipRule:"evenodd"}),e.createElement("path",{fill:"#13161C",fillRule:"evenodd",d:"M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",clipRule:"evenodd"}),e.createElement("path",{fill:"#13161C",fillRule:"evenodd",d:"M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75m0-1.5A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25",clipRule:"evenodd"})),esm_h=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M3.542 10c0-.345.28-.625.625-.625h11.666a.625.625 0 1 1 0 1.25H4.167A.625.625 0 0 1 3.542 10",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M10 3.542c.345 0 .625.28.625.625v11.667a.625.625 0 0 1-1.25 0V4.167c0-.345.28-.625.625-.625",clipRule:"evenodd"})),esm_n=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 19",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M13.067 9.695q-.04-2.21 1.994-3.415-1.157-1.608-3.39-1.809a3.9 3.9 0 0 0-1.357.161q-.678.201-1.197.402-.639.24-.957.281-.44-.04-1.117-.321a6.3 6.3 0 0 0-1.955-.482q-1.755.04-3.112 1.366Q.58 7.204.5 9.896q0 1.566.559 3.254.28.763.917 1.969.638 1.165 1.516 2.09.877.923 1.875.963a3.7 3.7 0 0 0 1.277-.321q.717-.361 1.715-.402.957.04 1.636.362.638.322 1.436.361.957-.08 1.795-.924a9.6 9.6 0 0 0 1.436-1.969q.599-1.125.838-1.888-1.795-1.005-2.154-2.25-.36-1.206-.28-1.446m-2.274-6.59q.757-1.005.917-1.808.12-.764.04-1.125-.718.04-1.476.442a5 5 0 0 0-1.237.965Q7.96 2.784 8.04 4.47q1.556.04 2.753-1.366"})),esm_c=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 18",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M3.188 9c0-.31.251-.562.562-.562h10.5a.562.562 0 1 1 0 1.124H3.75A.563.563 0 0 1 3.188 9"}),e.createElement("path",{fill:"#fff",d:"M7.898 4.852c.22.22.22.576 0 .796l-3.75 3.75a.563.563 0 0 1-.796-.796l3.75-3.75c.22-.22.576-.22.796 0"}),e.createElement("path",{fill:"#fff",d:"M3.352 8.602c.22-.22.576-.22.796 0l3.75 3.75a.562.562 0 1 1-.796.796l-3.75-3.75a.563.563 0 0 1 0-.796"})),esm_m=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.751 4a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0v-14a.75.75 0 0 1 .75-.75",clipRule:"evenodd"}),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M6.22 13.219a.75.75 0 0 1 1.06 0l4.471 4.47 4.47-4.47a.75.75 0 1 1 1.061 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5.001-5a.75.75 0 0 1 0-1.061",clipRule:"evenodd"})),esm_v=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 8 6",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M3.602 1.102c.22-.22.576-.22.796 0l3 3a.563.563 0 0 1-.796.796L4 2.296 1.398 4.898a.563.563 0 0 1-.796-.796z",clipRule:"evenodd"})),esm_d=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M12 4.25a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.47 4.469a.75.75 0 0 1 1.06 0l5.001 5a.75.75 0 1 1-1.06 1.061L12 6.06l-4.47 4.47a.75.75 0 0 1-1.061-1.06z",clipRule:"evenodd"})),esm_o=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7.076 5.5a2.75 2.75 0 0 1 2.75-2.75h4.348a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 0 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25H9.826c-.69 0-1.25.56-1.25 1.25v2a.75.75 0 0 1-1.5 0z",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",d:"M2.633 8.35A2.75 2.75 0 0 1 5 7h14a2.75 2.75 0 0 1 2.368 1.35l-7.132 4.715a1.25 1.25 0 0 1-.689.207h-3.094a1.25 1.25 0 0 1-.689-.207z"}),e.createElement("path",{fill:"#fff",d:"M2.25 9.895v8.855A2.75 2.75 0 0 0 5 21.5h14a2.75 2.75 0 0 0 2.75-2.75V9.895l-6.687 4.422a2.75 2.75 0 0 1-1.516.455h-3.094a2.75 2.75 0 0 1-1.515-.455z"})),esm_w=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M5 8.25c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-9c0-.69-.56-1.25-1.25-1.25zM2.25 9.5A2.75 2.75 0 0 1 5 6.75h14a2.75 2.75 0 0 1 2.75 2.75v9A2.75 2.75 0 0 1 19 21.25H5a2.75 2.75 0 0 1-2.75-2.75z",clipRule:"evenodd"}),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7.076 5.5a2.75 2.75 0 0 1 2.75-2.75h4.348a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 0 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25H9.826c-.69 0-1.25.56-1.25 1.25v2a.75.75 0 0 1-1.5 0zM2.374 9.087a.75.75 0 0 1 1.039-.213l6.351 4.191c.204.135.444.207.689.207h3.094c.245 0 .484-.072.689-.207l6.35-4.191a.75.75 0 1 1 .827 1.252l-6.35 4.19c-.45.298-.977.456-1.516.456h-3.094a2.75 2.75 0 0 1-1.515-.455l-6.351-4.191a.75.75 0 0 1-.213-1.04",clipRule:"evenodd"})),esm_f=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{stroke:"#0AE98A",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.25,d:"M10 9.167V3.34a.84.84 0 0 1 .936-.834 7.555 7.555 0 0 1 6.558 6.558.838.838 0 0 1-.834.936h-5.827A.833.833 0 0 1 10 9.167",clipRule:"evenodd"}),e.createElement("path",{stroke:"#0AE98A",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.25,d:"M7.5 2.937a7.524 7.524 0 1 0 9.701 9.343"})),esm_s=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7 3.75A3.25 3.25 0 0 0 3.75 7v10A3.25 3.25 0 0 0 7 20.25h10A3.25 3.25 0 0 0 20.25 17V7A3.25 3.25 0 0 0 17 3.75zM2.25 7A4.75 4.75 0 0 1 7 2.25h10A4.75 4.75 0 0 1 21.75 7v10A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17z",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M21.61 8.564a.75.75 0 0 1-.174 1.046l-7 5a.75.75 0 0 1-.966-.08l-3.551-3.55-6.483 4.63a.75.75 0 1 1-.872-1.22l7-5a.75.75 0 0 1 .966.08l3.551 3.55 6.483-4.63a.75.75 0 0 1 1.046.174",clipRule:"evenodd"})),esm_r=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 23 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{stroke:"#fff",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.5,d:"M14.665 11.135a4.66 4.66 0 0 1-6.331 0"}),e.createElement("path",{stroke:"#fff",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.5,d:"M3.25 18.79a.458.458 0 0 0 .741.362L7.375 16.5H17a2.75 2.75 0 0 0 2.75-2.75V5.5A2.75 2.75 0 0 0 17 2.75H6A2.75 2.75 0 0 0 3.25 5.5z",clipRule:"evenodd"})),esm_g=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M19.03 7.47a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.97 3.97 7.47-7.47a.75.75 0 0 1 1.06 0",clipRule:"evenodd"})),esm_p=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 14 11",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#13161C",d:"m5 10.42-5-5 1.41-1.41L5 7.59 12.59 0 14 1.42z"})),esm_E=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M8.47 11.47a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 1 1-1.06 1.06l-2.25-2.25a.75.75 0 0 1 0-1.06",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M15.53 9.97a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06l3.75-3.75a.75.75 0 0 1 1.06 0",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M12 21.75c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0",clipRule:"evenodd"})),esm_u=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M10.354 7.354a.5.5 0 0 0-.708-.708L7.5 8.793 6.354 7.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0zM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0",clipRule:"evenodd"})),esm_x=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M7.47 9.47a.75.75 0 0 1 1.06 0L12 12.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06",clipRule:"evenodd"})),M=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7.891 6.225a.625.625 0 0 1 .884 0l3.333 3.333a.625.625 0 0 1 0 .884l-3.333 3.333a.625.625 0 1 1-.884-.884L10.783 10 7.89 7.109a.625.625 0 0 1 0-.884",clipRule:"evenodd"})),esm_R=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M5.47 5.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06",clipRule:"evenodd"}),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M18.53 5.47a.75.75 0 0 1 0 1.06l-12 12a.75.75 0 0 1-1.06-1.06l12-12a.75.75 0 0 1 1.06 0",clipRule:"evenodd"})),esm_A=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 18",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M11.375.75h-9c-.825 0-1.5.675-1.5 1.5v10.5h1.5V2.25h9zm2.25 3h-8.25c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h8.25c.825 0 1.5-.675 1.5-1.5V5.25c0-.825-.675-1.5-1.5-1.5m0 12h-8.25V5.25h8.25z"})),z=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M21.7 12c0-2.5-1-5-2.9-6.9-1.8-1.8-4.3-2.9-6.9-2.9S6.8 3.2 5 5.1 2.3 9.5 2.3 12v.1c0 2.5 1 5 2.9 6.9s4.4 2.9 6.9 2.9 5-1 6.9-2.9c1.8-2 2.7-4.5 2.7-7m-8.9 1.2c-.1.1 0 .1 0 0-.5.5-1.2.5-1.7 0-.2-.2-.3-.5-.3-.8s.1-.6.3-.8c.4-.4 1.4-.6 2.3-.6-.1.8-.2 1.8-.6 2.2m2.9-6 1.6-1.6c.2.2.4.3.6.5s.3.4.5.6l-1.6 1.6c-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.4-.3-.4-.8-.1-1.1m-4.5-3.4h1.6v1.7c0 .4-.3.8-.8.8s-.8-.3-.8-.8zm-6.2 9H3.8v-1.5H5c.4 0 .8.3.8.8s-.4.7-.8.7m3.2 4.1-1.4 1.4c-.2-.2-.4-.3-.6-.5s-.3-.4-.5-.6l1.4-1.4c.3-.3.8-.3 1.1 0s.3.8 0 1.1m.1-8.6c-.2.1-.3.2-.5.2s-.4-.1-.6-.2L5.7 6.7c.1-.2.3-.4.5-.5.1-.2.3-.4.5-.5l1.6 1.6c.3.2.3.7 0 1m5.5 6c-.5.5-1.2.8-1.9.8a2.73 2.73 0 0 1-2.7-2.7c0-.7.3-1.4.8-1.9 1-1 2.9-1.1 3.9-1 .5 0 .9.4.9.9.1 1 0 2.9-1 3.9m4 3.5c-.2.2-.4.3-.6.5l-1.6-1.6c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l1.6 1.6c-.1.3-.3.5-.5.6m2.4-5H19c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h1.2c.1.6.1 1.1 0 1.6"})),H=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M18.9 5.1c1.9 1.9 2.9 4.4 2.9 6.9-.1 2.5-1 5-2.9 6.9s-4.4 2.9-6.9 2.9-5-1-6.9-2.9C3.3 17 2.3 14.5 2.3 12s.9-5 2.8-6.9C6.9 3.2 9.4 2.2 12 2.2s5.1 1.1 6.9 2.9M8.1 16.9l-1.4 1.4c3.1 2.6 7.5 2.6 10.5.2l-1.6-1.6c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l1.6 1.6c1.1-1.3 1.8-2.9 1.9-4.5H19c-.5 0-.8-.3-.8-.8s.4-.8.8-.8h1.2c-.2-1.6-.8-3.2-1.9-4.5l-1.6 1.6c-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.3-.3-.3-.8 0-1.1l1.6-1.6c-1.3-1.1-2.8-1.8-4.5-1.9v1.7c0 .5-.3.8-.8.8s-.8-.4-.8-.8V3.8c-1.6.1-3.2.8-4.5 1.9l1.6 1.5c.3.3.3.8 0 1.1-.1.1-.3.2-.5.2s-.4-.1-.5-.2L5.7 6.7C4.6 8 3.9 9.6 3.8 11.2H5c.4 0 .8.2.8.7s-.4.8-.8.8H3.7c.2 1.6.8 3.2 1.9 4.5L7 15.8c.3-.3.8-.3 1.1 0s.3.8 0 1.1m1.9-6.4c1-1 2.9-1.1 3.9-1 .5 0 .9.4.9.9.1 1 0 2.9-1 3.9-.5.5-1.2.8-1.9.8a2.73 2.73 0 0 1-2.7-2.7c0-.7.3-1.4.8-1.9m1.1 2.7c.5.5 1.2.5 1.7 0 .375-.375.486-1.279.581-2.05L13.4 11c-.9 0-1.9.2-2.3.6-.2.2-.3.5-.3.8s.1.6.3.8",clipRule:"evenodd"})),esm_B=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{fill:"#fff",fillRule:"evenodd",clipRule:"evenodd"},e.createElement("path",{d:"M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75m0-1.5A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25"}),e.createElement("path",{d:"M12 8.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75"}),e.createElement("path",{d:"M8.97 11.97a.75.75 0 0 1 1.06 0L12 13.94l1.97-1.97a.75.75 0 1 1 1.06 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 0 1 0-1.06"}))),C=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M14.305 2.818a1.75 1.75 0 0 1 2.474 0l1.403 1.403a1.75 1.75 0 0 1 0 2.475L7.348 17.53a.75.75 0 0 1-.53.22H4a.75.75 0 0 1-.75-.75v-2.818a.75.75 0 0 1 .22-.53zm1.414 1.06a.25.25 0 0 0-.353 0L4.75 14.493v1.757h1.757L17.122 5.636a.25.25 0 0 0 0-.355zM2.25 21a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75",clipRule:"evenodd"}),e.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M12.52 4.6a.75.75 0 0 1 1.06 0l2.82 2.82a.75.75 0 0 1-1.06 1.06l-2.82-2.82a.75.75 0 0 1 0-1.06",clipRule:"evenodd"})),V=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 28 28",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#87909D",d:"M17.138 2.578 5.052 13.405c-.747.677-.327 1.925.676 2.018l9.439.91-5.659 7.887a.92.92 0 0 0 .094 1.178c.35.35.898.362 1.26.024l12.086-10.827c.747-.677.327-1.925-.676-2.018l-9.439-.91 5.659-7.887a.92.92 0 0 0-.094-1.178.9.9 0 0 0-1.26-.024"})),L=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M21.75 12A9.75 9.75 0 0 0 12 2.25 9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12M12 6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m0 10.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",clipRule:"evenodd"})),esm_k=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 56 56",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#2D323A",fillRule:"evenodd",d:"M28 8.75C17.368 8.75 8.75 17.368 8.75 28S17.368 47.25 28 47.25 47.25 38.633 47.25 28 38.633 8.75 28 8.75m0-3.5c12.566 0 22.75 10.185 22.75 22.75S40.566 50.75 28 50.75 5.25 40.566 5.25 28 15.435 5.25 28 5.25",clipRule:"evenodd"}),e.createElement("path",{fill:"#2D323A",fillRule:"evenodd",d:"M28 15.75c.967 0 1.75.784 1.75 1.75v11.667a1.75 1.75 0 1 1-3.5 0V17.5c0-.966.784-1.75 1.75-1.75",clipRule:"evenodd"}),e.createElement("circle",{cx:28,cy:37.916,r:2.333,fill:"#2D323A"})),esm_=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{fill:"#C4C8CE",fillRule:"evenodd",clipRule:"evenodd"},e.createElement("path",{d:"M13.25 1A.75.75 0 0 1 14 .25h5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V1.75H14a.75.75 0 0 1-.75-.75"}),e.createElement("path",{d:"M19.53.47a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 1 1-1.06-1.06l7-7a.75.75 0 0 1 1.06 0"}),e.createElement("path",{d:"M3 3.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-5a.75.75 0 0 1 1.5 0v5A2.75 2.75 0 0 1 15 19.75H3A2.75 2.75 0 0 1 .25 17V5A2.75 2.75 0 0 1 3 2.25h5a.75.75 0 0 1 0 1.5z"}))),q=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 28 28",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#87909D",d:"M7.295 19.833c2.963 0 5.362-2.507 5.5-5.56a3.42 3.42 0 0 1 2.41 0c.138 3.084 2.537 5.56 5.5 5.56 2.835 0 5.154-2.255 5.481-5.13h1.17c.456 0 .644-.294.644-.692v-.483c0-.41-.188-.682-.644-.682h-1.23c-.515-2.654-2.735-4.68-5.42-4.68-2.548 0-4.68 1.826-5.313 4.302-.446-.189-.962-.252-1.398-.252-.426 0-.941.063-1.388.252-.634-2.476-2.775-4.301-5.312-4.301-2.656 0-4.877 1.983-5.402 4.616H.644c-.466 0-.644.262-.644.672v.555c0 .4.178.693.644.693h1.16c.337 2.875 2.656 5.13 5.49 5.13m0-1.899c-2.052 0-3.717-1.752-3.717-3.934s1.665-3.934 3.717-3.934c2.042 0 3.717 1.752 3.717 3.934s-1.646 3.934-3.717 3.934m13.41 0c-2.071 0-3.717-1.752-3.717-3.934s1.646-3.934 3.717-3.934c2.052 0 3.717 1.752 3.717 3.934s-1.665 3.934-3.717 3.934"})),S=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 19",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#3F92FC",d:"M18 9.227q-.036-2.519-1.234-4.564a9 9 0 0 0-3.23-3.25Q11.504.21 9 .174 6.496.21 4.464 1.414a9 9 0 0 0-3.23 3.25Q.036 6.708 0 9.227q.072 3.469 2.177 5.915 2.105 2.445 5.408 3.03v-6.316H5.298V9.227h2.287V7.22q.036-1.68.943-2.592.908-.913 2.468-.913.762 0 1.379.073.58.073.617.11v2.227h-1.125q-.836 0-1.161.438a1.3 1.3 0 0 0-.29.95v1.715h2.503l-.399 2.629h-2.105v6.316q3.302-.585 5.408-3.03Q17.928 12.697 18 9.227"})),esm_P=()=>e.createElement("svg",{"aria-hidden":"true","data-icon":"facebook-f","data-prefix":"fab",viewBox:"0 0 320 512",xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em"},e.createElement("path",{fill:"currentColor",d:"m279.1 288 14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.4 0 225.4 0c-73.22 0-121.1 44.38-121.1 124.7v70.62H22.89V288h81.39v224h100.2V288z"})),F=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 23 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#87909D",fillRule:"evenodd",d:"M7.833 3.438a3.896 3.896 0 0 0-3.895 3.895v7.334a3.896 3.896 0 0 0 3.895 3.896h7.334a3.896 3.896 0 0 0 3.896-3.896V8.315a3.9 3.9 0 0 0-1.142-2.755l-.981-.981a3.9 3.9 0 0 0-2.755-1.142zm-5.27 3.895a5.27 5.27 0 0 1 5.27-5.27h6.352a5.27 5.27 0 0 1 3.727 1.543l.982.982a5.27 5.27 0 0 1 1.544 3.727v6.352a5.27 5.27 0 0 1-5.271 5.27H7.833a5.27 5.27 0 0 1-5.27-5.27z",clipRule:"evenodd"}),e.createElement("path",{fill:"#87909D",fillRule:"evenodd",d:"M14.25 2.063c.38 0 .688.307.688.687V5.5c0 1.14.923 2.063 2.062 2.063h2.75a.687.687 0 1 1 0 1.375H17A3.437 3.437 0 0 1 13.563 5.5V2.75c0-.38.307-.687.687-.687M6.23 8.25c0-.38.307-.687.687-.687h3.666a.687.687 0 1 1 0 1.375H6.917a.687.687 0 0 1-.688-.688m9.853 3.896H6.917a.688.688 0 0 1 0-1.375h9.166a.687.687 0 1 1 0 1.375m-9.854 2.52c0-.379.308-.687.688-.687h9.166a.687.687 0 1 1 0 1.375H6.917a.687.687 0 0 1-.688-.687",clipRule:"evenodd"})),D=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#87909D",d:"M12.158 2.158a1.67 1.67 0 0 0-1.183-.491H5c-.917 0-1.667.75-1.667 1.666v13.334c0 .916.742 1.666 1.658 1.666H15c.916 0 1.666-.75 1.666-1.666V7.358c0-.441-.175-.866-.491-1.175zM12.5 15h-5a.836.836 0 0 1-.834-.833c0-.459.375-.834.834-.834h5c.458 0 .833.375.833.834A.836.836 0 0 1 12.5 15m0-3.333h-5a.836.836 0 0 1-.834-.834c0-.458.375-.833.834-.833h5c.458 0 .833.375.833.833a.836.836 0 0 1-.833.834m-1.667-5v-3.75L15.416 7.5h-3.75a.836.836 0 0 1-.833-.833"})),esm_b=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.938 2.75c0-.31.251-.562.562-.562h2.25a.562.562 0 1 1 0 1.124H12.5a.56.56 0 0 1-.562-.562m-11.25 0c0-.31.251-.562.562-.562H9.5a.563.563 0 0 1 0 1.124H1.25a.563.563 0 0 1-.562-.562M5.938 8c0-.31.251-.562.562-.562h8.25a.562.562 0 1 1 0 1.125H6.5A.563.563 0 0 1 5.938 8M.688 8c0-.31.251-.562.562-.562H3.5a.563.563 0 0 1 0 1.125H1.25A.563.563 0 0 1 .688 8m11.25 5.25c0-.31.251-.562.562-.562h2.25a.562.562 0 1 1 0 1.124H12.5a.56.56 0 0 1-.562-.562m-11.25 0c0-.31.251-.562.562-.562H9.5a.562.562 0 1 1 0 1.124H1.25a.56.56 0 0 1-.562-.562",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.663 2.087a.937.937 0 1 0-1.326 1.326.937.937 0 0 0 1.326-1.326m.795-.796A2.063 2.063 0 1 0 9.54 4.208a2.063 2.063 0 0 0 2.917-2.916zM5.663 7.337a.937.937 0 1 0-1.326 1.326.937.937 0 0 0 1.326-1.326m.795-.796A2.062 2.062 0 1 0 3.54 9.458a2.062 2.062 0 0 0 2.917-2.916zm5.205 6.046a.937.937 0 1 0-1.326 1.326.937.937 0 0 0 1.326-1.326m.795-.796a2.063 2.063 0 1 0-2.917 2.917 2.063 2.063 0 0 0 2.917-2.916z",clipRule:"evenodd"})),esm_O=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"currentColor",viewBox:"0 0 23 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fillRule:"evenodd",d:"M2.563 5.5a2.52 2.52 0 0 1 2.52-2.521h4.099c.531 0 1.027.263 1.325.701l1.288 1.893a.23.23 0 0 0 .19.101h5.932a2.52 2.52 0 0 1 2.52 2.52V16.5a2.52 2.52 0 0 1-2.52 2.52H5.083a2.52 2.52 0 0 1-2.52-2.52z",clipRule:"evenodd"})),esm_y=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M2.25 6A2.75 2.75 0 0 1 5 3.25h4.471c.58 0 1.12.287 1.446.765l1.405 2.065c.046.068.124.11.207.11H19a2.75 2.75 0 0 1 2.75 2.75V18A2.75 2.75 0 0 1 19 20.75H5A2.75 2.75 0 0 1 2.25 18zM5 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8.94c0-.69-.56-1.25-1.25-1.25h-6.471a1.75 1.75 0 0 1-1.447-.767L9.677 4.86a.25.25 0 0 0-.206-.109z",clipRule:"evenodd"})),W=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M21 13.75a.75.75 0 0 1 .75.75v2A3.75 3.75 0 0 1 18 20.25h-2a.75.75 0 0 1 0-1.5h2a2.25 2.25 0 0 0 2.25-2.25v-2a.75.75 0 0 1 .75-.75M15.25 4.5a.75.75 0 0 1 .75-.75h2a3.75 3.75 0 0 1 3.75 3.75v2a.75.75 0 0 1-1.5 0v-2A2.25 2.25 0 0 0 18 5.25h-2a.75.75 0 0 1-.75-.75M3 13.75a.75.75 0 0 1 .75.75v2A2.25 2.25 0 0 0 6 18.75h2a.75.75 0 0 1 0 1.5H6a3.75 3.75 0 0 1-3.75-3.75v-2a.75.75 0 0 1 .75-.75m3-8.5A2.25 2.25 0 0 0 3.75 7.5v2a.75.75 0 0 1-1.5 0v-2A3.75 3.75 0 0 1 6 3.75h2a.75.75 0 0 1 0 1.5z",clipRule:"evenodd"})),esm_N=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 19",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#FFC107",d:"M15.204 8.206h-.537v-.028h-6v2.667h3.767A3.998 3.998 0 0 1 4.667 9.51a4 4 0 0 1 4-4c1.02 0 1.947.385 2.653 1.013l1.886-1.885a6.64 6.64 0 0 0-4.54-1.794 6.667 6.667 0 1 0 6.538 5.36"}),e.createElement("path",{fill:"#FB5B5B",d:"m2.769 6.408 2.19 1.607A4 4 0 0 1 8.667 5.51c1.02 0 1.947.385 2.653 1.013l1.886-1.885a6.64 6.64 0 0 0-4.54-1.794A6.66 6.66 0 0 0 2.77 6.408"}),e.createElement("path",{fill:"#4CAF50",d:"M8.667 16.178a6.64 6.64 0 0 0 4.47-1.73l-2.064-1.746a3.97 3.97 0 0 1-2.406.81 4 4 0 0 1-3.761-2.65l-2.174 1.676a6.66 6.66 0 0 0 5.935 3.64"}),e.createElement("path",{fill:"#1976D2",d:"M15.204 8.206h-.537v-.028h-6v2.667h3.767a4 4 0 0 1-1.362 1.857h.001l2.063 1.745c-.146.133 2.197-1.602 2.197-4.936a6.7 6.7 0 0 0-.13-1.305"})),j=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M1.5 4.002a.5.5 0 0 1 .5-.5h12a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5m0 4.001a.5.5 0 0 1 .5-.5h12a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5m0 4.002a.5.5 0 0 1 .5-.5h12a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5",clipRule:"evenodd"})),esm_Q=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#87909D",d:"M2.5 10v5.833c0 .917.75 1.667 1.667 1.667h1.666c.917 0 1.667-.75 1.667-1.667V12.5c0-.917-.75-1.667-1.667-1.667H4.167V10c0-3.225 2.608-5.833 5.833-5.833S15.833 6.775 15.833 10v.833h-1.666c-.917 0-1.667.75-1.667 1.667v3.333c0 .917.75 1.667 1.667 1.667h1.666c.917 0 1.667-.75 1.667-1.667V10a7.5 7.5 0 0 0-15 0"})),U=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M18.962 7.04a4.38 4.38 0 0 0-5.973-.219l-.498.432a.75.75 0 0 1-.982 0l-.498-.431a4.38 4.38 0 0 0-5.973.218 4.423 4.423 0 0 0 .234 6.459l6.566 5.69a.246.246 0 0 0 .324 0l6.565-5.69a4.424 4.424 0 0 0 .235-6.459m1.064-1.058a5.88 5.88 0 0 0-8.02-.294L12 5.694l-.006-.006a5.88 5.88 0 0 0-8.02.294 5.923 5.923 0 0 0 .315 8.65l6.566 5.69c.657.57 1.633.57 2.29 0l6.565-5.69a5.924 5.924 0 0 0 .316-8.65",clipRule:"evenodd"})),T=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",d:"M12.007 5.688a5.88 5.88 0 0 1 8.019.294 5.923 5.923 0 0 1-.316 8.65l-6.565 5.69c-.657.57-1.633.57-2.29 0l-6.566-5.69a5.923 5.923 0 0 1-.315-8.65 5.88 5.88 0 0 1 8.02-.294l.006.006z"})),esm_G=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 23 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#87909D",d:"M12.634 2.99a1.603 1.603 0 0 0-2.269 0L4.219 9.14a2.52 2.52 0 0 0-.739 1.782v7.87c0 .38.308.688.688.688h5.041c.38 0 .688-.308.688-.687v-4.125a1.604 1.604 0 1 1 3.208 0v4.125c0 .38.308.687.688.687h5.041c.38 0 .688-.308.688-.687v-7.87c0-.67-.266-1.31-.739-1.783z"})),esm_I=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M10.762 3.263a1.75 1.75 0 0 1 2.475 0l6.707 6.707a2.75 2.75 0 0 1 .806 1.944V20.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75V16a1.75 1.75 0 1 0-3.5 0v4.5a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75v-8.586c0-.73.29-1.429.806-1.944zM12 12.75A3.25 3.25 0 0 1 15.25 16v3.75h4v-7.836c0-.33-.132-.65-.366-.884l-6.707-6.707a.25.25 0 0 0-.353 0L5.116 11.03a1.25 1.25 0 0 0-.366.884v7.836h4V16A3.25 3.25 0 0 1 12 12.75",clipRule:"evenodd"})),Y=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",d:"M13.237 3.263a1.75 1.75 0 0 0-2.475 0L4.056 9.97a2.75 2.75 0 0 0-.806 1.944V20.5c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75V16a1.75 1.75 0 1 1 3.5 0v4.5c0 .414.336.75.75.75H20a.75.75 0 0 0 .75-.75v-8.586c0-.73-.29-1.429-.806-1.944z"})),esm_J=()=>e.createElement("svg",{fill:"none",viewBox:"0 0 20 16",xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em"},e.createElement("path",{fill:"#C4C8CE",d:"M10 2.674 14.583 6.8v7.16H12.75v-5.5h-5.5v5.5H5.416V6.8zm0-2.466L.833 8.458h2.75v7.334h5.5v-5.5h1.833v5.5h5.5V8.459h2.75z"})),esm_K=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 6 8",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M4.898.602c.22.22.22.576 0 .796L2.296 4l2.602 2.602a.563.563 0 0 1-.796.796l-3-3a.563.563 0 0 1 0-.796l3-3c.22-.22.576-.22.796 0",clipRule:"evenodd"})),esm_X=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M2.246 10.999a2.75 2.75 0 0 1 2.75-2.75h14.008a2.75 2.75 0 0 1 2.75 2.75v8.005a2.75 2.75 0 0 1-2.75 2.75H4.996a2.75 2.75 0 0 1-2.75-2.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v8.005c0 .69.56 1.25 1.25 1.25h14.008c.69 0 1.25-.56 1.25-1.25v-8.005c0-.69-.56-1.25-1.25-1.25zm-.249-3.752a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H5.497a.75.75 0 0 1-.75-.75m2.001-3a.75.75 0 0 1 .75-.75h10.004a.75.75 0 0 1 0 1.5H7.498a.75.75 0 0 1-.75-.75",clipRule:"evenodd"})),esm_Z=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M4.996 8.249a2.75 2.75 0 0 0-2.75 2.75v8.005a2.75 2.75 0 0 0 2.75 2.75h14.008a2.75 2.75 0 0 0 2.75-2.75v-8.005a2.75 2.75 0 0 0-2.75-2.75zm-.249-2.252a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H5.497a.75.75 0 0 1-.75-.75m2.001-3a.75.75 0 0 1 .75-.75h10.004a.75.75 0 0 1 0 1.5H7.498a.75.75 0 0 1-.75-.75",clipRule:"evenodd"})),$=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#87909D",d:"M14.167 5.833h-2.5a.836.836 0 0 0-.833.834c0 .458.375.833.833.833h2.5c1.375 0 2.5 1.125 2.5 2.5s-1.125 2.5-2.5 2.5h-2.5a.836.836 0 0 0-.833.833c0 .459.375.834.833.834h2.5c2.3 0 4.167-1.867 4.167-4.167s-1.867-4.167-4.167-4.167M6.667 10c0 .458.375.833.833.833h5a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.833h-5a.836.836 0 0 0-.833.833m1.667 2.5h-2.5a2.507 2.507 0 0 1-2.5-2.5c0-1.375 1.125-2.5 2.5-2.5h2.5a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834h-2.5A4.17 4.17 0 0 0 1.667 10c0 2.3 1.867 4.167 4.167 4.167h2.5a.836.836 0 0 0 .833-.834.836.836 0 0 0-.833-.833"})),ee=()=>e.createElement("svg",{"aria-hidden":"true","data-icon":"linkedin-in","data-prefix":"fab",viewBox:"0 0 448 512",xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em"},e.createElement("path",{fill:"currentColor",d:"M100.3 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.6 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.3 61.9 111.3 142.3V448z"})),le=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M10.25 5a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75m0 7a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75m0 7a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75M5.884 4.116a1.25 1.25 0 1 0-1.768 1.768 1.25 1.25 0 0 0 1.768-1.768m1.06-1.061a2.75 2.75 0 1 0-3.89 3.889 2.75 2.75 0 0 0 3.89-3.889m-1.06 8.061a1.25 1.25 0 1 0-1.768 1.768 1.25 1.25 0 0 0 1.768-1.768m1.06-1.061a2.75 2.75 0 1 0-3.89 3.889 2.75 2.75 0 0 0 3.89-3.889m-1.06 8.061a1.25 1.25 0 1 0-1.768 1.768 1.25 1.25 0 0 0 1.768-1.768m1.06-1.061a2.75 2.75 0 1 0-3.89 3.888 2.75 2.75 0 0 0 3.89-3.887z",clipRule:"evenodd"})),te=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 6 6",xmlns:"http://www.w3.org/2000/svg"},e.createElement("circle",{cx:3,cy:3,r:3,fill:"#fff"})),esm_ae=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M12 3.75A3.25 3.25 0 0 0 8.75 7v3a.75.75 0 0 1-1.5 0V7a4.75 4.75 0 0 1 9.5 0v3a.75.75 0 0 1-1.5 0V7A3.25 3.25 0 0 0 12 3.75m0 9.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7 10.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25zM4.25 12A2.75 2.75 0 0 1 7 9.25h10A2.75 2.75 0 0 1 19.75 12v7A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19z",clipRule:"evenodd"})),ie=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 36 34",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{clipPath:"url(#logo-min_svg__a)"},e.createElement("g",{clipPath:"url(#logo-min_svg__b)"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"m24.314 7.017-7.305 7.362a3.49 3.49 0 0 0 0 4.909l7.305 7.362a3.424 3.424 0 0 0 4.87 0l2.435-2.454-2.435-2.454-2.435 2.454-7.305-7.363 7.305-7.362 4.87 4.908-4.87 4.909 2.435 2.454 4.87-4.909a3.49 3.49 0 0 0 0-4.908l-4.87-4.908a3.424 3.424 0 0 0-4.87 0",clipRule:"evenodd"}))),e.createElement("defs",null,e.createElement("clipPath",{id:"logo-min_svg__a"},e.createElement("path",{fill:"#fff",d:"M0 0h35.063v33.667H0z"})),e.createElement("clipPath",{id:"logo-min_svg__b"},e.createElement("path",{fill:"#fff",d:"M16 4h19.063v25.667H16z"})))),esm_he=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 74 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M8.314 1.277 1.01 8.639a3.49 3.49 0 0 0 0 4.908l7.305 7.363a3.424 3.424 0 0 0 4.87 0l2.435-2.454L13.184 16l-2.435 2.454-7.305-7.362 7.305-7.362 4.87 4.908-4.87 4.908L13.184 16l4.87-4.908a3.49 3.49 0 0 0 0-4.908l-4.87-4.908a3.424 3.424 0 0 0-4.87 0",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",d:"M22.456 18.376V3.567h6.087c3.274 0 5.184 2.412 5.184 5.225 0 2.814-1.952 5.141-5.184 5.141H24.91v4.443zm6.087-6.6c1.658 0 2.834-1.333 2.834-3.046 0-1.714-1.134-3.025-2.834-3.025H24.87v6.07zm8.997-8.209v11.15c0 1.692.44 2.22 2.183 1.945l.084 1.777c-3.107.508-4.534-.296-4.534-3.701V3.568zM50.277 15.33c0 .93-.021 1.523 1.092 1.417v1.565c-1.449.275-2.939.106-2.939-1.586v-.423c-.566 1.417-1.994 2.221-3.484 2.221-3.086 0-4.576-2.496-4.576-5.373.063-3.385 2.456-5.246 5.752-5.183 1.448 0 2.834.36 4.156.952zm-2.204-5.077c-.693-.318-1.47-.423-2.12-.423-1.931 0-3.233 1.121-3.296 3.321 0 1.862.903 3.321 2.771 3.321 1.7 0 2.582-1.333 2.645-3.216zM56.169 8.2h3.506v1.862h-3.506v4.38c0 2.602 1.617 2.771 3.695 2.03l.23 1.735c-3.463 1.079-6.17.275-6.17-3.723v-4.422h-2.058V8.2h2.057V5.704h2.246zm4.943 9.71 2.939-4.632 2.204-3.216h-4.828V8.179h8.124v.296l-3.128 4.887-2.057 3.025h5.164v1.99h-8.418zm11.19-14.367c.693 0 1.365.465 1.365 1.354 0 .888-.672 1.375-1.344 1.375s-1.406-.445-1.406-1.375c0-.931.692-1.354 1.385-1.354m1.134 14.833h-2.288V8.2h2.288z"})),esm_ne=()=>e.createElement("svg",{xmlSpace:"preserve",viewBox:"0 0 62 138",xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em"},e.createElement("path",{d:"M58.4.6c-.2-.2-.5-.2-.7 0l-3.2 3.2c-.2.2-.2.5 0 .7s.5.2.7 0L58 1.7l2.8 2.8c.2.2.5.2.7 0s.2-.5 0-.7zM1.3 137.4C32.9 117.5 58.5 75.1 58.5 1h-1C57.5 74.8 32 116.9.7 136.6z",style:{fill:"#0ae98a"}})),esm_ce=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 22 23",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M2.06 10.749a2.52 2.52 0 0 1 2.52-2.521h12.84a2.52 2.52 0 0 1 2.521 2.52v7.339a2.52 2.52 0 0 1-2.52 2.52H4.58a2.52 2.52 0 0 1-2.52-2.52zm2.52-1.146c-.633 0-1.146.513-1.146 1.146v7.338c0 .633.513 1.146 1.146 1.146h12.84c.633 0 1.146-.513 1.146-1.146v-7.338c0-.633-.513-1.146-1.146-1.146zm-.228-3.439c0-.38.307-.687.687-.687h11.922a.687.687 0 1 1 0 1.375H5.039a.69.69 0 0 1-.687-.688m1.834-2.75c0-.38.308-.688.688-.688h9.17a.687.687 0 1 1 0 1.375h-9.17a.69.69 0 0 1-.688-.688",clipRule:"evenodd"})),me=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 22 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#6C7583",d:"M16.279 18.79a.913.913 0 0 1-1.293 0l-1.943-1.943a.913.913 0 1 1 1.293-1.292l1.292 1.292 3.245-3.245a.913.913 0 1 1 1.293 1.293zm-5.473-1.182H3.4a1.84 1.84 0 0 1-1.834-1.833v-11c0-1.009.825-1.834 1.834-1.834h14.666c1.009 0 1.834.825 1.834 1.834v6.123a6.412 6.412 0 0 0-9.167 5.793c0 .312.028.615.073.917m-.559-6.72a.93.93 0 0 0 .972 0l6.48-4.05a.778.778 0 1 0-.825-1.32l-6.14 3.84-6.143-3.84a.778.778 0 1 0-.825 1.32z"})),ve=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 22 22",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#6C7583",d:"M18.333 1.833H3.667a1.83 1.83 0 0 0-1.825 1.834l-.009 16.5L5.5 16.5h12.833a1.84 1.84 0 0 0 1.834-1.833v-11a1.84 1.84 0 0 0-1.834-1.834m-2.75 11H6.417c-.505 0-.917-.412-.917-.916S5.912 11 6.417 11h9.166c.505 0 .917.412.917.917s-.412.916-.917.916m0-2.75H6.417a.92.92 0 0 1-.917-.916.92.92 0 0 1 .917-.917h9.166a.92.92 0 0 1 .917.917.92.92 0 0 1-.917.916m0-2.75H6.417a.92.92 0 0 1-.917-.916.92.92 0 0 1 .917-.917h9.166a.92.92 0 0 1 .917.917.92.92 0 0 1-.917.916"})),de=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75m0-1.5A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25",clipRule:"evenodd"})),esm_oe=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 18",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M2 9c0-.31.303-.562.677-.562h12.646c.374 0 .677.251.677.562s-.303.563-.677.563H2.677C2.303 9.563 2 9.31 2 9",clipRule:"evenodd"})),we=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42"})),fe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{fill:"#C4C8CE"},e.createElement("path",{d:"M12 21.8c-.9 0-1.7-.3-2.3-.9s-.9-1.4-.9-2.3V18c0-.4.3-.8.8-.8s.8.3.8.8v.5c0 .5.2.9.5 1.2.7.7 1.8.7 2.5 0 .3-.3.5-.8.5-1.2V18c0-.4.3-.8.8-.8s.8.3.8.8v.5c0 .9-.3 1.7-.9 2.3-.9.6-1.7 1-2.6 1"}),e.createElement("path",{d:"M17.85 18.85H6.05c-.7 0-1.5-.3-2-.8s-.8-1.2-.8-2 .3-1.5.9-2.1l1.1-1.1v-3.8c0-3.7 3-6.8 6.8-6.8 3.7 0 6.8 3 6.8 6.8v3.7l1.1 1.1q.9.9.9 2.1c-.1 1.6-1.4 2.9-3 2.9m-5.9-15.1c-2.9 0-5.3 2.4-5.3 5.3v4c0 .2-.1.4-.2.5l-1.4 1.4c-.3.3-.4.6-.4 1 0 .3.1.7.4.9.2.2.6.4.9.4h11.9c.7 0 1.3-.6 1.3-1.3 0-.4-.1-.7-.4-1l-1.4-1.4c-.1-.1-.2-.3-.2-.5v-4c.1-2.9-2.3-5.3-5.2-5.3"}))),esm_se=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{fill:"#fff",fillRule:"evenodd",clipRule:"evenodd"},e.createElement("path",{d:"M6.38 9.377a1.124 1.124 0 1 0-1.591 1.59 1.125 1.125 0 0 0 1.59-1.59m4.416.001a1.124 1.124 0 1 0-1.591 1.59 1.125 1.125 0 0 0 1.591-1.59m-.546-8.206a.75.75 0 0 1 .75-.75h1c.788 0 1.499.332 2 .863a2.74 2.74 0 0 1 2-.863h1a.75.75 0 0 1 0 1.5h-1c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0c0-.69-.56-1.25-1.25-1.25h-1a.75.75 0 0 1-.75-.75"}),e.createElement("path",{d:"M14 2.422a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0v-14a.75.75 0 0 1 .75-.75"}),e.createElement("path",{d:"M14 16.422a.75.75 0 0 1 .75.75c0 .691.56 1.25 1.25 1.25h1a.75.75 0 0 1 0 1.5h-1a2.74 2.74 0 0 1-2-.862 2.74 2.74 0 0 1-2 .862h-1a.75.75 0 0 1 0-1.5h1c.69 0 1.25-.559 1.25-1.25a.75.75 0 0 1 .75-.75M3 5.922c-.69 0-1.25.56-1.25 1.25v6c0 .691.56 1.25 1.25 1.25h8a.75.75 0 0 1 0 1.5H3a2.75 2.75 0 0 1-2.75-2.75v-6A2.75 2.75 0 0 1 3 4.422h8a.75.75 0 0 1 0 1.5zm10.25-.75a.75.75 0 0 1 .75-.75h3a2.75 2.75 0 0 1 2.75 2.75v6a2.75 2.75 0 0 1-2.75 2.75h-3a.75.75 0 0 1 0-1.5h3c.69 0 1.25-.559 1.25-1.25v-6c0-.69-.56-1.25-1.25-1.25h-3a.75.75 0 0 1-.75-.75"}))),esm_re=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 40 40",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M30 27.949a2.692 2.692 0 1 0 0 5.384 2.692 2.692 0 0 0 0-5.384m-5 2.692a5 5 0 1 1 10 0 5 5 0 0 1-10 0m-13.461-25a4.23 4.23 0 0 0-4.231 4.23c0 .884.514 1.949 1.378 3.057.83 1.064 1.852 2.006 2.597 2.63a.43.43 0 0 0 .51 0c.745-.624 1.768-1.565 2.598-2.63.864-1.108 1.378-2.173 1.378-3.056a4.23 4.23 0 0 0-4.23-4.23M5 9.871a6.538 6.538 0 0 1 13.077 0c0 1.674-.914 3.254-1.866 4.476-.98 1.256-2.15 2.324-2.958 2.997l-.029.024a2.74 2.74 0 0 1-3.403-.025c-.806-.673-1.977-1.74-2.956-2.997C5.913 13.124 5 11.545 5 9.872m15.385 2.309c0-.638.516-1.154 1.153-1.154h3.077a5.77 5.77 0 0 1 0 11.538h-9.23a3.462 3.462 0 0 0 0 6.923H20a1.154 1.154 0 1 1 0 2.308h-4.615a5.77 5.77 0 0 1 0-11.538h9.23a3.462 3.462 0 0 0 0-6.924H21.54a1.154 1.154 0 0 1-1.154-1.153",clipRule:"evenodd"}),e.createElement("path",{fill:"#0AE98A",d:"M11.539 11.41a1.538 1.538 0 1 0 0-3.077 1.538 1.538 0 0 0 0 3.077"})),ge=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M15.258 6.987 8.501 7A.75.75 0 1 1 8.5 5.5l6.757-.013a3.75 3.75 0 0 1 3.756 3.762v.016-.017.017A3.75 3.75 0 0 1 15.263 13h-5.014A2.25 2.25 0 0 0 8 15.249H6.5a3.75 3.75 0 0 1 3.749-3.749h5.014a2.25 2.25 0 0 0 2.249-2.24v.002-.003.001-.015a2.25 2.25 0 0 0-2.254-2.258m-5.006 12.011 9.998-.003a.75.75 0 0 0 0-1.5l-10 .003A2.25 2.25 0 0 1 8 15.249H6.5a3.75 3.75 0 0 0 3.752 3.749",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M20.78 17.715a.75.75 0 0 1 0 1.06l-1.997 1.997a.75.75 0 1 1-1.06-1.06l1.997-1.997a.75.75 0 0 1 1.06 0",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M17.723 15.717a.75.75 0 0 1 1.06 0l1.997 1.998a.75.75 0 1 1-1.06 1.06l-1.997-1.998a.75.75 0 0 1 0-1.06M7.31 5.188A1.5 1.5 0 1 0 5.188 7.31 1.5 1.5 0 0 0 7.31 5.188m1.06-1.06A3 3 0 1 0 4.13 8.37a3 3 0 0 0 4.24-4.24",clipRule:"evenodd"})),pe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M9.334 5.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m-2.667 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5",clipRule:"evenodd"}),e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m0-1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 1 0 0-13",clipRule:"evenodd"})),Ee=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 200 53",xmlns:"http://www.w3.org/2000/svg"},react.createElement("g",{fill:"#0AEB8B",clipPath:"url(#platzi-logo-minty_svg__a)"},react.createElement("path",{fillRule:"evenodd",d:"M20.304 2.462 2.462 20.303a8.41 8.41 0 0 0 0 11.897l17.842 17.842a8.41 8.41 0 0 0 11.896 0l5.945-5.946-5.945-5.945-5.945 5.945L8.413 26.254 26.255 8.412 38.15 20.31 26.254 32.205l5.946 5.946 11.896-11.897a8.41 8.41 0 0 0 0-11.896L32.2 2.462a8.41 8.41 0 0 0-11.896 0",clipRule:"evenodd"}),react.createElement("path",{d:"M192.283 13.785h7.043v33.597h-7.043zm-53.027-.09h-.621v5.838h5.384v20.544q.001 3.492 1.873 5.394c1.247 1.269 3.104 1.905 5.555 1.905h6.138v-5.752h-6.524V19.533h7.043v-5.839h-7.043V5.341h-6.33v4.174a4.18 4.18 0 0 1-4.175 4.18h-1.311zm56.548-4.127a4.19 4.19 0 1 0 .001-8.38 4.19 4.19 0 0 0-.001 8.38M95.84 47.392a4.19 4.19 0 0 1-4.19-4.19V5.378h7.042v36.256h4.65v5.753H98.82l-2.98.01zm65.903-.01v-5.689l18.029-22.16h-17.446v-5.839l25.778.091v5.427l-18.286 22.422h18.735v5.753h-26.816zm-27.052 0c-1.851 0-3.275-.525-4.265-1.584q-1.487-1.584-1.809-4.04h-.321q-.97 3.164-3.553 4.778-2.583 1.615-6.267 1.616-5.234 0-8.043-2.713-2.81-2.714-2.809-7.3-.002-5.04 3.649-7.56 3.652-2.521 10.692-2.521h6.074v-2.842q-.001-3.1-1.68-4.779-1.677-1.678-5.234-1.68c-1.98 0-3.596.433-4.848 1.29a11.6 11.6 0 0 0-3.168 3.296l-4.201-3.81q1.679-2.843 4.715-4.683 3.033-1.839 7.946-1.84 6.528-.001 10.013 3.034c2.328 2.023 3.489 4.934 3.489 8.723v16.862h3.554v5.753h-3.944zm-14.213-4.586q3.299-.001 5.426-1.456c1.424-.969 2.13-2.269 2.13-3.907V32.59h-5.945c-4.87 0-7.3 1.51-7.3 4.522v1.162q.002 2.262 1.52 3.393t4.169 1.129m-65.534 4.586V5.34h19.383c4.18 0 7.406 1.225 9.691 3.681 2.28 2.457 3.425 5.753 3.425 9.885q.001 6.198-3.425 9.884c-2.285 2.456-5.512 3.682-9.691 3.682H62.243v14.903h-7.3zm7.3-21.363h11.628q2.779-.001 4.33-1.44c1.032-.958 1.551-2.338 1.551-4.131v-3.072c0-1.793-.513-3.168-1.552-4.131q-1.55-1.439-4.33-1.44H62.244z"})),react.createElement("defs",null,react.createElement("clipPath",{id:"platzi-logo-minty_svg__a"},react.createElement("path",{fill:"#fff",d:"M0 0h200v52.503H0z"})))),esm_ue=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 92 32",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{fill:"#0AE98A",clipPath:"url(#platzi-logo-new_svg__a)"},e.createElement("path",{d:"M25.334 25.135V6.106h8.77c1.897 0 3.355.555 4.386 1.663s1.546 2.606 1.546 4.473-.515 3.364-1.546 4.473c-1.03 1.108-2.499 1.662-4.385 1.662H28.63v6.748h-3.306zm3.306-9.675h5.26c.837 0 1.488-.214 1.965-.651q.7-.657.7-1.867v-1.39c0-.807-.234-1.44-.7-1.867-.467-.438-1.119-.652-1.965-.652h-5.26v6.437zm32.797 9.675c-.836 0-1.478-.243-1.935-.72-.447-.476-.72-1.088-.816-1.827h-.146c-.292.953-.827 1.682-1.604 2.168q-1.165.73-2.84.73-2.362-.001-3.646-1.226c-.856-.817-1.274-1.925-1.274-3.306 0-1.517.554-2.664 1.653-3.423q1.648-1.137 4.842-1.137h2.752V15.11q0-1.398-.758-2.168c-.506-.506-1.294-.759-2.373-.759q-1.34 0-2.197.584a5.2 5.2 0 0 0-1.43 1.488l-1.906-1.721c.506-.856 1.216-1.566 2.14-2.12.914-.554 2.12-.836 3.597-.836 1.974 0 3.481.457 4.531 1.37 1.05.915 1.576 2.237 1.576 3.948v7.633h1.604v2.606h-1.789zM55 23.055c.992 0 1.819-.224 2.46-.662.642-.437.963-1.03.963-1.77v-2.197H55.73c-2.207 0-3.306.68-3.306 2.052v.525c0 .68.233 1.196.69 1.536s1.09.515 1.887.515m18.689 2.08v-2.577l8.158-10.034h-7.895V9.879l11.668.039v2.46l-8.275 10.151h8.479v2.606zm-29.841.01a1.89 1.89 0 0 1-1.896-1.896V6.126h3.189v16.413h2.11v2.606zM89.11 8.022a1.896 1.896 0 1 0 0-3.792 1.896 1.896 0 0 0 0 3.792M63.499 9.889h-.282v2.645h2.44v9.305c0 1.05.282 1.867.846 2.44.564.574 1.4.866 2.519.866h2.78v-2.606h-2.955V12.534h3.189V9.889h-3.19V6.106h-2.868v1.887c0 1.04-.846 1.886-1.886 1.886h-.593zm24.017.039h3.19v15.207h-3.19z"}),e.createElement("path",{fillRule:"evenodd",d:"m9.65 4.803-8.07 8.07a3.81 3.81 0 0 0 0 5.388l8.08 8.08a3.81 3.81 0 0 0 5.387 0l2.693-2.694-2.693-2.693-2.694 2.693-8.08-8.08 8.07-8.07 5.387 5.387-5.387 5.386 2.694 2.694 5.387-5.387a3.81 3.81 0 0 0 0-5.387l-5.387-5.387a3.81 3.81 0 0 0-5.387 0",clipRule:"evenodd"})),e.createElement("defs",null,e.createElement("clipPath",{id:"platzi-logo-new_svg__a"},e.createElement("path",{fill:"#fff",d:"M.461 0h91.077v32H.461z"})))),xe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 21 26",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M9.314 3.277 2.01 10.639a3.49 3.49 0 0 0 0 4.908l7.305 7.363a3.424 3.424 0 0 0 4.87 0l2.435-2.454L14.184 18l-2.435 2.454-7.305-7.362 7.305-7.362 4.87 4.908-4.87 4.908L14.184 18l4.87-4.908a3.49 3.49 0 0 0 0-4.908l-4.87-4.908a3.424 3.424 0 0 0-4.87 0",clipRule:"evenodd"})),Me=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7 7.141c0-1.36 1.484-2.2 2.65-1.5l8.098 4.859a1.75 1.75 0 0 1 0 3.001l-8.099 4.86C8.484 19.058 7 18.218 7 16.858z",clipRule:"evenodd"})),Re=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M17 9.5a.705.705 0 0 1 0 .998l-4 4.001a.705.705 0 0 1-1.013-.016L10 12.363l-1.987 2.12a.705.705 0 0 1-1.028-.964l2.5-2.668a.705.705 0 0 1 1.03 0l2.003 2.136 3.486-3.486a.705.705 0 0 1 .997 0",clipRule:"evenodd"}),react.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M2.246 7.996a5.75 5.75 0 0 1 5.75-5.75h8.008a5.75 5.75 0 0 1 5.75 5.75v8.008a5.75 5.75 0 0 1-5.75 5.75H7.996a5.75 5.75 0 0 1-5.75-5.75zm5.75-4.25a4.25 4.25 0 0 0-4.25 4.25v8.008a4.25 4.25 0 0 0 4.25 4.25h8.008a4.25 4.25 0 0 0 4.25-4.25V7.996a4.25 4.25 0 0 0-4.25-4.25z",clipRule:"evenodd"})),Ae=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7.996 2.246a5.75 5.75 0 0 0-5.75 5.75v8.008a5.75 5.75 0 0 0 5.75 5.75h8.008a5.75 5.75 0 0 0 5.75-5.75V7.996a5.75 5.75 0 0 0-5.75-5.75zM17 9.501a.705.705 0 0 1 0 .997l-4 4.001a.705.705 0 0 1-1.013-.016L10 12.363l-1.987 2.12a.705.705 0 1 1-1.028-.964l2.5-2.668a.705.705 0 0 1 1.03 0l2.002 2.136 3.487-3.486a.705.705 0 0 1 .997 0",clipRule:"evenodd"})),ze=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M18.624 4.084a.75.75 0 0 1-.208 1.04c-1.505 1.004-2.344 1.659-2.87 2.711-.493.987-.75 2.401-.79 4.915H19c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 0 1 19 20.25h-4a1.75 1.75 0 0 1-1.75-1.75v-5c0-3.01.244-4.916.954-6.335.724-1.448 1.885-2.293 3.38-3.289a.75.75 0 0 1 1.04.208M14.75 14.25v4.25c0 .138.112.25.25.25h4a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25zM8.624 4.084a.75.75 0 0 1-.208 1.04c-1.505 1.004-2.344 1.659-2.87 2.711-.493.987-.75 2.401-.79 4.915H9c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 0 1 9 20.25H5a1.75 1.75 0 0 1-1.75-1.75v-5c0-3.01.244-4.916.954-6.335.724-1.448 1.885-2.293 3.38-3.289a.75.75 0 0 1 1.04.208M4.75 14.25v4.25c0 .138.112.25.25.25h4a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25z",clipRule:"evenodd"})),He=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M12 3.25A8.75 8.75 0 1 1 3.25 12a.75.75 0 0 1 1.5 0 7.25 7.25 0 1 0 1.627-4.575h1.67a.75.75 0 1 1 0 1.5H4.512a.75.75 0 0 1-.75-.75V4.639a.75.75 0 1 1 1.5 0v1.78A8.73 8.73 0 0 1 12 3.25",clipRule:"evenodd"})),Be=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M8 2.5c-3.073 0-5.5 2.25-5.5 4.955 0 1.603.847 3.031 2.181 3.943a.5.5 0 0 1 .218.413v1.392l1.713-.847s.088-.035.148-.044c.063-.01.162 0 .162 0q.525.096 1.078.097c3.073 0 5.5-2.25 5.5-4.954C13.5 4.75 11.073 2.5 8 2.5M6.91 13.324q.532.084 1.09.085c3.53 0 6.5-2.607 6.5-5.954C14.5 4.107 11.53 1.5 8 1.5S1.5 4.107 1.5 7.455c0 1.881.95 3.533 2.4 4.613v1.94a.5.5 0 0 0 .721.449z",clipRule:"evenodd"})),Ce=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 22 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#6C7583",d:"M8.98 7.147V5.69c0-.816-.99-1.229-1.568-.651L3.205 9.246a.913.913 0 0 0 0 1.293l4.207 4.207c.578.578 1.568.175 1.568-.641v-1.55c4.583 0 7.792 1.467 10.083 4.676-.916-4.584-3.666-9.167-10.083-10.084"})),Ve=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 18",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#C4C8CE",d:"M4.586 15.173 5.914 16.5l7.5-7.5-7.5-7.5-1.328 1.328L10.76 9z"})),Le=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 12 12",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#13161C",d:"M6 0 4.943 1.058 9.128 5.25H0v1.5h9.128l-4.185 4.193L6 12l6-6z"})),ke=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 40 40",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M14.58 4.16a1.25 1.25 0 1 0-2.5 0v1.251H9.996a6.25 6.25 0 0 0-6.252 6.252v18.341a6.25 6.25 0 0 0 6.252 6.252h20.008a6.25 6.25 0 0 0 6.252-6.252v-18.34a6.25 6.25 0 0 0-6.252-6.253H27.92v-1.25a1.25 1.25 0 0 0-2.5 0v1.25H14.58zm-2.5 3.751v1.251a1.25 1.25 0 0 0 2.5 0v-1.25h10.84v1.25a1.25 1.25 0 1 0 2.5 0v-1.25h2.084a3.75 3.75 0 0 1 3.752 3.751v2.085H6.244v-2.085a3.75 3.75 0 0 1 3.752-3.752zm-5.836 8.337v13.756a3.75 3.75 0 0 0 3.752 3.752h20.008a3.75 3.75 0 0 0 3.752-3.752V16.248zM20 20.418a1.25 1.25 0 1 0 0 2.5h8.337a1.25 1.25 0 0 0 0-2.5zm-8.327 6.669a1.25 1.25 0 0 0-.02 2.5l8.179.061a1.25 1.25 0 1 0 .019-2.5z",clipRule:"evenodd"})),esm_e=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 22 22",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{stroke:"#fff",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.5,d:"m18.334 18.333-3.322-3.321m-11.346-4.7a6.646 6.646 0 1 0 6.646-6.645v0a6.646 6.646 0 0 0-6.645 6.646"})),qe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#2D323A",fillRule:"evenodd",d:"M18.049 3.38c1.606-.595 3.169.968 2.575 2.574l-5 13.486c-.685 1.846-3.343 1.7-3.821-.21l-1.406-5.612-5.632-1.415c-1.908-.48-2.054-3.136-.208-3.82zm-3.831 15.538 4.999-13.484a.504.504 0 0 0-.647-.648L5.078 9.79a.503.503 0 0 0 .052.96l6.067 1.524a.75.75 0 0 1 .545.545l1.515 6.048c.12.48.787.517.96.052",clipRule:"evenodd"})),Se=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{stroke:"#fff",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.5,d:"m3.9 15.647 1.398.214a2 2 0 0 1 1.693 2.123l-.103 1.411c-.03.411.194.798.565.977l1.034.498c.371.179.814.112 1.117-.167l1.039-.96a2 2 0 0 1 2.715 0l1.039.96c.303.28.745.346 1.117.167l1.036-.499a1 1 0 0 0 .563-.974l-.103-1.413a2 2 0 0 1 1.693-2.123l1.398-.214c.407-.062.735-.367.827-.769l.255-1.118a1 1 0 0 0-.411-1.051l-1.167-.799a2 2 0 0 1-.604-2.647l.705-1.226a1 1 0 0 0-.086-1.126l-.715-.897a1 1 0 0 0-1.079-.334l-1.352.414a2 2 0 0 1-2.448-1.178l-.518-1.313a1 1 0 0 0-.936-.635l-1.146.003a1 1 0 0 0-.933.64l-.505 1.298a2 2 0 0 1-2.452 1.186l-1.408-.432a1 1 0 0 0-1.082.336l-.71.898a1 1 0 0 0-.08 1.13l.722 1.229a2 2 0 0 1-.595 2.662l-1.153.79c-.34.233-.503.65-.411 1.051l.255 1.118a1 1 0 0 0 .826.77",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M13.386 10.614a1.96 1.96 0 1 0-2.772 2.773 1.96 1.96 0 0 0 2.772-2.773m1.06-1.06a3.46 3.46 0 1 0-4.892 4.893 3.46 3.46 0 0 0 4.892-4.893",clipRule:"evenodd"})),Pe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 18",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M2.438 9c0-1.14.923-2.062 2.062-2.062H6a.563.563 0 0 1 0 1.125H4.5A.937.937 0 0 0 3.563 9v5.25c0 .518.419.938.937.938h9c.518 0 .938-.42.938-.938V9a.937.937 0 0 0-.938-.937H12a.562.562 0 1 1 0-1.126h1.5c1.14 0 2.063.924 2.063 2.063v5.25c0 1.14-.924 2.063-2.063 2.063h-9a2.06 2.06 0 0 1-2.062-2.063z"}),e.createElement("path",{fill:"#fff",d:"M9 1.688c.31 0 .563.251.563.562v8.25a.562.562 0 1 1-1.126 0V2.25c0-.31.252-.562.563-.562"}),e.createElement("path",{fill:"#fff",d:"M9 1.688c.15 0 .292.059.398.164l2.25 2.25a.562.562 0 1 1-.796.796L9 3.046 7.15 4.898a.562.562 0 1 1-.796-.796l2.25-2.25A.56.56 0 0 1 9 1.687"})),Fe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 22 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#C4C8CE",d:"m11 1.833-7.333 2.75v5.583c0 4.629 3.125 8.946 7.333 10 4.207-1.054 7.333-5.371 7.333-10V4.583zm5.5 8.333c0 3.666-2.338 7.058-5.5 8.094-3.163-1.036-5.5-4.419-5.5-8.094V5.857L11 3.795l5.5 2.062z"})),De=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 18",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M4.5 13.5 10.875 9 4.5 4.5zm7.5-9v9h1.5v-9z"})),be=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 18",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",d:"M4.5 4.5H6v9H4.5zM7.125 9l6.375 4.5v-9z"})),Oe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 40 40",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M17.598 16.173v7.652l6.47-3.826zm1.273-2.152c-1.668-.987-3.773.218-3.773 2.152v7.652c0 1.935 2.105 3.14 3.773 2.153l6.47-3.827c1.636-.967 1.637-3.336 0-4.304z",clipRule:"evenodd"}),e.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M10 6.25A3.75 3.75 0 0 0 6.25 10v20A3.75 3.75 0 0 0 10 33.75h20A3.75 3.75 0 0 0 33.75 30V10A3.75 3.75 0 0 0 30 6.25zM3.75 10A6.25 6.25 0 0 1 10 3.75h20A6.25 6.25 0 0 1 36.25 10v20A6.25 6.25 0 0 1 30 36.25H10A6.25 6.25 0 0 1 3.75 30z",clipRule:"evenodd"})),ye=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#fff",d:"m9.6 18.2-2.375-5.225L2 10.6l5.225-2.375L9.6 3l2.375 5.225L17.2 10.6l-5.225 2.375zm8.6 2.8-1.175-2.625L14.4 17.2l2.625-1.2 1.175-2.6 1.2 2.6 2.6 1.2-2.6 1.175z"})),We=()=>react.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{fill:"#C4C8CE",d:"m9.6 14.575 1.252-2.723 2.723-1.252-2.723-1.252L9.6 6.625 8.348 9.348 5.625 10.6l2.723 1.252zm0 3.625-2.375-5.225L2 10.6l5.225-2.375L9.6 3l2.375 5.225L17.2 10.6l-5.225 2.375zm8.6 2.8-1.175-2.625L14.4 17.2l2.625-1.2 1.175-2.6 1.2 2.6 2.6 1.2-2.6 1.175z"})),Ne=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 10 10",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{fill:"#0AE98A"},e.createElement("path",{d:"M5.152 1.824a.73.73 0 0 1 1.363 0l.338.889A2.2 2.2 0 0 0 8.12 3.98l.889.337a.73.73 0 0 1 0 1.364l-.889.337a2.2 2.2 0 0 0-1.267 1.268l-.338.889a.73.73 0 0 1-1.363 0l-.338-.889A2.2 2.2 0 0 0 3.546 6.02l-.888-.337a.73.73 0 0 1 0-1.364l.888-.337a2.2 2.2 0 0 0 1.268-1.268z"}),e.createElement("path",{fillRule:"evenodd",d:"M2.5 6.77c.173 0 .313.14.313.313V8.75a.312.312 0 1 1-.626 0V7.083c0-.172.14-.312.313-.312",clipRule:"evenodd"}),e.createElement("path",{fillRule:"evenodd",d:"M1.354 7.917c0-.173.14-.313.313-.313h1.666a.312.312 0 1 1 0 .625H1.667a.31.31 0 0 1-.313-.312m.73-6.98c.172 0 .312.14.312.313v1.667a.312.312 0 1 1-.625 0V1.25c0-.173.14-.312.312-.312",clipRule:"evenodd"}),e.createElement("path",{fillRule:"evenodd",d:"M.938 2.083c0-.172.14-.312.312-.312h1.667a.312.312 0 1 1 0 .625H1.25a.31.31 0 0 1-.312-.313",clipRule:"evenodd"}))),je=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#E9C958",fillRule:"evenodd",d:"M8 1.5c-.434 0-.833.242-1.034.627L5.382 5.162l-2.908.49a1.167 1.167 0 0 0-.64 1.967l2.173 2.215-.494 3.327a1.167 1.167 0 0 0 1.674 1.216L8 12.977l2.814 1.4a1.167 1.167 0 0 0 1.673-1.216l-.494-3.327 2.173-2.215a1.167 1.167 0 0 0-.64-1.967l-2.908-.49-1.583-3.035A1.17 1.17 0 0 0 8 1.5",clipRule:"evenodd"})),Qe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.96 20.94c.52.52 1.21.81 1.95.81l-.01.01c.74 0 1.43-.29 1.95-.81l5.09-5.1c.52-.52.81-1.22.81-1.95s-.29-1.42-.81-1.94l-8.9-8.91c-.51-.52-1.27-.82-1.95-.8l-2.85.03c-.72 0-1.4.29-1.91.8L3.05 5.36c-.51.51-.8 1.21-.8 1.93v2.81c0 .73.28 1.41.8 1.93zM8.84 7.23c-.44-.44-1.17-.44-1.61 0s-.44 1.17 0 1.61 1.17.44 1.61 0 .44-1.17 0-1.61",clipRule:"evenodd"})),Ue=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.96 20.94c.52.52 1.21.81 1.95.81l-.01.01c.74 0 1.43-.29 1.95-.81l5.09-5.1c.52-.52.81-1.22.81-1.95s-.29-1.42-.81-1.94l-8.9-8.91c-.51-.52-1.27-.82-1.95-.8l-2.85.03c-.72 0-1.4.29-1.91.8L3.05 5.36c-.51.51-.8 1.21-.8 1.93v2.81c0 .73.28 1.41.8 1.93zM10.1 3.75h.01c.32 0 .64.13.87.36l8.9 8.91a1.234 1.234 0 0 1 0 1.76l-5.09 5.1c-.47.47-1.3.47-1.77 0l-8.91-8.91c-.23-.23-.36-.55-.36-.87V7.29c0-.32.13-.64.36-.87l2.28-2.29c.23-.23.54-.36.86-.36zM8.84 7.23c-.44-.44-1.17-.44-1.61 0s-.44 1.17 0 1.61 1.17.44 1.61 0 .44-1.17 0-1.61",clipRule:"evenodd"})),Te=()=>e.createElement("svg",{"aria-hidden":"true","data-icon":"telegram","data-prefix":"fab",viewBox:"0 0 496 512",xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em"},e.createElement("path",{fill:"currentColor",d:"M248 8C111 8 0 119 0 256s111 248 248 248 248-111.9 248-248S384.1 8 248 8m114.1 168.7c-3.732 39.22-19.88 134.4-28.1 178.3-3.476 18.58-10.32 24.82-16.95 25.42-14.4 1.326-25.34-9.517-39.29-18.66-21.83-14.31-34.16-23.22-55.35-37.18-24.49-16.14-8.612-25 5.342-39.5 3.652-3.793 67.11-61.51 68.33-66.75.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.6 69.14-14.85 10.19-26.89 9.934c-8.855-.191-25.89-5.006-38.55-9.123-15.53-5.048-27.88-7.717-26.8-16.29q.84-6.7 18.45-13.7 108.4-47.25 144.6-62.3c68.87-28.65 83.18-33.62 92.51-33.79 2.052-.034 6.639.474 9.61 2.885a10.45 10.45 0 0 1 3.53 6.716 43.8 43.8 0 0 1 .447 9.782"})),Ge=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M6 5.25a.75.75 0 0 1 .75.75v12.75c0 .837.66 1.5 1.481 1.5h7.5c.836 0 1.519-.68 1.519-1.5V6a.75.75 0 0 1 1.5 0v12.75c0 1.666-1.371 3-3.019 3h-7.5a2.983 2.983 0 0 1-2.981-3V6A.75.75 0 0 1 6 5.25",clipRule:"evenodd"}),e.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M3.75 6a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15A.75.75 0 0 1 3.75 6m5.5-3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9.25 3M14 9.25a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75m-4 0a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75",clipRule:"evenodd"})),Ie=()=>e.createElement("svg",{"aria-hidden":"true","data-icon":"twitter","data-prefix":"fab",viewBox:"0 0 512 512",xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em"},e.createElement("path",{fill:"currentColor",d:"M459.4 151.7c.325 4.548.325 9.097.325 13.65 0 138.7-105.6 298.6-298.6 298.6-59.45 0-114.7-17.22-161.1-47.11 8.447.974 16.57 1.299 25.34 1.299 49.06 0 94.21-16.57 130.3-44.83-46.13-.975-84.79-31.19-98.11-72.77 6.498.974 12.99 1.624 19.82 1.624 9.421 0 18.84-1.3 27.61-3.573-48.08-9.747-84.14-51.98-84.14-102.1v-1.299c13.97 7.797 30.21 12.67 47.43 13.32-28.26-18.84-46.78-51.01-46.78-87.39 0-19.49 5.197-37.36 14.29-52.95 51.65 63.67 129.3 105.3 216.4 109.8-1.624-7.797-2.599-15.92-2.599-24.04 0-57.83 46.78-104.9 104.9-104.9 30.21 0 57.5 12.67 76.67 33.14 23.72-4.548 46.46-13.32 66.6-25.34-7.798 24.37-24.37 44.83-46.13 57.83 21.12-2.273 41.58-8.122 60.43-16.24-14.29 20.79-32.16 39.31-52.63 54.25z"})),Ye=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7 10.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25zM4.25 12A2.75 2.75 0 0 1 7 9.25h10A2.75 2.75 0 0 1 19.75 12v7A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19zm3.157-6.16C7.926 3.784 9.774 2.25 12 2.25A4.75 4.75 0 0 1 16.75 7a.75.75 0 0 1-1.5 0A3.25 3.25 0 0 0 12 3.75a3.24 3.24 0 0 0-3.139 2.457.75.75 0 0 1-1.454-.368",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M16 6.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m-4 7a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",clipRule:"evenodd"})),Je=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 22 22",xmlns:"http://www.w3.org/2000/svg"},e.createElement("g",{stroke:"#C4C8CE",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.5},e.createElement("path",{d:"m16.283 17.334-.321-.806a2.94 2.94 0 0 0-.737-1.074l-.059-.054a2.75 2.75 0 0 0-1.868-.733H8.702a2.76 2.76 0 0 0-1.87.732l-.058.055a3 3 0 0 0-.737 1.074l-.32.806m7.552-10.507a3.208 3.208 0 1 1-4.538 4.537 3.208 3.208 0 0 1 4.538-4.537"}),e.createElement("path",{d:"M16.834 5.166A8.25 8.25 0 1 1 5.166 16.834 8.25 8.25 0 0 1 16.834 5.166"}))),Ke=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7 14.75A3.25 3.25 0 0 0 3.75 18a.75.75 0 0 1-1.5 0A4.75 4.75 0 0 1 7 13.25h4A4.75 4.75 0 0 1 15.75 18a.75.75 0 0 1-1.5 0A3.25 3.25 0 0 0 11 14.75zm8.25-10.099a.75.75 0 0 1 .75-.75 3.25 3.25 0 1 1 0 6.5.75.75 0 0 1 0-1.5 1.75 1.75 0 1 0 0-3.5.75.75 0 0 1-.75-.75m-4.375.875a2.651 2.651 0 1 0-3.75 3.75 2.651 2.651 0 0 0 3.75-3.75m1.06-1.06a4.151 4.151 0 1 0-5.87 5.87 4.151 4.151 0 0 0 5.87-5.87M16.25 13a.75.75 0 0 1 .75-.75A4.75 4.75 0 0 1 21.75 17a.75.75 0 0 1-1.5 0A3.25 3.25 0 0 0 17 13.75a.75.75 0 0 1-.75-.75",clipRule:"evenodd"})),Xe=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M19.252 12a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-6.002 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-6.003 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0",clipRule:"evenodd"})),Ze=()=>e.createElement("svg",{width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"#B72B23",fillRule:"evenodd",d:"M21.75 12A9.75 9.75 0 0 0 12 2.25 9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12M12 6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m0 10.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",clipRule:"evenodd"})),$e=()=>e.createElement("svg",{width:"1em",height:"1em","aria-hidden":"true","data-icon":"whatsapp","data-prefix":"fab",viewBox:"0 0 448 512",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{fill:"currentColor",d:"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157m-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6m101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6"}));
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@platzi/atomic-ui/node_modules/classnames/bind.js
var bind = __webpack_require__(9816);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/primitive/dist/index.mjs
function dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-compose-refs/dist/index.mjs



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function dist_$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function dist_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>dist_$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react.useCallback)(dist_$6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-context/dist/index.mjs



function dist_$c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0,react.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0,react.useMemo)(()=>context
        , Object.values(context));
        return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0,react.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function dist_$c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        dist_$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function dist_$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-id/dist/index.mjs





const $1746a345f3d73bb7$var$useReactId = react_namespaceObject['useId'.toString()] || (()=>undefined
);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = react.useState($1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs





function dist_$71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = dist_$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    const setValue = (0,react.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function dist_$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0,react.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0,react.useRef)(value);
    const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange);
    (0,react.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-slot/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find(dist_$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react.Children.count(newElement) > 1) return react.Children.only(null);
                return /*#__PURE__*/ (0,react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react.createElement)(dist_$5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react.isValidElement)(newElement) ? /*#__PURE__*/ (0,react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react.createElement)(dist_$5e63c961fc1ce211$var$SlotClone, (0,esm_extends/* default */.Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const dist_$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react.isValidElement)(children)) return /*#__PURE__*/ (0,react.cloneElement)(children, {
        ...dist_$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? dist_$6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    });
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
dist_$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const dist_$5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function dist_$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react.isValidElement)(child) && child.type === dist_$5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function dist_$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const dist_$5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-primitive/dist/index.mjs









const dist_$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const dist_$8927f6f2acc4f386$export$250ffa63cdc0d034 = dist_$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        (0,react.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react.createElement)(Comp, (0,esm_extends/* default */.Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function dist_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) (0,react_dom.flushSync)(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const dist_$8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && (dist_$8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs





/**
 * Listens for when the escape key is down
 */ function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs















/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = 'DismissableLayer';
const $5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0,react.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0,react.useContext)($5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0,react.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0,react.useState)({});
    const composedRefs = dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    $addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0,react.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0,react.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0,react.useEffect)(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    displayName: $5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $5cb92bef7577960e$var$BRANCH_NAME = 'DismissableLayerBranch';
const $5cb92bef7577960e$export$4d5eb2109db14228 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = (0,react.useContext)($5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0,react.useRef)(null);
    const composedRefs = dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($5cb92bef7577960e$export$4d5eb2109db14228, {
    displayName: $5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0,react.useRef)(false);
    const handleClickRef = (0,react.useRef)(()=>{});
    (0,react.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
    const isFocusInsideReactTreeRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) dist_$8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);
    else target.dispatchEvent(event);
}
const $5cb92bef7577960e$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5cb92bef7577960e$export$177fb62ff3ec1f22));
const $5cb92bef7577960e$export$aecb2ddcb55c95be = (/* unused pure expression or super */ null && ($5cb92bef7577960e$export$4d5eb2109db14228));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-focus-scope/dist/index.mjs











const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = 'FocusScope';
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0,react.useState)(null);
    const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
    const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0,react.useRef)(null);
    const composedRefs = dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setContainer(node)
    );
    const focusScope = (0,react.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0,react.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                for (const mutation of mutations){
                    if (mutation.removedNodes.length > 0) {
                        if (!(container1 !== null && container1 !== void 0 && container1.contains(focusedElement))) $d3863c46a17e8a28$var$focus(container1);
                    }
                }
            }
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener('focusin', handleFocusIn);
                document.removeEventListener('focusout', handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0,react.useEffect)(()=>{
        if (container1) {
            $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                     // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0,react.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($d3863c46a17e8a28$export$20e40289641fbbb6, {
    displayName: $d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === 'hidden') return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
    }
    return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && 'select' in element;
}
function $d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
             // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== 'A'
    );
}
const $d3863c46a17e8a28$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($d3863c46a17e8a28$export$20e40289641fbbb6));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-portal/dist/index.mjs









/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $f1701beae083dbae$var$PORTAL_NAME = 'Portal';
const $f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($f1701beae083dbae$export$602eac185826482c, {
    displayName: $f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $f1701beae083dbae$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($f1701beae083dbae$export$602eac185826482c));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-presence/dist/index.mjs










function dist_$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = dist_$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react.Children.only(children);
    const ref = dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react.cloneElement)(child, {
        ref: ref
    }) : null;
};
dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function dist_$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react.useState)();
    const stylesRef = (0,react.useRef)({});
    const prevPresentRef = (0,react.useRef)(present);
    const prevAnimationNameRef = (0,react.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = dist_$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react.useEffect)(()=>{
        const currentAnimationName = dist_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = dist_$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = dist_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = dist_$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function dist_$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-focus-guards/dist/index.mjs



/** Number of components which have requested interest to have focus guards */ let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$ac5b58043b79449b(props) {
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
    (0,react.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
        document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
        $3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll('[data-radix-focus-guard]').forEach((node)=>node.remove()
            );
            $3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement('span');
    element.setAttribute('data-radix-focus-guard', '');
    element.tabIndex = 0;
    element.style.cssText = 'outline: none; opacity: 0; position: fixed; pointer-events: none';
    return element;
}
const $3db38b7d1fb3fe6a$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($3db38b7d1fb3fe6a$export$ac5b58043b79449b));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/use-callback-ref/dist/es2015/useMergeRef.js



var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = createSidecarMedium();

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = __assign(__assign({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (react.cloneElement(react.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, __assign({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

;// CONCATENATED MODULE: ./node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function () {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function () {
    react.useEffect(function () {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function () {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) {
                document.body.removeAttribute(lockAttribute);
            }
            else {
                document.body.setAttribute(lockAttribute, newCounter.toString());
            }
        };
    }, []);
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(function () { return styleSingleton(); })[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) { return (react.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: sidecar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);

;// CONCATENATED MODULE: ./node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                try {
                    var attr = node.getAttribute(controlAttribute);
                    var alreadyHidden = attr !== null && attr !== 'false';
                    var counterValue = (counterMap.get(node) || 0) + 1;
                    var markerValue = (markerCounter.get(node) || 0) + 1;
                    counterMap.set(node, counterValue);
                    markerCounter.set(node, markerValue);
                    hiddenNodes.push(node);
                    if (counterValue === 1 && alreadyHidden) {
                        uncontrolledNodes.set(node, true);
                    }
                    if (markerValue === 1) {
                        node.setAttribute(markerName, 'true');
                    }
                    if (!alreadyHidden) {
                        node.setAttribute(controlAttribute, 'true');
                    }
                }
                catch (e) {
                    console.error('aria-hidden: cannot operate on ', node, e);
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-dialog/dist/index.mjs

































/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DIALOG_NAME = 'Dialog';
const [$5d3850c4d0b4e6c7$var$createDialogContext, $5d3850c4d0b4e6c7$export$cc702773b8ea3e41] = dist_$c512c27ab02ef895$export$50c7b4e9d9f19c1($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$5d3850c4d0b4e6c7$var$DialogProvider, $5d3850c4d0b4e6c7$var$useDialogContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $5d3850c4d0b4e6c7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = (0,react.useRef)(null);
    const contentRef = (0,react.useRef)(null);
    const [open = false, setOpen] = dist_$71cd76cc60e0454e$export$6f32135080cb4c3({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
        titleId: $1746a345f3d73bb7$export$f680877a34711e37(),
        descriptionId: $1746a345f3d73bb7$export$f680877a34711e37(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0,react.useCallback)(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$3ddf2d174ce01153, {
    displayName: $5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TRIGGER_NAME = 'DialogTrigger';
const $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.button, (0,esm_extends/* default */.Z)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$2e1e1122cf0cba88, {
    displayName: $5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$PORTAL_NAME = 'DialogPortal';
const [$5d3850c4d0b4e6c7$var$PortalProvider, $5d3850c4d0b4e6c7$var$usePortalContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $5d3850c4d0b4e6c7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, react.Children.map(children, (child)=>/*#__PURE__*/ (0,react.createElement)(dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0,react.createElement)($f1701beae083dbae$export$602eac185826482c, {
            asChild: true,
            container: container
        }, child))
    ));
};
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$dad7c95542bacce0, {
    displayName: $5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$OVERLAY_NAME = 'DialogOverlay';
const $5d3850c4d0b4e6c7$export$bd1d06c79be19e17 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0,react.createElement)(dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0,esm_extends/* default */.Z)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$bd1d06c79be19e17, {
    displayName: $5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    (0,react.createElement)(Combination, {
        as: dist_$5e63c961fc1ce211$export$8c6ed5c666ac1360,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.div, (0,esm_extends/* default */.Z)({
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: 'auto',
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CONTENT_NAME = 'DialogContent';
const $5d3850c4d0b4e6c7$export$b6d9565de1e068cf = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(dist_$921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentNonModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$b6d9565de1e068cf, {
    displayName: $5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0,react.useRef)(null);
    const composedRefs = dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0,react.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return hideOthers(content);
    }, []);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, (event)=>event.preventDefault()
        )
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0,react.useRef)(false);
    const hasPointerDownOutsideRef = (0,react.useRef)(false);
    return /*#__PURE__*/ (0,react.createElement)($5d3850c4d0b4e6c7$var$DialogContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === 'pointerdown') hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === 'focusin' && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0,react.useRef)(null);
    const composedRefs = dist_$6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, /*#__PURE__*/ (0,react.createElement)($d3863c46a17e8a28$export$20e40289641fbbb6, {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0,react.createElement)($5cb92bef7577960e$export$177fb62ff3ec1f22, (0,esm_extends/* default */.Z)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TITLE_NAME = 'DialogTitle';
const $5d3850c4d0b4e6c7$export$16f7638e4a34b909 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.h2, (0,esm_extends/* default */.Z)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$16f7638e4a34b909, {
    displayName: $5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = 'DialogDescription';
const $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.p, (0,esm_extends/* default */.Z)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$94e94c2ec2c954d5, {
    displayName: $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CLOSE_NAME = 'DialogClose';
const $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react.createElement)(dist_$8927f6f2acc4f386$export$250ffa63cdc0d034.button, (0,esm_extends/* default */.Z)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: dist_$e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, ()=>context.onOpenChange(false)
        )
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac, {
    displayName: $5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $5d3850c4d0b4e6c7$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = 'DialogTitleWarning';
const [$5d3850c4d0b4e6c7$export$69b62a49393917d6, $5d3850c4d0b4e6c7$var$useWarningContext] = dist_$c512c27ab02ef895$export$fd42f52fd3ae1109($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: 'dialog'
});
const $5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $5d3850c4d0b4e6c7$var$useWarningContext($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $67UHm$useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = 'DialogDescriptionWarning';
const $5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $5d3850c4d0b4e6c7$var$useWarningContext($5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $67UHm$useEffect(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute('aria-describedby'); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5d3850c4d0b4e6c7$export$3ddf2d174ce01153));
const $5d3850c4d0b4e6c7$export$41fb9f06171c75f4 = (/* unused pure expression or super */ null && ($5d3850c4d0b4e6c7$export$2e1e1122cf0cba88));
const $5d3850c4d0b4e6c7$export$602eac185826482c = (/* unused pure expression or super */ null && ($5d3850c4d0b4e6c7$export$dad7c95542bacce0));
const $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff = (/* unused pure expression or super */ null && ($5d3850c4d0b4e6c7$export$bd1d06c79be19e17));
const $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2 = (/* unused pure expression or super */ null && ($5d3850c4d0b4e6c7$export$b6d9565de1e068cf));
const $5d3850c4d0b4e6c7$export$f99233281efd08a0 = (/* unused pure expression or super */ null && ($5d3850c4d0b4e6c7$export$16f7638e4a34b909));
const $5d3850c4d0b4e6c7$export$393edc798c47379d = (/* unused pure expression or super */ null && ($5d3850c4d0b4e6c7$export$94e94c2ec2c954d5));
const $5d3850c4d0b4e6c7$export$f39c2d165cd861fe = $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(1296);
;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/primitive/dist/index.mjs
// packages/core/primitive/src/primitive.tsx
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler?.(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler?.(event);
    }
  };
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
// packages/react/compose-refs/src/composeRefs.tsx

function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return react.useCallback(composeRefs(...refs), refs);
}

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-context/dist/index.mjs
// packages/react/context/src/createContext.tsx


function createContext2(rootComponentName, defaultContext) {
  const Context = React.createContext(defaultContext);
  function Provider(props) {
    const { children, ...context } = props;
    const value = React.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  }
  function useContext2(consumerName) {
    const context = React.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useContext2];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = react.createContext(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = scope?.[scopeName][index] || BaseContext;
      const value = react.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(Context.Provider, { value, children });
    }
    function useContext2(consumerName, scope) {
      const Context = scope?.[scopeName][index] || BaseContext;
      const context = react.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [Provider, useContext2];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return react.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = scope?.[scopeName] || scopeContexts;
      return react.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return react.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-slot/dist/index.mjs
// packages/react/slot/src/Slot.tsx



var Slot = react.forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = react.Children.toArray(children);
  const slottable = childrenArray.find(isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (react.Children.count(newElement) > 1) return react.Children.only(null);
        return react.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(SlotClone, { ...slotProps, ref: forwardedRef, children: react.isValidElement(newElement) ? react.cloneElement(newElement, void 0, newChildren) : null });
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(SlotClone, { ...slotProps, ref: forwardedRef, children });
});
Slot.displayName = "Slot";
var SlotClone = react.forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (react.isValidElement(children)) {
    const childrenRef = getElementRef(children);
    return react.cloneElement(children, {
      ...mergeProps(slotProps, children.props),
      // @ts-ignore
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    });
  }
  return react.Children.count(children) > 1 ? react.Children.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var Slottable = ({ children }) => {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children });
};
function isSlottable(child) {
  return react.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var Root = (/* unused pure expression or super */ null && (Slot));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-primitive/dist/index.mjs
// packages/react/primitive/src/Primitive.tsx




var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Node = react.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) ReactDOM.flushSync(() => target.dispatchEvent(event));
}
var dist_Root = (/* unused pure expression or super */ null && (Primitive));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-collection/dist/index.mjs
"use client";

// packages/react/collection/src/Collection.tsx





function createCollection(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = createContextScope(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(
    PROVIDER_NAME,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  );
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = react.useRef(null);
    const itemMap = react.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(CollectionProviderImpl, { scope, itemMap, collectionRef: ref, children });
  };
  CollectionProvider.displayName = PROVIDER_NAME;
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = react.forwardRef(
    (props, forwardedRef) => {
      const { scope, children } = props;
      const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
      const composedRefs = useComposedRefs(forwardedRef, context.collectionRef);
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(Slot, { ref: composedRefs, children });
    }
  );
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = react.forwardRef(
    (props, forwardedRef) => {
      const { scope, children, ...itemData } = props;
      const ref = react.useRef(null);
      const composedRefs = useComposedRefs(forwardedRef, ref);
      const context = useCollectionContext(ITEM_SLOT_NAME, scope);
      react.useEffect(() => {
        context.itemMap.set(ref, { ref, ...itemData });
        return () => void context.itemMap.delete(ref);
      });
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(Slot, { ...{ [ITEM_DATA_ATTR]: "" }, ref: composedRefs, children });
    }
  );
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = react.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
      );
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [
    { Provider: CollectionProvider, Slot: CollectionSlot, ItemSlot: CollectionItemSlot },
    useCollection,
    createCollectionScope
  ];
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var useLayoutEffect2 = Boolean(globalThis?.document) ? react.useLayoutEffect : () => {
};

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-id/dist/index.mjs
// packages/react/id/src/id.tsx


var useReactId = react_namespaceObject["useId".toString()] || (() => void 0);
var count = 0;
function useId(deterministicId) {
  const [id, setId] = react.useState(useReactId());
  useLayoutEffect2(() => {
    if (!deterministicId) setId((reactId) => reactId ?? String(count++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
// packages/react/use-callback-ref/src/useCallbackRef.tsx

function dist_useCallbackRef(callback) {
  const callbackRef = react.useRef(callback);
  react.useEffect(() => {
    callbackRef.current = callback;
  });
  return react.useMemo(() => (...args) => callbackRef.current?.(...args), []);
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
// packages/react/use-controllable-state/src/useControllableState.tsx


function useControllableState({
  prop,
  defaultProp,
  onChange = () => {
  }
}) {
  const [uncontrolledProp, setUncontrolledProp] = useUncontrolledState({ defaultProp, onChange });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  const handleChange = dist_useCallbackRef(onChange);
  const setValue = react.useCallback(
    (nextValue) => {
      if (isControlled) {
        const setter = nextValue;
        const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
        if (value2 !== prop) handleChange(value2);
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, handleChange]
  );
  return [value, setValue];
}
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const uncontrolledState = react.useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = react.useRef(value);
  const handleChange = dist_useCallbackRef(onChange);
  react.useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-direction/dist/index.mjs
// packages/react/direction/src/Direction.tsx


var DirectionContext = react.createContext(void 0);
var DirectionProvider = (props) => {
  const { dir, children } = props;
  return /* @__PURE__ */ jsx(DirectionContext.Provider, { value: dir, children });
};
function useDirection(localDir) {
  const globalDir = react.useContext(DirectionContext);
  return localDir || globalDir || "ltr";
}
var Provider = (/* unused pure expression or super */ null && (DirectionProvider));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-roving-focus/dist/index.mjs
"use client";

// packages/react/roving-focus/src/RovingFocusGroup.tsx











var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var GROUP_NAME = "RovingFocusGroup";
var [Collection, useCollection, createCollectionScope] = createCollection(GROUP_NAME);
var [createRovingFocusGroupContext, createRovingFocusGroupScope] = createContextScope(
  GROUP_NAME,
  [createCollectionScope]
);
var [RovingFocusProvider, useRovingFocusContext] = createRovingFocusGroupContext(GROUP_NAME);
var RovingFocusGroup = react.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Collection.Provider, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Collection.Slot, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(RovingFocusGroupImpl, { ...props, ref: forwardedRef }) }) });
  }
);
RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = react.forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    orientation,
    loop = false,
    dir,
    currentTabStopId: currentTabStopIdProp,
    defaultCurrentTabStopId,
    onCurrentTabStopIdChange,
    onEntryFocus,
    preventScrollOnEntryFocus = false,
    ...groupProps
  } = props;
  const ref = react.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const direction = useDirection(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = useControllableState({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = react.useState(false);
  const handleEntryFocus = dist_useCallbackRef(onEntryFocus);
  const getItems = useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = react.useRef(false);
  const [focusableItemsCount, setFocusableItemsCount] = react.useState(0);
  react.useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
      return () => node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    RovingFocusProvider,
    {
      scope: __scopeRovingFocusGroup,
      orientation,
      dir: direction,
      loop,
      currentTabStopId,
      onItemFocus: react.useCallback(
        (tabStopId) => setCurrentTabStopId(tabStopId),
        [setCurrentTabStopId]
      ),
      onItemShiftTab: react.useCallback(() => setIsTabbingBackOut(true), []),
      onFocusableItemAdd: react.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount + 1),
        []
      ),
      onFocusableItemRemove: react.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount - 1),
        []
      ),
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
        Primitive.div,
        {
          tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
          "data-orientation": orientation,
          ...groupProps,
          ref: composedRefs,
          style: { outline: "none", ...props.style },
          onMouseDown: composeEventHandlers(props.onMouseDown, () => {
            isClickFocusRef.current = true;
          }),
          onFocus: composeEventHandlers(props.onFocus, (event) => {
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
              const entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
              event.currentTarget.dispatchEvent(entryFocusEvent);
              if (!entryFocusEvent.defaultPrevented) {
                const items = getItems().filter((item) => item.focusable);
                const activeItem = items.find((item) => item.active);
                const currentItem = items.find((item) => item.id === currentTabStopId);
                const candidateItems = [activeItem, currentItem, ...items].filter(
                  Boolean
                );
                const candidateNodes = candidateItems.map((item) => item.ref.current);
                focusFirst(candidateNodes, preventScrollOnEntryFocus);
              }
            }
            isClickFocusRef.current = false;
          }),
          onBlur: composeEventHandlers(props.onBlur, () => setIsTabbingBackOut(false))
        }
      )
    }
  );
});
var ITEM_NAME = "RovingFocusGroupItem";
var RovingFocusGroupItem = react.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeRovingFocusGroup,
      focusable = true,
      active = false,
      tabStopId,
      ...itemProps
    } = props;
    const autoId = useId();
    const id = tabStopId || autoId;
    const context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd, onFocusableItemRemove } = context;
    react.useEffect(() => {
      if (focusable) {
        onFocusableItemAdd();
        return () => onFocusableItemRemove();
      }
    }, [focusable, onFocusableItemAdd, onFocusableItemRemove]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Collection.ItemSlot,
      {
        scope: __scopeRovingFocusGroup,
        id,
        focusable,
        active,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          Primitive.span,
          {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: composeEventHandlers(props.onMouseDown, (event) => {
              if (!focusable) event.preventDefault();
              else context.onItemFocus(id);
            }),
            onFocus: composeEventHandlers(props.onFocus, () => context.onItemFocus(id)),
            onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
              if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
              }
              if (event.target !== event.currentTarget) return;
              const focusIntent = getFocusIntent(event, context.orientation, context.dir);
              if (focusIntent !== void 0) {
                if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                event.preventDefault();
                const items = getItems().filter((item) => item.focusable);
                let candidateNodes = items.map((item) => item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                  if (focusIntent === "prev") candidateNodes.reverse();
                  const currentIndex = candidateNodes.indexOf(event.currentTarget);
                  candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                setTimeout(() => focusFirst(candidateNodes));
              }
            })
          }
        )
      }
    );
  }
);
RovingFocusGroupItem.displayName = ITEM_NAME;
var MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
  const key = getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates, preventScroll = false) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus({ preventScroll });
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function wrapArray(array, startIndex) {
  return array.map((_, index) => array[(startIndex + index) % array.length]);
}
var react_roving_focus_dist_Root = RovingFocusGroup;
var Item = RovingFocusGroupItem;

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-use-size/dist/index.mjs
// packages/react/use-size/src/useSize.tsx


function useSize(element) {
  const [size, setSize] = react.useState(void 0);
  useLayoutEffect2(() => {
    if (element) {
      setSize({ width: element.offsetWidth, height: element.offsetHeight });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({ width, height });
      });
      resizeObserver.observe(element, { box: "border-box" });
      return () => resizeObserver.unobserve(element);
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size;
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-use-previous/dist/index.mjs
// packages/react/use-previous/src/usePrevious.tsx

function usePrevious(value) {
  const ref = react.useRef({ value, previous: value });
  return react.useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [value]);
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/node_modules/@radix-ui/react-presence/dist/index.mjs
"use client";

// packages/react/presence/src/Presence.tsx





// packages/react/presence/src/useStateMachine.tsx

function useStateMachine(initialState, machine) {
  return react.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}

// packages/react/presence/src/Presence.tsx
var Presence = (props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : react.Children.only(children);
  const ref = useComposedRefs(presence.ref, dist_getElementRef(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? react.cloneElement(child, { ref }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
  const [node, setNode] = react.useState();
  const stylesRef = react.useRef({});
  const prevPresentRef = react.useRef(present);
  const prevAnimationNameRef = react.useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  react.useEffect(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  useLayoutEffect2(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        send("MOUNT");
      } else if (currentAnimationName === "none" || styles?.display === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    if (node) {
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node && isCurrentAnimation) {
          react_dom.flushSync(() => send("ANIMATION_END"));
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: react.useCallback((node2) => {
      if (node2) stylesRef.current = getComputedStyle(node2);
      setNode(node2);
    }, [])
  };
}
function getAnimationName(styles) {
  return styles?.animationName || "none";
}
function dist_getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/node_modules/@radix-ui/react-radio-group/dist/index.mjs
"use client";

// packages/react/radio-group/src/RadioGroup.tsx










// packages/react/radio-group/src/Radio.tsx









var RADIO_NAME = "Radio";
var [createRadioContext, createRadioScope] = createContextScope(RADIO_NAME);
var [RadioProvider, useRadioContext] = createRadioContext(RADIO_NAME);
var Radio = react.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeRadio,
      name,
      checked = false,
      required,
      disabled,
      value = "on",
      onCheck,
      ...radioProps
    } = props;
    const [button, setButton] = react.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setButton(node));
    const hasConsumerStoppedPropagationRef = react.useRef(false);
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(RadioProvider, { scope: __scopeRadio, checked, disabled, children: [
      /* @__PURE__ */ (0,jsx_runtime.jsx)(
        Primitive.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": checked,
          "data-state": getState(checked),
          "data-disabled": disabled ? "" : void 0,
          disabled,
          value,
          ...radioProps,
          ref: composedRefs,
          onClick: composeEventHandlers(props.onClick, (event) => {
            if (!checked) onCheck?.();
            if (isFormControl) {
              hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
              if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
          })
        }
      ),
      isFormControl && /* @__PURE__ */ (0,jsx_runtime.jsx)(
        BubbleInput,
        {
          control: button,
          bubbles: !hasConsumerStoppedPropagationRef.current,
          name,
          value,
          checked,
          required,
          disabled,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Radio.displayName = RADIO_NAME;
var INDICATOR_NAME = "RadioIndicator";
var RadioIndicator = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeRadio, forceMount, ...indicatorProps } = props;
    const context = useRadioContext(INDICATOR_NAME, __scopeRadio);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Presence, { present: forceMount || context.checked, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Primitive.span,
      {
        "data-state": getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...indicatorProps,
        ref: forwardedRef
      }
    ) });
  }
);
RadioIndicator.displayName = INDICATOR_NAME;
var BubbleInput = (props) => {
  const { control, checked, bubbles = true, ...inputProps } = props;
  const ref = react.useRef(null);
  const prevChecked = usePrevious(checked);
  const controlSize = useSize(control);
  react.useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", { bubbles });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    "input",
    {
      type: "radio",
      "aria-hidden": true,
      defaultChecked: checked,
      ...inputProps,
      tabIndex: -1,
      ref,
      style: {
        ...props.style,
        ...controlSize,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function getState(checked) {
  return checked ? "checked" : "unchecked";
}

// packages/react/radio-group/src/RadioGroup.tsx

var ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
var RADIO_GROUP_NAME = "RadioGroup";
var [createRadioGroupContext, createRadioGroupScope] = createContextScope(RADIO_GROUP_NAME, [
  createRovingFocusGroupScope,
  createRadioScope
]);
var useRovingFocusGroupScope = createRovingFocusGroupScope();
var useRadioScope = createRadioScope();
var [RadioGroupProvider, useRadioGroupContext] = createRadioGroupContext(RADIO_GROUP_NAME);
var RadioGroup = react.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeRadioGroup,
      name,
      defaultValue,
      value: valueProp,
      required = false,
      disabled = false,
      orientation,
      dir,
      loop = true,
      onValueChange,
      ...groupProps
    } = props;
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = useDirection(dir);
    const [value, setValue] = useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      RadioGroupProvider,
      {
        scope: __scopeRadioGroup,
        name,
        required,
        disabled,
        value,
        onValueChange: setValue,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          react_roving_focus_dist_Root,
          {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation,
            dir: direction,
            loop,
            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
              Primitive.div,
              {
                role: "radiogroup",
                "aria-required": required,
                "aria-orientation": orientation,
                "data-disabled": disabled ? "" : void 0,
                dir: direction,
                ...groupProps,
                ref: forwardedRef
              }
            )
          }
        )
      }
    );
  }
);
RadioGroup.displayName = RADIO_GROUP_NAME;
var dist_ITEM_NAME = "RadioGroupItem";
var RadioGroupItem = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeRadioGroup, disabled, ...itemProps } = props;
    const context = useRadioGroupContext(dist_ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = useRadioScope(__scopeRadioGroup);
    const ref = react.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = react.useRef(false);
    react.useEffect(() => {
      const handleKeyDown = (event) => {
        if (ARROW_KEYS.includes(event.key)) {
          isArrowKeyPressedRef.current = true;
        }
      };
      const handleKeyUp = () => isArrowKeyPressedRef.current = false;
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("keyup", handleKeyUp);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("keyup", handleKeyUp);
      };
    }, []);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Item,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !isDisabled,
        active: checked,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          Radio,
          {
            disabled: isDisabled,
            required: context.required,
            checked,
            ...radioScope,
            ...itemProps,
            name: context.name,
            ref: composedRefs,
            onCheck: () => context.onValueChange(itemProps.value),
            onKeyDown: composeEventHandlers((event) => {
              if (event.key === "Enter") event.preventDefault();
            }),
            onFocus: composeEventHandlers(itemProps.onFocus, () => {
              if (isArrowKeyPressedRef.current) ref.current?.click();
            })
          }
        )
      }
    );
  }
);
RadioGroupItem.displayName = dist_ITEM_NAME;
var INDICATOR_NAME2 = "RadioGroupIndicator";
var RadioGroupIndicator = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = useRadioScope(__scopeRadioGroup);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(RadioIndicator, { ...radioScope, ...indicatorProps, ref: forwardedRef });
  }
);
RadioGroupIndicator.displayName = INDICATOR_NAME2;
var Root2 = RadioGroup;
var Item2 = RadioGroupItem;
var Indicator = RadioGroupIndicator;

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@platzi/atomic-ui/node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__(1246);
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);
// EXTERNAL MODULE: ./node_modules/@platzi/atomic-ui/node_modules/dayjs/locale/es.js
var locale_es = __webpack_require__(6239);
// EXTERNAL MODULE: ./node_modules/@platzi/atomic-ui/node_modules/dayjs/plugin/isoWeek.js
var isoWeek = __webpack_require__(850);
var isoWeek_default = /*#__PURE__*/__webpack_require__.n(isoWeek);
;// CONCATENATED MODULE: ./node_modules/@platzi/atomic-ui/dist/es/index.js
var es_ge,es_Ee="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},es_ye={exports:{}};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
es_ge=es_ye,function(){var e={}.hasOwnProperty;function t(){for(var n=[],o=0;o<arguments.length;o++){var r=arguments[o];if(r){var a=typeof r;if("string"===a||"number"===a)n.push(r);else if(Array.isArray(r)){if(r.length){var i=t.apply(null,r);i&&n.push(i)}}else if("object"===a){if(r.toString!==Object.prototype.toString&&!r.toString.toString().includes("[native code]")){n.push(r.toString());continue}for(var l in r)e.call(r,l)&&r[l]&&n.push(l)}}}return n.join(" ")}es_ge.exports?(t.default=t,es_ge.exports=t):window.classNames=t}();var es_be=es_ye.exports,es_Ne="Avatar-module_Avatar__ztcav";const es_we=({src:e,name:n,width:o=24,className:r=""})=>{const a=es_be(es_Ne,{[r]:r});return t.createElement("figure",{className:a,style:{width:o,height:o}},t.createElement("img",{src:e,alt:n}))};var es_Se,es_Te,es_Ce;!function(e){e.LARGE="lg",e.MEDIUM="md",e.SMALL="sm"}(es_Se||(es_Se={})),function(e){e.BASIC="basic",e.ICON="icon"}(es_Te||(es_Te={})),function(e){e.PRIMARY="primary",e.PRIMARY_SUBTLE="primary-subtle",e.SECONDARY="secondary",e.SECONDARY_INVERSE="secondary-inverse",e.TERTIARY="tertiary",e.SUBTLE="subtle",e.INTERACTIVE_AI="interactive-ai",e.OUTLINE="outline",e.OUTLINE_INVERSE="outline-inverse",e.GHOST="ghost",e.DESTROY="destroy"}(es_Ce||(es_Ce={}));var es_Le={ButtonLayout:"ButtonLayout-module_ButtonLayout__eaqR3","ButtonLayout--sm":"ButtonLayout-module_ButtonLayout--sm__hFh7H",ButtonLayout__Icon:"ButtonLayout-module_ButtonLayout__Icon__AaDMh","ButtonLayout--md":"ButtonLayout-module_ButtonLayout--md__llltG","ButtonLayout--lg":"ButtonLayout-module_ButtonLayout--lg__hMo4J","ButtonLayout--basic--sm":"ButtonLayout-module_ButtonLayout--basic--sm__Y--Zl","ButtonLayout--basic--md":"ButtonLayout-module_ButtonLayout--basic--md__AAMZG","ButtonLayout--basic--lg":"ButtonLayout-module_ButtonLayout--basic--lg__iC-SF","ButtonLayout--basic--withIconLeft--sm":"ButtonLayout-module_ButtonLayout--basic--withIconLeft--sm__DggSs","ButtonLayout--basic--withIconLeft--md":"ButtonLayout-module_ButtonLayout--basic--withIconLeft--md__BdPyU","ButtonLayout--basic--withIconLeft--lg":"ButtonLayout-module_ButtonLayout--basic--withIconLeft--lg__47Jv5","ButtonLayout--basic--withIconRight--sm":"ButtonLayout-module_ButtonLayout--basic--withIconRight--sm__LQdKe","ButtonLayout--basic--withIconRight--md":"ButtonLayout-module_ButtonLayout--basic--withIconRight--md__4hchp","ButtonLayout--basic--withIconRight--lg":"ButtonLayout-module_ButtonLayout--basic--withIconRight--lg__ouQYY","ButtonLayout--icon--sm":"ButtonLayout-module_ButtonLayout--icon--sm__n7Jmp","ButtonLayout--icon--md":"ButtonLayout-module_ButtonLayout--icon--md__irIk3","ButtonLayout--icon--lg":"ButtonLayout-module_ButtonLayout--icon--lg__XhuXR"};const es_ke=(0,react.forwardRef)(((e,n)=>{const{as:o="button",children:r,size:a=es_Se.SMALL,leftIcon:i,rightIcon:l,kind:s=es_Te.BASIC,className:c,...u}=e,d=es_be(es_Le.ButtonLayout,es_Le[`ButtonLayout--${a}`],es_Le[`ButtonLayout--${s}--${a}`],c,{[es_Le[`ButtonLayout--basic--withIconLeft--${a}`]]:s===es_Te.BASIC&&i,[es_Le[`ButtonLayout--basic--withIconRight--${a}`]]:s===es_Te.BASIC&&l}),m=es_be({[es_Le.ButtonLayout__Icon]:s===es_Te.ICON});if(!o)return null;const _=o;return react.createElement(_,{ref:n,className:d,...u,"data-id":"atomic-ui-button-layout"},i&&react.createElement("span",{className:es_Le.ButtonLayout__Icon,"data-id":"atomic-ui-button-layout-icon"},i),r&&react.createElement("span",{className:m},r),l&&react.createElement("span",{className:es_Le.ButtonLayout__Icon,"data-id":"atomic-ui-button-layout-icon"},l))}));var es_Me={Button:"Button-module_Button__uBoYP","Button--sm":"Button-module_Button--sm__kiOL-","Button--md":"Button-module_Button--md__BDDyh","Button--lg":"Button-module_Button--lg__Q-wdL","Button--primary":"Button-module_Button--primary__JykeJ","Button--primary-subtle":"Button-module_Button--primary-subtle__GwrpY","Button--secondary":"Button-module_Button--secondary__GXtjl","Button--secondary-inverse":"Button-module_Button--secondary-inverse__M2bfM","Button--tertiary":"Button-module_Button--tertiary__-Fwk4","Button--subtle":"Button-module_Button--subtle__ZnkfB","Button--interactive-ai":"Button-module_Button--interactive-ai__15Aq1","Button--outline":"Button-module_Button--outline__EzobK","Button--outline-inverse":"Button-module_Button--outline-inverse__ZH4-5","Button--ghost":"Button-module_Button--ghost__F8JSX","Button--destroy":"Button-module_Button--destroy__B8gsD"};const es_Ie=es_Se.SMALL,es_Pe=es_Ce.PRIMARY,es_Oe=(0,react.forwardRef)(((e,n)=>{const{size:o=es_Ie,className:r="",variant:a=es_Pe,children:i,...l}=e,s=es_be(r,es_Me.Button,es_Me[`Button--${o}`],es_Me[`Button--${a}`]);return react.createElement(es_ke,{className:s,size:o,...l,ref:n},i)}));var es_xe="Checkbox-module_Checkbox__cKy9C",es_Ae="Checkbox-module_Checkbox--checked__jT0hH";const es_Be=({checked:e,className:n="",...o})=>{const r=es_be(es_xe,n,{[es_Ae]:e});return react.createElement($e698a72e93240346$export$be92b6f5f03c0fe9,{...o,checked:e,className:r},react.createElement($e698a72e93240346$export$adb584737d712b70,null,!0===e&&react.createElement(esm_namespaceObject.Check,{"data-testid":"check-icon"}),"indeterminate"===e&&react.createElement(esm_oe,{"data-testid":"minus-icon"})))};var es_Re="CheckItem-module_CheckItem__5yWXn",es_De="CheckItem-module_CheckItem__Check__yyj1Q";const es_He=({checked:e,label:n="",className:o="",...r})=>{const a=es_be(es_Re,o),i={"data-checkitem-status":e};return react.createElement("label",{className:a,"data-id":"checkitem",...i},react.createElement(es_Be,{...r,className:es_De,checked:e,"data-id":"checkitem--check"}),n)};var es_$e={Chip:"Chip-module_Chip__4fP11","Chip--selected":"Chip-module_Chip--selected__7wL7o","Chip--disabled":"Chip-module_Chip--disabled__x5Hk0","Chip--sm":"Chip-module_Chip--sm__i0q3Y","Chip--md":"Chip-module_Chip--md__HZU7Q","Chip--nested":"Chip-module_Chip--nested__8wnd5"};const es_We=({id:e,text:n,isSelected:o,size:r="sm",disabled:a,onClick:i,nested:l,children:s,className:c="",ariaLabel:u})=>{const d=es_be(es_$e.Chip,{[es_$e["Chip--selected"]]:o,[es_$e["Chip--disabled"]]:a,[es_$e[`Chip--${r}`]]:r,[es_$e["Chip--nested"]]:o&&l,[c]:c});return t.createElement("button",{type:"button",className:d,"aria-label":`${u||n}`,tabIndex:0,onClick:()=>{i(e)}},n||s)};var es_je={InputText:"InputText-module_InputText__OIANf",InputText__password:"InputText-module_InputText__password__0Enlu",InputText__disabled:"InputText-module_InputText__disabled__UQMFq",InputText__error:"InputText-module_InputText__error__ozElh",InputText__passwordToggle:"InputText-module_InputText__passwordToggle__yiets"};const es_Fe=({innerRef:e,classnames:n,name:r,value:a,placeholder:i,required:l,type:s="text",pattern:c,onChange:u,onFocus:d,onBlur:m,togglePasswordOption:_,dataQa:p,error:f,disabled:h=!1,onkeydown:v,buttonTabIndex:g})=>{const E=re.bind(es_je),[y,b]=o(s),N="password"===s&&_&&a&&a?.length>0,w=E("InputText",n,{InputText__password:"password"===s,InputText__disabled:h,InputText__error:f});return t.createElement("div",{className:w},t.createElement("input",{ref:e,type:y,name:r,id:r,value:a,onChange:e=>{u&&u(e.target.value)},onFocus:e=>{d&&d(e)},onBlur:e=>{m&&m(e)},required:l,pattern:c?.length?c:void 0,"data-qa":p,disabled:h,onKeyDown:v}),i&&t.createElement("label",{htmlFor:r},i),N&&t.createElement("button",{className:es_je.InputText__passwordToggle,type:"button",onClick:e=>{e.preventDefault(),b("password"===y?"text":"password")},tabIndex:g,"data-qa":"show-password"},"password"===y?"Mostrar":"Ocultar"))};var es_Ue={SimpleSelect:"SimpleSelect-module_SimpleSelect__3Mnjq",SimpleSelect_icon:"SimpleSelect-module_SimpleSelect_icon__-zBjt",SimpleSelect__notEmpty:"SimpleSelect-module_SimpleSelect__notEmpty__7lZOH",SimpleSelect__disabled:"SimpleSelect-module_SimpleSelect__disabled__-eyEW",SimpleSelect__error:"SimpleSelect-module_SimpleSelect__error__VwBRg"};const es_ze=({innerRef:e,classnames:n,name:o,value:r,options:a=[],placeholder:i,required:l,onChange:s,dataQa:c,error:u,disabled:d=!1,onkeydown:m,withEmptyOption:_=!0})=>{const p=re.bind(es_Ue),f=p("SimpleSelect",{SimpleSelect__notEmpty:r?.length,SimpleSelect__disabled:d,SimpleSelect__error:u},n);return t.createElement("div",{className:f},t.createElement("select",{ref:e,name:o,id:o,value:r,onChange:e=>{s&&s(e.target.value)},required:l,"data-qa":c,disabled:d,onKeyDown:m},_&&t.createElement("option",{value:"","aria-label":"Empty option"}),a.map((e=>t.createElement("option",{key:e,value:e},e)))),t.createElement("label",{htmlFor:o},i),t.createElement("span",{className:p("SimpleSelect_icon")},t.createElement(N,null)))};var es_Ye="Spinner-module_Spinner__LoMV6";const es_qe=({className:e="",...n})=>{const o=es_be(es_Ye,e);return react.createElement("div",{"data-testid":"atomic-ui-spinner",className:o,...n})};var es_Ve="LoadingSpinner-module_LoadingSpinner__vCRtJ",es_Ke="LoadingSpinner-module_LoadingSpinner--loading__qmFMV";const es_Ge=({className:e="",loading:n=!1,...o})=>{const r=es_be(es_Ve,e,{[es_Ke]:n});return t.createElement("div",{"data-testid":"atomic-ui-loading-spinner",className:r,...o},t.createElement(es_qe,null))};var es_Ze={"Modal-overlay":"Modal-module_Modal-overlay__bGLa8","Modal-wrapper":"Modal-module_Modal-wrapper__9tiPW","Modal-wrapper--center":"Modal-module_Modal-wrapper--center__xVtCC",fadeIn:"Modal-module_fadeIn__rtu80",fadeOut:"Modal-module_fadeOut__kE1kk","Modal-wrapper--bottom":"Modal-module_Modal-wrapper--bottom__gnqxH",slideInBottom:"Modal-module_slideInBottom__GuMIQ",slideOutBottom:"Modal-module_slideOutBottom__Tty-J","Modal-wrapper--left":"Modal-module_Modal-wrapper--left__a9CNO",slideInLeft:"Modal-module_slideInLeft__KnA0O",slideOutLeft:"Modal-module_slideOutLeft__-xjki"};const es_Xe=({children:e,isOpen:n,handleClose:o,position:r="center",className:a,classNameOverlay:i,container:l=("undefined"!=typeof document?document.body:null),style:s,...c})=>{const u=es_be(es_Ze["Modal-wrapper"],{[es_Ze[`Modal-wrapper--${r}`]]:!0},a),d=es_be(es_Ze["Modal-overlay"],i);return t.createElement(ae.Root,{open:n,onOpenChange:o},t.createElement(ae.Portal,{className:es_Ze.Modal,container:l,id:"modal-portal-wrapper"},t.createElement(ae.Overlay,{style:{...s},className:d,id:"modal-overlay"},t.createElement(ae.Content,{className:u,id:"modal-content",...c},e))))};var es_Je="ModalBody-module_ModalBody__IYRTZ";const es_Qe=({children:e,className:n})=>{const o=es_be(es_Je,n);return t.createElement("div",{className:o},e)};var et="ModalFooter-module_ModalFooter__Bh0ij";const tt=({children:e,className:n=""})=>{const o=es_be(et,n);return t.createElement("div",{className:o},e)};var nt="ModalHeader-module_ModalHeader__Qmrb-",ot="ModalHeader-module_ModalHeader__close__f1mWq";const rt=({children:e,withCloseButton:n=!1,className:o,onClose:r})=>{const a=es_be(nt,o);return react.createElement("div",{className:a},e,n&&react.createElement($5d3850c4d0b4e6c7$export$f39c2d165cd861fe,{className:ot,"aria-label":"Close",onClick:()=>{r&&r()}},react.createElement(esm_R,null)))};rt.defaultProps={withCloseButton:!1,className:"",onClose:()=>null},rt.displayName="ModalHeader";const at=(e=!1)=>{const[t,n]=(0,react.useState)(e);return{isOpen:t,open:(0,react.useCallback)((()=>n(!0)),[]),close:(0,react.useCallback)((()=>n(!1)),[]),toggle:(0,react.useCallback)((e=>{n(void 0===e?e=>!e:Boolean(e))}),[])}};const it="change",lt=[{key:"mobile",query:"(max-width: 767px)"},{key:"tablet",query:"(min-width: 768px) and (max-width: 1023px)"},{key:"desktop",query:"(min-width: 1024px) and (max-width: 1279px)"},{key:"extra-large",query:"(min-width: 1280px)"}],st=(e=!0)=>{const{media:t}=((e,t=!0)=>{const[n,r]=(0,react.useState)({media:{},metadata:{}});return (0,react.useEffect)((()=>{const n={},o={width:window.innerWidth},a=[];return t&&(e.forEach((e=>{const t=window.matchMedia(e.query),o=t=>{const{matches:n}=t;r((t=>({...t,media:{...t.media,[e.key]:n},metadata:{...t.metadata,width:window.innerWidth}})))};!function(e,t){Object.prototype.hasOwnProperty.call(e,"addEventListener")?e.addEventListener(it,t):e.addListener(t)}(t,o),a.push({matchMedia:t,matchMediaListener:o}),n[e.key]=t.matches})),r({media:n,metadata:o})),()=>{a.forEach((({matchMedia:e,matchMediaListener:t})=>{!function(e,t){Object.prototype.hasOwnProperty.call(e,"removeEventListener")?e.removeEventListener(it,t):e.removeListener(t)}(e,t)}))}}),[e,t]),n})(lt,e);return t};var ct={Tooltip:"Tooltip-module_Tooltip__3RyoA",Tooltip__content:"Tooltip-module_Tooltip__content__QIvMN","Tooltip__content--top":"Tooltip-module_Tooltip__content--top__8-SJl","Tooltip__content--bottom":"Tooltip-module_Tooltip__content--bottom__zAoFC","Tooltip__content--left":"Tooltip-module_Tooltip__content--left__fIOwv","Tooltip__content--right":"Tooltip-module_Tooltip__content--right__WNwto","Tooltip__content--inverse":"Tooltip-module_Tooltip__content--inverse__daS21","Tooltip__content--neutral":"Tooltip-module_Tooltip__content--neutral__p5tlO"};const ut=({children:e,content:n,position:o="bottom",variant:r="default",defaultOpen:s})=>{const c=(0,react.useId)(),{isOpen:u,open:d,close:m}=at(),_=es_be(ct.Tooltip__content,{[ct[`Tooltip__content--${r}`]]:r,[ct[`Tooltip__content--${o}`]]:o}),p=(0,react.useCallback)((e=>{"Escape"===e.key&&m()}),[m]);(0,react.useEffect)((()=>(document.addEventListener("keydown",p),()=>{document.removeEventListener("keydown",p)})),[p]);const f=s||u;return react.createElement("div",{className:ct.Tooltip,onMouseEnter:d,onMouseLeave:m,onFocus:d,onBlur:m},e,f&&react.createElement("span",{className:_,"data-placement":o,"data-state":u?"opened":"closed",role:"tooltip",id:c},n))};ut.defaultProps={position:"bottom",variant:"default"},ut.displayName="Tooltip";var dt={Skeleton:"Skeleton-module_Skeleton__n-qDm","Skeleton--animated":"Skeleton-module_Skeleton--animated__crFsy","skeleton-loading":"Skeleton-module_skeleton-loading__iOkom","Skeleton--circle":"Skeleton-module_Skeleton--circle__OIDku"};const mt=({shape:e="",animated:n=!0,className:o="",height:r="auto",width:a="100%",...i})=>{const l=es_be(dt.Skeleton,o,{[dt[`Skeleton--${e}`]]:e,[dt["Skeleton--animated"]]:n});return t.createElement("div",{className:l,style:{height:r,width:a},...i})};var _t="Divider-module_Divider__lHNwD";const pt=({text:e="",className:n="",...o})=>{const r=es_be(_t,n);return t.createElement("div",{className:r,...o},t.createElement("div",null,e&&t.createElement("span",null,e)))};var ft="Card-module_Card__qduvl";const ht=({children:e})=>t.createElement("div",{className:ft},e);var vt={Like:"Like-module_Like__eUwmV","Like--liked":"Like-module_Like--liked__GdezY"};const gt=({isLiked:e,count:n,toggleLike:o,onClick:r,...a})=>{const i=bind_default().bind(vt)("Like",{"Like--liked":e}),l=(e=>e?e>1e3?`${(e/1e3).toFixed(1)}k`:e:0)(n);return react.createElement(es_Oe,{onClick:o,variant:"ghost","aria-label":e?"Remover Like":"Dar Like",...a},react.createElement("div",{className:i},react.createElement("div",{className:vt.Like__Icon},e?react.createElement(T,null):react.createElement(U,null)),react.createElement("span",{className:vt.Like__Count},l)))};const Et=({isActive:e=!1,targetBlank:n,label:o,icon:r,children:a,...i})=>{const l=r?function(e,t){const n=e;return n?.byStatus?n.byStatus[t]:e}(r,e?"active":"enabled"):null;return t.createElement("a",{target:n?"_blank":"_self",rel:n?"noopener noreferrer":"",...i},l&&t.createElement(l,null),t.createElement("span",null,o),a)};var yt="RadioButton-module_RadioButton__bc8K3",bt="RadioButton-module_RadioButton__item__DUcns",Nt="RadioButton-module_RadioButton__label__bvTN6",wt="RadioButton-module_RadioButton__indicator__1psnI";const St={Group:({children:e,...n})=>react.createElement(Root2,{...n},e),Button:({id:e,label:n,...o})=>{const r=Item2,a=Indicator;return react.createElement("div",{className:yt,"data-qa":o["data-qa"]},react.createElement(r,{id:e,className:bt,...o},react.createElement(a,{className:wt})),react.createElement("label",{className:Nt,htmlFor:e},n))}};var Tt={Textarea:"Textarea-module_Textarea__LLr6y",Textarea__disabled:"Textarea-module_Textarea__disabled__2r3EO",Textarea__error:"Textarea-module_Textarea__error__XTikO",Textarea__withoutLabel:"Textarea-module_Textarea__withoutLabel__lmuz1"};const Ct=(0,react.forwardRef)((({classnames:e,dataQa:n,error:o,id:r,required:a,disabled:i,...l},s)=>{const c=bind_default().bind(Tt)("Textarea",e,{Textarea__disabled:i,Textarea__error:o,Textarea__withoutLabel:!0});return react.createElement("div",{className:c},react.createElement("textarea",{ref:s,id:r,disabled:i,"data-qa":n,required:a,"aria-invalid":!!o,"data-class":"Textarea",...l}))}));Ct.displayName="Textarea";var Lt={Input:"Input-module_Input__LyEBU",Input__password:"Input-module_Input__password__i9qKA",Input__disabled:"Input-module_Input__disabled__fTtaa",Input__error:"Input-module_Input__error__ZrpLj",Input__withoutLabel:"Input-module_Input__withoutLabel__mJi8O",Input__passwordToggle:"Input-module_Input__passwordToggle__CV-aD",Input__helperText:"Input-module_Input__helperText__P76CE",Input__helperText__error:"Input-module_Input__helperText__error__YvkoT",Input__helperText__icon:"Input-module_Input__helperText__icon__SPZml",Input__helperText__text:"Input-module_Input__helperText__text__RbYIe"};const kt=(0,react.forwardRef)((({classnames:e,dataQa:n,error:r,id:a,togglePasswordOption:i,label:l,required:s,disabled:c,value:u,type:d="text",placeholder:m="",onChange:_,helperText:p,...f},h)=>{const[v,g]=(0,react.useState)(d),[E,y]=(0,react.useState)(!!u),b="password"===d&&i&&E,N=bind_default().bind(Lt),w=N("Input",e,{Input__password:b,Input__disabled:c,Input__error:r,Input__withoutLabel:!l}),S=N("Input__helperText",e,{Input__helperText__error:r}),T=r?esm_namespaceObject.CloseCircleFilled:esm_namespaceObject.InfoCircleFilled;return react.createElement(react.Fragment,null,react.createElement("div",{className:w},react.createElement("input",{ref:h,id:a,type:v,disabled:c,"data-qa":n,value:u,required:s,placeholder:m,"aria-invalid":!!r,"aria-describedby":r?`${a}-error`:void 0,onChange:e=>{const t=e.target;t.setAttribute("data-filled",""!==t.value?"true":"false"),y(""!==t.value),_&&_(e)},...f}),react.createElement("label",{htmlFor:a},l),b&&react.createElement("button",{className:Lt.Input__passwordToggle,type:"button",onClick:e=>{e.preventDefault(),g("password"!==v?"password":"text")},"data-qa":"show-password"},"password"===v?"Mostrar":"Ocultar")),p&&react.createElement("div",{title:p,className:S},react.createElement("div",{className:Lt.Input__helperText__icon},react.createElement(T,null)),react.createElement("span",{className:Lt.Input__helperText__text},p)))}));function Mt(){return Mt=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},Mt.apply(this,arguments)}function It(e,t,{checkForDefaultPrevented:n=!0}={}){return function(o){if(null==e||e(o),!1===n||!o.defaultPrevented)return null==t?void 0:t(o)}}function Pt(...e){return t=>e.forEach((e=>function(e,t){"function"==typeof e?e(t):null!=e&&(e.current=t)}(e,t)))}function Ot(...e){return (0,react.useCallback)(Pt(...e),e)}function xt(e,t=[]){let n=[];const o=()=>{const t=n.map((e=>(0,react.createContext)(e)));return function(n){const o=(null==n?void 0:n[e])||t;return (0,react.useMemo)((()=>({[`__scope${e}`]:{...n,[e]:o}})),[n,o])}};return o.scopeName=e,[function(t,o){const r=(0,react.createContext)(o),a=n.length;function i(t){const{scope:n,children:o,...i}=t,l=(null==n?void 0:n[e][a])||r,s=(0,react.useMemo)((()=>i),Object.values(i));return (0,react.createElement)(l.Provider,{value:s},o)}return n=[...n,o],i.displayName=t+"Provider",[i,function(n,i){const l=(null==i?void 0:i[e][a])||r,s=(0,react.useContext)(l);if(s)return s;if(void 0!==o)return o;throw new Error(`\`${n}\` must be used within \`${t}\``)}]},At(o,...t)]}function At(...e){const t=e[0];if(1===e.length)return t;const n=()=>{const n=e.map((e=>({useScope:e(),scopeName:e.scopeName})));return function(e){const o=n.reduce(((t,{useScope:n,scopeName:o})=>({...t,...n(e)[`__scope${o}`]})),{});return (0,react.useMemo)((()=>({[`__scope${t.scopeName}`]:o})),[o])}};return n.scopeName=t.scopeName,n}kt.displayName="Input";const Bt=(0,react.forwardRef)(((e,t)=>{const{children:n,...o}=e,r=react.Children.toArray(n),a=r.find(Ht);if(a){const e=a.props.children,n=r.map((t=>t===a?react.Children.count(e)>1?react.Children.only(null):(0,react.isValidElement)(e)?e.props.children:null:t));return (0,react.createElement)(Rt,Mt({},o,{ref:t}),(0,react.isValidElement)(e)?(0,react.cloneElement)(e,void 0,n):null)}return (0,react.createElement)(Rt,Mt({},o,{ref:t}),n)}));Bt.displayName="Slot";const Rt=(0,react.forwardRef)(((e,t)=>{const{children:n,...o}=e;return (0,react.isValidElement)(n)?(0,react.cloneElement)(n,{...$t(o,n.props),ref:Pt(t,n.ref)}):react.Children.count(n)>1?react.Children.only(null):null}));Rt.displayName="SlotClone";const Dt=({children:e})=>(0,react.createElement)(react.Fragment,null,e);function Ht(e){return (0,react.isValidElement)(e)&&e.type===Dt}function $t(e,t){const n={...t};for(const o in t){const r=e[o],a=t[o];/^on[A-Z]/.test(o)?r&&a?n[o]=(...e)=>{a(...e),r(...e)}:r&&(n[o]=r):"style"===o?n[o]={...r,...a}:"className"===o&&(n[o]=[r,a].filter(Boolean).join(" "))}return{...e,...n}}const Wt=["a","button","div","h2","h3","img","label","li","nav","ol","p","span","svg","ul"].reduce(((e,t)=>{const o=(0,react.forwardRef)(((e,n)=>{const{asChild:o,...r}=e,i=o?Bt:t;return (0,react.useEffect)((()=>{window[Symbol.for("radix-ui")]=!0}),[]),(0,react.createElement)(i,Mt({},r,{ref:n}))}));return o.displayName=`Primitive.${t}`,{...e,[t]:o}}),{});function jt(e){const t=(0,react.useRef)(e);return (0,react.useEffect)((()=>{t.current=e})),(0,react.useMemo)((()=>(...e)=>{var n;return null===(n=t.current)||void 0===n?void 0:n.call(t,...e)}),[])}const Ft="dismissableLayer.update",Ut="dismissableLayer.pointerDownOutside",zt="dismissableLayer.focusOutside";let Yt;const qt=(0,react.createContext)({layers:new Set,layersWithOutsidePointerEventsDisabled:new Set,branches:new Set}),Vt=(0,react.forwardRef)(((e,t)=>{var n;const{disableOutsidePointerEvents:i=!1,onEscapeKeyDown:l,onPointerDownOutside:s,onFocusOutside:c,onInteractOutside:m,onDismiss:_,...p}=e,f=(0,react.useContext)(qt),[h,v]=(0,react.useState)(null),g=null!==(n=null==h?void 0:h.ownerDocument)&&void 0!==n?n:null===globalThis||void 0===globalThis?void 0:globalThis.document,[,E]=(0,react.useState)({}),y=Ot(t,(e=>v(e))),b=Array.from(f.layers),[N]=[...f.layersWithOutsidePointerEventsDisabled].slice(-1),w=b.indexOf(N),S=h?b.indexOf(h):-1,T=f.layersWithOutsidePointerEventsDisabled.size>0,C=S>=w,L=function(e,t=(null===globalThis||void 0===globalThis?void 0:globalThis.document)){const n=jt(e),o=(0,react.useRef)(!1),i=(0,react.useRef)((()=>{}));return (0,react.useEffect)((()=>{const e=e=>{if(e.target&&!o.current){const r={originalEvent:e};function a(){Gt(Ut,n,r,{discrete:!0})}"touch"===e.pointerType?(t.removeEventListener("click",i.current),i.current=a,t.addEventListener("click",i.current,{once:!0})):a()}o.current=!1},r=window.setTimeout((()=>{t.addEventListener("pointerdown",e)}),0);return()=>{window.clearTimeout(r),t.removeEventListener("pointerdown",e),t.removeEventListener("click",i.current)}}),[t,n]),{onPointerDownCapture:()=>o.current=!0}}((e=>{const t=e.target,n=[...f.branches].some((e=>e.contains(t)));C&&!n&&(null==s||s(e),null==m||m(e),e.defaultPrevented||null==_||_())}),g),k=function(e,t=(null===globalThis||void 0===globalThis?void 0:globalThis.document)){const n=jt(e),o=(0,react.useRef)(!1);return (0,react.useEffect)((()=>{const e=e=>{if(e.target&&!o.current){Gt(zt,n,{originalEvent:e},{discrete:!1})}};return t.addEventListener("focusin",e),()=>t.removeEventListener("focusin",e)}),[t,n]),{onFocusCapture:()=>o.current=!0,onBlurCapture:()=>o.current=!1}}((e=>{const t=e.target;[...f.branches].some((e=>e.contains(t)))||(null==c||c(e),null==m||m(e),e.defaultPrevented||null==_||_())}),g);return function(e,t=(null===globalThis||void 0===globalThis?void 0:globalThis.document)){const n=jt(e);(0,react.useEffect)((()=>{const e=e=>{"Escape"===e.key&&n(e)};return t.addEventListener("keydown",e),()=>t.removeEventListener("keydown",e)}),[n,t])}((e=>{S===f.layers.size-1&&(null==l||l(e),!e.defaultPrevented&&_&&(e.preventDefault(),_()))}),g),(0,react.useEffect)((()=>{if(h)return i&&(0===f.layersWithOutsidePointerEventsDisabled.size&&(Yt=g.body.style.pointerEvents,g.body.style.pointerEvents="none"),f.layersWithOutsidePointerEventsDisabled.add(h)),f.layers.add(h),Kt(),()=>{i&&1===f.layersWithOutsidePointerEventsDisabled.size&&(g.body.style.pointerEvents=Yt)}}),[h,g,i,f]),(0,react.useEffect)((()=>()=>{h&&(f.layers.delete(h),f.layersWithOutsidePointerEventsDisabled.delete(h),Kt())}),[h,f]),(0,react.useEffect)((()=>{const e=()=>E({});return document.addEventListener(Ft,e),()=>document.removeEventListener(Ft,e)}),[]),(0,react.createElement)(Wt.div,Mt({},p,{ref:y,style:{pointerEvents:T?C?"auto":"none":void 0,...e.style},onFocusCapture:It(e.onFocusCapture,k.onFocusCapture),onBlurCapture:It(e.onBlurCapture,k.onBlurCapture),onPointerDownCapture:It(e.onPointerDownCapture,L.onPointerDownCapture)}))}));function Kt(){const e=new CustomEvent(Ft);document.dispatchEvent(e)}function Gt(e,t,n,{discrete:o}){const r=n.originalEvent.target,a=new CustomEvent(e,{bubbles:!1,cancelable:!0,detail:n});t&&r.addEventListener(e,t,{once:!0}),o?function(e,t){e&&(0,react_dom.flushSync)((()=>e.dispatchEvent(t)))}(r,a):r.dispatchEvent(a)}let Zt=0;function Xt(){const e=document.createElement("span");return e.setAttribute("data-radix-focus-guard",""),e.tabIndex=0,e.style.cssText="outline: none; opacity: 0; position: fixed; pointer-events: none",e}const Jt="focusScope.autoFocusOnMount",Qt="focusScope.autoFocusOnUnmount",en={bubbles:!1,cancelable:!0},tn=(0,react.forwardRef)(((e,t)=>{const{loop:n=!1,trapped:l=!1,onMountAutoFocus:s,onUnmountAutoFocus:c,...d}=e,[m,_]=(0,react.useState)(null),p=jt(s),f=jt(c),h=(0,react.useRef)(null),v=Ot(t,(e=>_(e))),g=(0,react.useRef)({paused:!1,pause(){this.paused=!0},resume(){this.paused=!1}}).current;(0,react.useEffect)((()=>{if(l){function e(e){if(g.paused||!m)return;const t=e.target;m.contains(t)?h.current=t:an(h.current,{select:!0})}function t(e){!g.paused&&m&&(m.contains(e.relatedTarget)||an(h.current,{select:!0}))}return document.addEventListener("focusin",e),document.addEventListener("focusout",t),()=>{document.removeEventListener("focusin",e),document.removeEventListener("focusout",t)}}}),[l,m,g.paused]),(0,react.useEffect)((()=>{if(m){ln.add(g);const t=document.activeElement;if(!m.contains(t)){const n=new CustomEvent(Jt,en);m.addEventListener(Jt,p),m.dispatchEvent(n),n.defaultPrevented||(!function(e,{select:t=!1}={}){const n=document.activeElement;for(const o of e)if(an(o,{select:t}),document.activeElement!==n)return}((e=nn(m),e.filter((e=>"A"!==e.tagName))),{select:!0}),document.activeElement===t&&an(m))}return()=>{m.removeEventListener(Jt,p),setTimeout((()=>{const e=new CustomEvent(Qt,en);m.addEventListener(Qt,f),m.dispatchEvent(e),e.defaultPrevented||an(null!=t?t:document.body,{select:!0}),m.removeEventListener(Qt,f),ln.remove(g)}),0)}}var e}),[m,p,f,g]);const E=(0,react.useCallback)((e=>{if(!n&&!l)return;if(g.paused)return;const t="Tab"===e.key&&!e.altKey&&!e.ctrlKey&&!e.metaKey,o=document.activeElement;if(t&&o){const t=e.currentTarget,[r,a]=function(e){const t=nn(e),n=on(t,e),o=on(t.reverse(),e);return[n,o]}(t);r&&a?e.shiftKey||o!==a?e.shiftKey&&o===r&&(e.preventDefault(),n&&an(a,{select:!0})):(e.preventDefault(),n&&an(r,{select:!0})):o===t&&e.preventDefault()}}),[n,l,g.paused]);return (0,react.createElement)(Wt.div,Mt({tabIndex:-1},d,{ref:v,onKeyDown:E}))}));function nn(e){const t=[],n=document.createTreeWalker(e,NodeFilter.SHOW_ELEMENT,{acceptNode:e=>{const t="INPUT"===e.tagName&&"hidden"===e.type;return e.disabled||e.hidden||t?NodeFilter.FILTER_SKIP:e.tabIndex>=0?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP}});for(;n.nextNode();)t.push(n.currentNode);return t}function on(e,t){for(const n of e)if(!rn(n,{upTo:t}))return n}function rn(e,{upTo:t}){if("hidden"===getComputedStyle(e).visibility)return!0;for(;e;){if(void 0!==t&&e===t)return!1;if("none"===getComputedStyle(e).display)return!0;e=e.parentElement}return!1}function an(e,{select:t=!1}={}){if(e&&e.focus){const n=document.activeElement;e.focus({preventScroll:!0}),e!==n&&function(e){return e instanceof HTMLInputElement&&"select"in e}(e)&&t&&e.select()}}const ln=function(){let e=[];return{add(t){const n=e[0];t!==n&&(null==n||n.pause()),e=sn(e,t),e.unshift(t)},remove(t){var n;e=sn(e,t),null===(n=e[0])||void 0===n||n.resume()}}}();function sn(e,t){const n=[...e],o=n.indexOf(t);return-1!==o&&n.splice(o,1),n}const cn=Boolean(null===globalThis||void 0===globalThis?void 0:globalThis.document)?react.useLayoutEffect:()=>{},un=react_namespaceObject["useId".toString()]||(()=>{});let dn=0;function mn(t){const[n,o]=e.useState(un());return cn((()=>{t||o((e=>null!=e?e:String(dn++)))}),[t]),t||(n?`radix-${n}`:"")}function _n(e){return e.split("-")[0]}function pn(e){return e.split("-")[1]}function fn(e){return["top","bottom"].includes(_n(e))?"x":"y"}function hn(e){return"y"===e?"height":"width"}function vn(e,t,n){let{reference:o,floating:r}=e;const a=o.x+o.width/2-r.width/2,i=o.y+o.height/2-r.height/2,l=fn(t),s=hn(l),c=o[s]/2-r[s]/2,u="x"===l;let d;switch(_n(t)){case"top":d={x:a,y:o.y-r.height};break;case"bottom":d={x:a,y:o.y+o.height};break;case"right":d={x:o.x+o.width,y:i};break;case"left":d={x:o.x-r.width,y:i};break;default:d={x:o.x,y:o.y}}switch(pn(t)){case"start":d[l]-=c*(n&&u?-1:1);break;case"end":d[l]+=c*(n&&u?-1:1)}return d}function gn(e){return"number"!=typeof e?function(e){return{top:0,right:0,bottom:0,left:0,...e}}(e):{top:e,right:e,bottom:e,left:e}}function En(e){return{...e,top:e.y,left:e.x,right:e.x+e.width,bottom:e.y+e.height}}async function yn(e,t){var n;void 0===t&&(t={});const{x:o,y:r,platform:a,rects:i,elements:l,strategy:s}=e,{boundary:c="clippingAncestors",rootBoundary:u="viewport",elementContext:d="floating",altBoundary:m=!1,padding:_=0}=t,p=gn(_),f=l[m?"floating"===d?"reference":"floating":d],h=En(await a.getClippingRect({element:null==(n=await(null==a.isElement?void 0:a.isElement(f)))||n?f:f.contextElement||await(null==a.getDocumentElement?void 0:a.getDocumentElement(l.floating)),boundary:c,rootBoundary:u,strategy:s})),v=En(a.convertOffsetParentRelativeRectToViewportRelativeRect?await a.convertOffsetParentRelativeRectToViewportRelativeRect({rect:"floating"===d?{...i.floating,x:o,y:r}:i.reference,offsetParent:await(null==a.getOffsetParent?void 0:a.getOffsetParent(l.floating)),strategy:s}):i[d]);return{top:h.top-v.top+p.top,bottom:v.bottom-h.bottom+p.bottom,left:h.left-v.left+p.left,right:v.right-h.right+p.right}}const bn=Math.min,Nn=Math.max;function wn(e,t,n){return Nn(e,bn(t,n))}const Sn=e=>({name:"arrow",options:e,async fn(t){const{element:n,padding:o=0}=null!=e?e:{},{x:r,y:a,placement:i,rects:l,platform:s}=t;if(null==n)return false&&0,{};const c=gn(o),u={x:r,y:a},d=fn(i),m=pn(i),_=hn(d),p=await s.getDimensions(n),f="y"===d?"top":"left",h="y"===d?"bottom":"right",v=l.reference[_]+l.reference[d]-u[d]-l.floating[_],g=u[d]-l.reference[d],E=await(null==s.getOffsetParent?void 0:s.getOffsetParent(n));let y=E?"y"===d?E.clientHeight||0:E.clientWidth||0:0;0===y&&(y=l.floating[_]);const b=v/2-g/2,N=c[f],w=y-p[_]-c[h],S=y/2-p[_]/2+b,T=wn(N,S,w),C=("start"===m?c[f]:c[h])>0&&S!==T&&l.reference[_]<=l.floating[_]?S<N?N-S:w-S:0;return{[d]:u[d]-C,data:{[d]:T,centerOffset:S-T}}}}),Tn={left:"right",right:"left",bottom:"top",top:"bottom"};function Cn(e){return e.replace(/left|right|bottom|top/g,(e=>Tn[e]))}const Ln={start:"end",end:"start"};function kn(e){return e.replace(/start|end/g,(e=>Ln[e]))}const Mn=["top","right","bottom","left"];const In=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(t){var n;const{placement:o,middlewareData:r,rects:a,initialPlacement:i,platform:l,elements:s}=t,{mainAxis:c=!0,crossAxis:u=!0,fallbackPlacements:d,fallbackStrategy:m="bestFit",flipAlignment:_=!0,...p}=e,f=_n(o),h=d||(f===i||!_?[Cn(i)]:function(e){const t=Cn(e);return[kn(e),t,kn(t)]}(i)),v=[i,...h],g=await yn(t,p),E=[];let y=(null==(n=r.flip)?void 0:n.overflows)||[];if(c&&E.push(g[f]),u){const{main:e,cross:t}=function(e,t,n){void 0===n&&(n=!1);const o=pn(e),r=fn(e),a=hn(r);let i="x"===r?o===(n?"end":"start")?"right":"left":"start"===o?"bottom":"top";return t.reference[a]>t.floating[a]&&(i=Cn(i)),{main:i,cross:Cn(i)}}(o,a,await(null==l.isRTL?void 0:l.isRTL(s.floating)));E.push(g[e],g[t])}if(y=[...y,{placement:o,overflows:E}],!E.every((e=>e<=0))){var b,N;const e=(null!=(b=null==(N=r.flip)?void 0:N.index)?b:0)+1,t=v[e];if(t)return{data:{index:e,overflows:y},reset:{placement:t}};let n="bottom";switch(m){case"bestFit":{var w;const e=null==(w=y.map((e=>[e,e.overflows.filter((e=>e>0)).reduce(((e,t)=>e+t),0)])).sort(((e,t)=>e[1]-t[1]))[0])?void 0:w[0].placement;e&&(n=e);break}case"initialPlacement":n=i}if(o!==n)return{reset:{placement:n}}}return{}}}};function Pn(e,t){return{top:e.top-t.height,right:e.right-t.width,bottom:e.bottom-t.height,left:e.left-t.width}}function On(e){return Mn.some((t=>e[t]>=0))}const xn=function(e){let{strategy:t="referenceHidden",...n}=void 0===e?{}:e;return{name:"hide",async fn(e){const{rects:o}=e;switch(t){case"referenceHidden":{const t=Pn(await yn(e,{...n,elementContext:"reference"}),o.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:On(t)}}}case"escaped":{const t=Pn(await yn(e,{...n,altBoundary:!0}),o.floating);return{data:{escapedOffsets:t,escaped:On(t)}}}default:return{}}}}};const An=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(t){const{x:n,y:o}=t,r=await async function(e,t){const{placement:n,platform:o,elements:r}=e,a=await(null==o.isRTL?void 0:o.isRTL(r.floating)),i=_n(n),l=pn(n),s="x"===fn(n),c=["left","top"].includes(i)?-1:1,u=a&&s?-1:1,d="function"==typeof t?t(e):t;let{mainAxis:m,crossAxis:_,alignmentAxis:p}="number"==typeof d?{mainAxis:d,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...d};return l&&"number"==typeof p&&(_="end"===l?-1*p:p),s?{x:_*u,y:m*c}:{x:m*c,y:_*u}}(t,e);return{x:n+r.x,y:o+r.y,data:r}}}};function Bn(e){return"x"===e?"y":"x"}const Rn=function(e){return void 0===e&&(e={}),{name:"shift",options:e,async fn(t){const{x:n,y:o,placement:r}=t,{mainAxis:a=!0,crossAxis:i=!1,limiter:l={fn:e=>{let{x:t,y:n}=e;return{x:t,y:n}}},...s}=e,c={x:n,y:o},u=await yn(t,s),d=fn(_n(r)),m=Bn(d);let _=c[d],p=c[m];if(a){const e="y"===d?"bottom":"right";_=wn(_+u["y"===d?"top":"left"],_,_-u[e])}if(i){const e="y"===m?"bottom":"right";p=wn(p+u["y"===m?"top":"left"],p,p-u[e])}const f=l.fn({...t,[d]:_,[m]:p});return{...f,data:{x:f.x-n,y:f.y-o}}}}},Dn=function(e){return void 0===e&&(e={}),{options:e,fn(t){const{x:n,y:o,placement:r,rects:a,middlewareData:i}=t,{offset:l=0,mainAxis:s=!0,crossAxis:c=!0}=e,u={x:n,y:o},d=fn(r),m=Bn(d);let _=u[d],p=u[m];const f="function"==typeof l?l({...a,placement:r}):l,h="number"==typeof f?{mainAxis:f,crossAxis:0}:{mainAxis:0,crossAxis:0,...f};if(s){const e="y"===d?"height":"width",t=a.reference[d]-a.floating[e]+h.mainAxis,n=a.reference[d]+a.reference[e]-h.mainAxis;_<t?_=t:_>n&&(_=n)}if(c){var v,g,E,y;const e="y"===d?"width":"height",t=["top","left"].includes(_n(r)),n=a.reference[m]-a.floating[e]+(t&&null!=(v=null==(g=i.offset)?void 0:g[m])?v:0)+(t?0:h.crossAxis),o=a.reference[m]+a.reference[e]+(t?0:null!=(E=null==(y=i.offset)?void 0:y[m])?E:0)-(t?h.crossAxis:0);p<n?p=n:p>o&&(p=o)}return{[d]:_,[m]:p}}}},Hn=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(t){const{placement:n,rects:o,platform:r,elements:a}=t,{apply:i,...l}=e,s=await yn(t,l),c=_n(n),u=pn(n);let d,m;"top"===c||"bottom"===c?(d=c,m=u===(await(null==r.isRTL?void 0:r.isRTL(a.floating))?"start":"end")?"left":"right"):(m=c,d="end"===u?"top":"bottom");const _=Nn(s.left,0),p=Nn(s.right,0),f=Nn(s.top,0),h=Nn(s.bottom,0),v={availableHeight:o.floating.height-(["left","right"].includes(n)?2*(0!==f||0!==h?f+h:Nn(s.top,s.bottom)):s[d]),availableWidth:o.floating.width-(["top","bottom"].includes(n)?2*(0!==_||0!==p?_+p:Nn(s.left,s.right)):s[m])},g=await r.getDimensions(a.floating);null==i||i({...t,...v});const E=await r.getDimensions(a.floating);return g.width!==E.width||g.height!==E.height?{reset:{rects:!0}}:{}}}};function $n(e){return e&&e.document&&e.location&&e.alert&&e.setInterval}function Wn(e){if(null==e)return window;if(!$n(e)){const t=e.ownerDocument;return t&&t.defaultView||window}return e}function jn(e){return Wn(e).getComputedStyle(e)}function Fn(e){return $n(e)?"":e?(e.nodeName||"").toLowerCase():""}function Un(){const e=navigator.userAgentData;return null!=e&&e.brands?e.brands.map((e=>e.brand+"/"+e.version)).join(" "):navigator.userAgent}function zn(e){return e instanceof Wn(e).HTMLElement}function Yn(e){return e instanceof Wn(e).Element}function qn(e){if("undefined"==typeof ShadowRoot)return!1;return e instanceof Wn(e).ShadowRoot||e instanceof ShadowRoot}function Vn(e){const{overflow:t,overflowX:n,overflowY:o}=jn(e);return/auto|scroll|overlay|hidden/.test(t+o+n)}function Kn(e){return["table","td","th"].includes(Fn(e))}function Gn(e){const t=/firefox/i.test(Un()),n=jn(e);return"none"!==n.transform||"none"!==n.perspective||"paint"===n.contain||["transform","perspective"].includes(n.willChange)||t&&"filter"===n.willChange||t&&!!n.filter&&"none"!==n.filter}function Zn(){return!/^((?!chrome|android).)*safari/i.test(Un())}const Xn=Math.min,Jn=Math.max,Qn=Math.round;function eo(e,t,n){var o,r,a,i;void 0===t&&(t=!1),void 0===n&&(n=!1);const l=e.getBoundingClientRect();let s=1,c=1;t&&zn(e)&&(s=e.offsetWidth>0&&Qn(l.width)/e.offsetWidth||1,c=e.offsetHeight>0&&Qn(l.height)/e.offsetHeight||1);const u=Yn(e)?Wn(e):window,d=!Zn()&&n,m=(l.left+(d&&null!=(o=null==(r=u.visualViewport)?void 0:r.offsetLeft)?o:0))/s,_=(l.top+(d&&null!=(a=null==(i=u.visualViewport)?void 0:i.offsetTop)?a:0))/c,p=l.width/s,f=l.height/c;return{width:p,height:f,top:_,right:m+p,bottom:_+f,left:m,x:m,y:_}}function to(e){return(t=e,(t instanceof Wn(t).Node?e.ownerDocument:e.document)||window.document).documentElement;var t}function no(e){return Yn(e)?{scrollLeft:e.scrollLeft,scrollTop:e.scrollTop}:{scrollLeft:e.pageXOffset,scrollTop:e.pageYOffset}}function oo(e){return eo(to(e)).left+no(e).scrollLeft}function ro(e,t,n){const o=zn(t),r=to(t),a=eo(e,o&&function(e){const t=eo(e);return Qn(t.width)!==e.offsetWidth||Qn(t.height)!==e.offsetHeight}(t),"fixed"===n);let i={scrollLeft:0,scrollTop:0};const l={x:0,y:0};if(o||!o&&"fixed"!==n)if(("body"!==Fn(t)||Vn(r))&&(i=no(t)),zn(t)){const e=eo(t,!0);l.x=e.x+t.clientLeft,l.y=e.y+t.clientTop}else r&&(l.x=oo(r));return{x:a.left+i.scrollLeft-l.x,y:a.top+i.scrollTop-l.y,width:a.width,height:a.height}}function ao(e){return"html"===Fn(e)?e:e.assignedSlot||e.parentNode||(qn(e)?e.host:null)||to(e)}function io(e){return zn(e)&&"fixed"!==getComputedStyle(e).position?e.offsetParent:null}function lo(e){const t=Wn(e);let n=io(e);for(;n&&Kn(n)&&"static"===getComputedStyle(n).position;)n=io(n);return n&&("html"===Fn(n)||"body"===Fn(n)&&"static"===getComputedStyle(n).position&&!Gn(n))?t:n||function(e){let t=ao(e);for(qn(t)&&(t=t.host);zn(t)&&!["html","body"].includes(Fn(t));){if(Gn(t))return t;t=t.parentNode}return null}(e)||t}function so(e){if(zn(e))return{width:e.offsetWidth,height:e.offsetHeight};const t=eo(e);return{width:t.width,height:t.height}}function co(e){const t=ao(e);return["html","body","#document"].includes(Fn(t))?e.ownerDocument.body:zn(t)&&Vn(t)?t:co(t)}function uo(e,t){var n;void 0===t&&(t=[]);const o=co(e),r=o===(null==(n=e.ownerDocument)?void 0:n.body),a=Wn(o),i=r?[a].concat(a.visualViewport||[],Vn(o)?o:[]):o,l=t.concat(i);return r?l:l.concat(uo(i))}function mo(e,t,n){return"viewport"===t?En(function(e,t){const n=Wn(e),o=to(e),r=n.visualViewport;let a=o.clientWidth,i=o.clientHeight,l=0,s=0;if(r){a=r.width,i=r.height;const e=Zn();(e||!e&&"fixed"===t)&&(l=r.offsetLeft,s=r.offsetTop)}return{width:a,height:i,x:l,y:s}}(e,n)):Yn(t)?function(e,t){const n=eo(e,!1,"fixed"===t),o=n.top+e.clientTop,r=n.left+e.clientLeft;return{top:o,left:r,x:r,y:o,right:r+e.clientWidth,bottom:o+e.clientHeight,width:e.clientWidth,height:e.clientHeight}}(t,n):En(function(e){var t;const n=to(e),o=no(e),r=null==(t=e.ownerDocument)?void 0:t.body,a=Jn(n.scrollWidth,n.clientWidth,r?r.scrollWidth:0,r?r.clientWidth:0),i=Jn(n.scrollHeight,n.clientHeight,r?r.scrollHeight:0,r?r.clientHeight:0);let l=-o.scrollLeft+oo(e);const s=-o.scrollTop;return"rtl"===jn(r||n).direction&&(l+=Jn(n.clientWidth,r?r.clientWidth:0)-a),{width:a,height:i,x:l,y:s}}(to(e)))}function _o(e){const t=uo(e),n=["absolute","fixed"].includes(jn(e).position)&&zn(e)?lo(e):e;return Yn(n)?t.filter((e=>Yn(e)&&function(e,t){const n=null==t.getRootNode?void 0:t.getRootNode();if(e.contains(t))return!0;if(n&&qn(n)){let n=t;do{if(n&&e===n)return!0;n=n.parentNode||n.host}while(n)}return!1}(e,n)&&"body"!==Fn(e))):[]}const po={getClippingRect:function(e){let{element:t,boundary:n,rootBoundary:o,strategy:r}=e;const a=[..."clippingAncestors"===n?_o(t):[].concat(n),o],i=a[0],l=a.reduce(((e,n)=>{const o=mo(t,n,r);return e.top=Jn(o.top,e.top),e.right=Xn(o.right,e.right),e.bottom=Xn(o.bottom,e.bottom),e.left=Jn(o.left,e.left),e}),mo(t,i,r));return{width:l.right-l.left,height:l.bottom-l.top,x:l.left,y:l.top}},convertOffsetParentRelativeRectToViewportRelativeRect:function(e){let{rect:t,offsetParent:n,strategy:o}=e;const r=zn(n),a=to(n);if(n===a)return t;let i={scrollLeft:0,scrollTop:0};const l={x:0,y:0};if((r||!r&&"fixed"!==o)&&(("body"!==Fn(n)||Vn(a))&&(i=no(n)),zn(n))){const e=eo(n,!0);l.x=e.x+n.clientLeft,l.y=e.y+n.clientTop}return{...t,x:t.x-i.scrollLeft+l.x,y:t.y-i.scrollTop+l.y}},isElement:Yn,getDimensions:so,getOffsetParent:lo,getDocumentElement:to,getElementRects:e=>{let{reference:t,floating:n,strategy:o}=e;return{reference:ro(t,lo(n),o),floating:{...so(n),x:0,y:0}}},getClientRects:e=>Array.from(e.getClientRects()),isRTL:e=>"rtl"===jn(e).direction};function fo(e,t,n,o){void 0===o&&(o={});const{ancestorScroll:r=!0,ancestorResize:a=!0,elementResize:i=!0,animationFrame:l=!1}=o,s=r&&!l,c=a&&!l,u=s||c?[...Yn(e)?uo(e):[],...uo(t)]:[];u.forEach((e=>{s&&e.addEventListener("scroll",n,{passive:!0}),c&&e.addEventListener("resize",n)}));let d,m=null;if(i){let o=!0;m=new ResizeObserver((()=>{o||n(),o=!1})),Yn(e)&&!l&&m.observe(e),m.observe(t)}let _=l?eo(e):null;return l&&function t(){const o=eo(e);!_||o.x===_.x&&o.y===_.y&&o.width===_.width&&o.height===_.height||n();_=o,d=requestAnimationFrame(t)}(),n(),()=>{var e;u.forEach((e=>{s&&e.removeEventListener("scroll",n),c&&e.removeEventListener("resize",n)})),null==(e=m)||e.disconnect(),m=null,l&&cancelAnimationFrame(d)}}const ho=(e,t,n)=>(async(e,t,n)=>{const{placement:o="bottom",strategy:r="absolute",middleware:a=[],platform:i}=n,l=await(null==i.isRTL?void 0:i.isRTL(t));if(false){}let s=await i.getElementRects({reference:e,floating:t,strategy:r}),{x:c,y:u}=vn(s,o,l),d=o,m={},_=0;for(let n=0;n<a.length;n++){const{name:p,fn:f}=a[n],{x:h,y:v,data:g,reset:E}=await f({x:c,y:u,initialPlacement:o,placement:d,strategy:r,middlewareData:m,rects:s,platform:i,elements:{reference:e,floating:t}});c=null!=h?h:c,u=null!=v?v:u,m={...m,[p]:{...m[p],...g}}, false&&0,E&&_<=50&&(_++,"object"==typeof E&&(E.placement&&(d=E.placement),E.rects&&(s=!0===E.rects?await i.getElementRects({reference:e,floating:t,strategy:r}):E.rects),({x:c,y:u}=vn(s,d,l))),n=-1)}return{x:c,y:u,placement:d,strategy:r,middlewareData:m}})(e,t,{platform:po,...n});var vo="undefined"!=typeof document?react.useLayoutEffect:react.useEffect;function go(e,t){if(e===t)return!0;if(typeof e!=typeof t)return!1;if("function"==typeof e&&e.toString()===t.toString())return!0;let n,o,r;if(e&&t&&"object"==typeof e){if(Array.isArray(e)){if(n=e.length,n!=t.length)return!1;for(o=n;0!=o--;)if(!go(e[o],t[o]))return!1;return!0}if(r=Object.keys(e),n=r.length,n!==Object.keys(t).length)return!1;for(o=n;0!=o--;)if(!Object.prototype.hasOwnProperty.call(t,r[o]))return!1;for(o=n;0!=o--;){const n=r[o];if(("_owner"!==n||!e.$$typeof)&&!go(e[n],t[n]))return!1}return!0}return e!=e&&t!=t}function Eo(t){let{middleware:n,placement:o="bottom",strategy:r="absolute",whileElementsMounted:a}=void 0===t?{}:t;const i=react.useRef(null),l=react.useRef(null),s=function(t){const n=react.useRef(t);return vo((()=>{n.current=t})),n}(a),c=react.useRef(null),[u,d]=react.useState({x:null,y:null,strategy:r,placement:o,middlewareData:{}}),[m,_]=react.useState(n);go(null==m?void 0:m.map((e=>{let{options:t}=e;return t})),null==n?void 0:n.map((e=>{let{options:t}=e;return t})))||_(n);const p=react.useCallback((()=>{i.current&&l.current&&ho(i.current,l.current,{middleware:m,placement:o,strategy:r}).then((e=>{f.current&&react_dom.flushSync((()=>{d(e)}))}))}),[m,o,r]);vo((()=>{f.current&&p()}),[p]);const f=react.useRef(!1);vo((()=>(f.current=!0,()=>{f.current=!1})),[]);const h=react.useCallback((()=>{if("function"==typeof c.current&&(c.current(),c.current=null),i.current&&l.current)if(s.current){const e=s.current(i.current,l.current,p);c.current=e}else p()}),[p,s]),v=react.useCallback((e=>{i.current=e,h()}),[h]),g=react.useCallback((e=>{l.current=e,h()}),[h]),E=react.useMemo((()=>({reference:i,floating:l})),[]);return react.useMemo((()=>({...u,update:p,refs:E,reference:v,floating:g})),[u,p,E,v,g])}const yo=e=>{const{element:t,padding:n}=e;return{name:"arrow",options:e,fn(e){return o=t,Object.prototype.hasOwnProperty.call(o,"current")?null!=t.current?Sn({element:t.current,padding:n}).fn(e):{}:t?Sn({element:t,padding:n}).fn(e):{};var o}}},bo=(0,react.forwardRef)(((e,t)=>{const{children:n,width:o=10,height:r=5,...a}=e;return (0,react.createElement)(Wt.svg,Mt({},a,{ref:t,width:o,height:r,viewBox:"0 0 30 10",preserveAspectRatio:"none"}),e.asChild?n:(0,react.createElement)("polygon",{points:"0,0 30,0 15,10"}))}));const No="Popper",[wo,So]=xt(No),[To,Co]=wo(No),Lo=(0,react.forwardRef)(((e,t)=>{const{__scopePopper:n,virtualRef:o,...i}=e,l=Co("PopperAnchor",n),s=(0,react.useRef)(null),c=Ot(t,s);return (0,react.useEffect)((()=>{l.onAnchorChange((null==o?void 0:o.current)||s.current)})),o?null:(0,react.createElement)(Wt.div,Mt({},i,{ref:c}))})),ko="PopperContent",[Mo,Io]=wo(ko),[Po,Oo]=wo(ko,{hasParent:!1,positionUpdateFns:new Set}),xo=(0,react.forwardRef)(((e,t)=>{var n,r,a,i,l,s,c,d;const{__scopePopper:m,side:_="bottom",sideOffset:p=0,align:f="center",alignOffset:v=0,arrowPadding:g=0,collisionBoundary:E=[],collisionPadding:y=0,sticky:b="partial",hideWhenDetached:N=!1,avoidCollisions:w=!0,onPlaced:S,...T}=e,C=Co(ko,m),[L,k]=(0,react.useState)(null),M=Ot(t,(e=>k(e))),[I,P]=(0,react.useState)(null),O=function(e){const[t,n]=(0,react.useState)(void 0);return cn((()=>{if(e){n({width:e.offsetWidth,height:e.offsetHeight});const t=new ResizeObserver((t=>{if(!Array.isArray(t))return;if(!t.length)return;const o=t[0];let r,a;if("borderBoxSize"in o){const e=o.borderBoxSize,t=Array.isArray(e)?e[0]:e;r=t.inlineSize,a=t.blockSize}else r=e.offsetWidth,a=e.offsetHeight;n({width:r,height:a})}));return t.observe(e,{box:"border-box"}),()=>t.unobserve(e)}n(void 0)}),[e]),t}(I),x=null!==(n=null==O?void 0:O.width)&&void 0!==n?n:0,A=null!==(r=null==O?void 0:O.height)&&void 0!==r?r:0,B=_+("center"!==f?"-"+f:""),R="number"==typeof y?y:{top:0,right:0,bottom:0,left:0,...y},D=Array.isArray(E)?E:[E],H=D.length>0,$={padding:R,boundary:D.filter(Ro),altBoundary:H},{reference:W,floating:j,strategy:F,x:U,y:z,placement:Y,middlewareData:q,update:V}=Eo({strategy:"fixed",placement:B,whileElementsMounted:fo,middleware:[Do(),An({mainAxis:p+A,alignmentAxis:v}),w?Rn({mainAxis:!0,crossAxis:!1,limiter:"partial"===b?Dn():void 0,...$}):void 0,I?yo({element:I,padding:g}):void 0,w?In({...$}):void 0,Hn({...$,apply:({elements:e,availableWidth:t,availableHeight:n})=>{e.floating.style.setProperty("--radix-popper-available-width",`${t}px`),e.floating.style.setProperty("--radix-popper-available-height",`${n}px`)}}),Ho({arrowWidth:x,arrowHeight:A}),N?xn({strategy:"referenceHidden"}):void 0].filter(Bo)});cn((()=>{W(C.anchor)}),[W,C.anchor]);const K=null!==U&&null!==z,[G,Z]=$o(Y),X=jt(S);cn((()=>{K&&(null==X||X())}),[K,X]);const J=null===(a=q.arrow)||void 0===a?void 0:a.x,Q=null===(i=q.arrow)||void 0===i?void 0:i.y,ee=0!==(null===(l=q.arrow)||void 0===l?void 0:l.centerOffset),[te,ne]=(0,react.useState)();cn((()=>{L&&ne(window.getComputedStyle(L).zIndex)}),[L]);const{hasParent:oe,positionUpdateFns:re}=Oo(ko,m),ae=!oe;(0,react.useLayoutEffect)((()=>{if(!ae)return re.add(V),()=>{re.delete(V)}}),[ae,re,V]),cn((()=>{ae&&K&&Array.from(re).reverse().forEach((e=>requestAnimationFrame(e)))}),[ae,K,re]);const ie={"data-side":G,"data-align":Z,...T,ref:M,style:{...T.style,animation:K?void 0:"none",opacity:null!==(s=q.hide)&&void 0!==s&&s.referenceHidden?0:void 0}};return (0,react.createElement)("div",{ref:j,"data-radix-popper-content-wrapper":"",style:{position:F,left:0,top:0,transform:K?`translate3d(${Math.round(U)}px, ${Math.round(z)}px, 0)`:"translate3d(0, -200%, 0)",minWidth:"max-content",zIndex:te,"--radix-popper-transform-origin":[null===(c=q.transformOrigin)||void 0===c?void 0:c.x,null===(d=q.transformOrigin)||void 0===d?void 0:d.y].join(" ")},dir:e.dir},(0,react.createElement)(Mo,{scope:m,placedSide:G,onArrowChange:P,arrowX:J,arrowY:Q,shouldHideArrow:ee},ae?(0,react.createElement)(Po,{scope:m,hasParent:!0,positionUpdateFns:re},(0,react.createElement)(Wt.div,ie)):(0,react.createElement)(Wt.div,ie)))})),Ao={top:"bottom",right:"left",bottom:"top",left:"right"};function Bo(e){return void 0!==e}function Ro(e){return null!==e}const Do=()=>({name:"anchorCssProperties",fn(e){const{rects:t,elements:n}=e,{width:o,height:r}=t.reference;return n.floating.style.setProperty("--radix-popper-anchor-width",`${o}px`),n.floating.style.setProperty("--radix-popper-anchor-height",`${r}px`),{}}}),Ho=e=>({name:"transformOrigin",options:e,fn(t){var n,o,r,a,i;const{placement:l,rects:s,middlewareData:c}=t,u=0!==(null===(n=c.arrow)||void 0===n?void 0:n.centerOffset),d=u?0:e.arrowWidth,m=u?0:e.arrowHeight,[_,p]=$o(l),f={start:"0%",center:"50%",end:"100%"}[p],h=(null!==(o=null===(r=c.arrow)||void 0===r?void 0:r.x)&&void 0!==o?o:0)+d/2,v=(null!==(a=null===(i=c.arrow)||void 0===i?void 0:i.y)&&void 0!==a?a:0)+m/2;let g="",E="";return"bottom"===_?(g=u?f:`${h}px`,E=-m+"px"):"top"===_?(g=u?f:`${h}px`,E=`${s.floating.height+m}px`):"right"===_?(g=-m+"px",E=u?f:`${v}px`):"left"===_&&(g=`${s.floating.width+m}px`,E=u?f:`${v}px`),{data:{x:g,y:E}}}});function $o(e){const[t,n="center"]=e.split("-");return[t,n]}const Wo=e=>{const{__scopePopper:t,children:n}=e,[r,a]=o(null);return u(To,{scope:t,anchor:r,onAnchorChange:a},n)},jo=Lo,Fo=xo,Uo=(0,react.forwardRef)((function(e,t){const{__scopePopper:n,...o}=e,r=Io("PopperArrow",n),a=Ao[r.placedSide];return (0,react.createElement)("span",{ref:r.onArrowChange,style:{position:"absolute",left:r.arrowX,top:r.arrowY,[a]:0,transformOrigin:{top:"",right:"0 0",bottom:"center 0",left:"100% 0"}[r.placedSide],transform:{top:"translateY(100%)",right:"translateY(50%) rotate(90deg) translateX(-50%)",bottom:"rotate(180deg)",left:"translateY(50%) rotate(-90deg) translateX(50%)"}[r.placedSide],visibility:r.shouldHideArrow?"hidden":void 0}},(0,react.createElement)(bo,Mt({},o,{ref:t,style:{...o.style,display:"block"}})))}));const zo=e=>{const{present:t,children:n}=e,l=function(e){const[t,n]=(0,react.useState)(),l=(0,react.useRef)({}),s=(0,react.useRef)(e),c=(0,react.useRef)("none"),u=e?"mounted":"unmounted",[d,m]=function(e,t){return (0,react.useReducer)(((e,n)=>{const o=t[e][n];return null!=o?o:e}),e)}(u,{mounted:{UNMOUNT:"unmounted",ANIMATION_OUT:"unmountSuspended"},unmountSuspended:{MOUNT:"mounted",ANIMATION_END:"unmounted"},unmounted:{MOUNT:"mounted"}});return (0,react.useEffect)((()=>{const e=Yo(l.current);c.current="mounted"===d?e:"none"}),[d]),cn((()=>{const t=l.current,n=s.current;if(n!==e){const o=c.current,r=Yo(t);if(e)m("MOUNT");else if("none"===r||"none"===(null==t?void 0:t.display))m("UNMOUNT");else{m(n&&o!==r?"ANIMATION_OUT":"UNMOUNT")}s.current=e}}),[e,m]),cn((()=>{if(t){const e=e=>{const n=Yo(l.current).includes(e.animationName);e.target===t&&n&&(0,react_dom.flushSync)((()=>m("ANIMATION_END")))},n=e=>{e.target===t&&(c.current=Yo(l.current))};return t.addEventListener("animationstart",n),t.addEventListener("animationcancel",e),t.addEventListener("animationend",e),()=>{t.removeEventListener("animationstart",n),t.removeEventListener("animationcancel",e),t.removeEventListener("animationend",e)}}m("ANIMATION_END")}),[t,m]),{isPresent:["mounted","unmountSuspended"].includes(d),ref:(0,react.useCallback)((e=>{e&&(l.current=getComputedStyle(e)),n(e)}),[])}}(t),s="function"==typeof n?n({present:l.isPresent}):react.Children.only(n),c=Ot(l.ref,s.ref);return"function"==typeof n||l.isPresent?(0,react.cloneElement)(s,{ref:c}):null};function Yo(e){return(null==e?void 0:e.animationName)||"none"}function qo({prop:e,defaultProp:t,onChange:n=(()=>{})}){const[l,s]=function({defaultProp:e,onChange:t}){const n=o(e),[i]=n,l=r(i),s=jt(t);return a((()=>{l.current!==i&&(s(i),l.current=i)}),[i,l,s]),n}({defaultProp:t,onChange:n}),c=void 0!==e,u=c?e:l,d=jt(n);return[u,i((t=>{if(c){const n="function"==typeof t?t(e):t;n!==e&&d(n)}else s(t)}),[c,e,s,d])]}zo.displayName="Presence";var Vo=new WeakMap,Ko=new WeakMap,Go={},Zo=0,Xo=function(e){return e&&(e.host||Xo(e.parentNode))},Jo=function(e,t,n,o){var r=function(e,t){return t.map((function(t){if(e.contains(t))return t;var n=Xo(t);return n&&e.contains(n)?n:(console.error("aria-hidden",t,"in not contained inside",e,". Doing nothing"),null)})).filter((function(e){return Boolean(e)}))}(t,Array.isArray(e)?e:[e]);Go[n]||(Go[n]=new WeakMap);var a=Go[n],i=[],l=new Set,s=new Set(r),c=function(e){e&&!l.has(e)&&(l.add(e),c(e.parentNode))};r.forEach(c);var u=function(e){e&&!s.has(e)&&Array.prototype.forEach.call(e.children,(function(e){if(l.has(e))u(e);else try{var t=e.getAttribute(o),r=null!==t&&"false"!==t,s=(Vo.get(e)||0)+1,c=(a.get(e)||0)+1;Vo.set(e,s),a.set(e,c),i.push(e),1===s&&r&&Ko.set(e,!0),1===c&&e.setAttribute(n,"true"),r||e.setAttribute(o,"true")}catch(t){console.error("aria-hidden: cannot operate on ",e,t)}}))};return u(t),l.clear(),Zo++,function(){i.forEach((function(e){var t=Vo.get(e)-1,r=a.get(e)-1;Vo.set(e,t),a.set(e,r),t||(Ko.has(e)||e.removeAttribute(o),Ko.delete(e)),r||e.removeAttribute(n)})),--Zo||(Vo=new WeakMap,Vo=new WeakMap,Ko=new WeakMap,Go={})}},Qo=function(e,t,n){void 0===n&&(n="data-aria-hidden");var o=Array.from(Array.isArray(e)?e:[e]),r=t||function(e){return"undefined"==typeof document?null:(Array.isArray(e)?e[0]:e).ownerDocument.body}(e);return r?(o.push.apply(o,Array.from(r.querySelectorAll("[aria-live]"))),Jo(o,r,n,"aria-hidden")):function(){return null}},er=function(){return er=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},er.apply(this,arguments)};function tr(e,t){var n={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)t.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(n[o[r]]=e[o[r]])}return n}"function"==typeof SuppressedError&&SuppressedError;var nr="right-scroll-bar-position",or="width-before-scroll-bar";function rr(e,t){return"function"==typeof e?e(t):e&&(e.current=t),e}var ar="undefined"!=typeof window?react.useLayoutEffect:react.useEffect,ir=new WeakMap;function lr(e,t){var n,r,a,i=(n=t||null,r=function(t){return e.forEach((function(e){return rr(e,t)}))},(a=(0,react.useState)((function(){return{value:n,callback:r,facade:{get current(){return a.value},set current(e){var t=a.value;t!==e&&(a.value=e,a.callback(e,t))}}}}))[0]).callback=r,a.facade);return ar((function(){var t=ir.get(i);if(t){var n=new Set(t),o=new Set(e),r=i.current;n.forEach((function(e){o.has(e)||rr(e,null)})),o.forEach((function(e){n.has(e)||rr(e,r)}))}ir.set(i,e)}),[e]),i}function sr(e){return e}var cr=function(t){var n=t.sideCar,o=tr(t,["sideCar"]);if(!n)throw new Error("Sidecar: please provide `sideCar` property to import the right car");var r=n.read();if(!r)throw new Error("Sidecar medium not found");return react.createElement(r,er({},o))};cr.isSideCarExport=!0;var ur=function(e){void 0===e&&(e={});var t=function(e,t){void 0===t&&(t=sr);var n=[],o=!1;return{read:function(){if(o)throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");return n.length?n[n.length-1]:e},useMedium:function(e){var r=t(e,o);return n.push(r),function(){n=n.filter((function(e){return e!==r}))}},assignSyncMedium:function(e){for(o=!0;n.length;){var t=n;n=[],t.forEach(e)}n={push:function(t){return e(t)},filter:function(){return n}}},assignMedium:function(e){o=!0;var t=[];if(n.length){var r=n;n=[],r.forEach(e),t=n}var a=function(){var n=t;t=[],n.forEach(e)},i=function(){return Promise.resolve().then(a)};i(),n={push:function(e){t.push(e),i()},filter:function(e){return t=t.filter(e),n}}}}}(null);return t.options=er({async:!0,ssr:!1},e),t}(),dr=function(){},mr=react.forwardRef((function(t,n){var o=react.useRef(null),r=react.useState({onScrollCapture:dr,onWheelCapture:dr,onTouchMoveCapture:dr}),a=r[0],i=r[1],l=t.forwardProps,s=t.children,c=t.className,u=t.removeScrollBar,d=t.enabled,m=t.shards,_=t.sideCar,p=t.noIsolation,f=t.inert,h=t.allowPinchZoom,v=t.as,g=void 0===v?"div":v,E=tr(t,["forwardProps","children","className","removeScrollBar","enabled","shards","sideCar","noIsolation","inert","allowPinchZoom","as"]),y=_,b=lr([o,n]),N=er(er({},E),a);return react.createElement(react.Fragment,null,d&&react.createElement(y,{sideCar:ur,removeScrollBar:u,shards:m,noIsolation:p,inert:f,setCallbacks:i,allowPinchZoom:!!h,lockRef:o}),l?react.cloneElement(react.Children.only(s),er(er({},N),{ref:b})):react.createElement(g,er({},N,{className:c,ref:b}),s))}));mr.defaultProps={enabled:!0,removeScrollBar:!0,inert:!1},mr.classNames={fullWidth:or,zeroRight:nr};function _r(){if(!document)return null;var e=document.createElement("style");e.type="text/css";var t=function(){if(true)return __webpack_require__.nc}();return t&&e.setAttribute("nonce",t),e}var pr=function(){var e=0,t=null;return{add:function(n){var o,r;0==e&&(t=_r())&&(r=n,(o=t).styleSheet?o.styleSheet.cssText=r:o.appendChild(document.createTextNode(r)),function(e){(document.head||document.getElementsByTagName("head")[0]).appendChild(e)}(t)),e++},remove:function(){! --e&&t&&(t.parentNode&&t.parentNode.removeChild(t),t=null)}}},fr=function(){var t,n=(t=pr(),function(n,o){react.useEffect((function(){return t.add(n),function(){t.remove()}}),[n&&o])});return function(e){var t=e.styles,o=e.dynamic;return n(t,o),null}},hr={left:0,top:0,right:0,gap:0},vr=function(e){return parseInt(e||"",10)||0},gr=function(e){if(void 0===e&&(e="margin"),"undefined"==typeof window)return hr;var t=function(e){var t=window.getComputedStyle(document.body),n=t["padding"===e?"paddingLeft":"marginLeft"],o=t["padding"===e?"paddingTop":"marginTop"],r=t["padding"===e?"paddingRight":"marginRight"];return[vr(n),vr(o),vr(r)]}(e),n=document.documentElement.clientWidth,o=window.innerWidth;return{left:t[0],top:t[1],right:t[2],gap:Math.max(0,o-n+t[2]-t[0])}},Er=fr(),yr="data-scroll-locked",br=function(e,t,n,o){var r=e.left,a=e.top,i=e.right,l=e.gap;return void 0===n&&(n="margin"),"\n  .".concat("with-scroll-bars-hidden"," {\n   overflow: hidden ").concat(o,";\n   padding-right: ").concat(l,"px ").concat(o,";\n  }\n  body[").concat(yr,"] {\n    overflow: hidden ").concat(o,";\n    overscroll-behavior: contain;\n    ").concat([t&&"position: relative ".concat(o,";"),"margin"===n&&"\n    padding-left: ".concat(r,"px;\n    padding-top: ").concat(a,"px;\n    padding-right: ").concat(i,"px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(l,"px ").concat(o,";\n    "),"padding"===n&&"padding-right: ".concat(l,"px ").concat(o,";")].filter(Boolean).join(""),"\n  }\n  \n  .").concat(nr," {\n    right: ").concat(l,"px ").concat(o,";\n  }\n  \n  .").concat(or," {\n    margin-right: ").concat(l,"px ").concat(o,";\n  }\n  \n  .").concat(nr," .").concat(nr," {\n    right: 0 ").concat(o,";\n  }\n  \n  .").concat(or," .").concat(or," {\n    margin-right: 0 ").concat(o,";\n  }\n  \n  body[").concat(yr,"] {\n    ").concat("--removed-body-scroll-bar-size",": ").concat(l,"px;\n  }\n")},Nr=function(){var e=parseInt(document.body.getAttribute(yr)||"0",10);return isFinite(e)?e:0},wr=function(t){var n=t.noRelative,o=t.noImportant,r=t.gapMode,a=void 0===r?"margin":r;react.useEffect((function(){return document.body.setAttribute(yr,(Nr()+1).toString()),function(){var e=Nr()-1;e<=0?document.body.removeAttribute(yr):document.body.setAttribute(yr,e.toString())}}),[]);var i=react.useMemo((function(){return gr(a)}),[a]);return react.createElement(Er,{styles:br(i,!n,a,o?"":"!important")})},Sr=!1;if("undefined"!=typeof window)try{var Tr=Object.defineProperty({},"passive",{get:function(){return Sr=!0,!0}});window.addEventListener("test",Tr,Tr),window.removeEventListener("test",Tr,Tr)}catch(e){Sr=!1}var Cr=!!Sr&&{passive:!1},Lr=function(e,t){var n=window.getComputedStyle(e);return"hidden"!==n[t]&&!(n.overflowY===n.overflowX&&!function(e){return"TEXTAREA"===e.tagName}(e)&&"visible"===n[t])},kr=function(e,t){var n=t;do{if("undefined"!=typeof ShadowRoot&&n instanceof ShadowRoot&&(n=n.host),Mr(e,n)){var o=Ir(e,n);if(o[1]>o[2])return!0}n=n.parentNode}while(n&&n!==document.body);return!1},Mr=function(e,t){return"v"===e?function(e){return Lr(e,"overflowY")}(t):function(e){return Lr(e,"overflowX")}(t)},Ir=function(e,t){return"v"===e?[(n=t).scrollTop,n.scrollHeight,n.clientHeight]:function(e){return[e.scrollLeft,e.scrollWidth,e.clientWidth]}(t);var n},Pr=function(e){return"changedTouches"in e?[e.changedTouches[0].clientX,e.changedTouches[0].clientY]:[0,0]},Or=function(e){return[e.deltaX,e.deltaY]},xr=function(e){return e&&"current"in e?e.current:e},Ar=function(e){return"\n  .block-interactivity-".concat(e," {pointer-events: none;}\n  .allow-interactivity-").concat(e," {pointer-events: all;}\n")},Br=0,Rr=[];var Dr,Hr=(Dr=function(t){var n=react.useRef([]),o=react.useRef([0,0]),r=react.useRef(),a=react.useState(Br++)[0],i=react.useState((function(){return fr()}))[0],l=react.useRef(t);react.useEffect((function(){l.current=t}),[t]),react.useEffect((function(){if(t.inert){document.body.classList.add("block-interactivity-".concat(a));var e=function(e,t,n){if(n||2===arguments.length)for(var o,r=0,a=t.length;r<a;r++)!o&&r in t||(o||(o=Array.prototype.slice.call(t,0,r)),o[r]=t[r]);return e.concat(o||Array.prototype.slice.call(t))}([t.lockRef.current],(t.shards||[]).map(xr),!0).filter(Boolean);return e.forEach((function(e){return e.classList.add("allow-interactivity-".concat(a))})),function(){document.body.classList.remove("block-interactivity-".concat(a)),e.forEach((function(e){return e.classList.remove("allow-interactivity-".concat(a))}))}}}),[t.inert,t.lockRef.current,t.shards]);var s=react.useCallback((function(e,t){if("touches"in e&&2===e.touches.length)return!l.current.allowPinchZoom;var n,a=Pr(e),i=o.current,s="deltaX"in e?e.deltaX:i[0]-a[0],c="deltaY"in e?e.deltaY:i[1]-a[1],u=e.target,d=Math.abs(s)>Math.abs(c)?"h":"v";if("touches"in e&&"h"===d&&"range"===u.type)return!1;var m=kr(d,u);if(!m)return!0;if(m?n=d:(n="v"===d?"h":"v",m=kr(d,u)),!m)return!1;if(!r.current&&"changedTouches"in e&&(s||c)&&(r.current=n),!n)return!0;var _=r.current||n;return function(e,t,n,o,r){var a=function(e,t){return"h"===e&&"rtl"===t?-1:1}(e,window.getComputedStyle(t).direction),i=a*o,l=n.target,s=t.contains(l),c=!1,u=i>0,d=0,m=0;do{var _=Ir(e,l),p=_[0],f=_[1]-_[2]-a*p;(p||f)&&Mr(e,l)&&(d+=f,m+=p),l=l.parentNode}while(!s&&l!==document.body||s&&(t.contains(l)||t===l));return(u&&(r&&0===d||!r&&i>d)||!u&&(r&&0===m||!r&&-i>m))&&(c=!0),c}(_,t,e,"h"===_?s:c,!0)}),[]),c=react.useCallback((function(e){var t=e;if(Rr.length&&Rr[Rr.length-1]===i){var o="deltaY"in t?Or(t):Pr(t),r=n.current.filter((function(e){return e.name===t.type&&e.target===t.target&&function(e,t){return e[0]===t[0]&&e[1]===t[1]}(e.delta,o)}))[0];if(r&&r.should)t.cancelable&&t.preventDefault();else if(!r){var a=(l.current.shards||[]).map(xr).filter(Boolean).filter((function(e){return e.contains(t.target)}));(a.length>0?s(t,a[0]):!l.current.noIsolation)&&t.cancelable&&t.preventDefault()}}}),[]),u=react.useCallback((function(e,t,o,r){var a={name:e,delta:t,target:o,should:r};n.current.push(a),setTimeout((function(){n.current=n.current.filter((function(e){return e!==a}))}),1)}),[]),d=react.useCallback((function(e){o.current=Pr(e),r.current=void 0}),[]),m=react.useCallback((function(e){u(e.type,Or(e),e.target,s(e,t.lockRef.current))}),[]),_=react.useCallback((function(e){u(e.type,Pr(e),e.target,s(e,t.lockRef.current))}),[]);react.useEffect((function(){return Rr.push(i),t.setCallbacks({onScrollCapture:m,onWheelCapture:m,onTouchMoveCapture:_}),document.addEventListener("wheel",c,Cr),document.addEventListener("touchmove",c,Cr),document.addEventListener("touchstart",d,Cr),function(){Rr=Rr.filter((function(e){return e!==i})),document.removeEventListener("wheel",c,Cr),document.removeEventListener("touchmove",c,Cr),document.removeEventListener("touchstart",d,Cr)}}),[]);var p=t.removeScrollBar,f=t.inert;return react.createElement(react.Fragment,null,f?react.createElement(i,{styles:Ar(a)}):null,p?react.createElement(wr,{gapMode:"margin"}):null)},ur.useMedium(Dr),cr),$r=react.forwardRef((function(t,n){return react.createElement(mr,er({},t,{ref:n,sideCar:Hr}))}));$r.classNames=mr.classNames;var Wr=$r;const jr="Popover",[Fr,Ur]=xt(jr,[So]),zr=So(),[Yr,qr]=Fr(jr),Vr=(0,react.forwardRef)(((e,t)=>{const{__scopePopover:n,...o}=e,r=qr("PopoverAnchor",n),i=zr(n),{onCustomAnchorAdd:l,onCustomAnchorRemove:s}=r;return (0,react.useEffect)((()=>(l(),()=>s())),[l,s]),(0,react.createElement)(jo,Mt({},i,o,{ref:t}))})),Kr=(0,react.forwardRef)(((e,t)=>{const{__scopePopover:n,...o}=e,r=qr("PopoverTrigger",n),a=zr(n),i=Ot(t,r.triggerRef),l=(0,react.createElement)(Wt.button,Mt({type:"button","aria-haspopup":"dialog","aria-expanded":r.open,"aria-controls":r.contentId,"data-state":na(r.open)},o,{ref:i,onClick:It(e.onClick,r.onOpenToggle)}));return r.hasCustomAnchor?l:(0,react.createElement)(jo,Mt({asChild:!0},a),l)})),[Gr,Zr]=Fr("PopoverPortal",{forceMount:void 0}),Xr="PopoverContent",Jr=(0,react.forwardRef)(((e,t)=>{const n=Zr(Xr,e.__scopePopover),{forceMount:o=n.forceMount,...r}=e,a=qr(Xr,e.__scopePopover);return (0,react.createElement)(zo,{present:o||a.open},a.modal?(0,react.createElement)(Qr,Mt({},r,{ref:t})):(0,react.createElement)(ea,Mt({},r,{ref:t})))})),Qr=(0,react.forwardRef)(((e,t)=>{const n=qr(Xr,e.__scopePopover),o=(0,react.useRef)(null),i=Ot(t,o),l=(0,react.useRef)(!1);return (0,react.useEffect)((()=>{const e=o.current;if(e)return Qo(e)}),[]),(0,react.createElement)(Wr,{as:Bt,allowPinchZoom:!0},(0,react.createElement)(ta,Mt({},e,{ref:i,trapFocus:n.open,disableOutsidePointerEvents:!0,onCloseAutoFocus:It(e.onCloseAutoFocus,(e=>{var t;e.preventDefault(),l.current||null===(t=n.triggerRef.current)||void 0===t||t.focus()})),onPointerDownOutside:It(e.onPointerDownOutside,(e=>{const t=e.detail.originalEvent,n=0===t.button&&!0===t.ctrlKey,o=2===t.button||n;l.current=o}),{checkForDefaultPrevented:!1}),onFocusOutside:It(e.onFocusOutside,(e=>e.preventDefault()),{checkForDefaultPrevented:!1})})))})),ea=(0,react.forwardRef)(((e,t)=>{const n=qr(Xr,e.__scopePopover),o=(0,react.useRef)(!1);return (0,react.createElement)(ta,Mt({},e,{ref:t,trapFocus:!1,disableOutsidePointerEvents:!1,onCloseAutoFocus:t=>{var r,a;(null===(r=e.onCloseAutoFocus)||void 0===r||r.call(e,t),t.defaultPrevented)||(o.current||null===(a=n.triggerRef.current)||void 0===a||a.focus(),t.preventDefault());o.current=!1},onInteractOutside:t=>{var r,a;null===(r=e.onInteractOutside)||void 0===r||r.call(e,t),t.defaultPrevented||(o.current=!0);const i=t.target;(null===(a=n.triggerRef.current)||void 0===a?void 0:a.contains(i))&&t.preventDefault()}}))})),ta=(0,react.forwardRef)(((e,t)=>{const{__scopePopover:n,trapFocus:o,onOpenAutoFocus:r,onCloseAutoFocus:i,disableOutsidePointerEvents:l,onEscapeKeyDown:s,onPointerDownOutside:c,onFocusOutside:d,onInteractOutside:m,..._}=e,p=qr(Xr,n),f=zr(n);return (0,react.useEffect)((()=>{var e,t;const n=document.querySelectorAll("[data-radix-focus-guard]");return document.body.insertAdjacentElement("afterbegin",null!==(e=n[0])&&void 0!==e?e:Xt()),document.body.insertAdjacentElement("beforeend",null!==(t=n[1])&&void 0!==t?t:Xt()),Zt++,()=>{1===Zt&&document.querySelectorAll("[data-radix-focus-guard]").forEach((e=>e.remove())),Zt--}}),[]),(0,react.createElement)(tn,{asChild:!0,loop:!0,trapped:o,onMountAutoFocus:r,onUnmountAutoFocus:i},(0,react.createElement)(Vt,{asChild:!0,disableOutsidePointerEvents:l,onInteractOutside:m,onEscapeKeyDown:s,onPointerDownOutside:c,onFocusOutside:d,onDismiss:()=>p.onOpenChange(!1)},(0,react.createElement)(Fo,Mt({"data-state":na(p.open),role:"dialog",id:p.contentId},f,_,{ref:t,style:{..._.style,"--radix-popover-content-transform-origin":"var(--radix-popper-transform-origin)","--radix-popover-content-available-width":"var(--radix-popper-available-width)","--radix-popover-content-available-height":"var(--radix-popper-available-height)","--radix-popover-trigger-width":"var(--radix-popper-anchor-width)","--radix-popover-trigger-height":"var(--radix-popper-anchor-height)"}}))))}));function na(e){return e?"open":"closed"}const oa=e=>{const{__scopePopover:t,children:n,open:a,defaultOpen:l,onOpenChange:s,modal:c=!1}=e,d=zr(t),m=r(null),[_,p]=o(!1),[f=!1,h]=qo({prop:a,defaultProp:l,onChange:s});return u(Wo,d,u(Yr,{scope:t,contentId:mn(),triggerRef:m,open:f,onOpenChange:h,onOpenToggle:i((()=>h((e=>!e))),[h]),hasCustomAnchor:_,onCustomAnchorAdd:i((()=>p(!0)),[]),onCustomAnchorRemove:i((()=>p(!1)),[]),modal:c},n))},ra=(/* unused pure expression or super */ null && (Vr)),aa=(/* unused pure expression or super */ null && (Kr)),ia=(/* unused pure expression or super */ null && (Jr)),la=(0,react.forwardRef)(((e,t)=>{const{__scopePopover:n,...o}=e,r=zr(n);return (0,react.createElement)(Uo,Mt({},r,o,{ref:t}))}));var sa="Popover-module_Popover__overlay__io-hP";const ca=({triggerChildren:e,contentChildren:n,isOpen:o,close:r,side:a="bottom",popoverContentProps:i,withOverlay:l})=>t.createElement(oa,{open:o},t.createElement(ra,null,t.createElement(aa,{asChild:!0},e)),l&&o&&t.createElement("div",{className:sa}),t.createElement(ia,{side:a,align:"center",onInteractOutside:r,onEscapeKeyDown:r,onPointerDownOutside:r,onMouseLeave:r,...i},n));var ua;!function(e){e.INFO="info",e.PROCESSING="processing",e.WARNING="warning",e.FAILURE="failure"}(ua||(ua={}));var da={SnackBar__ToastViewport:"SnackBar-module_SnackBar__ToastViewport__Glmsh",SnackBar__ToastRoot:"SnackBar-module_SnackBar__ToastRoot__kj-49",SnackBar__ToastTitle:"SnackBar-module_SnackBar__ToastTitle__dS9cl",SnackBar__ToastDescription:"SnackBar-module_SnackBar__ToastDescription__gPnTH",SnackBar__Spinner:"SnackBar-module_SnackBar__Spinner__PaFCP",SnackBar__Action:"SnackBar-module_SnackBar__Action__NdaKX",slideIn:"SnackBar-module_slideIn__gaoH1",hide:"SnackBar-module_hide__Aw75z",swipeOut:"SnackBar-module_swipeOut__vdZoY"};const ma=(0,react.createContext)(void 0),_a={withCloseIcon:!1,type:ua.INFO,duration:5e3,swipeDirection:"up",LeftIcon:null},pa=({children:e})=>{const{open:n,close:r,isOpen:a}=at(!1),[l,s]=o(_a),u=i((e=>{s({..._a,...e}),n()}),[n]),d=i((()=>{r()}),[r]),m=c((()=>({closeToast:d,triggerToast:u})),[u,d]);return t.createElement(ma.Provider,{value:m},t.createElement(_e.Provider,{swipeDirection:l.swipeDirection,duration:l.duration},e,t.createElement(_e.Root,{className:da.SnackBar__ToastRoot,open:a,onOpenChange:r},l.LeftIcon&&l.LeftIcon,t.createElement("div",null,l.title&&t.createElement(_e.Title,{className:da.SnackBar__ToastTitle},l.title),l.description&&t.createElement(_e.Description,{className:da.SnackBar__ToastDescription,asChild:!0},t.createElement("p",null,l.description))),l.withCloseIcon&&t.createElement(_e.Close,{asChild:!0,"aria-label":"Close"},t.createElement(es_Oe,{className:da.SnackBar__BtnClose},"x"))),t.createElement(_e.Viewport,{"data-class":"snackbar-viewport",className:da.SnackBar__ToastViewport})))},fa=()=>{const e=d(ma);if(!e)throw new Error("useSnackBar must be used within a SnackBarProvider");return e};var ha={Tag:"Tag-module_Tag__soVSJ",Tag__iconWrapper:"Tag-module_Tag__iconWrapper__o8icS",Tag__sm:"Tag-module_Tag__sm__bFIKZ",Tag__md:"Tag-module_Tag__md__i6Dqx",Tag__lg:"Tag-module_Tag__lg__FQac5",Tag__neutral:"Tag-module_Tag__neutral__zmQp7",Tag__suffix:"Tag-module_Tag__suffix__ono3n",Tag__primary:"Tag-module_Tag__primary__kUFNc"};const va=({label:e,suffix:n,icon:o,variant:r="neutral",size:a="md",className:i=""})=>{const l=es_be(ha.Tag,ha[`Tag__${a}`],ha[`Tag__${r}`],{[i]:i});return t.createElement("div",{className:l},o&&t.createElement("span",{className:ha.Tag__iconWrapper},o),t.createElement("span",null,e),n&&t.createElement("span",{className:ha.Tag__suffix},n))};var ga="AvatarGroup-module_AvatarGroup__2ShvI",Ea="AvatarGroup-module_AvatarWrapper__eH-LW";const ya=({users:e,maxDisplayed:n=5,size:o=30,margin:r=-10,className:a=""})=>{const i=e.slice(0,n),l=es_be(ga,{[a]:a});return t.createElement("div",{role:"group","aria-label":"Avatares del grupo",className:l},i.map(((e,n)=>t.createElement("div",{key:`${e.name}-${n}`,className:Ea,style:{zIndex:i.length-n,marginRight:n===i.length-1?0:r}},t.createElement(es_we,{src:e.src,name:e.name,width:o})))))};var ba={hidden:"EvaluationHeader-module_hidden__HC5io",mobileHidden:"EvaluationHeader-module_mobileHidden__BlqK2",desktopHidden:"EvaluationHeader-module_desktopHidden__iscVh","u-wrapper":"EvaluationHeader-module_u-wrapper__thI3S",Toolbar:"EvaluationHeader-module_Toolbar__pRrxs",Toolbar_Container:"EvaluationHeader-module_Toolbar_Container__PIDoG",Toolbar_CloseIcon:"EvaluationHeader-module_Toolbar_CloseIcon__HqWPv",Toolbar_TitlesContainer:"EvaluationHeader-module_Toolbar_TitlesContainer__qBloP",Toolbar_ActionsContainer:"EvaluationHeader-module_Toolbar_ActionsContainer__XI3oV",Toolbar_Progress:"EvaluationHeader-module_Toolbar_Progress__KxqNA",Toolbar_ProgressQuestion:"EvaluationHeader-module_Toolbar_ProgressQuestion__ogxAs",Toolbar_ProgressDivider:"EvaluationHeader-module_Toolbar_ProgressDivider__QuC2O",timer:"EvaluationHeader-module_timer__Hroad",timeover:"EvaluationHeader-module_timeover__QqEUQ",LoadingBar:"EvaluationHeader-module_LoadingBar__aap8a",LoadingBar__loading:"EvaluationHeader-module_LoadingBar__loading__u5I0V","loading-animation":"EvaluationHeader-module_loading-animation__2yNH2",LoadingBar__withProgress:"EvaluationHeader-module_LoadingBar__withProgress__ykUe9"};const Na=({onClose:e,className:n})=>{const o=es_be(n,ba.Toolbar_CloseIcon);return t.createElement("button",{type:"button",className:o,onClick:e,"aria-label":"Close Button"},t.createElement(w,null))},wa=({loading:e,progress:n})=>{const o=void 0!==n,r=es_be(ba.LoadingBar,{[ba.LoadingBar__loading]:e,[ba.LoadingBar__withProgress]:o}),a={"--loading-bar-width":o?`${Math.min(n.current/n.total*100,100)}%`:"100%"};return t.createElement("div",{id:"loadingBar",className:r,style:a})},Sa=({progress:e,progressDesktopCopy:n="Pregunta"})=>void 0===e?.current||void 0===e?.total?null:t.createElement("div",{className:ba.Toolbar_Progress},t.createElement("small",{className:ba.Toolbar_ProgressQuestion},n)," ",t.createElement("span",null,e.current)," ",t.createElement("small",{className:ba.Toolbar_ProgressDivider},"de")," ",t.createElement("span",null,e.total)),Ta={Platzi:react.createElement(Ee,{id:"logoPlatzi"}),PlatziBusiness:react.createElement(esm_namespaceObject.PlatziBusiness,{id:"logoPlatziBusiness"})},Ca=({logo:e="Platzi",title:n="",titleImg:o="",loading:r=!1,withLoadingBar:a=!0,hideMobileTopToolbar:i=!0,progress:l,progressDesktopCopy:s,onClose:c})=>{const u=n.length>0,d=o.length>0,m=u||d,_=void 0!==c&&!m,p=(a||r)&&!m,f=es_be(ba.Toolbar,ba.Toolbar__top,{[ba.mobileHidden]:m&&i});return t.createElement("div",{className:f},t.createElement("div",{className:ba["u-wrapper"]},t.createElement("div",{className:ba.Toolbar_Container},Ta[e],t.createElement("div",{className:ba.Toolbar_ActionsContainer},!m&&t.createElement(Sa,{progress:l,progressDesktopCopy:s}),_&&t.createElement(Na,{onClose:c}))),p&&t.createElement(wa,{loading:r,progress:l})))},La=({title:e="",titleImg:n="",progress:o,progressDesktopCopy:r,onClose:a,loading:i=!1,withLoadingBar:l=!0})=>{const s=void 0!==a,c=e.length>0,u=n.length>0,d=l||i,m=es_be(ba.Toolbar,ba.Toolbar__progress);return t.createElement("div",{className:m},t.createElement("div",{className:ba["u-wrapper"]},t.createElement("div",{className:ba.Toolbar_Container},t.createElement("div",{className:ba.Toolbar_TitlesContainer},u&&t.createElement("img",{src:n,alt:e}),c&&t.createElement("p",null,e)),t.createElement("div",{className:ba.Toolbar_ActionsContainer},t.createElement(Sa,{progress:o,progressDesktopCopy:r}),s&&t.createElement(Na,{onClose:a}))),d&&t.createElement(wa,{loading:i,progress:o})))},ka=e=>{const{title:n="",titleImg:o=""}=e,r=n.length>0,a=o.length>0,i=r||a;return t.createElement("header",{id:"evaluationHeader"},t.createElement(Ca,{...e}),i&&t.createElement(La,{...e}))};var Ma="ErrorBox-module_ErrorBox__W1dIi",Ia="ErrorBox-module_ErrorBox__Icon__1Dfhi",Pa="ErrorBox-module_ErrorBox__Title__iUwMm",Oa="ErrorBox-module_ErrorBox__Description__ML-xK",xa="ErrorBox-module_ErrorBox__RetryButton__SlZIG";const Aa=({className:e="",title:n="Parece que hubo un error",description:o="Por favor, inténtalo de nuevo.",onRetryClick:r,retryText:a="Recargar",...i})=>{const l=es_be(Ma,e);return t.createElement("div",{className:l,...i},t.createElement(I,{className:Ia,"data-id":"ErrorBox__Icon"}),t.createElement("h4",{className:Pa,"data-id":"ErrorBox__Title"},n),t.createElement("p",{className:Oa,"data-id":"ErrorBox__Description"},o),t.createElement(es_Oe,{variant:"secondary",className:xa,onClick:r,"data-id":"ErrorBox__RetryButton"},a))};var Ba="CheckGroupContainer-module_CheckGroupContainer__kElab";const Ra=(0,react.forwardRef)((({className:e="",children:n,...o},r)=>{const a=es_be(Ba,e);return react.createElement("div",{className:a,...o,ref:r},n)})),Da=(0,react.forwardRef)((({items:e,selectedValues:n,onCheckedChange:i,...l},s)=>{const c=function(e){const t=void 0!==e,n=(0,react.useRef)(t);return (0,react.useEffect)((()=>{if(n.current!==t)throw new Error("Cannot use controlled and uncontrolled props at the same time.")}),[t]),t}(n),{selectedValues:u,selectItem:d}=((e=[])=>{const[t,n]=(0,react.useState)(new Set(e));return{selectedValues:t,selectItem:e=>{t.has(e)?t.delete(e):t.add(e),n((()=>new Set(t)))}}})(n),m=l.id??"checkbox-group";return react.createElement(Ra,{...l,ref:s},e.map((e=>{return react.createElement(es_He,{key:`${m}-${e.id}`,value:e.value,label:e.label,checked:(o=e.id,c?n?.includes(o):u.has(o)),onCheckedChange:t=>{c||d(e.id),i?.(e.id,t)}});var o})))})),Ha={Item:es_He,Container:Ra,Group:Da};var $a="AnswerCheck-module_AnswerCheck__zYXdf";const Wa=({className:e="",...n})=>{const o=es_be($a,e);return t.createElement(es_He,{className:o,...n})};var ja="AnswerOption-module_AnswerOption__zqsJ7",Fa="AnswerOption-module_AnswerOption__Item__LJQSR",Ua="AnswerOption-module_AnswerOption__Text__Pb3Wt";const za=({className:e="",id:n,label:o,letterIndicator:r,value:a,...i})=>{const l=`${n}`,s=es_be(ja,e);return t.createElement("label",{className:s,key:n,htmlFor:l,"data-id":"answer-option"},t.createElement(ce,{className:Fa,id:l,value:a,...i},r,t.createElement(ue,null)),t.createElement("span",{className:Ua},o))};var Ya="AnswerOptionGroup-module_AnswerOptionGroup__nmeuE";const qa=({className:e,onValueChange:n,options:o,...r})=>{const a=es_be(Ya,e);return t.createElement(se,{className:a,onValueChange:n,...r},o.map((e=>t.createElement(za,{key:e.id,...e}))))};var Va={ButtonWithLoading:"ButtonWithLoading-module_ButtonWithLoading__BfokE",ButtonWithLoading__Spinner:"ButtonWithLoading-module_ButtonWithLoading__Spinner__bANCc","ButtonWithLoading__Button--loading":"ButtonWithLoading-module_ButtonWithLoading__Button--loading__hScmt","ButtonWithLoading--primary":"ButtonWithLoading-module_ButtonWithLoading--primary__JfhhC","ButtonWithLoading--secondary":"ButtonWithLoading-module_ButtonWithLoading--secondary__PNggu","ButtonWithLoading--secondary-inverse":"ButtonWithLoading-module_ButtonWithLoading--secondary-inverse__UB3pp","ButtonWithLoading--subtle":"ButtonWithLoading-module_ButtonWithLoading--subtle__qScVp","ButtonWithLoading--outline":"ButtonWithLoading-module_ButtonWithLoading--outline__vzLlR","ButtonWithLoading--ghost":"ButtonWithLoading-module_ButtonWithLoading--ghost__sAigY","ButtonWithLoading--outline-inverse":"ButtonWithLoading-module_ButtonWithLoading--outline-inverse__wek0u","ButtonWithLoading--destroy":"ButtonWithLoading-module_ButtonWithLoading--destroy__9TK4h","ButtonWithLoading--sm":"ButtonWithLoading-module_ButtonWithLoading--sm__iUQhN","ButtonWithLoading--md":"ButtonWithLoading-module_ButtonWithLoading--md__P69Gi","ButtonWithLoading--lg":"ButtonWithLoading-module_ButtonWithLoading--lg__-h8oX"};const Ka=({className:e="",loading:n=!1,children:o,size:i=es_Ie,variant:l=es_Pe,...s})=>{const c=r(null),u=es_be(Va.ButtonWithLoading,Va[`ButtonWithLoading--${i}`],Va[`ButtonWithLoading--${l}`]),d=es_be(Va.ButtonWithLoading__Button,e,{[Va["ButtonWithLoading__Button--loading"]]:n}),m=n?{tabIndex:-1,"aria-hidden":!0}:{};return a((()=>{n&&c.current?.blur()}),[n]),t.createElement("div",{className:u},t.createElement(es_Ge,{loading:n,className:Va.ButtonWithLoading__Spinner,"data-testid":"loading-spinner"}),t.createElement(es_Oe,{className:d,size:i,variant:l,...s,...m,ref:c},o))};var Ga="Notifications-module_Notifications__GjS9f";const Za=({children:e})=>t.createElement("ul",{className:Ga},e);var Xa;!function(e){e.Comment="comment",e.Reaction="reaction",e.NewCourse="new-course"}(Xa||(Xa={}));var Ja={exports:{}};Ja.exports=function(){var e=1e3,t=6e4,n=36e5,o="millisecond",r="second",a="minute",i="hour",l="day",s="week",c="month",u="quarter",d="year",m="date",_="Invalid Date",p=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,f=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,h={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},v=function(e,t,n){var o=String(e);return!o||o.length>=t?e:""+Array(t+1-o.length).join(n)+e},g={s:v,z:function(e){var t=-e.utcOffset(),n=Math.abs(t),o=Math.floor(n/60),r=n%60;return(t<=0?"+":"-")+v(o,2,"0")+":"+v(r,2,"0")},m:function e(t,n){if(t.date()<n.date())return-e(n,t);var o=12*(n.year()-t.year())+(n.month()-t.month()),r=t.clone().add(o,c),a=n-r<0,i=t.clone().add(o+(a?-1:1),c);return+(-(o+(n-r)/(a?r-i:i-r))||0)},a:function(e){return e<0?Math.ceil(e)||0:Math.floor(e)},p:function(e){return{M:c,y:d,w:s,d:l,D:m,h:i,m:a,s:r,ms:o,Q:u}[e]||String(e||"").toLowerCase().replace(/s$/,"")},u:function(e){return void 0===e}},E="en",y={};y[E]=h;var b=function(e){return e instanceof T},N=function(e,t,n){var o;if(!e)return E;if("string"==typeof e)y[e]&&(o=e),t&&(y[e]=t,o=e);else{var r=e.name;y[r]=e,o=r}return!n&&o&&(E=o),o||!n&&E},w=function(e,t){if(b(e))return e.clone();var n="object"==typeof t?t:{};return n.date=e,n.args=arguments,new T(n)},S=g;S.l=N,S.i=b,S.w=function(e,t){return w(e,{locale:t.$L,utc:t.$u,x:t.$x,$offset:t.$offset})};var T=function(){function h(e){this.$L=N(e.locale,null,!0),this.parse(e)}var v=h.prototype;return v.parse=function(e){this.$d=function(e){var t=e.date,n=e.utc;if(null===t)return new Date(NaN);if(S.u(t))return new Date;if(t instanceof Date)return new Date(t);if("string"==typeof t&&!/Z$/i.test(t)){var o=t.match(p);if(o){var r=o[2]-1||0,a=(o[7]||"0").substring(0,3);return n?new Date(Date.UTC(o[1],r,o[3]||1,o[4]||0,o[5]||0,o[6]||0,a)):new Date(o[1],r,o[3]||1,o[4]||0,o[5]||0,o[6]||0,a)}}return new Date(t)}(e),this.$x=e.x||{},this.init()},v.init=function(){var e=this.$d;this.$y=e.getFullYear(),this.$M=e.getMonth(),this.$D=e.getDate(),this.$W=e.getDay(),this.$H=e.getHours(),this.$m=e.getMinutes(),this.$s=e.getSeconds(),this.$ms=e.getMilliseconds()},v.$utils=function(){return S},v.isValid=function(){return!(this.$d.toString()===_)},v.isSame=function(e,t){var n=w(e);return this.startOf(t)<=n&&n<=this.endOf(t)},v.isAfter=function(e,t){return w(e)<this.startOf(t)},v.isBefore=function(e,t){return this.endOf(t)<w(e)},v.$g=function(e,t,n){return S.u(e)?this[t]:this.set(n,e)},v.unix=function(){return Math.floor(this.valueOf()/1e3)},v.valueOf=function(){return this.$d.getTime()},v.startOf=function(e,t){var n=this,o=!!S.u(t)||t,u=S.p(e),_=function(e,t){var r=S.w(n.$u?Date.UTC(n.$y,t,e):new Date(n.$y,t,e),n);return o?r:r.endOf(l)},p=function(e,t){return S.w(n.toDate()[e].apply(n.toDate("s"),(o?[0,0,0,0]:[23,59,59,999]).slice(t)),n)},f=this.$W,h=this.$M,v=this.$D,g="set"+(this.$u?"UTC":"");switch(u){case d:return o?_(1,0):_(31,11);case c:return o?_(1,h):_(0,h+1);case s:var E=this.$locale().weekStart||0,y=(f<E?f+7:f)-E;return _(o?v-y:v+(6-y),h);case l:case m:return p(g+"Hours",0);case i:return p(g+"Minutes",1);case a:return p(g+"Seconds",2);case r:return p(g+"Milliseconds",3);default:return this.clone()}},v.endOf=function(e){return this.startOf(e,!1)},v.$set=function(e,t){var n,s=S.p(e),u="set"+(this.$u?"UTC":""),_=(n={},n[l]=u+"Date",n[m]=u+"Date",n[c]=u+"Month",n[d]=u+"FullYear",n[i]=u+"Hours",n[a]=u+"Minutes",n[r]=u+"Seconds",n[o]=u+"Milliseconds",n)[s],p=s===l?this.$D+(t-this.$W):t;if(s===c||s===d){var f=this.clone().set(m,1);f.$d[_](p),f.init(),this.$d=f.set(m,Math.min(this.$D,f.daysInMonth())).$d}else _&&this.$d[_](p);return this.init(),this},v.set=function(e,t){return this.clone().$set(e,t)},v.get=function(e){return this[S.p(e)]()},v.add=function(o,u){var m,_=this;o=Number(o);var p=S.p(u),f=function(e){var t=w(_);return S.w(t.date(t.date()+Math.round(e*o)),_)};if(p===c)return this.set(c,this.$M+o);if(p===d)return this.set(d,this.$y+o);if(p===l)return f(1);if(p===s)return f(7);var h=(m={},m[a]=t,m[i]=n,m[r]=e,m)[p]||1,v=this.$d.getTime()+o*h;return S.w(v,this)},v.subtract=function(e,t){return this.add(-1*e,t)},v.format=function(e){var t=this,n=this.$locale();if(!this.isValid())return n.invalidDate||_;var o=e||"YYYY-MM-DDTHH:mm:ssZ",r=S.z(this),a=this.$H,i=this.$m,l=this.$M,s=n.weekdays,c=n.months,u=function(e,n,r,a){return e&&(e[n]||e(t,o))||r[n].substr(0,a)},d=function(e){return S.s(a%12||12,e,"0")},m=n.meridiem||function(e,t,n){var o=e<12?"AM":"PM";return n?o.toLowerCase():o},p={YY:String(this.$y).slice(-2),YYYY:this.$y,M:l+1,MM:S.s(l+1,2,"0"),MMM:u(n.monthsShort,l,c,3),MMMM:u(c,l),D:this.$D,DD:S.s(this.$D,2,"0"),d:String(this.$W),dd:u(n.weekdaysMin,this.$W,s,2),ddd:u(n.weekdaysShort,this.$W,s,3),dddd:s[this.$W],H:String(a),HH:S.s(a,2,"0"),h:d(1),hh:d(2),a:m(a,i,!0),A:m(a,i,!1),m:String(i),mm:S.s(i,2,"0"),s:String(this.$s),ss:S.s(this.$s,2,"0"),SSS:S.s(this.$ms,3,"0"),Z:r};return o.replace(f,(function(e,t){return t||p[e]||r.replace(":","")}))},v.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},v.diff=function(o,m,_){var p,f=S.p(m),h=w(o),v=(h.utcOffset()-this.utcOffset())*t,g=this-h,E=S.m(this,h);return E=(p={},p[d]=E/12,p[c]=E,p[u]=E/3,p[s]=(g-v)/6048e5,p[l]=(g-v)/864e5,p[i]=g/n,p[a]=g/t,p[r]=g/e,p)[f]||g,_?E:S.a(E)},v.daysInMonth=function(){return this.endOf(c).$D},v.$locale=function(){return y[this.$L]},v.locale=function(e,t){if(!e)return this.$L;var n=this.clone(),o=N(e,t,!0);return o&&(n.$L=o),n},v.clone=function(){return S.w(this.$d,this)},v.toDate=function(){return new Date(this.valueOf())},v.toJSON=function(){return this.isValid()?this.toISOString():null},v.toISOString=function(){return this.$d.toISOString()},v.toString=function(){return this.$d.toUTCString()},h}(),C=T.prototype;return w.prototype=C,[["$ms",o],["$s",r],["$m",a],["$H",i],["$W",l],["$M",c],["$y",d],["$D",m]].forEach((function(e){C[e[1]]=function(t){return this.$g(t,e[0],e[1])}})),w.extend=function(e,t){return e.$i||(e(t,T,w),e.$i=!0),w},w.locale=N,w.isDayjs=b,w.unix=function(e){return w(1e3*e)},w.en=y[E],w.Ls=y,w.p={},w}();var Qa=Ja.exports,ei="Notification-module_Notification__ij9KC",ti="Notification-module_Notification__indicators__7wn-P",ni="Notification-module_Notification--seen__rhhvz",oi="Notification-module_Notification--unseen__mhk2w",ri="Notification-module_Notification__info__title__NC3e5",ai="Notification-module_Notification__info__WifYu",ii="Notification-module_Notification__info__badge__qtKyB",li="Notification-module_Notification__info__title__text__xH126",si="Notification-module_Notification__info__title__author__cqI5n",ci="Notification-module_Notification__info__description__u-8h1",ui="Notification-module_Notification__info__date__Cwnrf",di="Notification-module_Notification__info__participants__WpBSH",mi="Notification-module_Notification__info__participants--multiple__9RtjG",_i="Notification-module_Notification__info__participants__avatar__xKiEn",pi="Notification-module_Notification__indicators__indicator__Gg1cV",fi="Notification-module_Notification__indicators__indicator__dot__eugPB";Qa.extend((relativeTime_default())),Qa.locale(locale_es);const hi=({date:e})=>{const n=Qa(e).fromNow();return react.createElement("span",{className:ui},n)},vi={[Xa.NewCourse]:({extra_data:e,created_at:n})=>{const o=e?.course_data;return o?react.createElement("div",{className:ai},react.createElement("span",{className:ii},"Nuevo"),react.createElement("div",{className:ri},react.createElement("p",{className:li},"Hemos lanzado: ",react.createElement("b",{className:si},o?.title)),react.createElement(hi,{date:n}))):null},[Xa.Comment]:({content:e,extra_data:n,created_at:o})=>{const r=gi(e),a=n?.author_data,i=n?.course_data;return react.createElement("div",{className:ai},react.createElement("div",{className:ri},react.createElement("p",{className:li,dangerouslySetInnerHTML:{__html:`<b>${a?.name}</b> respondió a tu comentario ${yi(i?.title)}`}}),react.createElement(hi,{date:o})),r&&react.createElement("div",{className:ci,dangerouslySetInnerHTML:{__html:e}}))},[Xa.Reaction]:({extra_data:e,created_at:n})=>{const o=e?.course_data,r=bi(e?.participants);if(!r?.length)return null;return react.createElement("div",{className:ai},react.createElement("div",{className:ri},react.createElement("p",{className:li,dangerouslySetInnerHTML:{__html:(e=>{const t=e?.comment_likes||0,[n,a]=r;if(t<=1)return`A <b>${n?.name}</b> le gustó tu comentario${yi(o?.title)}.`;const i=t-2;let l=`A <b>${n?.name}</b> ${i?",":"y"} <b>${a?.name}</b>`;if(i>0){l+=` y a <b>${i}</b> ${1===i?"persona más":"personas más"}`}return`${l} ${1===i?"le":"les"} gustó tu comentario${yi(o?.title)}.`})(e)}}),react.createElement(hi,{date:n})))}},gi=e=>e.length>0,Ei=e=>{const t=e.extra_data,n=!!t?.parent_id;switch(e.notification_type){case Xa.NewCourse:return`/cursos/${t?.course_data?.slug}`;case Xa.Comment:return`/comentario/${n?t?.parent_id:t?.comment_id}`;case Xa.Reaction:return`/comentario/${t?.comment_id}`;default:return"/"}},yi=e=>e?` en el <b>${e}</b>`:"",bi=e=>e.filter((e=>Boolean(e?.name))),Ni=({avatars:e})=>{if(0===e.length)return null;const n=es_be(di,{[mi]:e.length>1});return t.createElement("div",{className:n},e.map(((e,n)=>t.createElement(es_we,{key:`${e?.name}-${n}`,src:e?.avatar,name:e?.name,className:_i}))))},wi=({data:e,type:n})=>{const o=n===Xa.NewCourse;if(!e)return null;if((e=>e===Xa.Reaction)(n)){const n=bi(e?.participants||[]).slice(-2);return t.createElement(Ni,{avatars:n})}const r=o?(()=>{const n=e?.course_data;return t.createElement(es_we,{src:n?.badge,name:n?.slug,className:_i})})():(()=>{const n=e?.author_data;return t.createElement(es_we,{src:n?.avatar||"",name:n?.name||"",className:_i})})();return t.createElement("div",{className:di},r)},Si=e=>{const n=t.useRef(null),[o,r]=t.useState("auto"),{seen:a,notification_type:i,extra_data:l,onClick:s,onMarkAsRead:c}=e,u=es_be(ei,{[ni]:a,[oi]:!a});t.useEffect((()=>{null!==n?.current&&r(n.current.offsetHeight-24+"px")}),[n]);const d=(e=>vi?.[e]||null)(i),m={"--heightItem":o},_=Ei(e);return t.createElement("li",{ref:n,style:m},t.createElement("a",{href:_,className:u,onClick:t=>{t.stopPropagation(),s&&s({...e,url:Ei(e)})}},t.createElement(wi,{data:l,type:i}),t.createElement(d,{...e}),t.createElement("div",{className:ti},!a&&t.createElement(t.Fragment,null,t.createElement("div",{className:pi},t.createElement("div",{className:fi})),t.createElement(ut,{content:"Marcar como leído",position:"left",variant:"neutral"},t.createElement(es_Oe,{kind:"icon",variant:"ghost",onClick:t=>{t.preventDefault(),t.stopPropagation(),c&&c(e)},"aria-label":"Marcar como leído","data-testid":"mark_as_read_button"},t.createElement(P,null)))))))};var Ti="ChipGroup-module_ChipGroup__cLuym",Ci="ChipGroup-module_ChipGroup__clear__rElok";const Li=({chips:e,selectedIds:n=[],onSelect:o})=>{const r=i((()=>o([])),[o]),a=i(((e,t)=>{const r=[...e,t];JSON.stringify(n)===JSON.stringify(r)?o(e):o(r)}),[n,o]),l=i(((e,o=[])=>e.map((e=>{const r=[...o,e.id],i=n.length>=r.length&&r.every(((e,t)=>e===n[t])),s=o.length>0&&o.every(((e,t)=>e===n[t]));return!o.length&&n.length>0&&!i||s&&n.length>o.length&&!i?null:t.createElement(t.Fragment,{key:e.id},t.createElement(es_We,{...e,isSelected:i,onClick:()=>a(o,e.id),nested:o.length>0}),i&&e.subChips&&e.subChips.length>0&&l(e.subChips,r))}))),[n,a]),s=c((()=>e.find((e=>e.id===n[0]))),[e,n]);return e?.length?t.createElement("div",{className:Ti},n.length>0&&t.createElement(t.Fragment,null,t.createElement(es_We,{id:"clear",onClick:r,className:Ci,ariaLabel:"Quitar todos los filtros"},t.createElement(w,null)),t.createElement(es_We,{...s,isSelected:!0,onClick:()=>a([],s.id)})),0===n.length?l(e):l(s?.subChips||[],[s.id])):null},ki=({children:e,showIf:n})=>n?react.createElement(react.Fragment,null,e):null;var Mi="TextAreaHints-module_TextAreaHints__1X5Jk",Ii="TextAreaHints-module_TextAreaHints__error__ZTMk4",Pi="TextAreaHints-module_TextAreaHints_textarea__RBvdJ",Oi="TextAreaHints-module_TextAreaHints_hints__gPkma",xi="TextAreaHints-module_TextAreaHints_hints_msg__4xASS",Ai="TextAreaHints-module_TextAreaHints_hints_list__r3S4x",Bi="TextAreaHints-module_TextAreaHints_hints_list_hint__G-71-",Ri="TextAreaHints-module_TextAreaHints_info__oNuAB",Di="TextAreaHints-module_TextAreaHints_info_validation__glJDW",Hi="TextAreaHints-module_TextAreaHints_info_error__kO978";const $i=({hints:e=[],hintsLabel:n,error:o=!1,disabled:r,placeholder:a,handleChange:i,handleHintClick:l,value:s,minLength:c,maxLength:u})=>{const d=es_be(Mi,{[Ii]:o}),m=e?.length>0,_=!!o,p=!o&&!!c&&s.length<c;return t.createElement("section",{className:d,"aria-live":"polite","data-class":"TextAreaHints"},t.createElement(Ct,{classnames:Pi,placeholder:a,onChange:e=>i(e.target.value),value:s,disabled:r,maxLength:u}),t.createElement(ki,{showIf:m},t.createElement("section",{className:Oi},t.createElement(ki,{showIf:!!n},t.createElement("h3",{className:xi},n)),t.createElement("div",{className:Ai},e.map(((e,n)=>t.createElement(es_We,{disabled:r,isSelected:s.includes(e),id:n.toString(),key:e,onClick:()=>l(e),ariaLabel:e,className:Bi},t.createElement("span",null,e))))),t.createElement(ki,{showIf:p||_},t.createElement("div",{className:Ri},t.createElement(ki,{showIf:p},t.createElement("span",{className:Di},"Mínimo ",c," caracteres")),t.createElement(ki,{showIf:_},t.createElement("span",{className:Hi},o)))))))};var Wi,ji="ContentRater-module_ContentRater__d-xyd",Fi="ContentRater-module_ContentRater_disliked__AUpl8";!function(e){e.UNSET="unset",e.LIKE="like",e.DISLIKE="dislike"}(Wi||(Wi={}));const Ui=({text:e="¿Fue útil?",likeLabel:n="Sí, fue útil",dislikeLabel:o="No, no fue útil",status:r,onLike:a,onDislike:i})=>{const l=es_be({[Fi]:r===Wi.DISLIKE});return t.createElement("div",{className:ji},e&&t.createElement("p",null,e),t.createElement(es_Oe,{variant:"ghost",kind:"icon",title:n,"aria-label":n,leftIcon:r===Wi.LIKE?t.createElement(O,null):t.createElement(x,null),onClick:a}),t.createElement(es_Oe,{className:l,variant:"ghost",kind:"icon",title:o,"aria-label":o,leftIcon:r===Wi.DISLIKE?t.createElement(A,null):t.createElement(B,null),onClick:i}))};var zi="SchoolCard-module_SchoolCard__XmVN6",Yi="SchoolCard-module_SchoolCard_header__sIfNH",qi="SchoolCard-module_SchoolCard_header__withIcon__PhyIi",Vi="SchoolCard-module_SchoolCard_footer__01za7";const Ki=({url:e,target:n="_self",badge:o,title:r,icon:a=t.createElement(R,null),preTitle:i,footerCopy:l,className:s,...c})=>{const u=es_be(zi,s),d=es_be(Yi,{[qi]:!l});return t.createElement("li",{className:u,...c},t.createElement("a",{href:e,target:n},t.createElement("div",{className:d},t.createElement("figure",null,t.createElement("img",{src:o,alt:r,height:44,width:44})),t.createElement("h3",null,i&&t.createElement("span",null,i)," ",r),!l&&a),l&&t.createElement("div",{className:Vi},t.createElement("p",null,l),a)))};var Gi="ToggleDefaultItem-module_ToggleDefaultItem__LvfKq";const Zi=({children:e,value:n})=>t.createElement(he.Item,{value:n,className:Gi},e);var Xi="ToggleGroup-module_ToggleGroup__XndlF";const Ji=({items:e,component:n=Zi,className:o="",...r})=>{const a=es_be(Xi,o);return t.createElement(he.Root,{className:a,...r},e.map((e=>t.createElement(n,{value:e.value},e.label))))},Qi=({children:e,slot:n})=>n?react.createElement(react.Fragment,null,e):null;function el(e,t){return t?.props?.slot===e}function tl(e){return el.bind(null,e)}function nl(e,n){return react.Children.toArray(e).filter((e=>react.isValidElement(e)&&n(e)))}var ol=Object.freeze({__proto__:null,filterBySlot:el,buildSlotFilter:tl,filterReactChildren:nl}),rl=Object.freeze({__proto__:null});const al=(0,react.createContext)(null),il=()=>d(al),ll=({children:e,screenInfo:n})=>{const o=st(!n),r=n??o;return react.createElement(al.Provider,{value:r},e)};function sl({children:e,matcher:t}){const n=il();return n&&t(n)?e:null}function cl(e){return!(!e.desktop&&!e["extra-large"])}var ul=Object.freeze({__proto__:null,isExtraLarge:function(e){return!!e["extra-large"]},isNotExtraLarge:function(e){return!!(e.tablet||e.desktop||e.mobile)},isMobile:function(e){return!!e.mobile},isMobileOrTablet:function(e){return!(!e.tablet&&!e.mobile)},isTablet:function(e){return!!e.tablet},isDesktop:cl,isDesktopOrTablet:function(e){return!!(e.tablet||e.desktop||e["extra-large"])}}),dl={},ml={};Object.defineProperty(ml,"__esModule",{value:!0});var _l,pl,fl,hl={};Object.defineProperty(hl,"__esModule",{value:!0}),hl.VARIANTS=hl.SIZES=hl.COLORS=void 0,function(e){e.PLATZI="platzi",e.SKY="sky",e.ERROR="error",e.ADMIN="admin"}(_l||(hl.COLORS=_l={})),function(e){e.LARGE="large",e.MEDIUM="medium",e.SMALL="small"}(pl||(hl.SIZES=pl={})),function(e){e.PRIMARY="primary",e.SECONDARY="secondary",e.TERTIARY="tertiary"}(fl||(hl.VARIANTS=fl={}));var vl,gl,El,yl,bl={},Nl={};Object.defineProperty(Nl,"__esModule",{value:!0}),Nl.PLATZI_B2B_COMPANY_PLANS=Nl.PLATZI_PLANS_NAMES=Nl.PLATZI_USER_TYPE=Nl.PLATZI_PLANS=void 0,function(e){e.BASIC="monthly_plan",e.EXPERT="expert_plan",e.EXPERT_DUO="annual_plan",e.ACADEMY="platzi_academy",e.FAMILY="family_plan",e.FREE="free_plan",e.ENTERPRISE="enterprise"}(vl||(Nl.PLATZI_PLANS=vl={})),function(e){e.FREE="free",e.PAY_ONE="pay_one",e.ONE_PAYMENT="one_payment",e.PAY_ANNUAL="pay_annual",e.EXPERT_ANNUAL="expert_annual",e.COURSE_ONLY="course_only",e.MONTHLY_SUBSCRIPTION="monthly_subscription",e.MONTHLY_SUBSCRIPTION_TERM="monthly_subscription_term",e.ANNUAL_SUBSCRIPTION="annual_subscription",e.EXPERT_SUBSCRIPTION="expert_subscription",e.ENGLISH_ACADEMY_SUBSCRIPTION="english_academy_subscription",e.ENGLISH_ACADEMY_ANNUAL="english_academy_annual",e.MANUAL_MENSUAL_SUBSCRIPTION="manual_mensual_subscription",e.UNSUBSCRIBED="unsubscribed",e.UNSUBSCRIBED_MANUAL="unsubscribed_manual",e.PAUSED="paused",e.PENDING_UNSUBSCRIPTION="pending_unsubscription",e.ALLIANCE="alliance",e.BLOCKED="blocked",e.ESSENTIAL="essential",e.TEAM="team",e.STARTUP="startup",e.BUSINESS="business",e.ENTERPRISE="enterprise",e.TEAM_MONTH="team-month",e.BUSINESS_MONTH="business-month",e.ENTERPRISE_MONTH="enterprise-month"}(gl||(Nl.PLATZI_USER_TYPE=gl={})),function(e){e.EXPERT="Platzi Expert",e.EXPERT_PLUS="Platzi Expert+",e.B2B="Plan Empresarial",e.ACADEMY="Platzi English Academy"}(El||(Nl.PLATZI_PLANS_NAMES=El={})),function(e){e.FLEXIBLE="Flexible"}(yl||(Nl.PLATZI_B2B_COMPANY_PLANS=yl={}));var wl,Sl={};Object.defineProperty(Sl,"__esModule",{value:!0}),Sl.BUSINESS_MODEL=void 0,function(e){e.B2C="user",e.B2B="b2b"}(wl||(Sl.BUSINESS_MODEL=wl={}));var Tl,Cl,Ll,kl,Ml={};Object.defineProperty(Ml,"__esModule",{value:!0}),Ml.PLATZI_USER_ROLE=void 0,function(e){e.BETA_TESTER="beta-tester",e.COMPANY_ADMIN="company_admin",e.ORGANIZER="organizer",e.STUDENT="student",e.TEACHER="teacher",e.ANONYMOUS="anonymous",e.READ_ONLY="read-only"}(Tl||(Ml.PLATZI_USER_ROLE=Tl={})),Cl=bl,Ll=es_Ee&&es_Ee.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n);var r=Object.getOwnPropertyDescriptor(t,n);r&&!("get"in r?!t.__esModule:r.writable||r.configurable)||(r={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,o,r)}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),kl=es_Ee&&es_Ee.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||Ll(t,e,n)},Object.defineProperty(Cl,"__esModule",{value:!0}),kl(Nl,Cl),kl(Sl,Cl),kl(Ml,Cl);var Il={},Pl={};Object.defineProperty(Pl,"__esModule",{value:!0}),function(e){var t=es_Ee&&es_Ee.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n);var r=Object.getOwnPropertyDescriptor(t,n);r&&!("get"in r?!t.__esModule:r.writable||r.configurable)||(r={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,o,r)}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),n=es_Ee&&es_Ee.__exportStar||function(e,n){for(var o in e)"default"===o||Object.prototype.hasOwnProperty.call(n,o)||t(n,e,o)};Object.defineProperty(e,"__esModule",{value:!0}),n(Pl,e)}(Il);var Ol={};Object.defineProperty(Ol,"__esModule",{value:!0});var xl={},Al={};Object.defineProperty(Al,"__esModule",{value:!0});var Bl={};Object.defineProperty(Bl,"__esModule",{value:!0});var Rl={};Object.defineProperty(Rl,"__esModule",{value:!0});var Dl={};Object.defineProperty(Dl,"__esModule",{value:!0});var Hl={},$l={};Object.defineProperty($l,"__esModule",{value:!0});var Wl={};Object.defineProperty(Wl,"__esModule",{value:!0});var jl={};Object.defineProperty(jl,"__esModule",{value:!0});var Fl={};Object.defineProperty(Fl,"__esModule",{value:!0});var Ul={};Object.defineProperty(Ul,"__esModule",{value:!0});var zl={};Object.defineProperty(zl,"__esModule",{value:!0});var Yl={};Object.defineProperty(Yl,"__esModule",{value:!0});var ql={};Object.defineProperty(ql,"__esModule",{value:!0});var Vl={};Object.defineProperty(Vl,"__esModule",{value:!0}),function(e){var t=es_Ee&&es_Ee.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n);var r=Object.getOwnPropertyDescriptor(t,n);r&&!("get"in r?!t.__esModule:r.writable||r.configurable)||(r={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,o,r)}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),n=es_Ee&&es_Ee.__exportStar||function(e,n){for(var o in e)"default"===o||Object.prototype.hasOwnProperty.call(n,o)||t(n,e,o)};Object.defineProperty(e,"__esModule",{value:!0}),n($l,e),n(Wl,e),n(jl,e),n(Fl,e),n(Ul,e),n(zl,e),n(Yl,e),n(ql,e),n(Vl,e)}(Hl);var Kl,Gl={};Object.defineProperty(Gl,"__esModule",{value:!0}),Gl.CHAT_ACTIONS=void 0,function(e){e.SHOW_LEARNING_PATH="show_learning_path"}(Kl||(Gl.CHAT_ACTIONS=Kl={}));var Zl={},Xl={};Object.defineProperty(Xl,"__esModule",{value:!0});var Jl={};Object.defineProperty(Jl,"__esModule",{value:!0});var Ql={};Object.defineProperty(Ql,"__esModule",{value:!0});var es_es={};Object.defineProperty(es_es,"__esModule",{value:!0});var ts={};Object.defineProperty(ts,"__esModule",{value:!0});var ns={};Object.defineProperty(ns,"__esModule",{value:!0});var os={};Object.defineProperty(os,"__esModule",{value:!0});var rs={};Object.defineProperty(rs,"__esModule",{value:!0}),function(e){var t=es_Ee&&es_Ee.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n);var r=Object.getOwnPropertyDescriptor(t,n);r&&!("get"in r?!t.__esModule:r.writable||r.configurable)||(r={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,o,r)}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),n=es_Ee&&es_Ee.__exportStar||function(e,n){for(var o in e)"default"===o||Object.prototype.hasOwnProperty.call(n,o)||t(n,e,o)};Object.defineProperty(e,"__esModule",{value:!0}),n(Xl,e),n(Jl,e),n(Ql,e),n(es_es,e),n(ts,e),n(ns,e),n(os,e),n(rs,e)}(Zl);var as={};Object.defineProperty(as,"__esModule",{value:!0}),function(e){var t=es_Ee&&es_Ee.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n);var r=Object.getOwnPropertyDescriptor(t,n);r&&!("get"in r?!t.__esModule:r.writable||r.configurable)||(r={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,o,r)}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),n=es_Ee&&es_Ee.__exportStar||function(e,n){for(var o in e)"default"===o||Object.prototype.hasOwnProperty.call(n,o)||t(n,e,o)};Object.defineProperty(e,"__esModule",{value:!0}),n(Al,e),n(Bl,e),n(Rl,e),n(Dl,e),n(Hl,e),n(Gl,e),n(Zl,e),n(as,e)}(xl);var is={},ls={};Object.defineProperty(ls,"__esModule",{value:!0}),function(e){var t=es_Ee&&es_Ee.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n);var r=Object.getOwnPropertyDescriptor(t,n);r&&!("get"in r?!t.__esModule:r.writable||r.configurable)||(r={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,o,r)}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),n=es_Ee&&es_Ee.__exportStar||function(e,n){for(var o in e)"default"===o||Object.prototype.hasOwnProperty.call(n,o)||t(n,e,o)};Object.defineProperty(e,"__esModule",{value:!0}),n(ls,e)}(is);var ss={};Object.defineProperty(ss,"__esModule",{value:!0});var cs,us,ds={};Object.defineProperty(ds,"__esModule",{value:!0}),ds.COMMENT_OBJECT_TYPE=ds.COMMENT_RELATION=void 0,function(e){e.DISCUSSION="discussion",e.CONTRIBUTION="contribution",e.MATERIAL="material"}(cs||(ds.COMMENT_RELATION=cs={})),function(e){e.DISCUSSION="discussion",e.COMMENT="comment",e.MATERIAL="material"}(us||(ds.COMMENT_OBJECT_TYPE=us={})),function(e){var t=es_Ee&&es_Ee.__createBinding||(Object.create?function(e,t,n,o){void 0===o&&(o=n);var r=Object.getOwnPropertyDescriptor(t,n);r&&!("get"in r?!t.__esModule:r.writable||r.configurable)||(r={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,o,r)}:function(e,t,n,o){void 0===o&&(o=n),e[o]=t[n]}),n=es_Ee&&es_Ee.__exportStar||function(e,n){for(var o in e)"default"===o||Object.prototype.hasOwnProperty.call(n,o)||t(n,e,o)};Object.defineProperty(e,"__esModule",{value:!0}),n(ml,e),n(hl,e),n(bl,e),n(Il,e),n(Ol,e),n(xl,e),n(is,e),n(ss,e),n(ds,e)}(dl);const ms="/home/",_s=[{id:"search-side-bar",label:"Buscar",href:"/search/",icon:esm_e,isExternal:!0,attributes:{"data-id":"search-side-bar"}},{id:"home-side-bar-desktop",label:"Inicio",href:ms,icon:{byStatus:{enabled:esm_I,active:Y}},data_qa:"sidebar_feed_button",onlyShowOnDesktop:!0},{id:"home-side-bar-mobile-tablet",label:"Inicio",href:ms,icon:esm_I,data_qa:"sidebar_feed_button",onlyShowOnMobile:!0,onlyShowOnTablet:!0},{id:"my-paths-bar-desktop",label:"Mis Rutas",tooltip:"Mis rutas",href:`${ms}mis-rutas/`,icon:{byStatus:{enabled:esm_X,active:esm_Z}},data_qa:"sidebar_my_paths_button",onlyShowOnDesktop:!0},{id:"my-paths-side-bar-mobile-tablet",label:"Mis Rutas",tooltip:"Mis rutas",href:`${ms}mis-rutas/`,icon:esm_ce,data_qa:"sidebar_my_paths_button",onlyShowOnMobile:!0,onlyShowOnTablet:!0},{id:"my-progress-side-bar",label:"Mi progreso",href:"/estadisticas/",icon:Re,isExternal:!0,data_qa:"sidebar_my_progress_button",onlyShowOnDesktop:!0},{id:"chat-side-bar-desktop",label:"Chat ADA",href:`${ms}chat/`,icon:{byStatus:{enabled:We,active:ye}},onlyShowOnDesktop:!0},{id:"chat-side-bar-mobile-tablet",label:"Chat ADA",href:`${ms}chat/`,icon:We,onlyShowOnTablet:!0,onlyShowOnMobile:!0},{id:"notifications-bell-desktop",label:"Notificaciones",tooltip:"Notificaciones",href:"javascript:void(0);",icon:{byStatus:{enabled:esm_namespaceObject.BellOutline,active:esm_namespaceObject.BellFilled}},onlyShowOnDesktop:!0,onlyShowOnTablet:!0,attributes:{"data-id":"notifications-bell"}}],ps={id:"role-menu-teacher",permissions:{[dl.PLATZI_USER_ROLE.TEACHER]:!0},title:"Profesores",items:[{id:"role-menu-teacher-dashboard",label:"Dashboard",href:()=>"/profesor/",icon:H,isExternal:!0}]},fs={id:"role-menu-b2b-dashboard",permissions:{[dl.PLATZI_USER_ROLE.COMPANY_ADMIN]:!0},title:"Empresas",items:[{id:"role-menu-b2b-dashboard",label:"Administración",href:e=>`/business/dashboard/${e.companyId}/reportes/`,icon:esm_w,isExternal:!0}]},hs=[ps,fs];var vs="LiveButton-module_LiveButton__EvNdW";const gs=({liveInfo:e,linkWrapper:n})=>{if(!e?.slug)return null;const o=`/live/${e.slug}`;return t.createElement(n,{href:o,className:vs,id:"button_live_dot",label:""},"Live ",t.createElement(Z,null))};var Es={MainNavItem:"MainNavItem-module_MainNavItem__-o6B3",MainNavItem__StatusIndicator:"MainNavItem-module_MainNavItem__StatusIndicator__e8Rj4","MainNavItem__StatusIndicator--active":"MainNavItem-module_MainNavItem__StatusIndicator--active__vua09","MainNavItem__StatusIndicator--minified":"MainNavItem-module_MainNavItem__StatusIndicator--minified__m-LsH",MainNavItem__notification:"MainNavItem-module_MainNavItem__notification__-ZaRt","MainNavItem__notification--minified":"MainNavItem-module_MainNavItem__notification--minified__jjvt6","MainNavItem__notification--active":"MainNavItem-module_MainNavItem__notification--active__CI843"};function ys({className:e,children:n,isActive:o=!1,isMinified:r=!1,showNotification:a=!1,...i}){const l=es_be(Es.MainNavItem,e),s=es_be(Es.MainNavItem__StatusIndicator,{[Es["MainNavItem__StatusIndicator--active"]]:o,[Es["MainNavItem__StatusIndicator--minified"]]:r}),c=es_be(Es.MainNavItem__notification,{[Es["MainNavItem__notification--minified"]]:r,[Es["MainNavItem__notification--active"]]:o});return t.createElement("li",{className:l,...i},a&&t.createElement("div",{className:c},t.createElement(Z,null)),t.createElement("div",{className:s}),n)}var bs="MinifiedLogo-module_MinifiedLogo__wdkwq",Ns="MinifiedLogo-module_MinifiedLogo__live__Pmcpd";const ws=({liveInfo:e,mainUrl:n})=>{let o=n;return e?.slug&&(o=`/live/${e.slug}`),t.createElement("a",{href:o,className:bs,"data-qa":"platzi_logo","aria-label":"Platzi Home"},t.createElement(X,null),e?.slug&&t.createElement("div",{className:Ns},t.createElement(Z,null)))};function Ss(e,t){return"function"==typeof t.href?t.href(e):t.href}function Ts(e,t){const n=function(e){const t=[];return(e.role===dl.PLATZI_USER_ROLE.TEACHER||e.is_teacher)&&t.push(dl.PLATZI_USER_ROLE.TEACHER),(e.role===dl.PLATZI_USER_ROLE.COMPANY_ADMIN||e.is_company_admin)&&t.push(dl.PLATZI_USER_ROLE.COMPANY_ADMIN),t}(e);return n.some((e=>t.permissions[e]))}const Cs=(e,t)=>{return n=e?.href,t===ms&&"/"===n||!(!t?.includes(n)||""===n||"/"===n);var n};var Ls="MainMenu-module_MainMenu__bjOsN",ks="MainMenu-module_MainMenu__content__uo3M-",Ms="MainMenu-module_MainMenu--logo__C3HEp",Is="MainMenu-module_MainMenu--logo-container__BH9vp",Ps="MainMenu-module_MainMenu--minified__b5FTZ",Os="MainMenu-module_Sidebar__n9C-R",xs="MainMenu-module_MainMenu--hiddenOnMobile__2PNl4",As="MainMenu-module_Sidebar-item__7Fjaa",Bs="MainMenu-module_Sidebar-item--onlyMobile__wgPfD",Rs="MainMenu-module_Sidebar-item--onlyTablet__rWaAJ",Ds="MainMenu-module_Sidebar-item--onlyDesktop__R72oU",Hs="MainMenu-module_Sidebar-item-navigator__Nj-TR",$s="MainMenu-module_Sidebar-item-action__PU-ed",Ws="MainMenu-module_Sidebar-item-navigator--minified__D-EcJ";const js=({route:e,minified:t=!1,pathname:n=null})=>{const o=!("function"==typeof e?.href)&&Cs(e,n);return{sidebarItem:es_be(As,{[Bs]:e?.onlyShowOnMobile,[Rs]:e?.onlyShowOnTablet,[Ds]:e?.onlyShowOnDesktop}),itemNavigatorClassname:es_be([Hs],{isActive:o,[Ws]:t}),itemActionClassname:es_be([$s],{[Ws]:t})}};var Fs={RoleMenuUI:"RoleMenuUI-module_RoleMenuUI__Nkfpn","RoleMenuUI--minified":"RoleMenuUI-module_RoleMenuUI--minified__KUQCL",RoleMenuUI__Title:"RoleMenuUI-module_RoleMenuUI__Title__XFq-U"};function Us({user:e,menu:n,isMinified:o=!1,linkWrapper:r}){if(!n?.items?.length)return null;const a=es_be(Fs.RoleMenuUI,{[Fs["RoleMenuUI--minified"]]:o}),i=n.items.map((n=>{const{itemNavigatorClassname:a,sidebarItem:i}=js({route:n,minified:o}),{label:l,...s}=n,c=t.createElement(r,{className:a,label:o?"":l,...s,href:Ss(e,n)});return t.createElement(ys,{className:i,key:`role_itemMenu_${n.id}`,isMinified:o},o?t.createElement(ut,{content:n?.tooltip??n?.label,position:"right"},c):c)}));return t.createElement("div",{className:a},t.createElement(ki,{showIf:!o},t.createElement("h4",{className:Fs.RoleMenuUI__Title},n.title)),t.createElement("ul",null,i))}var zs="RoleMenu-module_RoleMenu__6rR2O";function Ys({isMinified:e=!1,user:n=null,linkWrapper:o}){if(!n)return null;const r=hs.filter((e=>Ts(n,e)));return r.length?t.createElement("div",{className:zs},t.createElement(ki,{showIf:e},t.createElement(pt,{"data-testid":"divider"})),r.map((r=>t.createElement(Us,{isMinified:e,key:r.id,user:n,menu:r,linkWrapper:o})))):null}const qs=({...e})=>t.createElement(Et,{...e}),Vs=[{id:"route-banner-info",label:"Cuéntanos tu opinión",href:"https://forms.gle/GVFtbkN1bFjk1qFo6",icon:ve,isExternal:!0,targetBlank:!0}];var Ks="ConfirmEmail-module_ConfirmEmail__MjqZK",Gs="ConfirmEmail-module_ConfirmEmail__Info__aYK-y",Zs="ConfirmEmail-module_ConfirmEmail__Info__Head__D9uG5",Xs="ConfirmEmail-module_ConfirmEmail__Info__Text__WmsRv";const Js=({email:e})=>{const n=`Enviamos un enlace de confirmación a tu correo electrónico ${e}`;return t.createElement("section",{className:Ks},t.createElement("div",{className:Gs},t.createElement("div",{className:Zs},t.createElement(J,null),t.createElement("h2",null,"Confirmar tu correo")),t.createElement("p",{title:n,className:Xs},n)))};var Qs="BannerBusinessRedirect-module_BannerBusinessRedirect__9aPa4",ec="BannerBusinessRedirect-module_BannerBusinessRedirect__copy__L66Ux",tc="BannerBusinessRedirect-module_BannerBusinessRedirect__button__7xwb4";const nc=()=>t.createElement("section",{className:Qs},t.createElement("p",{className:ec},"Hay empresas que le pagan Platzi a sus empleados 👀"),t.createElement(es_Oe,{rightIcon:t.createElement(Q,null),className:tc,as:"a",target:"blank",href:"https://platzi.com/business",variant:"tertiary"},"Descubre más"));var oc="MainMenuBottom-module_BannersInfo__bWaUh",rc="MainMenuBottom-module_BannersInfo__Options__yiU61";const ac=({email:e,emailNotValidated:n,isB2B:o,linkWrapper:r=qs})=>t.createElement("section",{className:oc},(()=>{const r=!n&&!o;return n?t.createElement(Js,{email:e}):r?t.createElement(nc,null):null})(),t.createElement("ul",{className:rc},Vs.map((e=>t.createElement("li",{key:`infoRoute_${e.label}`,"data-qa":e.data_qa},t.createElement(r,{...e})))))),ic=({minified:e=!1,hideOnMobile:n=!1,liveInfo:o,notifications:r={},pathname:a="",user:i=null,linkWrapper:l=qs,children:s,mainUrl:c=ms,routesMainMenu:u=_s,className:d="",...m})=>{const _=es_be(Ls,d,{[Ps]:e,[xs]:n});return t.createElement("nav",{className:_,id:"mainmenu",...m},t.createElement("div",{className:Is},e?t.createElement(ws,{mainUrl:c,liveInfo:o}):t.createElement(t.Fragment,null,t.createElement("a",{href:c,className:Ms},t.createElement(k,null)),t.createElement(gs,{liveInfo:o,linkWrapper:l}))),t.createElement("div",{className:ks},t.createElement("ul",{className:Os},u.map((n=>{const{itemNavigatorClassname:o,sidebarItem:i}=js({route:n,minified:e,pathname:a}),s=(e=>{if("undefined"==typeof window)return null;const t=window.location.href;return new URL(t).searchParams.get(e)})(n.id),c=!!s&&"true"===s,u=n?.onClick?c:Cs(n,a),d=t.createElement(l,{className:o,...n,onClick:()=>{return e=n?.onClick,void(e&&e());var e},isActive:u,key:`child-element${n.id}`});return t.createElement(ys,{className:i,key:`itemMenu_${n.id}`,"data-qa":n.data_qa,isActive:u,isMinified:e,showNotification:r[n.id],id:n.id,...n.attributes??{}},e?t.createElement(ut,{content:n?.tooltip??n?.label,position:"right"},d):d)})),t.createElement(Ys,{isMinified:e,user:i,linkWrapper:l})),t.createElement(ac,{emailNotValidated:i?.emailNotValidated,isB2B:i?.isB2B,email:i?.email})),s)};var lc={CommentLayout:"CommentLayout-module_CommentLayout__QB8z8",CommentLayout__Content:"CommentLayout-module_CommentLayout__Content__t1pRT",CommentLayout__Header:"CommentLayout-module_CommentLayout__Header__HAyTV",CommentLayout__Footer:"CommentLayout-module_CommentLayout__Footer__wu8OA"};const sc="AVATAR",cc=tl(sc),uc="HEADER",dc=tl(uc),mc="MESSAGE",_c=tl(mc),pc="CONTENT",fc=tl(pc),hc="CHILDS",vc=tl(hc),gc="FOOTER",Ec=tl(gc),yc="REPLIES",bc=tl(yc),Nc=(0,react.forwardRef)((({className:e,children:n,...o},r)=>{const a=es_be(lc.CommentLayout,e),i=nl(n,cc),l=nl(n,dc),s=nl(n,_c),c=nl(n,fc),u=nl(n,vc),d=nl(n,Ec),m=nl(n,bc);return react.createElement("article",{ref:r,className:a,...o},i,react.createElement("header",{className:lc.CommentLayout__Content},react.createElement("div",{className:lc.CommentLayout__Header},l),react.createElement("div",{className:lc.CommentLayout__Message},s),c),u,react.createElement("footer",{className:lc.CommentLayout__Footer},d),m)}));var wc=Object.freeze({__proto__:null,SLOT_AVATAR:sc,filterAvatarElement:cc,SLOT_HEADER:uc,filterHeaderElement:dc,SLOT_MESSAGE:mc,filterMessageElement:_c,SLOT_CONTENT:pc,filterContentElement:fc,SLOT_CHILDS:hc,filterChildsElement:vc,SLOT_FOOTER:gc,filterFooterElement:Ec,SLOT_REPLIES:yc,filterRepliesElement:bc,CommentLayout:Nc}),Sc={Tag:"Tag-module_Tag__l6HmF","Tag--outline":"Tag-module_Tag--outline__AvnLT"};const Tc=({children:e,outline:n,className:o=""})=>{const r=bind_default().bind(Sc)("Tag",{"Tag--outline":n},o);return e?react.createElement("span",{className:r},e):null};Qa.extend((relativeTime_default()));var Cc="CommentHeader-module_CommentHeader__7qRuJ",Lc="CommentHeader-module_CommentHeader__Name__uDmIE",kc="CommentHeader-module_CommentHeader__Author__hNqm1",Mc="CommentHeader-module_CommentHeader__Info__fieaw",Ic="CommentHeader-module_CommentHeader__Type__2lscR",Pc="CommentHeader-module_CommentHeader__Time__Qe-hj";const Oc=({className:e="",comment:n})=>{const o=es_be(Cc,e),r="discussion"===n?.object_type,a=(e=>"organizer"===e?.author?.role?.toLowerCase?.()?"Team Platzi":e?.ai_generated?"Generado con IA":e?.author?.role)(n);return react.createElement("div",{className:o},react.createElement("div",{className:kc},react.createElement("p",{className:Lc},n?.author?.name),react.createElement(ki,{showIf:r},react.createElement(Tc,{className:Ic},"Pregunta"))),react.createElement("div",{className:Mc},a,react.createElement("span",null,"•"),react.createElement("span",{className:Pc},n?.created_at&&(i=n.created_at,Qa(i).locale("es").fromNow()))));var i};var xc="CommentGradient-module_CommentGradient__S9B52";const Ac=({shouldShowFullContent:e=!1})=>react.createElement(ki,{showIf:!e},react.createElement("div",{className:xc,"data-testid":"comment-gradient"}));var Bc="CommentLike-module_CommentLike__ltmZ1";const Rc=({isLiked:e,nLikes:n,handleToggleLike:o})=>react.createElement("div",{className:Bc},react.createElement(gt,{isLiked:e,count:n,toggleLike:o}));var Dc="CommentSeeMore-module_CommentSeeMore__2sZNz";const Hc=({shouldShowFullContent:e,onShowFullContent:n})=>react.createElement(ki,{showIf:!e},react.createElement("div",{className:Dc},react.createElement(es_Oe,{variant:"ghost",onClick:()=>{n(!0)},rightIcon:react.createElement(esm_x,null)},"Ver más"))),$c=({className:e="",src:n="",alt:o="",width:r=24,height:a=24})=>react.createElement("img",{className:e,src:n,alt:o,width:r,height:a});function Wc(e,t){switch(t.type){case"SET_SHOW_COMMENT_EDITOR":return{...e,showCommentEditor:t.payload};case"SET_REPLIES_LIMIT":return{...e,repliesLimit:t.payload};case"SET_SHOULD_SHOW_FULL_CONTENT":return{...e,shouldShowFullContent:t.payload};default:return e}}const jc=()=>{const[e,t]=(0,react.useReducer)(Wc,{showCommentEditor:!1,repliesLimit:2,shouldShowFullContent:!0});return{state:e,setShowCommentEditor:e=>t({type:"SET_SHOW_COMMENT_EDITOR",payload:e}),setRepliesLimit:e=>t({type:"SET_REPLIES_LIMIT",payload:e}),setShouldShowFullContent:e=>t({type:"SET_SHOULD_SHOW_FULL_CONTENT",payload:e})}},Fc=({content:e=""})=>react.createElement("p",null,e);var Uc="CommentReplyLineContainer-module_CommentReplyLineContainer__ddoO-";const zc="comment-reply-line-container",Yc=({className:e,...n})=>{const o=es_be(Uc,e);return react.createElement("div",{className:o,"data-id":zc,...n},n.children)};var qc="Comment-module_Comment__DNRHW",Vc="Comment-module_Comment__Avatar__afkJJ",Kc="Comment-module_Comment--has-replies__vC3UI";const Gc=({parentId:e,comment:n,onLike:o,avatar:r=$c,commentVisualizer:a=Fc})=>{const{setShouldShowFullContent:i,state:l}=jc(),{shouldShowFullContent:s}=l;if(!n?.author||!n?.content)return null;return react.createElement(Yc,null,react.createElement(Nc,{"data-id":"comment-ui-reply"},react.createElement(Qi,{slot:sc},react.createElement(r,{className:Vc,src:n?.author?.avatar,alt:n?.author?.name,width:24,height:24})),react.createElement(Qi,{slot:uc},react.createElement(Oc,{comment:n})),react.createElement(Qi,{slot:mc},react.createElement(a,{content:n.content})),react.createElement(Qi,{slot:pc},react.createElement(Ac,{shouldShowFullContent:s})),react.createElement(Qi,{slot:hc},react.createElement(Hc,{onShowFullContent:i,shouldShowFullContent:s}),react.createElement(Rc,{isLiked:!!n.liked,nLikes:n.nLikes??0,handleToggleLike:()=>{o?.(n.id,n?.object_type??"",e)}}))))};var Zc="CommentReplies-module_CommentReplies__Wjy1V",Xc="CommentReplies-module_CommentReplies__List__Wj7pZ",Jc="CommentReplies-module_CommentReplies__MoreReplies__4A7FO";const Qc=({avatar:e=$c,className:n="",comment:o,parentId:a,repliesLimit:i,onMoreReplies:l,onLike:s,onDelete:c,currentUser:u,commentVisualizer:d,showAll:m=!1})=>{const _=!!a,p=o?.replies??[],f=!_&&p.length>0,h=!_&&p.length>i,v=(0,react.useRef)(null),g=m?p:p?.slice?.(0,i),E=es_be(Zc,n);return react.createElement(ki,{showIf:f},react.createElement("div",{className:E},react.createElement("ul",{className:Xc,ref:v},g?.map?.((n=>react.createElement(Gc,{avatar:e,key:n?.id,comment:n,parentId:o?.id,onLike:s,onDelete:c,currentUser:u,commentVisualizer:d}))))),react.createElement(ki,{showIf:h&&!m},react.createElement(Yc,{className:Jc},react.createElement(es_Oe,{onClick:l,variant:"ghost"},react.createElement(esm_m,null)," Ver más respuestas"))))};var eu="CommentRepliesMessage-module_CommentRepliesMessage__e3MzY",tu="CommentRepliesMessage-module_CommentRepliesMessage__Line__UHOMm",nu="CommentRepliesMessage-module_CommentRepliesMessage__Text__KZX18";const ou=({repliesCount:e=0})=>{const n=e?`${e} respuestas`:"No hay respuestas";return react.createElement("div",{className:eu},react.createElement("div",{className:tu}),react.createElement("span",{className:nu},n),react.createElement("div",{className:tu}))},ru=e=>{const[t,n]=(0,react.useState)("0px"),r=(e=>{const[t,n]=(0,react.useState)(0);return (0,react.useEffect)((()=>{let t=()=>{};if(window.addEventListener("resize",(()=>{})),"undefined"!=typeof window&&e.current)if(window?.ResizeObserver){const o=new ResizeObserver((e=>{e.forEach((e=>{n(e.contentRect.height)}))}));o.observe(e.current),t=()=>{o.disconnect()}}else{const o=()=>{n(e.current?.clientHeight??0)};window.addEventListener("resize",o),t=()=>{window.removeEventListener("resize",o)}}return()=>{t()}}),[e]),t})(e);return (0,react.useEffect)((()=>{if(e?.current){const t=e?.current?.querySelectorAll?.(`[data-id="${zc}"]`);if(t?.length){const e=`${t[t.length-1].clientHeight}px`;n(e)}}}),[r,e]),t},au=({parentId:e,comment:n,onLike:o,onDelete:a,avatar:i=$c,currentUser:l,commentVisualizer:s=Fc,children:c,className:u})=>{const{setShouldShowFullContent:d,state:m,setRepliesLimit:_}=jc(),{shouldShowFullContent:p,repliesLimit:f}=m,h=(0,react.useRef)(null),v=ru(h);if(!n?.author||!n?.content)return null;const g=es_be(qc,u,{[Kc]:!!n?.replies?.length});return react.createElement(Nc,{ref:h,className:g,style:{"--last-item-height":v}},react.createElement(Qi,{slot:sc},react.createElement(i,{className:Vc,src:n?.author?.avatar,alt:n?.author?.name,width:24,height:24})),react.createElement(Qi,{slot:uc},react.createElement(Oc,{comment:n})),react.createElement(Qi,{slot:mc},react.createElement(s,{content:n.content})),react.createElement(Qi,{slot:pc},react.createElement(Ac,{shouldShowFullContent:p})),react.createElement(Qi,{slot:hc},react.createElement(Hc,{onShowFullContent:d,shouldShowFullContent:p}),react.createElement(Rc,{isLiked:!!n.liked,nLikes:n.nLikes??0,handleToggleLike:()=>{o?.(n.id,n.object_type??"",e)}})),react.createElement(Qi,{slot:gc},react.createElement(ou,{repliesCount:n.replies_count}),c),react.createElement(Qi,{slot:yc},react.createElement(Qc,{avatar:i,comment:n,parentId:e,repliesLimit:f,onMoreReplies:()=>{f>n?.replies?.length||_(f+5)},onLike:o,onDelete:a,currentUser:l,commentVisualizer:s,showAll:!0})))},iu=(0,react.createContext)(null);(0,react.createContext)(null);const lu=(e,t)=>{if(e.id===t){const t=e?.liked,n=e?.nLikes??0,o=!t,r=n>=0?n+(o?1:-1):0;return{...e,liked:o,nLikes:r}}return e},su={LIKE:(e,{commentId:t,parentId:n})=>{if(!n)return lu(e,t);const o=e.replies?.map?.((e=>lu(e,t)));return{...e,replies:o}},DELETE:(e,{commentId:t,parentId:n})=>n?{...e,subcards:e.replies?.filter?.((e=>e.id!==t))}:e,ADD:(e,t)=>({...e,replies_count:(e.replies_count??0)+1,replies:[t,...e.replies||[]]}),SET:(e,t)=>({...e,...t}),REPLACE_REPLY:(e,t)=>{const{comment:n,commentId:o}=t,r=e.replies?.map?.((e=>e.id===o?n:e));return{...e,replies:r}}};function cu(e,t){const n=su[t.type];return n?n(e,t.payload):e}const uu=e=>{const t=e,[n,o]=(0,react.useReducer)(cu,t),r=(0,react.useCallback)((e=>o({type:"ADD",payload:e})),[]),a=(0,react.useCallback)((e=>o({type:"DELETE",payload:e})),[]);return{state:n,onLikeComment:(0,react.useCallback)((e=>o({type:"LIKE",payload:e})),[]),onDeleteComment:a,onAddComment:r,setStateComment:(0,react.useCallback)((e=>o({type:"SET",payload:e})),[]),replaceReply:(0,react.useCallback)(((e,t)=>{o({type:"REPLACE_REPLY",payload:{comment:e,commentId:t}})}),[])}},du={Layout:wc,Comment:au,Provider:({comment:e,user:n})=>{const{state:o}=uu(e);return react.createElement(iu.Provider,{value:o},react.createElement(ll,null,react.createElement(au,{comment:o,currentUser:n})))},ReplyLineContainer:Yc,hooks:{useComment:uu}};var mu="NotificationPanelHeading-module_NotificationPanelHeading__P6gkI",_u="NotificationPanelHeading-module_NotificationPanelHeading__title__f1fHB",pu="NotificationPanelHeading-module_NotificationPanelHeading__back__BMC3-",fu="NotificationPanelHeading-module_NotificationPanelHeading__actions__SMT38";const hu=({onClose:e,onMarkAllAsRead:n=(()=>null),user:o=null})=>t.createElement("div",{className:mu},t.createElement("div",{className:_u},t.createElement(es_Oe,{variant:"ghost",title:"Cerrar",onClick:e,className:pu},t.createElement(ne,{width:18,height:18})),t.createElement("p",null,"Notificaciones")),t.createElement("div",{className:fu},t.createElement(ut,{variant:"neutral",content:"Marcar todo como leído",position:"left"},t.createElement(es_Oe,{kind:"icon",variant:"ghost","data-testid":"mark_all_as_read_button",onClick:n},t.createElement(P,null))),o?.username&&t.createElement("a",{href:`/p/${o?.username}/edit/#notification-options`,"aria-label":"settings"},t.createElement(oe,null))));var vu="NotificationPanelSkeleton-module_NotificationPanelSkeleton__item__RfLMf",gu="NotificationPanelSkeleton-module_NotificationPanelSkeleton__info__DREWH";const Eu=()=>t.createElement(Za,null,Array.from({length:5}).map(((e,n)=>t.createElement("div",{className:vu,key:`skeleton-notification-${n}`},t.createElement(mt,{shape:"circle",width:"36px",height:"36px"}),t.createElement("div",null,t.createElement(mt,{width:"254px",height:"16px",className:gu}),t.createElement(mt,{width:"220px",height:"16px",className:gu}),t.createElement(mt,{width:"254px",height:"16px",className:gu}),t.createElement(mt,{width:"96px",height:"16px",className:gu}))))));var yu=new Map,bu=new WeakMap,Nu=0,wu=void 0;function Su(e){return Object.keys(e).sort().filter((t=>void 0!==e[t])).map((t=>{return`${t}_${"root"===t?(n=e.root,n?(bu.has(n)||(Nu+=1,bu.set(n,Nu.toString())),bu.get(n)):"0"):e[t]}`;var n})).toString()}function Tu(e,t,n={},o=wu){if(void 0===window.IntersectionObserver&&void 0!==o){const r=e.getBoundingClientRect();return t(o,{isIntersecting:o,target:e,intersectionRatio:"number"==typeof n.threshold?n.threshold:0,time:0,boundingClientRect:r,intersectionRect:r,rootBounds:r}),()=>{}}const{id:r,observer:a,elements:i}=function(e){const t=Su(e);let n=yu.get(t);if(!n){const o=new Map;let r;const a=new IntersectionObserver((t=>{t.forEach((t=>{var n;const a=t.isIntersecting&&r.some((e=>t.intersectionRatio>=e));e.trackVisibility&&void 0===t.isVisible&&(t.isVisible=a),null==(n=o.get(t.target))||n.forEach((e=>{e(a,t)}))}))}),e);r=a.thresholds||(Array.isArray(e.threshold)?e.threshold:[e.threshold||0]),n={id:t,observer:a,elements:o},yu.set(t,n)}return n}(n),l=i.get(e)||[];return i.has(e)||i.set(e,l),l.push(t),a.observe(e),function(){l.splice(l.indexOf(t),1),0===l.length&&(i.delete(e),a.unobserve(e)),0===i.size&&(a.disconnect(),yu.delete(r))}}var Cu="NotificationPanelEmpty-module_NotificationPanelEmpty__esIN7",Lu="NotificationPanelEmpty-module_NotificationPanelEmpty__title__-0D67",ku="NotificationPanelEmpty-module_NotificationPanelEmpty__description__8g21n";const Mu=()=>t.createElement("div",{className:Cu},t.createElement("p",{className:Lu},"No hay notificaciones"),t.createElement("p",{className:ku},"Prueba filtrando por otra categoría o quita los filtros para ver todo.")),Iu=({notifications:n,hasNextPage:o,onReachEnd:r,onClose:i,onMarkAsRead:l})=>{const{ref:s,inView:c}=function({threshold:t,delay:n,trackVisibility:o,rootMargin:r,root:a,triggerOnce:i,skip:l,initialInView:s,fallbackInView:c,onChange:u}={}){var d;const[m,_]=e.useState(null),p=e.useRef(),[f,h]=e.useState({inView:!!s,entry:void 0});p.current=u,e.useEffect((()=>{if(l||!m)return;let e;return e=Tu(m,((t,n)=>{h({inView:t,entry:n}),p.current&&p.current(t,n),n.isIntersecting&&i&&e&&(e(),e=void 0)}),{root:a,rootMargin:r,threshold:t,trackVisibility:o,delay:n},c),()=>{e&&e()}}),[Array.isArray(t)?t.toString():t,m,a,r,i,l,o,c,n]);const v=null==(d=f.entry)?void 0:d.target,g=e.useRef();m||!v||i||l||g.current===v||(g.current=v,h({inView:!!s,entry:void 0}));const E=[_,f.inView,f.entry];return E.ref=E[0],E.inView=E[1],E.entry=E[2],E}();a((()=>{c&&r()}),[c,r]);const u=async e=>{l&&l(e)};if(!n?.length)return t.createElement(Mu,{onClick:i});const d=async e=>{l&&l(e)};return t.createElement(Za,null,n?.map((e=>t.createElement(Si,{key:e.id,...e,onClick:u,onMarkAsRead:d}))),o&&t.createElement("div",{ref:s}))};var Pu="NotificationPanelFilters-module_NotificationPanelFilters__-Rjmf";const Ou=({filters:e,onChange:n,currentFilters:o=[]})=>t.createElement("div",{className:Pu},t.createElement(Li,{chips:e,onSelect:n,selectedIds:o})),xu="unseen",Au=[{text:"Sin leer",id:xu,subChips:[{text:"Comentarios",id:Xa.Comment},{text:"Lanzamientos",id:Xa.NewCourse}]},{text:"Comentarios",id:Xa.Comment,subChips:[{text:"Sin leer",id:xu}]},{text:"Lanzamientos",id:Xa.NewCourse,subChips:[{text:"Sin leer",id:xu}]}];var Bu="NotificationPanel-module_NotificationPanel__content__4XE1S",Ru="NotificationPanel-module_NotificationPanel__overlay__JMayf",Du="NotificationPanel-module_NotificationPanel__content--mobile__oZTby",Hu="NotificationPanel-module_NotificationPanel__overlay--mobile__UwKz8",$u="NotificationPanel-module_NotificationPanel__content--fullWidth__S4a9t",Wu="NotificationPanel-module_NotificationPanel__content__head__Dncyd",ju="NotificationPanel-module_NotificationPanel__content__body__Q-sVK",Fu="NotificationPanel-module_NotificationPanel__error__qqUDt";const Uu=({isOpen:e,onClose:n,fullWidth:o,notifications:r,onMarkAsRead:a,rootElement:i,isMobile:l=!1,isLoading:s=!1,ignoreOffset:c=!1,error:u=null,hasNextPage:d=!1,fetchNextPage:m=(()=>null),isFetchingNextPage:_=!1,onMarkAllAsRead:p=(()=>null),setFilter:f=(()=>null)})=>{const[h,v]=t.useState([]),g={"--leftOffset":`${i?i?.clientWidth:0}px`},E=es_be(Bu,{[$u]:o,[Du]:l}),y=es_be(Ru,{[Hu]:l});return t.createElement(es_Xe,{style:c?{}:g,className:E,classNameOverlay:y,position:"left",isOpen:e,handleClose:n},t.createElement(rt,{className:Wu},t.createElement(hu,{onClose:n,onMarkAllAsRead:p}),t.createElement(Ou,{currentFilters:h,filters:Au,onChange:e=>{var t;v(e),f((t=e).length?t.includes(Xa.Comment)?[...t,Xa.Reaction].join(","):t.join(","):"default")}})),t.createElement(es_Qe,{className:ju},!s&&!u&&t.createElement(Iu,{notifications:r,hasNextPage:d,onReachEnd:m,onClose:n,onMarkAsRead:a}),(s||_)&&t.createElement(Eu,null),null!=u&&t.createElement(Aa,{onRetryClick:()=>{},title:"Hubo un problema al cargar tus notificaciones",description:"Por favor, intenta de nuevo.",retryText:"Reintentar",className:Fu})))},zu=({handleOpen:e,isActiveOnClick:n,...o})=>t.createElement(t.Fragment,null,t.createElement(es_Oe,{onClick:e,kind:"icon",variant:"ghost",key:"notifications"},n?t.createElement(G,null):t.createElement(K,null)),t.createElement(Uu,{fullWidth:!0,ignoreOffset:!0,...o}));var Yu;function qu(){return qu=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},qu.apply(this,arguments)}var Vu,Ku,Gu,Zu,Xu,Ju=function(t){return react.createElement("svg",qu({xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em",fill:"none",viewBox:"0 0 60 60"},t),Yu||(Yu=react.createElement("path",{fill:"#87909D",fillRule:"evenodd",d:"M33.456 53.592c1.65-.168 2.878-1.575 2.79-3.2s-1.46-2.896-3.121-2.892h-6.696c-1.48 0-2.679 1.175-2.679 2.625s1.2 2.625 2.679 2.625c-.003 1.768 1.341 3.26 3.132 3.474 1.79.215 3.463-.915 3.895-2.632M29.116 7.075a24.77 24.77 0 0 0-7.143 20.236l1.874 17.183c.07.633.604 1.114 1.241 1.115l9.671.02a1.25 1.25 0 0 0 1.246-1.11l1.943-17.176a24.77 24.77 0 0 0-7.063-20.264 1.25 1.25 0 0 0-1.769-.004M13.346 38.67l6.63-6.604 1.386 12.7a3.74 3.74 0 0 0 1.109 2.277l-4.123 2.051a2.5 2.5 0 0 1-3.488-1.453l-2.124-6.413a2.5 2.5 0 0 1 .61-2.558m25.143 6.13 1.436-12.695 6.605 6.631a2.5 2.5 0 0 1 .599 2.56l-2.15 6.405a2.5 2.5 0 0 1-3.493 1.44l-4.115-2.068A3.74 3.74 0 0 0 38.49 44.8M30 26.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5",clipRule:"evenodd"})))};function Qu(){return Qu=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},Qu.apply(this,arguments)}var ed,td,nd=function(t){return react.createElement("svg",Qu({xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em",fill:"none",viewBox:"0 0 60 60"},t),Vu||(Vu=react.createElement("path",{fill:"#D5AB00",fillRule:"evenodd",d:"M14.647 53.33a7.013 7.013 0 1 0-7.978-7.977L5.636 52.23a1.875 1.875 0 0 0 2.133 2.133z",clipRule:"evenodd"})),Ku||(Ku=react.createElement("circle",{cx:49.975,cy:45,r:1.875,fill:"#0AE98A"})),Gu||(Gu=react.createElement("circle",{cx:22.5,cy:10,r:1.875,fill:"#0AE98A"})),Zu||(Zu=react.createElement("circle",{cx:5,cy:35,r:1.875,fill:"#0AE98A"})),Xu||(Xu=react.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M42.745 30.309A26.02 26.02 0 0 0 52.51 9.992a2.5 2.5 0 0 0-2.501-2.502 26 26 0 0 0-1.427.04 26.02 26.02 0 0 0-18.89 9.725L18.894 30.753a2.5 2.5 0 0 0 .163 3.31l.021.02 6.838 6.84q.128.125.267.23l.01.008c.898.67 2.156.665 3.054-.054zM25.972 43.853l1.338 4.012a4.376 4.376 0 0 0 6.108 2.53l6.043-3.02a4.38 4.38 0 0 0 2.419-3.914v-9.258l-11.071 8.856a5 5 0 0 1-4.837.794m-9.03-14.662a5 5 0 0 0-.795 4.837l-4.012-1.337a4.376 4.376 0 0 1-2.53-6.109l3.02-6.042a4.38 4.38 0 0 1 3.915-2.42h9.258zM40 23.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5",clipRule:"evenodd"})))};function od(){return od=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},od.apply(this,arguments)}var rd,ad=function(t){return react.createElement("svg",od({xmlns:"http://www.w3.org/2000/svg",width:"1em",height:"1em",fill:"none",viewBox:"0 0 28 28"},t),ed||(ed=react.createElement("path",{fill:"#FF476C",fillRule:"evenodd",d:"M13.352 19.681a12.14 12.14 0 0 0 9.48 4.557A1.166 1.166 0 0 0 24 23.071a13 13 0 0 0-.018-.666 12.14 12.14 0 0 0-4.539-8.816L13.144 8.55a1.167 1.167 0 0 0-1.544.077l-.01.01-3.191 3.19q-.06.06-.109.125l-.003.005c-.312.419-.31 1.006.025 1.425zM7.03 11.854l-1.873.624a2.042 2.042 0 0 0-1.18 2.85l1.41 2.82a2.04 2.04 0 0 0 1.826 1.13h4.32L7.401 14.11a2.33 2.33 0 0 1-.37-2.257m6.842-4.215a2.33 2.33 0 0 0-2.257-.37l.624-1.873a2.042 2.042 0 0 1 2.85-1.18l2.82 1.41a2.04 2.04 0 0 1 1.13 1.826v4.32zm2.54 10.761a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0",clipRule:"evenodd"})),td||(td=react.createElement("path",{fill:"#FF476C",d:"M2.74 2.906a.817.817 0 0 1 1.154 0L9.34 8.35a.817.817 0 0 1-1.155 1.155L2.739 4.061a.817.817 0 0 1 0-1.155M7.095 2.906a.817.817 0 0 1 1.155 0l2.178 2.177a.817.817 0 0 1-1.155 1.155L7.095 4.061a.817.817 0 0 1 0-1.155M3.894 7.261A.817.817 0 1 0 2.74 8.416l2.178 2.178a.817.817 0 0 0 1.155-1.155z"})))};!function(e){e.RISK="risk",e.RUNNING="running",e.DEFAULT="default"}(rd||(rd={})),Qa.extend((isoWeek_default()));const id={[rd.RISK]:ad,[rd.RUNNING]:nd,[rd.DEFAULT]:Ju},ld={[rd.RISK]:"¡Estás a punto de perder tu racha semanal! Mira una clase ahora para salvarla.",[rd.RUNNING]:"¡Avanza en tu racha! Mira una clase esta semana para avanzar.",[rd.DEFAULT]:"Mira una clase para iniciar tu racha y medir tu progreso estudiando."},sd=(e=rd.DEFAULT)=>id[e]||Ju,cd=e=>{const t=e?.total_materials>=1,n=e?.streak_completed;return 7===Qa().isoWeekday()&&!t?rd.RISK:0===e?.streak&&t||e?.current_streak>1&&!n||e?.current_streak>=1&&n?rd.RUNNING:rd.DEFAULT};var ud="StreakProgress-module_StreakProgress__ZPCth",dd="StreakProgress-module_StreakProgress__element__nk5oN",md="StreakProgress-module_StreakProgress__element__slot__eRG9a",_d="StreakProgress-module_StreakProgress__element__slot--running__5-tYj",pd="StreakProgress-module_StreakProgress__element__slot--active__rHn-2",fd="StreakProgress-module_StreakProgress__element__slot--inactive__7m52Y",hd="StreakProgress-module_StreakProgress__element__slot--risk__sstYJ",vd="StreakProgress-module_StreakProgress__element--active__qxL7H",gd="StreakProgress-module_StreakProgress__element--displaced__KahYF",Ed="StreakProgress-module_StreakProgress__element__number__le1em",yd="StreakProgress-module_StreakProgress__element__number--active__6f7CD";const bd=({status:e="default",currentStreak:n=0,isCompleted:o=!1,className:r=""})=>{const a=(i=n)<3?[1,2,3,4]:[i-2,i-1,i,i+1];var i;const l=es_be(ud,r);return react.createElement("ul",{className:l},a.map((r=>{const a=(t=>es_be(md,{[pd]:n<t||o,[fd]:n<t,[_d]:n===t,[hd]:n===t&&"risk"===e}))(r),i=(e=>es_be(dd,{[vd]:e<n,[gd]:n>=4}))(r),l=(e=>es_be(Ed,{[yd]:n>=e}))(r),s=r<n||o&&r===n;return react.createElement("li",{key:r,className:i},react.createElement("div",{className:a},s?react.createElement(esm_namespaceObject.Check,null):null),react.createElement("span",{className:l},r))})))};var Nd={StreakPopover__content:"StreakPopover-module_StreakPopover__content__b-vMB",StreakPopover__heading:"StreakPopover-module_StreakPopover__heading__Sobtb",StreakPopover__heading__icon:"StreakPopover-module_StreakPopover__heading__icon__aAqIH",StreakPopover__heading__content:"StreakPopover-module_StreakPopover__heading__content__VlkkY",StreakPopover__heading__content__title:"StreakPopover-module_StreakPopover__heading__content__title__cMTKX",StreakPopover__heading__content__paragraph:"StreakPopover-module_StreakPopover__heading__content__paragraph__0EPTi",StreakPopover__progress:"StreakPopover-module_StreakPopover__progress__dbn6u",StreakPopover__progress__week:"StreakPopover-module_StreakPopover__progress__week__0iv5X"};const wd=({status:e,currentStreak:n,isCompleted:o,message:r})=>{const a=sd(e);return react.createElement("div",{className:Nd.StreakPopover,id:"StreakPopover"},react.createElement("div",{className:Nd.StreakPopover__content},react.createElement("div",{className:Nd.StreakPopover__heading},react.createElement("div",{className:Nd.StreakPopover__heading__icon},react.createElement(a,null)),react.createElement("div",{className:Nd.StreakPopover__heading__content},react.createElement("h4",{className:Nd.StreakPopover__heading__content__title},"Racha semanal"),react.createElement("p",{className:Nd.StreakPopover__heading__content__paragraph,dangerouslySetInnerHTML:{__html:`${r}`}}))),react.createElement("div",{className:Nd.StreakPopover__progress},react.createElement("span",{className:Nd.StreakPopover__progress__week},"Semana:"),react.createElement(bd,{status:e,isCompleted:o,currentStreak:n}))))};wd.displayName="StreakPopover";var Sd="StreakTrigger-module_StreakTrigger__ATTQ0",Td="StreakTrigger-module_StreakTrigger--triggered__eMWn-",Cd="StreakTrigger-module_StreakTrigger--risk__FVTxe",Ld="StreakTrigger-module_StreakTrigger__rocket__fxZTh",kd="StreakTrigger-module_StreakTrigger__counter__zADXa";const Md=({status:e,streak:n=0,isActive:o=!1,className:r,...a})=>{const i=es_be(Sd,r,{[Cd]:e===rd.RISK,[Td]:o}),l=sd(e);return t.createElement("button",{className:i,...a,"aria-label":"ver racha",type:"button",id:"StreakTrigger"},t.createElement("div",{className:Ld},t.createElement(l,null)),t.createElement("span",{className:kd},n))};var Id={Streak:"Streak-module_Streak__p0vN0",Streak__arrow:"Streak-module_Streak__arrow__WzZT5",Streak__overlay:"Streak-module_Streak__overlay__vLsKk",slideUpAndFade:"Streak-module_slideUpAndFade__qS-6o"};const Pd=({className:e="",...n})=>{const{isOpen:o,open:r,close:a}=at(),i=cl(st()),l=n,s=cd(l),c=(e=>{const t=cd(e);if(t===rd.RUNNING&&e?.streak_completed){const t=e?.current_streak>1?"semanas":"semana";return`¡Llevas <b>${e?.current_streak} ${t}</b> en racha! Regresa la próxima semana para mantenerla.`}return ld[t]||ld[rd.DEFAULT]})(l),u=i?{onMouseEnter:r}:{onClick:r},d=i?{onMouseLeave:a,onMouseEnter:r}:{};return t.createElement(oa,{open:o},t.createElement(ra,{className:Id.Streak__anchor},t.createElement(aa,{asChild:!0},t.createElement(Md,{...u,className:e,streak:l?.streak,status:s,isActive:o}))),o&&t.createElement("div",{className:Id.Streak__overlay}),t.createElement(ia,{align:i?"center":"end",className:Id.Streak,onInteractOutside:a,onEscapeKeyDown:a,onPointerDownOutside:a,...d},t.createElement(wd,{status:s,message:c,currentStreak:l?.current_streak,isCompleted:l?.streak_completed}),t.createElement(la,{className:Id.Streak__arrow})))};
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/object-assign.js
var object_assign = __webpack_require__(6086);
;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.countdown/dist/es/index.js
var dist_es_i,dist_es_s={exports:{}},dist_es_c={exports:{}},micro_ui_countdown_dist_es_u={};var es_f,es_l,es_p,es_m,dist_es_d,es_y,es_v,es_h,es_b,es_S,es_g,es_T,es_w={};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */function es_(){return es_l||(es_l=1,e=dist_es_c, true?e.exports=function(){if(dist_es_i)return micro_ui_countdown_dist_es_u;dist_es_i=1;var e="function"==typeof Symbol&&Symbol.for,t=e?Symbol.for("react.element"):60103,n=e?Symbol.for("react.portal"):60106,r=e?Symbol.for("react.fragment"):60107,o=e?Symbol.for("react.strict_mode"):60108,a=e?Symbol.for("react.profiler"):60114,s=e?Symbol.for("react.provider"):60109,c=e?Symbol.for("react.context"):60110,f=e?Symbol.for("react.async_mode"):60111,l=e?Symbol.for("react.concurrent_mode"):60111,p=e?Symbol.for("react.forward_ref"):60112,m=e?Symbol.for("react.suspense"):60113,d=e?Symbol.for("react.suspense_list"):60120,y=e?Symbol.for("react.memo"):60115,v=e?Symbol.for("react.lazy"):60116,h=e?Symbol.for("react.block"):60121,b=e?Symbol.for("react.fundamental"):60117,S=e?Symbol.for("react.responder"):60118,g=e?Symbol.for("react.scope"):60119;function T(e){if("object"==typeof e&&null!==e){var i=e.$$typeof;switch(i){case t:switch(e=e.type){case f:case l:case r:case a:case o:case m:return e;default:switch(e=e&&e.$$typeof){case c:case p:case v:case y:case s:return e;default:return i}}case n:return i}}}function w(e){return T(e)===l}return micro_ui_countdown_dist_es_u.AsyncMode=f,micro_ui_countdown_dist_es_u.ConcurrentMode=l,micro_ui_countdown_dist_es_u.ContextConsumer=c,micro_ui_countdown_dist_es_u.ContextProvider=s,micro_ui_countdown_dist_es_u.Element=t,micro_ui_countdown_dist_es_u.ForwardRef=p,micro_ui_countdown_dist_es_u.Fragment=r,micro_ui_countdown_dist_es_u.Lazy=v,micro_ui_countdown_dist_es_u.Memo=y,micro_ui_countdown_dist_es_u.Portal=n,micro_ui_countdown_dist_es_u.Profiler=a,micro_ui_countdown_dist_es_u.StrictMode=o,micro_ui_countdown_dist_es_u.Suspense=m,micro_ui_countdown_dist_es_u.isAsyncMode=function(e){return w(e)||T(e)===f},micro_ui_countdown_dist_es_u.isConcurrentMode=w,micro_ui_countdown_dist_es_u.isContextConsumer=function(e){return T(e)===c},micro_ui_countdown_dist_es_u.isContextProvider=function(e){return T(e)===s},micro_ui_countdown_dist_es_u.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===t},micro_ui_countdown_dist_es_u.isForwardRef=function(e){return T(e)===p},micro_ui_countdown_dist_es_u.isFragment=function(e){return T(e)===r},micro_ui_countdown_dist_es_u.isLazy=function(e){return T(e)===v},micro_ui_countdown_dist_es_u.isMemo=function(e){return T(e)===y},micro_ui_countdown_dist_es_u.isPortal=function(e){return T(e)===n},micro_ui_countdown_dist_es_u.isProfiler=function(e){return T(e)===a},micro_ui_countdown_dist_es_u.isStrictMode=function(e){return T(e)===o},micro_ui_countdown_dist_es_u.isSuspense=function(e){return T(e)===m},micro_ui_countdown_dist_es_u.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===r||e===l||e===a||e===o||e===m||e===d||"object"==typeof e&&null!==e&&(e.$$typeof===v||e.$$typeof===y||e.$$typeof===s||e.$$typeof===c||e.$$typeof===p||e.$$typeof===b||e.$$typeof===S||e.$$typeof===g||e.$$typeof===h)},micro_ui_countdown_dist_es_u.typeOf=T,micro_ui_countdown_dist_es_u}():0),dist_es_c.exports;var e}function es_x(){if(es_m)return es_p;es_m=1;return es_p="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function es_D(){return es_y?dist_es_d:(es_y=1,dist_es_d=Function.call.bind(Object.prototype.hasOwnProperty))}if(false){ var es_E; }else dist_es_s.exports=function(){if(es_T)return es_g;es_T=1;var e=es_x();function t(){}function n(){}return n.resetWarningCache=t,es_g=function(){function r(t,n,r,o,a,i){if(i!==e){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function o(){return r}r.isRequired=r;var a={array:r,bigint:r,bool:r,func:r,number:r,object:r,string:r,symbol:r,any:r,arrayOf:o,element:r,elementType:r,instanceOf:o,node:r,objectOf:o,oneOf:o,oneOfType:o,shape:o,exact:o,checkPropTypes:n,resetWarningCache:t};return a.PropTypes=a,a}}()();function es_C(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function es_O(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function es_P(e,t,n){return t&&es_O(e.prototype,t),n&&es_O(e,n),e}function es_j(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&es_$(e,t)}function es_N(e){return es_N=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},es_N(e)}function es_$(e,t){return es_$=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},es_$(e,t)}function es_k(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function es_M(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=es_N(e);if(t){var o=es_N(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return es_k(this,n)}}function es_I(e){return function(e){if(Array.isArray(e))return es_R(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return es_R(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return es_R(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function es_R(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function es_A(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2,n=String(e);if(0===t)return n;var r=n.match(/(.*?)([0-9]+)(.*)/),o=r?r[1]:"",a=r?r[3]:"",i=r?r[2]:n,s=i.length>=t?i:(es_I(Array(t)).map((function(){return"0"})).join("")+i).slice(-1*t);return"".concat(o).concat(s).concat(a)}var es_V={daysInHours:!1,zeroPadTime:2};function es_z(e,t){var n=e.days,r=e.hours,o=e.minutes,a=e.seconds,i=Object.assign(Object.assign({},es_V),t),s=i.daysInHours,c=i.zeroPadTime,u=i.zeroPadDays,f=void 0===u?c:u,l=Math.min(2,c),p=s?es_A(r+24*n,c):es_A(r,l);return{days:s?"":es_A(n,f),hours:p,minutes:es_A(o,l),seconds:es_A(a,l)}}var es_F=function(e){es_j(o,react.Component);var r=es_M(o);function o(){var e;return es_C(this,o),(e=r.apply(this,arguments)).state={count:e.props.count||3},e.startCountdown=function(){e.interval=window.setInterval((function(){0===e.state.count-1?(e.stopCountdown(),e.props.onComplete&&e.props.onComplete()):e.setState((function(e){return{count:e.count-1}}))}),1e3)},e.stopCountdown=function(){clearInterval(e.interval)},e.addTime=function(t){e.stopCountdown(),e.setState((function(e){return{count:e.count+t}}),e.startCountdown)},e}return es_P(o,[{key:"componentDidMount",value:function(){this.startCountdown()}},{key:"componentWillUnmount",value:function(){clearInterval(this.interval)}},{key:"render",value:function(){return this.props.children?(0,react.cloneElement)(this.props.children,{count:this.state.count}):null}}]),o}();es_F.propTypes={count:dist_es_s.exports.number,children:dist_es_s.exports.element,onComplete:dist_es_s.exports.func};var es_L=function(e){es_j(i,react.Component);var a=es_M(i);function i(e){var t;if(es_C(this,i),(t=a.call(this,e)).mounted=!1,t.initialTimestamp=t.calcOffsetStartTimestamp(),t.offsetStartTimestamp=t.props.autoStart?0:t.initialTimestamp,t.offsetTime=0,t.legacyMode=!1,t.legacyCountdownRef=(0,react.createRef)(),t.tick=function(){var e=t.calcTimeDelta(),n=e.completed&&!t.props.overtime?void 0:t.props.onTick;t.setTimeDeltaState(e,void 0,n)},t.start=function(){if(!t.isStarted()){var e=t.offsetStartTimestamp;t.offsetStartTimestamp=0,t.offsetTime+=e?t.calcOffsetStartTimestamp()-e:0;var n=t.calcTimeDelta();t.setTimeDeltaState(n,"STARTED",t.props.onStart),t.props.controlled||n.completed&&!t.props.overtime||(t.clearTimer(),t.interval=window.setInterval(t.tick,t.props.intervalDelay))}},t.pause=function(){t.isPaused()||(t.clearTimer(),t.offsetStartTimestamp=t.calcOffsetStartTimestamp(),t.setTimeDeltaState(t.state.timeDelta,"PAUSED",t.props.onPause))},t.stop=function(){t.isStopped()||(t.clearTimer(),t.offsetStartTimestamp=t.calcOffsetStartTimestamp(),t.offsetTime=t.offsetStartTimestamp-t.initialTimestamp,t.setTimeDeltaState(t.calcTimeDelta(),"STOPPED",t.props.onStop))},t.isStarted=function(){return t.isStatus("STARTED")},t.isPaused=function(){return t.isStatus("PAUSED")},t.isStopped=function(){return t.isStatus("STOPPED")},t.isCompleted=function(){return t.isStatus("COMPLETED")},e.date){var n=t.calcTimeDelta();t.state={timeDelta:n,status:n.completed?"COMPLETED":"STOPPED"}}else t.legacyMode=!0;return t}return es_P(i,[{key:"componentDidMount",value:function(){this.legacyMode||(this.mounted=!0,this.props.onMount&&this.props.onMount(this.calcTimeDelta()),this.props.autoStart&&this.start())}},{key:"componentDidUpdate",value:function(e){this.legacyMode||this.props.date!==e.date&&(this.initialTimestamp=this.calcOffsetStartTimestamp(),this.offsetStartTimestamp=this.initialTimestamp,this.offsetTime=0,this.setTimeDeltaState(this.calcTimeDelta()))}},{key:"componentWillUnmount",value:function(){this.legacyMode||(this.mounted=!1,this.clearTimer())}},{key:"calcTimeDelta",value:function(){var e=this.props,t=e.date,n=e.now,r=e.precision,o=e.controlled,a=e.overtime;return function(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.now,o=void 0===r?Date.now:r,a=n.precision,i=void 0===a?0:a,s=n.controlled,c=n.offsetTime,u=void 0===c?0:c,f=n.overtime;t="string"==typeof e?new Date(e).getTime():e instanceof Date?e.getTime():e,s||(t+=u);var l=s?t:t-o(),p=Math.min(20,Math.max(0,i)),m=Math.round(1e3*parseFloat(((f?l:Math.max(0,l))/1e3).toFixed(p))),d=Math.abs(m)/1e3;return{total:m,days:Math.floor(d/86400),hours:Math.floor(d/3600%24),minutes:Math.floor(d/60%60),seconds:Math.floor(d%60),milliseconds:Number((d%1*1e3).toFixed()),completed:m<=0}}(t,{now:n,precision:r,controlled:o,offsetTime:this.offsetTime,overtime:a})}},{key:"calcOffsetStartTimestamp",value:function(){return Date.now()}},{key:"addTime",value:function(e){this.legacyCountdownRef.current.addTime(e)}},{key:"clearTimer",value:function(){window.clearInterval(this.interval)}},{key:"isStatus",value:function(e){return this.state.status===e}},{key:"setTimeDeltaState",value:function(e,t,n){var r=this;if(this.mounted){var o=e.completed&&!this.state.timeDelta.completed,a=e.completed&&"STARTED"===t;o&&!this.props.overtime&&this.clearTimer();return this.setState((function(n){var o=t||n.status;return e.completed&&!r.props.overtime?o="COMPLETED":t||"COMPLETED"!==o||(o="STOPPED"),{timeDelta:e,status:o}}),(function(){n&&n(r.state.timeDelta),r.props.onComplete&&(o||a)&&r.props.onComplete(e,a)}))}}},{key:"getApi",value:function(){return this.api=this.api||{start:this.start,pause:this.pause,stop:this.stop,isStarted:this.isStarted,isPaused:this.isPaused,isStopped:this.isStopped,isCompleted:this.isCompleted}}},{key:"getRenderProps",value:function(){var e=this.props,t=e.daysInHours,n=e.zeroPadTime,r=e.zeroPadDays,o=this.state.timeDelta;return Object.assign(Object.assign({},o),{api:this.getApi(),props:this.props,formatted:es_z(o,{daysInHours:t,zeroPadTime:n,zeroPadDays:r})})}},{key:"render",value:function(){if(this.legacyMode){var e=this.props,n=e.count,r=e.children,a=e.onComplete;return (0,react.createElement)(es_F,{ref:this.legacyCountdownRef,count:n,onComplete:a},r)}var i=this.props,s=i.className,c=i.overtime,u=i.children,f=i.renderer,l=this.getRenderProps();if(f)return f(l);if(u&&this.state.timeDelta.completed&&!c)return (0,react.cloneElement)(u,{countdown:l});var p=l.formatted,m=p.days,d=p.hours,y=p.minutes,v=p.seconds;return (0,react.createElement)("span",{className:s},l.total<0?"-":"",m,m?":":"",d,":",y,":",v)}}]),i}();es_L.defaultProps=Object.assign(Object.assign({},es_V),{controlled:!1,intervalDelay:1e3,precision:0,autoStart:!0}),es_L.propTypes={date:dist_es_s.exports.oneOfType([dist_es_s.exports.instanceOf(Date),dist_es_s.exports.string,dist_es_s.exports.number]),daysInHours:dist_es_s.exports.bool,zeroPadTime:dist_es_s.exports.number,zeroPadDays:dist_es_s.exports.number,controlled:dist_es_s.exports.bool,intervalDelay:dist_es_s.exports.number,precision:dist_es_s.exports.number,autoStart:dist_es_s.exports.bool,overtime:dist_es_s.exports.bool,className:dist_es_s.exports.string,children:dist_es_s.exports.element,renderer:dist_es_s.exports.func,now:dist_es_s.exports.func,onMount:dist_es_s.exports.func,onStart:dist_es_s.exports.func,onPause:dist_es_s.exports.func,onStop:dist_es_s.exports.func,onTick:dist_es_s.exports.func,onComplete:dist_es_s.exports.func};var es_U,es_W={exports:{}};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/es_U=es_W,function(){var e={}.hasOwnProperty;function t(){for(var n=[],r=0;r<arguments.length;r++){var o=arguments[r];if(o){var a=typeof o;if("string"===a||"number"===a)n.push(o);else if(Array.isArray(o)){if(o.length){var i=t.apply(null,o);i&&n.push(i)}}else if("object"===a){if(o.toString!==Object.prototype.toString&&!o.toString.toString().includes("[native code]")){n.push(o.toString());continue}for(var s in o)e.call(o,s)&&o[s]&&n.push(s)}}}return n.join(" ")}es_U.exports?(t.default=t,es_U.exports=t):window.classNames=t}();var es_B=es_W.exports;var es_q={CountDown:"CountDown-module_CountDown__5lqxy",CountDown__time:"CountDown-module_CountDown__time__BJ5hK",CountDown__separator:"CountDown-module_CountDown__separator__k-BN-"};!function(e,t){void 0===t&&(t={});var n=t.insertAt;if(e&&"undefined"!=typeof document){var r=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style");o.type="text/css","top"===n&&r.firstChild?r.insertBefore(o,r.firstChild):r.appendChild(o),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(document.createTextNode(e))}}(".CountDown-module_CountDown__5lqxy{display:flex;justify-content:center}.CountDown-module_CountDown__time__BJ5hK{align-items:center;display:flex;gap:.125rem;justify-content:center}.CountDown-module_CountDown__separator__k-BN-{margin:0 .125rem}");const es_H=({endDate:t,customClassContainer:n,customClassSeparator:r,customClassTimer:o,separator:a=":",labels:i,...s})=>{const c=es_B(es_q.CountDown,n),u=es_B(es_q.CountDown__separator,r),f=es_B(es_q.CountDown__time__number,o);return react.createElement(es_L,{date:t,renderer:t=>react.createElement("section",{className:c},t.days?react.createElement(react.Fragment,null,react.createElement("time",{className:f},react.createElement("span",{className:es_q.CountDown__time__number},t.days),react.createElement("span",{className:es_q.CountDown__time__text},i?.days||"D")),a&&react.createElement("span",{className:u},a)):"",react.createElement("time",{className:f},react.createElement("span",{className:es_q.CountDown__time__number},t.hours),react.createElement("span",{className:es_q.CountDown__time__text},i?.hours||"H")),a&&react.createElement("span",{className:u},a),react.createElement("time",{className:f},react.createElement("span",{className:es_q.CountDown__time__number},t.minutes),react.createElement("span",{className:es_q.CountDown__time__text},i?.minutes||"M")),a&&react.createElement("span",{className:u},a),react.createElement("time",{className:f},react.createElement("span",{className:es_q.CountDown__time__number},t.seconds),react.createElement("span",{className:es_q.CountDown__time__text},i?.seconds||"S"))),...s})};
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.plans/dist/es/index.js
/* provided dependency */ var process = __webpack_require__(4155);
var dist_es_h,dist_es_v="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},dist_es_E={exports:{}};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
dist_es_h=dist_es_E,function(){var e={}.hasOwnProperty;function n(){for(var t=[],a=0;a<arguments.length;a++){var l=arguments[a];if(l){var _=typeof l;if("string"===_||"number"===_)t.push(l);else if(Array.isArray(l)){if(l.length){var o=n.apply(null,l);o&&t.push(o)}}else if("object"===_){if(l.toString!==Object.prototype.toString&&!l.toString.toString().includes("[native code]")){t.push(l.toString());continue}for(var r in l)e.call(l,r)&&l[r]&&t.push(r)}}}return t.join(" ")}dist_es_h.exports?(n.default=n,dist_es_h.exports=n):window.classNames=n}();var dist_es_b=dist_es_E.exports;const dist_es_g=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 74 22",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{d:"M-24-23h768v68H-24z",className:"Platzi_svg__background"}),react.createElement("g",{fill:"#fff"},react.createElement("path",{fillRule:"evenodd",d:"M8.314 1.276 1.01 8.64a3.49 3.49 0 0 0 0 4.908l7.305 7.363a3.424 3.424 0 0 0 4.87 0l2.435-2.454L13.184 16l-2.435 2.454-7.305-7.362 7.305-7.362 4.87 4.908-4.87 4.908L13.184 16l4.87-4.908a3.49 3.49 0 0 0 0-4.908l-4.87-4.909a3.424 3.424 0 0 0-4.87 0",className:"Platzi_svg__isotipo",clipRule:"evenodd"}),react.createElement("path",{d:"M22.456 18.376V3.567h6.087c3.274 0 5.184 2.412 5.184 5.225 0 2.814-1.952 5.141-5.184 5.141H24.91v4.443zm6.087-6.6c1.658 0 2.834-1.333 2.834-3.046 0-1.714-1.134-3.025-2.834-3.025H24.87v6.07zm8.997-8.209v11.15c0 1.692.44 2.22 2.183 1.945l.084 1.778c-3.107.507-4.534-.297-4.534-3.702V3.568zM50.277 15.33c0 .93-.021 1.523 1.092 1.417v1.565c-1.449.275-2.939.106-2.939-1.586v-.423c-.566 1.417-1.994 2.221-3.484 2.221-3.086 0-4.576-2.496-4.576-5.373.063-3.385 2.456-5.246 5.752-5.183 1.448 0 2.834.36 4.156.952zm-2.204-5.077c-.693-.318-1.47-.423-2.12-.423-1.931 0-3.233 1.12-3.295 3.321 0 1.862.902 3.321 2.77 3.321 1.7 0 2.582-1.333 2.645-3.216zM56.169 8.2h3.506v1.862h-3.506v4.38c0 2.602 1.617 2.771 3.695 2.03l.23 1.735c-3.463 1.079-6.17.275-6.17-3.723v-4.422h-2.058V8.2h2.057V5.704h2.246zm4.943 9.71 2.939-4.632 2.204-3.216h-4.828V8.179h8.124v.296l-3.128 4.887-2.057 3.025h5.164v1.99h-8.418zm11.19-14.367c.693 0 1.365.465 1.365 1.353 0 .889-.672 1.376-1.344 1.376s-1.406-.445-1.406-1.376.692-1.353 1.385-1.353m1.134 14.833h-2.288V8.2h2.288z",className:"Platzi_svg__letter"})),react.createElement("path",{fill:"#2D323A",d:"M744 44H-24v2h768z",mask:"url(#Platzi_svg__path-3-inside-1_1521_29282)"}),react.createElement("rect",{width:1263,height:431,x:-55.5,y:-254.5,stroke:"#9747FF",strokeDasharray:"10 5",rx:31.5})),dist_es_y=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{stroke:"#0AE98A",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.25,d:"M10 9.167V3.34a.84.84 0 0 1 .936-.834 7.555 7.555 0 0 1 6.558 6.558.838.838 0 0 1-.834.936h-5.827A.833.833 0 0 1 10 9.167",clipRule:"evenodd"}),react.createElement("path",{stroke:"#0AE98A",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:1.25,d:"M7.5 2.937a7.524 7.524 0 1 0 9.701 9.343"})),dist_es_B=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M19.03 7.47a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.97 3.97 7.47-7.47a.75.75 0 0 1 1.06 0",clipRule:"evenodd"})),dist_es_C=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#0AE98A",fillRule:"evenodd",d:"M10.354 7.354a.5.5 0 0 0-.708-.708L7.5 8.793 6.354 7.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0zM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0",clipRule:"evenodd"})),dist_es_N=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M7.47 9.47a.75.75 0 0 1 1.06 0L12 12.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06",clipRule:"evenodd"})),dist_es_w=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 20 20",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7.891 6.225a.625.625 0 0 1 .884 0l3.333 3.333a.625.625 0 0 1 0 .884l-3.333 3.333a.625.625 0 1 1-.884-.884L10.783 10 7.89 7.109a.625.625 0 0 1 0-.884",clipRule:"evenodd"})),dist_es_R=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M5.47 5.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06",clipRule:"evenodd"}),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M18.53 5.47a.75.75 0 0 1 0 1.06l-12 12a.75.75 0 0 1-1.06-1.06l12-12a.75.75 0 0 1 1.06 0",clipRule:"evenodd"})),dist_es_T=n=>e.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75m0-1.5A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M10.25 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-4.25H11a.75.75 0 0 1-.75-.75",clipRule:"evenodd"}),e.createElement("path",{fill:"#fff",d:"M12.75 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"})),dist_es_S=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 18 18",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#C4C8CE",d:"M4.586 15.173 5.914 16.5l7.5-7.5-7.5-7.5-1.328 1.328L10.76 9z"})),dist_es_A=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.96 20.94c.52.52 1.21.81 1.95.81l-.01.01c.74 0 1.43-.29 1.95-.81l5.09-5.1c.52-.52.81-1.22.81-1.95s-.29-1.42-.81-1.94l-8.9-8.91c-.51-.52-1.27-.82-1.95-.8l-2.85.03c-.72 0-1.4.29-1.91.8L3.05 5.36c-.51.51-.8 1.21-.8 1.93v2.81c0 .73.28 1.41.8 1.93zM8.84 7.23c-.44-.44-1.17-.44-1.61 0s-.44 1.17 0 1.61 1.17.44 1.61 0 .44-1.17 0-1.61",clipRule:"evenodd"})),dist_es_O=n=>e.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),e.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7 14.75A3.25 3.25 0 0 0 3.75 18a.75.75 0 0 1-1.5 0A4.75 4.75 0 0 1 7 13.25h4A4.75 4.75 0 0 1 15.75 18a.75.75 0 0 1-1.5 0A3.25 3.25 0 0 0 11 14.75zm8.25-10.099a.75.75 0 0 1 .75-.75 3.25 3.25 0 1 1 0 6.5.75.75 0 0 1 0-1.5 1.75 1.75 0 1 0 0-3.5.75.75 0 0 1-.75-.75m-4.375.875a2.651 2.651 0 1 0-3.75 3.75 2.651 2.651 0 0 0 3.75-3.75m1.06-1.06a4.151 4.151 0 1 0-5.87 5.87 4.151 4.151 0 0 0 5.87-5.87M16.25 13a.75.75 0 0 1 .75-.75A4.75 4.75 0 0 1 21.75 17a.75.75 0 0 1-1.5 0A3.25 3.25 0 0 0 17 13.75a.75.75 0 0 1-.75-.75",clipRule:"evenodd"})),dist_es_I=n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#B72B23",fillRule:"evenodd",d:"M21.75 12A9.75 9.75 0 0 0 12 2.25 9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12M12 6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m0 10.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",clipRule:"evenodd"})),dist_es_M={annual:"anual",monthly:"mensual"};var dist_es_L;!function(e){e.BASIC="monthly_plan",e.EXPERT="expert_plan",e.DUO="annual_plan",e.FAMILY="family_plan"}(dist_es_L||(dist_es_L={}));const dist_es_x={[dist_es_L.DUO]:"two_students_button",[dist_es_L.FAMILY]:"four_students_button"};var dist_es_k;!function(e){e.PLATZI_INSTALLMENTS="platzi-installments",e.CC_12_INSTALLMENTS="cc-12-installments"}(dist_es_k||(dist_es_k={}));const dist_es_j={[dist_es_k.PLATZI_INSTALLMENTS]:"pricing.benefits.extra.4_installments",[dist_es_k.CC_12_INSTALLMENTS]:"pricing.benefits.extra.12_installments"},dist_es_U=(e,{fees:n,price:t})=>e===dist_es_k.PLATZI_INSTALLMENTS?`Paga a <strong>${n} cuotas</strong> sin intereses <span id="extraBenefitsPrice">de <strong>${t}</strong></span>`:e===dist_es_k.CC_12_INSTALLMENTS?"Paga hasta en 12 meses <strong>sin intereses</strong> con tarjeta de crédito o PayPal.":"",dist_es_$=(e,n=0,t=!1)=>t?"Precio Especial":e||n>0?`Ahorras ${n>0?n:""} meses`:"",dist_es_D=e=>e===dist_es_L.BASIC,dist_es_H=e=>e===dist_es_L.EXPERT,dist_es_z=e=>e===dist_es_L.FAMILY,dist_es_F=e=>e===dist_es_L.DUO,es_Y=e=>"expert"===e,dist_es_V=e=>dist_es_M[e],dist_es_q=e=>e.charAt(0).toUpperCase()+e.slice(1),dist_es_W=(e,n,t,a="cobro")=>{const l=dist_es_q(((e,n)=>"cobro"===n?`cobro ${dist_es_M[e]} recurrente`:"sub"===n?`suscripción ${dist_es_M[e]}`:"")(n,a));return dist_es_D(e)?l:(dist_es_H(e)||dist_es_z(e)||dist_es_F(e),`${l} de <strong>${t}</strong>`)},es_X=(e,n)=>e.search(n)>-1,es_G=(e,n="")=>e?.reduce(((e,t)=>es_X(t.text,n)?[t,...e]:[...e,t]),[]),es_K=e=>`${e} ${e>1?"estudiantes":"estudiante"}`,es_Z=(e,n)=>e.replace(n,""),es_J=[dist_es_L.BASIC,dist_es_L.EXPERT,dist_es_L.DUO,dist_es_L.FAMILY],es_Q=(e,n)=>`${e}${n}`,es_ee=(e,n)=>n.map((n=>({...n,apply:e?.benefits?.includes(n.id)}))),es_ne=e=>{if(!e)return[];const{plans:n,benefits:t,flag_url:a,symbol:l,country_code:_}=e,o={flag:a,symbol:l,countryCode:_};return n.map((e=>{if(e?.items&&Object.keys(e?.items).length){const n=Object.values(e?.items);return{...e,...o,items:n.reduce(((n,a)=>({...n,[a.name]:{...a,...o,benefits:es_ee(e,t)}})),{})}}return{...e,...o,benefits:es_ee(e,t)}}))},es_te=(e,n)=>e.reduce(((e,n)=>{if(n?.items&&Object.keys(n?.items).length){const t=Object.values(n?.items).map((e=>({...e,extra_benefits:e?.extra_benefits.length?e.extra_benefits:n.extra_benefits})));return{...e,...es_te(t)}}return{...e,[n.name]:{...n}}}),{}),es_ae=e=>e.reduce(((e,n)=>({...e,[n.name]:n?.benefits?.filter((e=>e.apply))})),{}),es_le=e=>{const n=es_ne(e),t=es_ae(n);return t[dist_es_L.EXPERT].filter((e=>!t[dist_es_L.BASIC]?.some((n=>n.id===e.id))))};var micro_ui_plans_dist_es_e=Object.freeze({__proto__:null,frequencyTag:dist_es_M,BREAKPOINTS_PLANS:1050,get PLAN_KEYS(){return dist_es_L},dataQaSelector:dist_es_x,get INSTALLMENTS_KEYS(){return dist_es_k},EXTRA_BENEFITS_KEYS:dist_es_j,getInstallmentsMessage:dist_es_U,getTagMessage:dist_es_$,isBasic:dist_es_D,isExpert:dist_es_H,isFamilyPlan:dist_es_z,isExpertDuoPlan:dist_es_F,isExpertFamilyPlan:es_Y,getFrequencyText:dist_es_V,capitalizeFirstLetter:dist_es_q,buildDetailsMessage:dist_es_W,hasCriteriaInText:es_X,getOrderBenefitsByCriteria:es_G,buildCountStudentMessage:es_K,cleanInstallmentPrice:es_Z,plansOrder:es_J,getParsePrice:es_Q,benefitsMatcher:es_ee,plansParser:es_ne,getIndexedPlans:es_te,getOnlyApplyableBenefits:es_ae,getBenefitsDataTable:es_le}),es_oe={BenefitsItem:"BenefitsItem-module_BenefitsItem__fxJma",BenefitsItem__icon:"BenefitsItem-module_BenefitsItem__icon__bPfX8","BenefitsItem__icon--apply":"BenefitsItem-module_BenefitsItem__icon--apply__rcMCI","BenefitsItem--apply":"BenefitsItem-module_BenefitsItem--apply__jle29","BenefitsItem--b2b":"BenefitsItem-module_BenefitsItem--b2b__vabjM"};const es_re=({id:e,apply:t,isB2b:a,text:l})=>{const _=l??"",o=dist_es_b(es_oe.BenefitsItem,{[es_oe["BenefitsItem--apply"]]:t,[es_oe["BenefitsItem--b2b"]]:a}),r=dist_es_b(es_oe.BenefitsItem__icon,{[es_oe["BenefitsItem__icon--apply"]]:t}),s="Plan__content__benefits__benefit"+(t?"--apply":""),c="Plan__content__benefits__benefit__icon"+(t?"--apply":"");return react.createElement("li",{key:e,className:o,"data-class":s},react.createElement("span",{className:r,"data-class":c},t?react.createElement(dist_es_B,null):react.createElement(dist_es_R,null)),react.createElement("p",{className:es_oe.Plan__content__benefits__benefit__text,dangerouslySetInnerHTML:{__html:_}}))};var es_se="ExtraBenefits-module_ExtraBenefits__Udbf1",es_ce="ExtraBenefits-module_ExtraBenefits__icon__vG8Fg",es_ie="ExtraBenefits-module_ExtraBenefits__info__Yubqm";const es_de=({extraBenefits:e,amount:t})=>{if(0===e.length)return null;const a=e[0];return react.createElement("div",{className:es_se,"data-class":"ExtraBenefits"},react.createElement("span",{className:es_ce},react.createElement(dist_es_y,null)),react.createElement("p",{className:es_ie,dangerouslySetInnerHTML:{__html:dist_es_U(a?.id,{fees:a?.fees,price:t})}}))},es_me="click_buy_suscription",es_ue="b2b_flexible_plan_calculator_submit",es_pe=e=>e<=constants_r?"mobile":e<=constants_u?"tablet":"desktop",es_fe=()=>{if("undefined"==typeof window)return null;return"/"===window.location.pathname?"new_home":window.location.pathname};var dist_es_Pe={StudentSelector:"StudentSelector-module_StudentSelector__Gdr1H",StudentSelector__option:"StudentSelector-module_StudentSelector__option__1a3CC"};const es_he=({items:e,selectedPlan:t,onSelectPlan:a,promoStyles:l})=>react.createElement("section",{className:dist_es_Pe.StudentSelector,style:l},Object.entries(e).map((([e,_])=>react.createElement("div",{key:e,className:dist_es_Pe.StudentSelector__option},react.createElement("input",{onChange:()=>a(_),checked:e===t.name,value:e,id:`student-option-${e}`,name:"student-count",type:"radio","data-qa":dist_es_x[e],"data-class":"RadioButton","aria-labelledby":`student-label-${e}`,style:l}),react.createElement("label",{id:`student-label-${e}`,htmlFor:`student-option-${e}`,className:dist_es_Pe.StudentSelector__label},_?.students," estudiantes")))));var es_ve,dist_es_Ee={Plan:"Plan-module_Plan__EWKOh",Plan__content:"Plan-module_Plan__content__d7V9u","Plan__content--highlight":"Plan-module_Plan__content--highlight__-hKd1",Plan__content__tag:"Plan-module_Plan__content__tag__VVDY6","Plan__content__tag--highlight":"Plan-module_Plan__content__tag--highlight__ippQb",Plan__content__header:"Plan-module_Plan__content__header__Nme9E",Plan__content__header__name:"Plan-module_Plan__content__header__name__EDYUz",Plan__content__header__badge:"Plan-module_Plan__content__header__badge__VqDfN",Plan__content__info:"Plan-module_Plan__content__info__WfHWn",Plan__content__info__price:"Plan-module_Plan__content__info__price__e9Svx",Plan__content__info__price__flag:"Plan-module_Plan__content__info__price__flag__gUEAu",Plan__content__info__price__amount:"Plan-module_Plan__content__info__price__amount__f9NXZ",Plan__content__info__price__icon:"Plan-module_Plan__content__info__price__icon__wviHY",Plan__content__info__details:"Plan-module_Plan__content__info__details__IvWLL",Plan__content__info__details__promo:"Plan-module_Plan__content__info__details__promo__78af2",Plan__content__info__details__promo__divider:"Plan-module_Plan__content__info__details__promo__divider__9O8oX",Plan__content__info__details__promo__price:"Plan-module_Plan__content__info__details__promo__price__kadM-","Plan__content__info__details__promo__price--before":"Plan-module_Plan__content__info__details__promo__price--before__J2UsT","Plan__content__info__details__promo__price--saving":"Plan-module_Plan__content__info__details__promo__price--saving__q77gA",Plan__content__selector:"Plan-module_Plan__content__selector__IE3SV",Plan__content__students:"Plan-module_Plan__content__students__l9OHb",Plan__content__benefits:"Plan-module_Plan__content__benefits__SDIxL",Plan__content__benefits__list:"Plan-module_Plan__content__benefits__list__OdgZO",Plan__content__extraBenefits:"Plan-module_Plan__content__extraBenefits__SmeBI",Plan__content__cta:"Plan-module_Plan__content__cta__os8LW",ctaPrimary:"Plan-module_ctaPrimary__xmHnd",ctaTertiary:"Plan-module_ctaTertiary__lAj3E"};!function(e){e.BEFORE="before",e.SAVING="saving"}(es_ve||(es_ve={}));const dist_es_be=e=>{const{width:a}=index_89705ca0_l(),l=a<=1050,_=e?.items&&Object.keys(e?.items).length>0,o=_?e?.items:{},r=e?.default_plan,m=e?.extra_benefits||[],[u,p]=(0,react.useState)(_?o?.[r]:e),{highlight:f,title:P,price:h,frequency:v,plan_price:E,save_months:g,students:y,symbol:B,benefits:C,flag:N,full_price:w,name:R,installment_price:T,currency_code:S,promo:O}=u;if(!R)return null;const I=O?.active,M=I&&!dist_es_D(R),L=f,x=M?{"--primaryColorPromo":O?.styles?.background_color}:{},k=`${es_Q(B,h)}/mes`,j=dist_es_V(v),U=()=>{(()=>{const e={event:es_me,type:R,view:es_fe(),device:es_pe(a)};index_754db556_a.send(e)})(),e?.onClickPlan&&e?.onClickPlan(u)},H=es_Y(e.name),z=L||M,F=dist_es_b(dist_es_Ee.Plan__content,{[dist_es_Ee["Plan__content--highlight"]]:z}),q=dist_es_b(dist_es_Ee.Plan__content__tag,{[dist_es_Ee["Plan__content__tag--highlight"]]:z}),X=e=>dist_es_b(dist_es_Ee.Plan__content__info__details__promo__price,dist_es_Ee[`Plan__content__info__details__promo__price--${e}`]),J=e=>`Plan__content__info__details__promo__price--${e}`,ee=L||M||g>0,ne=dist_es_W(e?.name,v,es_Q(B,`${E}`),l?"sub":"cobro"),te=z?"Plan__content--highlight":"Plan__content",ae=z?"Plan__content__tag--highlight":"Plan__content__tag",le=z?"Button--primary":"Button--secondary",_e=dist_es_b({[dist_es_Ee.ctaPrimary]:z,[dist_es_Ee.ctaTertiary]:!z}),oe=M?{"--primaryColorPromo":O?.styles?.background_color}:{};return react.createElement("div",{className:dist_es_Ee.Plan,style:x,onClick:()=>{l&&U()},id:R},react.createElement("div",{className:F,"data-class":te},ee&&react.createElement("p",{className:q,"data-class":ae,"data-qa":`${R}_recurrence`},dist_es_$(L,g,M)),react.createElement("div",{className:dist_es_Ee.Plan__content__header},react.createElement("h3",{className:dist_es_Ee.Plan__content__header__name,"data-class":"Plan__content__header__name","data-qa":`${R}_title`},P),react.createElement("p",{className:dist_es_Ee.Plan__content__header__badge,"data-class":"Plan__content__header__badge"},l?es_K(y):j)),react.createElement("div",{className:dist_es_Ee.Plan__content__selector,"data-class":"Plan__content__selector"},H&&Object.keys(e?.items||{}).length>1?react.createElement(es_he,{items:e?.items,selectedPlan:u,onSelectPlan:e=>{p(e)},promoStyles:oe}):react.createElement("p",{className:dist_es_Ee.Plan__content__students,"data-class":"Plan__content__students","data-qa":`students_${R}_count`},"Para ",react.createElement("strong",null,es_K(y)))),react.createElement("div",{className:dist_es_Ee.Plan__content__info,"data-class":"Plan__content__info"},react.createElement("div",{className:dist_es_Ee.Plan__content__info__price},react.createElement(es_u,{src:N,alt:"country flag",customClass:dist_es_Ee.Plan__content__info__price__flag}),react.createElement("p",{className:dist_es_Ee.Plan__content__info__price__amount,"data-class":"Plan__content__info__price__amount"},k),M&&react.createElement("div",{className:dist_es_Ee.Plan__content__info__price__icon,"data-class":"Plan__content__info__price__icon"},react.createElement(dist_es_A,null))),react.createElement("div",{className:dist_es_Ee.Plan__content__info__details,"data-class":"Plan__content__info__details"},react.createElement("p",{"data-qa":`recurrent_${R}_price`,dangerouslySetInnerHTML:{__html:ne}}),M&&react.createElement("div",{className:dist_es_Ee.Plan__content__info__details__promo,"data-qa":`promo_${R}_price`},react.createElement("p",{className:X(es_ve.BEFORE),"data-class":J(es_ve.BEFORE)},l?"Precio normal":"Antes"," ",react.createElement("span",{"data-qa":`promo_${R}_price_before`},"$",w)),react.createElement("hr",{className:dist_es_Ee.Plan__content__info__details__promo__divider}),react.createElement("p",{"data-qa":`promo_${R}_price_saving`,className:X(es_ve.SAVING),"data-class":J(es_ve.SAVING)},"Ahorras",react.createElement("span",null,"$",O?.discount_amount))))),react.createElement("div",{className:dist_es_Ee.Plan__content__benefits,"data-testid":"benefits","data-class":"Plan__content__benefits"},react.createElement("ul",{className:dist_es_Ee.Plan__content__benefits__list},(()=>{const e=es_G(C,"PlatziConf");return e?.map((e=>react.createElement(es_re,{key:e.id,apply:e?.apply,text:e?.text})))})())),react.createElement("div",{className:dist_es_Ee.Plan__content__extraBenefits},react.createElement(es_de,{extraBenefits:m,amount:es_Q(B,es_Z(T||"",S))})),react.createElement("div",{className:dist_es_Ee.Plan__content__cta,"data-class":"Plan__content__cta"},react.createElement(es_d,{variant:z?"primary":"secondary","data-class":le,fullWidth:!0,"data-qa":`subscribe_to_${R}_button`,className:_e,onClick:U},"Suscríbete a ",P))))};var dist_es_ge="Plans-module_Plans__WweRu",dist_es_ye="Plans-module_Plans__container__u4yho",dist_es_Be="Plans-module_Plans__container--desktop__7Sw2-",dist_es_Ce="Plans-module_Plans__container--mobile__UZtfl",dist_es_Ne="Plans-module_Plans__link__t8bzi",dist_es_we="Plans-module_Plans__link__anchor__KB9GT";const dist_es_Re=e=>{const{width:t}=index_89705ca0_l();if(!e?.plans&&!Object.keys(!e?.plans).length)return null;const a=e?.plans,l=es_ne(a),_=es_te(l,a.benefits),o=()=>l.map((t=>react.createElement(dist_es_be,{key:t?.name,...t,onClickPlan:e?.onClickPlan}))),r={"--plans-length":o().length||3,"--plan-width":o().length>2?"325px":"350px"},i=dist_es_b(dist_es_ye,dist_es_Be),d=dist_es_b(dist_es_ye,dist_es_Ce);return react.createElement("div",{style:r,className:dist_es_ge,"data-testid":"plans",id:"plans"},react.createElement("div",{className:i},o()),react.createElement("div",{className:d},es_J.map((t=>{const a=_[t];return react.createElement(dist_es_be,{key:a?.name,...a,onClickPlan:e?.onClickPlan})}))),e?.showB2BLink&&react.createElement("div",{className:dist_es_Ne},react.createElement("a",{"data-qa":"see_enterprise_plans_link",onClick:()=>{(()=>{const e={event:"click_business",view:es_fe(),device:es_pe(t)};index_754db556_a.send(e)})(),e?.onClickB2BLink&&e?.onClickB2BLink()},href:"/business#planes",className:dist_es_we,"data-class":"Plans__link__anchor","data-trans":"paywalls_modal_b2b_link"},e?.b2bLinkText||"Conoce los planes para empresas",react.createElement(dist_es_S,null))))};var dist_es_Te={PlanResponsive:"PlanResponsive-module_PlanResponsive__P2BYB",PlanResponsive__content:"PlanResponsive-module_PlanResponsive__content__bY-jd","PlanResponsive__content--highlight":"PlanResponsive-module_PlanResponsive__content--highlight__38eMi",PlanResponsive__content__countdown:"PlanResponsive-module_PlanResponsive__content__countdown__54sYG",PlanResponsive__content__countdown__title:"PlanResponsive-module_PlanResponsive__content__countdown__title__GrhX3",PlanResponsive__content__countdown__container:"PlanResponsive-module_PlanResponsive__content__countdown__container__kFJGi",PlanResponsive__content__countdown__time:"PlanResponsive-module_PlanResponsive__content__countdown__time__ZJOFP",PlanResponsive__content__tag:"PlanResponsive-module_PlanResponsive__content__tag__Y6OFO","PlanResponsive__content__tag--highlight":"PlanResponsive-module_PlanResponsive__content__tag--highlight__AmKdh",PlanResponsive__content__header:"PlanResponsive-module_PlanResponsive__content__header__P8-lH",PlanResponsive__content__header__name:"PlanResponsive-module_PlanResponsive__content__header__name__RVMfc",PlanResponsive__content__header__badge:"PlanResponsive-module_PlanResponsive__content__header__badge__LljhD",PlanResponsive__content__info:"PlanResponsive-module_PlanResponsive__content__info__0TRTg",PlanResponsive__content__info__price:"PlanResponsive-module_PlanResponsive__content__info__price__hBT--",PlanResponsive__content__info__price__flag:"PlanResponsive-module_PlanResponsive__content__info__price__flag__4F53W",PlanResponsive__content__info__price__amount:"PlanResponsive-module_PlanResponsive__content__info__price__amount__yoLAd",PlanResponsive__content__info__price__icon:"PlanResponsive-module_PlanResponsive__content__info__price__icon__Tv18i",PlanResponsive__content__info__details:"PlanResponsive-module_PlanResponsive__content__info__details__ljrac",PlanResponsive__content__info__details__promo:"PlanResponsive-module_PlanResponsive__content__info__details__promo__HFdMF",PlanResponsive__content__info__details__promo__divider:"PlanResponsive-module_PlanResponsive__content__info__details__promo__divider__O7Aw9",PlanResponsive__content__info__details__promo__price:"PlanResponsive-module_PlanResponsive__content__info__details__promo__price__F1kWf","PlanResponsive__content__info__details__promo__price--before":"PlanResponsive-module_PlanResponsive__content__info__details__promo__price--before__4f3-O","PlanResponsive__content__info__details__promo__price--saving":"PlanResponsive-module_PlanResponsive__content__info__details__promo__price--saving__bb5GC",PlanResponsive__content__selector:"PlanResponsive-module_PlanResponsive__content__selector__Vuxgd",PlanResponsive__content__students:"PlanResponsive-module_PlanResponsive__content__students__ySgIY",PlanResponsive__content__benefits:"PlanResponsive-module_PlanResponsive__content__benefits__lUTSb",PlanResponsive__content__benefits__list:"PlanResponsive-module_PlanResponsive__content__benefits__list__wtKf5",PlanResponsive__content__extraBenefits:"PlanResponsive-module_PlanResponsive__content__extraBenefits__d20z1",PlanResponsive__content__cta:"PlanResponsive-module_PlanResponsive__content__cta__bDdc1","PlanResponsive--small":"PlanResponsive-module_PlanResponsive--small__TYuDT"};const dist_es_Se={small:constants_r,medium:constants_u},dist_es_Ae=({className:e,plan:a,size:l="small",showCountdown:_=!0,...o})=>{const r=dist_es_Se[l],s="small"===l,d=a?.items&&Object.keys(a?.items).length>0,u=d?a?.items:{},p=a?.default_plan,f=a?.extra_benefits||[],[h,v]=t(d?u?.[p]:a),{highlight:E,title:g,price:y,frequency:B,plan_price:C,save_months:N,students:w,symbol:R,benefits:T,flag:S,full_price:O,name:I,installment_price:M,currency_code:L,promo:x}=h;if(!I)return null;const k=x?.active,j=k&&!dist_es_D(I),U=E,H=j?{"--primaryColorPromo":x?.styles?.background_color}:{},z=`${es_Q(R,y)}/mes`,F=dist_es_V(B),q=()=>{(()=>{const e={event:es_me,type:I,view:es_fe(),device:es_pe(r)};c.send(e)})(),a?.onClickPlan&&a?.onClickPlan(h)},X=es_Y(a.name),J=U||j,ee=dist_es_b(dist_es_Te.PlanResponsive__content,{[dist_es_Te["PlanResponsive__content--highlight"]]:J}),ne=dist_es_b(dist_es_Te.PlanResponsive__content__tag,{[dist_es_Te["PlanResponsive__content__tag--highlight"]]:J}),te=e=>dist_es_b(dist_es_Te.PlanResponsive__content__info__details__promo__price,dist_es_Te[`PlanResponsive__content__info__details__promo__price--${e}`]),ae=e=>`PlanResponsive__content__info__details__promo__price--${e}`,le=U||j||N>0,_e=dist_es_W(a?.name,B,es_Q(R,`${C}`),s?"sub":"cobro"),oe=J?"PlanResponsive__content--highlight":"PlanResponsive__content",se=J?"PlanResponsive__content__tag--highlight":"PlanResponsive__content__tag",ce=J?"Button--primary":"Button--secondary",ie=dist_es_b({[dist_es_Te.ctaPrimary]:J,[dist_es_Te.ctaTertiary]:!J}),ue=j?{"--primaryColorPromo":x?.styles?.background_color}:{},Pe=dist_es_b(dist_es_Te.Plan,e);return n.createElement("div",{className:Pe,style:H,onClick:()=>{s&&q()},id:I,...o},n.createElement("div",{className:ee,"data-class":oe},le&&n.createElement("p",{className:ne,"data-class":se,"data-qa":`${I}_recurrence`},dist_es_$(U,N,j)),x?.end_at&&_&&n.createElement("div",{className:dist_es_Te.PlanResponsive__content__countdown},n.createElement("p",{className:dist_es_Te.PlanResponsive__content__countdown__title},"Termina en:"),n.createElement(P,{endDate:x?.end_at,customClassContainer:dist_es_Te.PlanResponsive__content__countdown__container,customClassTimer:dist_es_Te.PlanResponsive__content__countdown__time,separator:"",labels:{days:"días",hours:"hrs",minutes:"min",seconds:"seg"}})),n.createElement("div",{className:dist_es_Te.PlanResponsive__content__header},n.createElement("h3",{className:dist_es_Te.PlanResponsive__content__header__name,"data-class":"Plan__content__header__name","data-qa":`${I}_title`},g),n.createElement("p",{className:dist_es_Te.PlanResponsive__content__header__badge,"data-class":"Plan__content__header__badge"},s?es_K(w):F)),n.createElement("div",{className:dist_es_Te.PlanResponsive__content__selector,"data-class":"Plan__content__selector"},X&&Object.keys(a?.items||{}).length>1?n.createElement(es_he,{items:a?.items,selectedPlan:h,onSelectPlan:e=>{v(e)},promoStyles:ue}):n.createElement("p",{className:dist_es_Te.PlanResponsive__content__students,"data-class":"Plan__content__students","data-qa":`students_${I}_count`},"Para ",n.createElement("strong",null,es_K(w)))),n.createElement("div",{className:dist_es_Te.PlanResponsive__content__info,"data-class":"Plan__content__info"},n.createElement("div",{className:dist_es_Te.PlanResponsive__content__info__price},n.createElement(i,{src:S,alt:"country flag",customClass:dist_es_Te.PlanResponsive__content__info__price__flag}),n.createElement("p",{className:dist_es_Te.PlanResponsive__content__info__price__amount,"data-class":"Plan__content__info__price__amount"},z),j&&n.createElement("div",{className:dist_es_Te.PlanResponsive__content__info__price__icon,"data-class":"Plan__content__info__price__icon"},n.createElement(dist_es_A,null))),n.createElement("div",{className:dist_es_Te.PlanResponsive__content__info__details,"data-class":"Plan__content__info__details"},n.createElement("p",{"data-qa":`recurrent_${I}_price`,dangerouslySetInnerHTML:{__html:_e}}),j&&n.createElement("div",{className:dist_es_Te.PlanResponsive__content__info__details__promo,"data-qa":`promo_${I}_price`},n.createElement("p",{className:te(es_ve.BEFORE),"data-class":ae(es_ve.BEFORE)},s?"Precio normal":"Antes"," ",n.createElement("span",{"data-qa":`promo_${I}_price_before`},"$",O)),n.createElement("hr",{className:dist_es_Te.PlanResponsive__content__info__details__promo__divider}),n.createElement("p",{"data-qa":`promo_${I}_price_saving`,className:te(es_ve.SAVING),"data-class":ae(es_ve.SAVING)},"Ahorras",n.createElement("span",null,"$",x?.discount_amount))))),n.createElement("div",{className:dist_es_Te.PlanResponsive__content__benefits,"data-testid":"benefits","data-class":"Plan__content__benefits"},n.createElement("ul",{className:dist_es_Te.PlanResponsive__content__benefits__list},(()=>{const e=es_G(T,"PlatziConf");return e?.map((e=>n.createElement(es_re,{key:e.id,apply:e?.apply,text:e?.text})))})())),n.createElement("div",{className:dist_es_Te.PlanResponsive__content__extraBenefits},n.createElement(es_de,{extraBenefits:f,amount:es_Q(R,es_Z(M||"",L))})),n.createElement("div",{className:dist_es_Te.PlanResponsive__content__cta,"data-class":"Plan__content__cta"},n.createElement(m,{variant:J?"primary":"secondary","data-class":ce,"data-qa":`subscribe_to_${I}_button`,className:ie,onClick:q},"Suscríbete a ",g))))};var dist_es_Oe={},dist_es_Ie={};Object.defineProperty(dist_es_Ie,"__esModule",{value:!0});var dist_es_Me,dist_es_Le,dist_es_xe,dist_es_ke={};Object.defineProperty(dist_es_ke,"__esModule",{value:!0}),dist_es_ke.VARIANTS=dist_es_ke.SIZES=dist_es_ke.COLORS=void 0,function(e){e.PLATZI="platzi",e.SKY="sky",e.ERROR="error",e.ADMIN="admin"}(dist_es_Me||(dist_es_ke.COLORS=dist_es_Me={})),function(e){e.LARGE="large",e.MEDIUM="medium",e.SMALL="small"}(dist_es_Le||(dist_es_ke.SIZES=dist_es_Le={})),function(e){e.PRIMARY="primary",e.SECONDARY="secondary",e.TERTIARY="tertiary"}(dist_es_xe||(dist_es_ke.VARIANTS=dist_es_xe={}));var dist_es_je,dist_es_Ue,dist_es_$e,dist_es_De,dist_es_He={},dist_es_ze={};Object.defineProperty(dist_es_ze,"__esModule",{value:!0}),dist_es_ze.PLATZI_B2B_COMPANY_PLANS=dist_es_ze.PLATZI_PLANS_MAP_NAMES=dist_es_ze.PLATZI_PLANS_NAMES=dist_es_ze.PLATZI_USER_TYPE=dist_es_ze.PLATZI_PLANS=void 0,function(e){e.BASIC="monthly_plan",e.EXPERT="expert_plan",e.EXPERT_DUO="annual_plan",e.ACADEMY="platzi_academy",e.FAMILY="family_plan",e.FREE="free_plan",e.ENTERPRISE="enterprise"}(dist_es_je||(dist_es_ze.PLATZI_PLANS=dist_es_je={})),function(e){e.FREE="free",e.PAY_ONE="pay_one",e.ONE_PAYMENT="one_payment",e.PAY_ANNUAL="pay_annual",e.EXPERT_ANNUAL="expert_annual",e.COURSE_ONLY="course_only",e.MONTHLY_SUBSCRIPTION="monthly_subscription",e.MONTHLY_SUBSCRIPTION_TERM="monthly_subscription_term",e.ANNUAL_SUBSCRIPTION="annual_subscription",e.EXPERT_SUBSCRIPTION="expert_subscription",e.ENGLISH_ACADEMY_SUBSCRIPTION="english_academy_subscription",e.ENGLISH_ACADEMY_ANNUAL="english_academy_annual",e.MANUAL_MENSUAL_SUBSCRIPTION="manual_mensual_subscription",e.UNSUBSCRIBED="unsubscribed",e.UNSUBSCRIBED_MANUAL="unsubscribed_manual",e.PAUSED="paused",e.PENDING_UNSUBSCRIPTION="pending_unsubscription",e.ALLIANCE="alliance",e.BLOCKED="blocked",e.ESSENTIAL="essential",e.TEAM="team",e.STARTUP="startup",e.BUSINESS="business",e.ENTERPRISE="enterprise",e.TEAM_MONTH="team-month",e.BUSINESS_MONTH="business-month",e.ENTERPRISE_MONTH="enterprise-month"}(dist_es_Ue||(dist_es_ze.PLATZI_USER_TYPE=dist_es_Ue={})),function(e){e.EXPERT="Platzi Expert",e.EXPERT_PLUS="Platzi Expert+",e.B2B="Plan Empresarial",e.ACADEMY="Platzi English Academy"}(dist_es_$e||(dist_es_ze.PLATZI_PLANS_NAMES=dist_es_$e={})),dist_es_ze.PLATZI_PLANS_MAP_NAMES={[dist_es_je.EXPERT]:dist_es_$e.EXPERT},function(e){e.FLEXIBLE="Flexible"}(dist_es_De||(dist_es_ze.PLATZI_B2B_COMPANY_PLANS=dist_es_De={}));var dist_es_Fe,dist_es_Ye={};Object.defineProperty(dist_es_Ye,"__esModule",{value:!0}),dist_es_Ye.BUSINESS_MODEL=void 0,function(e){e.B2C="user",e.B2B="b2b"}(dist_es_Fe||(dist_es_Ye.BUSINESS_MODEL=dist_es_Fe={}));var dist_es_Ve,dist_es_qe={};Object.defineProperty(dist_es_qe,"__esModule",{value:!0}),dist_es_qe.PLATZI_USER_ROLE=void 0,function(e){e.BETA_TESTER="beta-tester",e.COMPANY_ADMIN="company_admin",e.ORGANIZER="organizer",e.STUDENT="student",e.TEACHER="teacher",e.ANONYMOUS="anonymous",e.READ_ONLY="read-only"}(dist_es_Ve||(dist_es_qe.PLATZI_USER_ROLE=dist_es_Ve={}));var dist_es_We,dist_es_Xe,dist_es_Ge,dist_es_Ke={};Object.defineProperty(dist_es_Ke,"__esModule",{value:!0}),dist_es_We=dist_es_He,dist_es_Xe=dist_es_v&&dist_es_v.__createBinding||(Object.create?function(e,n,t,a){void 0===a&&(a=t);var l=Object.getOwnPropertyDescriptor(n,t);l&&!("get"in l?!n.__esModule:l.writable||l.configurable)||(l={enumerable:!0,get:function(){return n[t]}}),Object.defineProperty(e,a,l)}:function(e,n,t,a){void 0===a&&(a=t),e[a]=n[t]}),dist_es_Ge=dist_es_v&&dist_es_v.__exportStar||function(e,n){for(var t in e)"default"===t||Object.prototype.hasOwnProperty.call(n,t)||dist_es_Xe(n,e,t)},Object.defineProperty(dist_es_We,"__esModule",{value:!0}),dist_es_Ge(dist_es_ze,dist_es_We),dist_es_Ge(dist_es_Ye,dist_es_We),dist_es_Ge(dist_es_qe,dist_es_We),dist_es_Ge(dist_es_Ke,dist_es_We);var dist_es_Ze={},dist_es_Je={};Object.defineProperty(dist_es_Je,"__esModule",{value:!0}),function(e){var n=dist_es_v&&dist_es_v.__createBinding||(Object.create?function(e,n,t,a){void 0===a&&(a=t);var l=Object.getOwnPropertyDescriptor(n,t);l&&!("get"in l?!n.__esModule:l.writable||l.configurable)||(l={enumerable:!0,get:function(){return n[t]}}),Object.defineProperty(e,a,l)}:function(e,n,t,a){void 0===a&&(a=t),e[a]=n[t]}),t=dist_es_v&&dist_es_v.__exportStar||function(e,t){for(var a in e)"default"===a||Object.prototype.hasOwnProperty.call(t,a)||n(t,e,a)};Object.defineProperty(e,"__esModule",{value:!0}),t(dist_es_Je,e)}(dist_es_Ze);var dist_es_Qe={};Object.defineProperty(dist_es_Qe,"__esModule",{value:!0});var es_en={},es_nn={};Object.defineProperty(es_nn,"__esModule",{value:!0});var es_tn={};Object.defineProperty(es_tn,"__esModule",{value:!0});var es_an={};Object.defineProperty(es_an,"__esModule",{value:!0});var es_ln={};Object.defineProperty(es_ln,"__esModule",{value:!0});var micro_ui_plans_dist_es_n={},es_on={};Object.defineProperty(es_on,"__esModule",{value:!0});var es_rn={};Object.defineProperty(es_rn,"__esModule",{value:!0});var es_sn={};Object.defineProperty(es_sn,"__esModule",{value:!0});var es_cn={};Object.defineProperty(es_cn,"__esModule",{value:!0});var es_dn={};Object.defineProperty(es_dn,"__esModule",{value:!0});var es_mn={};Object.defineProperty(es_mn,"__esModule",{value:!0});var es_un={};Object.defineProperty(es_un,"__esModule",{value:!0});var es_pn={};Object.defineProperty(es_pn,"__esModule",{value:!0});var es_fn={};Object.defineProperty(es_fn,"__esModule",{value:!0}),function(e){var n=dist_es_v&&dist_es_v.__createBinding||(Object.create?function(e,n,t,a){void 0===a&&(a=t);var l=Object.getOwnPropertyDescriptor(n,t);l&&!("get"in l?!n.__esModule:l.writable||l.configurable)||(l={enumerable:!0,get:function(){return n[t]}}),Object.defineProperty(e,a,l)}:function(e,n,t,a){void 0===a&&(a=t),e[a]=n[t]}),t=dist_es_v&&dist_es_v.__exportStar||function(e,t){for(var a in e)"default"===a||Object.prototype.hasOwnProperty.call(t,a)||n(t,e,a)};Object.defineProperty(e,"__esModule",{value:!0}),t(es_on,e),t(es_rn,e),t(es_sn,e),t(es_cn,e),t(es_dn,e),t(es_mn,e),t(es_un,e),t(es_pn,e),t(es_fn,e)}(micro_ui_plans_dist_es_n);var es_Pn,es_hn={};Object.defineProperty(es_hn,"__esModule",{value:!0}),es_hn.CHAT_ACTIONS=void 0,function(e){e.SHOW_LEARNING_PATH="show_learning_path"}(es_Pn||(es_hn.CHAT_ACTIONS=es_Pn={}));var es_vn={},es_En={};Object.defineProperty(es_En,"__esModule",{value:!0});var es_bn={};Object.defineProperty(es_bn,"__esModule",{value:!0});var es_gn={};Object.defineProperty(es_gn,"__esModule",{value:!0});var es_yn={};Object.defineProperty(es_yn,"__esModule",{value:!0});var es_Bn={};Object.defineProperty(es_Bn,"__esModule",{value:!0});var es_Cn={};Object.defineProperty(es_Cn,"__esModule",{value:!0});var es_Nn={};Object.defineProperty(es_Nn,"__esModule",{value:!0});var es_wn={};Object.defineProperty(es_wn,"__esModule",{value:!0}),function(e){var n=dist_es_v&&dist_es_v.__createBinding||(Object.create?function(e,n,t,a){void 0===a&&(a=t);var l=Object.getOwnPropertyDescriptor(n,t);l&&!("get"in l?!n.__esModule:l.writable||l.configurable)||(l={enumerable:!0,get:function(){return n[t]}}),Object.defineProperty(e,a,l)}:function(e,n,t,a){void 0===a&&(a=t),e[a]=n[t]}),t=dist_es_v&&dist_es_v.__exportStar||function(e,t){for(var a in e)"default"===a||Object.prototype.hasOwnProperty.call(t,a)||n(t,e,a)};Object.defineProperty(e,"__esModule",{value:!0}),t(es_En,e),t(es_bn,e),t(es_gn,e),t(es_yn,e),t(es_Bn,e),t(es_Cn,e),t(es_Nn,e),t(es_wn,e)}(es_vn);var es_Rn={};Object.defineProperty(es_Rn,"__esModule",{value:!0}),function(e){var n=dist_es_v&&dist_es_v.__createBinding||(Object.create?function(e,n,t,a){void 0===a&&(a=t);var l=Object.getOwnPropertyDescriptor(n,t);l&&!("get"in l?!n.__esModule:l.writable||l.configurable)||(l={enumerable:!0,get:function(){return n[t]}}),Object.defineProperty(e,a,l)}:function(e,n,t,a){void 0===a&&(a=t),e[a]=n[t]}),t=dist_es_v&&dist_es_v.__exportStar||function(e,t){for(var a in e)"default"===a||Object.prototype.hasOwnProperty.call(t,a)||n(t,e,a)};Object.defineProperty(e,"__esModule",{value:!0}),t(es_nn,e),t(es_tn,e),t(es_an,e),t(es_ln,e),t(micro_ui_plans_dist_es_n,e),t(es_hn,e),t(es_vn,e),t(es_Rn,e)}(es_en);var es_Tn={},es_Sn={};Object.defineProperty(es_Sn,"__esModule",{value:!0}),function(e){var n=dist_es_v&&dist_es_v.__createBinding||(Object.create?function(e,n,t,a){void 0===a&&(a=t);var l=Object.getOwnPropertyDescriptor(n,t);l&&!("get"in l?!n.__esModule:l.writable||l.configurable)||(l={enumerable:!0,get:function(){return n[t]}}),Object.defineProperty(e,a,l)}:function(e,n,t,a){void 0===a&&(a=t),e[a]=n[t]}),t=dist_es_v&&dist_es_v.__exportStar||function(e,t){for(var a in e)"default"===a||Object.prototype.hasOwnProperty.call(t,a)||n(t,e,a)};Object.defineProperty(e,"__esModule",{value:!0}),t(es_Sn,e)}(es_Tn);var es_An={};Object.defineProperty(es_An,"__esModule",{value:!0});var es_On,es_In,es_Mn={};Object.defineProperty(es_Mn,"__esModule",{value:!0}),es_Mn.COMMENT_OBJECT_TYPE=es_Mn.COMMENT_RELATION=void 0,function(e){e.DISCUSSION="discussion",e.CONTRIBUTION="contribution",e.MATERIAL="material"}(es_On||(es_Mn.COMMENT_RELATION=es_On={})),function(e){e.DISCUSSION="discussion",e.COMMENT="comment",e.MATERIAL="material"}(es_In||(es_Mn.COMMENT_OBJECT_TYPE=es_In={})),function(e){var n=dist_es_v&&dist_es_v.__createBinding||(Object.create?function(e,n,t,a){void 0===a&&(a=t);var l=Object.getOwnPropertyDescriptor(n,t);l&&!("get"in l?!n.__esModule:l.writable||l.configurable)||(l={enumerable:!0,get:function(){return n[t]}}),Object.defineProperty(e,a,l)}:function(e,n,t,a){void 0===a&&(a=t),e[a]=n[t]}),t=dist_es_v&&dist_es_v.__exportStar||function(e,t){for(var a in e)"default"===a||Object.prototype.hasOwnProperty.call(t,a)||n(t,e,a)};Object.defineProperty(e,"__esModule",{value:!0}),t(dist_es_Ie,e),t(dist_es_ke,e),t(dist_es_He,e),t(dist_es_Ze,e),t(dist_es_Qe,e),t(es_en,e),t(es_Tn,e),t(es_An,e),t(es_Mn,e)}(dist_es_Oe);const es_Ln={AUTH:e=>`${e}/api/v5/users/credentials/`,ALL_COUNTRY_CODES:e=>`${e}/business/api/country?all`,USER_ACTUAL_COUNTRY:e=>`${e}/business/api/country`,CRM_CREATE_LEAD:(e,n)=>`${e}/hubspot/v2/lead/?ref=${n||"price_table"}`,CRM_UPDATE_LEAD:(e,n,t)=>`${e}/hubspot/v2/lead/${n}/?ref=${t||"price_table"}`,LP_MAKER:e=>`${e}/ai-engine/v1/lp-model/`,SELF_CHECKOUT:e=>`${e}/pricing/v1/flexible/`,SELF_CHECKOUT_VALIDATION:e=>`${e}/b2b/v1/can-buy-validation/`,PRE_CHECKOUT:e=>`${e}/webhookemail/holaapi/`,ONE_CLICK_PAYMENT:(e,n)=>`${e}${n}`};function es_xn(){const e={};return process.env.CF_CLIENT_ID&&(e["CF-Access-Client-Id"]=process.env.CF_CLIENT_ID),process.env.NEXT_PUBLIC_CF_CLIENT_ID&&(e["CF-Access-Client-Id"]=process.env.NEXT_PUBLIC_CF_CLIENT_ID),process.env.CF_CLIENT_SECRET&&(e["CF-Access-Client-Secret"]=process.env.CF_CLIENT_SECRET),process.env.NEXT_PUBLIC_CF_CLIENT_SECRET&&(e["CF-Access-Client-Secret"]=process.env.NEXT_PUBLIC_CF_CLIENT_SECRET),e}class es_kn{static getToken(){if(this.token.length)return this.token}static setToken(e){this.token=e}static getBasePath(){return this.base_path.length?this.base_path:function(){const e=process.env.NEXT_PUBLIC_BASE_PATH||process.env.BASE_PATH||"https://api.platzi.com"||0||0;if(e&&e.length)return e.replace("api.","").replace("api-","");throw new Error("No URL provided")}()}static setBasePath(e){const n=e.replace("api.","").replace("api-","");this.base_path=n}static getApiUrl(){return this.api_url.length?this.api_url:function(){const e="https://api.platzi.com"||0||0;if(e&&e.length)return console.log("Fallback API URL: ",e),e;throw new Error("No URL provided")}()}static setApiUrl(e){this.api_url=e}}async function es_jn(){try{if(es_kn.getToken()?.length&&es_kn.getBasePath()?.length&&es_kn.getApiUrl()?.length)return{token:es_kn.getToken(),msUrl:es_kn.getBasePath()};const e=await fetch(es_Ln.AUTH(es_kn.getBasePath()),{method:"GET",headers:{...es_xn(),"Content-Type":"application/json"}}),n=await e.json(),t=n.token.access,a=n.token.microservices.ms_url;return es_kn.setToken(t),es_kn.setBasePath(a),es_kn.setApiUrl(a),{token:t,msUrl:a}}catch(e){return Promise.reject(e)}}es_kn.token="",es_kn.base_path="",es_kn.api_url="";var es_Un={Plan_card:"PlanCard-module_Plan_card__Exc6c",Plan_card_header:"PlanCard-module_Plan_card_header__SssTB",Plan_card_body:"PlanCard-module_Plan_card_body__PiNao",Plan_card_footer:"PlanCard-module_Plan_card_footer__1xbon",Plan_card_header_plan_duration:"PlanCard-module_Plan_card_header_plan_duration__Cjyrv",Plan_card_header_plan_duration_separator:"PlanCard-module_Plan_card_header_plan_duration_separator__h-ZV6",Plan_card_header_plan_duration_users:"PlanCard-module_Plan_card_header_plan_duration_users__XoaC8",Plan_card_header_plan_duration_users_icon:"PlanCard-module_Plan_card_header_plan_duration_users_icon__ejcRV",Plan_card_body_price:"PlanCard-module_Plan_card_body_price__Q8sVx",Plan_card_body_price_amount:"PlanCard-module_Plan_card_body_price_amount__SRl64",Plan_card_body_price_period:"PlanCard-module_Plan_card_body_price_period__t7Npm",Plan_card_body_discount:"PlanCard-module_Plan_card_body_discount__nzCYV",Plan_card_body_discount_amount:"PlanCard-module_Plan_card_body_discount_amount__N1huq",Plan_card_body_discount_before:"PlanCard-module_Plan_card_body_discount_before__P-BW3",Plan_card_body_discount_before_amount:"PlanCard-module_Plan_card_body_discount_before_amount__QtpaZ",Plan_card_body_content:"PlanCard-module_Plan_card_body_content__U5aWU",Plan_card_body_content_opened:"PlanCard-module_Plan_card_body_content_opened__ZrBAS",Plan_card_body_content_form:"PlanCard-module_Plan_card_body_content_form__Xb0h1",Plan_card_body_content_ocp:"PlanCard-module_Plan_card_body_content_ocp__nbuc-",Plan_card_body_content_ocp_separator:"PlanCard-module_Plan_card_body_content_ocp_separator__Lfb2B",Plan_card_body_content_ocp_icon:"PlanCard-module_Plan_card_body_content_ocp_icon__YfOHI",Plan_card_body_content_ocp_extend:"PlanCard-module_Plan_card_body_content_ocp_extend__8C8QL",Plan_card_body_content_ocp_extend_text:"PlanCard-module_Plan_card_body_content_ocp_extend_text__YSXX1",Plan_card_body_content_ocp_payment:"PlanCard-module_Plan_card_body_content_ocp_payment__xEgEY",Plan_card_body_content_ocp_payment_card:"PlanCard-module_Plan_card_body_content_ocp_payment_card__Q4i8k",Plan_card_body_content_ocp_payment_card_text:"PlanCard-module_Plan_card_body_content_ocp_payment_card_text__SVLrg",Plan_card_body_price_button:"PlanCard-module_Plan_card_body_price_button__IipL3",Plan_card_footer_info:"PlanCard-module_Plan_card_footer_info__AAXHK",Plan_card_footer_info_icon:"PlanCard-module_Plan_card_footer_info_icon__4qQOW",Plan_card_footer_info_text:"PlanCard-module_Plan_card_footer_info_text__UKyaY",Plan_card_bg:"PlanCard-module_Plan_card_bg__buBQf"};const es_$n=new Intl.DateTimeFormat("es-ES",{day:"numeric",month:"long",year:"numeric"}),es_Dn=({promo:e,setIsContentOpened:l,plan:_,onCardClick:o,OCPData:r,student:s,API_URL:d,BASE_PATH:f,className:P="",...h})=>{const[v,E]=t(s?.hasSubscription?"Agregar 1 año a mi plan":"Suscríbete a Platzi"),[g,y]=t({show:!1,content:""}),C="https://platzi.com",[N,w]=t(""),[R,S]=t(""),[A,I]=t(!1),M=a(null),L=()=>{const e=`${C}/quiero-renovar`;window.open(e,"_self"),I(!0)};async function x(){if(r?.one_payment_renew_data.url){I(!0);try{await(async(e,n)=>{const t=es_Ln.ONE_CLICK_PAYMENT(e,n);try{const e=await es_jn(),n=await fetch(t,{method:"POST",headers:{...es_xn(),"Api-Authorization":`Bearer ${e}`}});return await n.json()}catch(e){throw new Error(`Error in getOneClickPaymentData: ${t} -- ${e}`)}})(d,r?.one_payment_renew_data?.url)}catch(e){L()}}L()}const k=(e,n)=>{const t=`${`${f}${_.buy_url}`}&name=${encodeURIComponent(e)}&email=${encodeURIComponent(n)}`;window.open(t,"_self"),I(!0)},j=async()=>{const e=M.current?.querySelector?.(".Plan_card_body_content_form");if(!e||!e.checkValidity())return void e?.reportValidity();let n=`${f}${_.buy_url}`;n+=`&name=${encodeURIComponent(N)}&l&email=${encodeURIComponent(R)}`;try{const e=window.location.href||"promo-landing";I(!0),t={plan_name:_.title},c.send({event:"checkout_first_step",...t}),await(async(e,n)=>{const t=es_Ln.PRE_CHECKOUT(e);try{await fetch(t,{method:"POST",headers:{...es_xn()},body:JSON.stringify(n)})}catch(e){throw new Error(`Error in dispatchPrecheckout: ${t} -- ${e}`)}})(f,{origin:s?.registerType??"",full_path:e,name:N,email:R})}finally{window.open(n,"_self")}var t};async function U(){s?.isAuthenticated&&s?.hasSubscription?async function(){if("ocp"!==g.content)if(r?.can_renew&&r?.can_renew_one_payment)l&&l(!0),y({show:!0,content:"ocp"}),E("Agregar 1 año ahora");else{if(r?.url_renew_checkout){const e=`${C}${r?.url_renew_checkout??""}`;return void window.open(e,"_self")}L()}else x()}():s?.isAuthenticated||s?.hasSubscription?async function(){"form"!==g.content?(y({show:!0,content:"form"}),l&&l(!0),E("Continuar")):await j()}():k(s?.firstName??"",s?.emailStudent??"")}const $=dist_es_b(es_Un.Plan_card,P),D=dist_es_b(es_Un.Plan_card_body_content,{[es_Un.Plan_card_body_content_opened]:g.show});return n.createElement("form",{...h,className:$,onClick:o,onSubmit:e=>{e.preventDefault(),U()},id:`plan-card-${_.name}`,ref:M},n.createElement("div",{className:es_Un.Plan_card_header},n.createElement("div",{className:es_Un.Plan_card_header_planName},n.createElement("span",null,dist_es_Oe.PLATZI_PLANS_MAP_NAMES[_.name])),n.createElement("div",{className:es_Un.Plan_card_header_plan_duration},n.createElement("span",null,"1 año"),n.createElement("div",{className:es_Un.Plan_card_header_plan_duration_separator}),n.createElement("div",{className:es_Un.Plan_card_header_plan_duration_users},n.createElement(dist_es_O,{className:es_Un.Plan_card_header_plan_duration_users_icon}),n.createElement("span",null,_.students)))),n.createElement("div",{className:es_Un.Plan_card_body},n.createElement("div",{className:es_Un.Plan_card_body_price},n.createElement(i,{src:e.flag_url,alt:e.currency_text,height:18,width:18}),n.createElement("span",{className:es_Un.Plan_card_body_price_amount},e.symbol,_.price),n.createElement("span",{className:es_Un.Plan_card_body_price_period},"/mes")),n.createElement("div",{className:es_Un.Plan_card_body_discount},n.createElement("span",{className:es_Un.Plan_card_body_discount_amount},"Ahorras ",e.symbol,_.promo.discount_amount),n.createElement("span",{className:es_Un.Plan_card_body_discount_before},"Antes"," ",n.createElement("span",{className:es_Un.Plan_card_body_discount_before_amount},e.symbol,_.full_price)," ","anual")),n.createElement("div",{className:D},"form"===g.content&&n.createElement("form",{className:es_Un.Plan_card_body_content_form},n.createElement(u,{required:!0,type:"text",label:"",placeholder:"Nombre y Apellido",value:N,onChange:e=>{return n=e.target.value,w(n);var n},form:`plan-card-${_.name}`}),n.createElement(u,{onKeyDown:e=>"Enter"===e.key&&U(),required:!0,type:"email",label:"",placeholder:"Correo electrónico",value:R,onChange:e=>{return n=e.target.value,S(n);var n},form:`plan-card-${_.name}`})),"ocp"===g.content&&r?.can_renew_one_payment&&n.createElement("div",{className:es_Un.Plan_card_body_content_ocp},n.createElement("div",{className:es_Un.Plan_card_body_content_ocp_extend},n.createElement(dist_es_B,{className:es_Un.Plan_card_body_content_ocp_icon}),n.createElement("div",{className:es_Un.Plan_card_body_content_ocp_extend_text},n.createElement("span",null,"Tu plan se extenderá hasta el:"),n.createElement("span",null,n.createElement("b",null,es_$n.format(new Date(r.limit_date)))))),n.createElement("div",{className:es_Un.Plan_card_body_content_ocp_separator}),n.createElement("div",{className:es_Un.Plan_card_body_content_ocp_payment},n.createElement("div",{className:es_Un.Plan_card_body_content_ocp_payment_card},n.createElement(dist_es_B,{className:es_Un.Plan_card_body_content_ocp_icon}),n.createElement("div",{className:es_Un.Plan_card_body_content_ocp_payment_card_text},n.createElement("span",null,"Se cobrará a la tarjeta:"),n.createElement("span",null,n.createElement("b",null,"**** **** **** ",r.one_payment_renew_data.card.last_four)))),n.createElement(m,{onClick:()=>{if(r?.url_renew_checkout){const e=`${C}${r?.url_renew_checkout}`;window.open(e,"_self")}else L()},variant:"outline",size:"md"},"Cambiar")))),n.createElement(m,{type:"submit",disabled:A,className:es_Un.Plan_card_body_price_button,variant:"secondary",size:"md",form:`plan-card-${_.name}`},A?n.createElement(p,{loading:!0,style:{borderWidth:2,padding:1}}):v)),!s?.hasSubscription&&n.createElement("div",{className:es_Un.Plan_card_footer},n.createElement("div",{className:es_Un.Plan_card_footer_info},n.createElement(dist_es_T,{className:es_Un.Plan_card_footer_info_icon}),n.createElement("span",{className:es_Un.Plan_card_footer_info_text},"Paga 4 Cuotas sin intereses de ",e.symbol,_.installment_price.split(" ")[0]))),n.createElement("figure",{className:es_Un.Plan_card_bg,id:`plan-card-bg-${_.name}`}))};var es_Hn={BenefitsTable:"BenefitsTable-module_BenefitsTable__S9m-B",BenefitsTable__header:"BenefitsTable-module_BenefitsTable__header__Mhyls",BenefitsTable__header__head:"BenefitsTable-module_BenefitsTable__header__head__kRILa",BenefitsTable__body:"BenefitsTable-module_BenefitsTable__body__OXsl6",BenefitsTable__body__icon:"BenefitsTable-module_BenefitsTable__body__icon__rDCYO","BenefitsTable__body__icon--apply":"BenefitsTable-module_BenefitsTable__body__icon--apply__szP-U"};const es_zn=({benefits:e})=>{if(!e.length)return null;const t=(e=!1)=>dist_es_b(es_Hn.BenefitsTable__body__icon,{[es_Hn["BenefitsTable__body__icon--apply"]]:e});return react.createElement("table",{className:es_Hn.BenefitsTable},react.createElement("thead",{className:es_Hn.BenefitsTable__header},react.createElement("tr",null,react.createElement("th",{className:es_Hn.BenefitsTable__header__head,colSpan:2},"Beneficios"),react.createElement("th",{className:es_Hn.BenefitsTable__header__head},"Basic"),react.createElement("th",{className:es_Hn.BenefitsTable__header__head},"Expert"))),react.createElement("tbody",{className:es_Hn.BenefitsTable__body},e.map((e=>react.createElement("tr",{key:e.id},react.createElement("td",{className:es_Hn.BenefitsTable__body__data,colSpan:2,dangerouslySetInnerHTML:{__html:e.text},"aria-label":"benefit"}),react.createElement("td",{className:t(),"data-class":"BenefitsTable__body__data--notIncluded","aria-label":"notIncluded"},react.createElement(dist_es_R,null)),react.createElement("td",{className:t(!0),"data-class":"BenefitsTable__body__data--included","aria-label":"included"},react.createElement(dist_es_B,null)))))))},es_Fn=({plans:e})=>{if(e&&!Object.keys(e).length)return null;const t=es_le(e),a=es_G(t,"PlatziConf");return react.createElement(es_zn,{benefits:a})};var es_Yn={Banner:"Banner-module_Banner__DqQ3y",Banner__content:"Banner-module_Banner__content__C1r8W",Banner__content__image:"Banner-module_Banner__content__image__020zu",Banner__content__copy:"Banner-module_Banner__content__copy__c-TPW",Banner__countdown:"Banner-module_Banner__countdown__65YpE",Banner__countdown__text:"Banner-module_Banner__countdown__text__rzk8f",Banner__countdown__element:"Banner-module_Banner__countdown__element__y7lRJ",Banner__countdown__element__timer:"Banner-module_Banner__countdown__element__timer__wogUo",Banner__countdown__element__separator:"Banner-module_Banner__countdown__element__separator__R3XAA","Banner__countdown__element--2024":"Banner-module_Banner__countdown__element--2024__J3Q5-"};const es_Vn=({active:e,end_date:t,banner_text:a,primary_color:l,primary_logo:_,secondary_color:o,font_color:r,countdown_styles:s,register_type:c})=>{if(!e)return null;const d=c?.split("-")?.[0]||null,m={"--bgColor":l,"--textColor":r},u={"--bgCountdownColor":o,"--fontCountdownColor":s?.color},p="2024"===d,f=dist_es_b(es_Yn.Banner__countdown__element,{[es_Yn[`Banner__countdown__element--${d}`]]:p});return react.createElement("div",{className:es_Yn.Banner,style:m},react.createElement("div",{className:es_Yn.Banner__content},react.createElement(es_u,{customClass:es_Yn.Banner__content__image,src:_,alt:a,width:30,height:30}),react.createElement("h3",{className:es_Yn.Banner__content__copy},a)),react.createElement("div",{className:es_Yn.Banner__countdown,style:u},react.createElement("p",{className:es_Yn.Banner__countdown__text},"Termina en:"),react.createElement(es_H,{customClassContainer:f,customClassSeparator:es_Yn.Banner__countdown__element__separator,customClassTimer:es_Yn.Banner__countdown__element__timer,endDate:t})))},es_qn=[{id:1,code:"CO",name:"Colombia",phoneCode:"+57",flag:"https://static.platzi.com/media/flags/CO.png"},{id:2,code:"MX",name:"Mexico",phoneCode:"+52",flag:"https://static.platzi.com/media/flags/MX.png"},{id:3,code:"US",name:"Estados unidos",phoneCode:"+1",flag:"https://static.platzi.com/media/flags/US.png"}],es_Wn=es_qn[2];async function es_Xn(){const e=await async function(){try{const e=await fetch(es_Ln.ALL_COUNTRY_CODES(es_kn.getBasePath()),{method:"GET",headers:{...es_xn(),"Content-Type":"application/json"}});return await e.json()}catch(e){return es_qn}}(),n={};return e.map((e=>({label:e.name,value:e.phoneCode,flag:e.flag}))).filter((e=>!n[e.value]&&(n[e.value]=e.label,e.label&&e.value)))}async function es_Gn(){const e=await async function(){try{const e=await fetch(es_Ln.USER_ACTUAL_COUNTRY(es_kn.getBasePath()),{method:"GET",headers:{...es_xn(),"Content-Type":"application/json"}});return await e.json()}catch(e){return es_Wn}}();return{label:e.name,value:e.phoneCode,flag:e.flag}}const es_Kn=e=>e>2500?"2500+":e>500?"501-2499":e>100?"101-500":"1-100";async function es_Zn(){const e=await fetch(es_Ln.SELF_CHECKOUT(es_kn.getBasePath()),{headers:{...es_xn(),"Content-Type":"application/json"}}),{data:n}=await e.json();return n}const es_Jn={companyName:"",name:"",email:"",position:"",areaCodes:[],phone:{areaCode:{label:"",value:"",flag:""},number:""},employees:0,learningNeeds:"",lpCourses:[],months:3,currency:{currency:"",symbol:"",price:0,flag:"",max_amount:0},companyIsNew:!1};var es_Qn="B2BSteps-module_B2BSteps__zP-w9",es_et="B2BSteps-module_B2BSteps__step__wjvXJ",es_nt="B2BSteps-module_B2BSteps__step--active__Fk-AQ",es_tt="B2BSteps-module_B2BSteps__step--checked__qfq2D",es_at="B2BSteps-module_B2BSteps--fullDeviceWidth__Ehdkg";const es_lt=({step:e,b2bStep:t,text:a})=>{const l=dist_es_b(es_et,{[es_nt]:1===t,[es_tt]:t>1}),_=dist_es_b(es_et,{[es_nt]:2===t,[es_tt]:t>2}),o=dist_es_b(es_et,{[es_nt]:3===t});let r=l;return 2===e&&(r=_),3===e&&(r=o),react.createElement("li",{className:r},react.createElement("small",null,e,react.createElement(dist_es_B,null)),react.createElement("span",null,a))},es_t=[{step:1,text:"Tu empresa"},{step:2,text:"Tus objetivos"},{step:3,text:"Precio"}],es_ot=({b2bStep:e,fullDeviceWidth:t=!0})=>{const a=dist_es_b(es_Qn,{[es_at]:t});return react.createElement("div",{className:a},react.createElement("ul",null,es_t.map((({step:t,text:a})=>react.createElement(es_lt,{key:t,step:t,b2bStep:e,text:a})))))};var es_rt="B2BBenefit-module_B2BBenefit__0tbtY";const es_st=({icon:e,label:t})=>react.createElement("li",{className:es_rt},e," ",t);var es_ct="B2BBenefits-module_B2BBenefits__fWlkG",es_it="B2BBenefits-module_B2BBenefits__subtitle__yLE8-",es_dt="B2BBenefits-module_B2BBenefits--fullDeviceWidth__tp6kR";const es_mt=[{icon:react.createElement((n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M15.258 6.987 8.501 7A.75.75 0 1 1 8.5 5.5l6.757-.013a3.75 3.75 0 0 1 3.756 3.762v.016-.017.017A3.75 3.75 0 0 1 15.263 13h-5.014A2.25 2.25 0 0 0 8 15.249H6.5a3.75 3.75 0 0 1 3.749-3.749h5.014a2.25 2.25 0 0 0 2.249-2.24v.002-.003.001-.015a2.25 2.25 0 0 0-2.254-2.258m-5.006 12.011 9.998-.003a.75.75 0 0 0 0-1.5l-10 .003A2.25 2.25 0 0 1 8 15.249H6.5a3.75 3.75 0 0 0 3.752 3.749",clipRule:"evenodd"}),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M20.78 17.715a.75.75 0 0 1 0 1.06l-1.997 1.997a.75.75 0 1 1-1.06-1.06l1.997-1.997a.75.75 0 0 1 1.06 0",clipRule:"evenodd"}),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M17.723 15.717a.75.75 0 0 1 1.06 0l1.997 1.998a.75.75 0 1 1-1.06 1.06l-1.997-1.998a.75.75 0 0 1 0-1.06M7.31 5.188A1.5 1.5 0 1 0 5.188 7.31 1.5 1.5 0 0 0 7.31 5.188m1.06-1.06A3 3 0 1 0 4.13 8.37a3 3 0 0 0 4.24-4.24",clipRule:"evenodd"}))),null),label:"Rutas de aprendizaje personalizadas por empleado y por equipos"},{icon:react.createElement((n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M17 9.5a.705.705 0 0 1 0 .998l-4 4.001a.705.705 0 0 1-1.013-.016L10 12.363l-1.987 2.12a.705.705 0 0 1-1.028-.964l2.5-2.668a.705.705 0 0 1 1.03 0l2.003 2.136 3.486-3.486a.705.705 0 0 1 .997 0",clipRule:"evenodd"}),react.createElement("path",{fill:"#C4C8CE",fillRule:"evenodd",d:"M2.246 7.996a5.75 5.75 0 0 1 5.75-5.75h8.008a5.75 5.75 0 0 1 5.75 5.75v8.008a5.75 5.75 0 0 1-5.75 5.75H7.996a5.75 5.75 0 0 1-5.75-5.75zm5.75-4.25a4.25 4.25 0 0 0-4.25 4.25v8.008a4.25 4.25 0 0 0 4.25 4.25h8.008a4.25 4.25 0 0 0 4.25-4.25V7.996a4.25 4.25 0 0 0-4.25-4.25z",clipRule:"evenodd"}))),null),label:"Panel de administración para medir el progreso de tus empleados"},{icon:react.createElement((n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 26 26",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M18.5 6.08h-11c-1.14 0-2.062.923-2.062 2.062v9.67c0 1.14.923 2.063 2.062 2.063h11c1.14 0 2.063-.923 2.063-2.062V8.142c0-1.14-.924-2.063-2.063-2.063m-11-1.376h11a3.437 3.437 0 0 1 3.438 3.438v9.67A3.437 3.437 0 0 1 18.5 21.25h-11a3.437 3.437 0 0 1-3.437-3.437V8.142A3.44 3.44 0 0 1 7.5 4.704m4.813 8.754c0-.38.307-.687.687-.687h5.042a.687.687 0 1 1 0 1.375H13a.687.687 0 0 1-.687-.688m-5.042 0c0-.38.308-.687.687-.687h2.292a.687.687 0 1 1 0 1.375H7.958a.69.69 0 0 1-.687-.688m7.792 3.209c0-.38.307-.688.687-.688h2.292a.688.688 0 0 1 0 1.375H15.75a.687.687 0 0 1-.687-.687m-7.792 0c0-.38.308-.688.687-.688H13a.687.687 0 1 1 0 1.375H7.958a.687.687 0 0 1-.687-.687",clipRule:"evenodd"}))),null),label:"Certificados con el logo de tu empresa"},{icon:react.createElement((n=>react.createElement("svg",Object.assign({width:"1em",height:"1em",fill:"none",viewBox:"0 0 26 26",xmlns:"http://www.w3.org/2000/svg"},n),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M11.68 10.895v4.209L15.237 13zm.7-1.184a1.375 1.375 0 0 0-2.076 1.184v4.209a1.375 1.375 0 0 0 2.075 1.184l3.558-2.105c.9-.532.9-1.835 0-2.367z",clipRule:"evenodd"}),react.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M7.5 5.438c-1.14 0-2.062.923-2.062 2.062v11c0 1.14.923 2.063 2.062 2.063h11c1.14 0 2.063-.924 2.063-2.063v-11c0-1.14-.924-2.062-2.063-2.062zM4.063 7.5A3.437 3.437 0 0 1 7.5 4.063h11A3.437 3.437 0 0 1 21.938 7.5v11a3.437 3.437 0 0 1-3.438 3.438h-11A3.437 3.437 0 0 1 4.063 18.5z",clipRule:"evenodd"}))),null),label:"Acceso a todos los cursos, clases en vivo, eventos y actividades de la comunidad"}],es_ut=({fullDeviceWidth:e=!0})=>{const t=dist_es_b(es_ct,{[es_dt]:e});return react.createElement("div",{className:t,"data-class":"b2bBenefits"},react.createElement("p",{className:es_it},react.createElement("span",null,"Adquiere los "),react.createElement("strong",null,"meses de acceso"),react.createElement("span",null," que necesitas y "),react.createElement("strong",null,"asígnalos"),react.createElement("span",null," como prefieras.")),react.createElement("ul",null,es_mt.map((e=>react.createElement(es_st,{key:e.label,label:e.label,icon:e.icon})))))};var es_pt={B2BPlansContainer:"B2BPlans-module_B2BPlansContainer__zN-aA",B2BPlans:"B2BPlans-module_B2BPlans__7K0hT","B2BPlans--fullDeviceWidth":"B2BPlans-module_B2BPlans--fullDeviceWidth__CjHEj",B2BPlans__form:"B2BPlans-module_B2BPlans__form__5VtVX","B2BPlans__form--steps":"B2BPlans-module_B2BPlans__form--steps__wwI40",InputContainer:"B2BPlans-module_InputContainer__Dckep",ErrorMsg:"B2BPlans-module_ErrorMsg__Xdm8W",AlertMsg:"B2BPlans-module_AlertMsg__BznXb",InfoMsg:"B2BPlans-module_InfoMsg__p-ZBU",PhoneInput:"B2BPlans-module_PhoneInput__JWxiQ"};const es_ft=({children:e,hasError:t,formHasError:a})=>t&&a?react.createElement("p",{className:es_pt.ErrorMsg},react.createElement(dist_es_I,null),e):null,es_Pt=({children:e,hasError:t,formHasError:a})=>t&&a?react.createElement("p",{className:es_pt.AlertMsg},react.createElement(dist_es_I,null),e):null,es_ht=({children:e,hasError:t,formHasError:a})=>t&&a?react.createElement("p",{className:es_pt.InfoMsg},react.createElement(dist_es_I,null),e):null,es_vt=["gmail","hotmail","yahoo","outlook"];var es_Et;!function(e){e.EMPTY="empty",e.LOADING="loading",e.ERROR="error",e.SUBMIT_ERROR="submitError"}(es_Et||(es_Et={}));const es_bt=e=>{"."!==e.key&&","!==e.key||e.preventDefault()},es_gt=({type:e="text",value:t,onChange:a,placeholder:l,status:_,valueHasError:o,pattern:r,errorMsg:s="Este campo es obligatorio"})=>react.createElement("div",{className:es_pt.InputContainer},react.createElement("input",{id:l,step:"number"===e?1:void 0,type:e,value:`${t}`,onChange:e=>a(e.target.value),onKeyDown:"number"===e?es_bt:void 0,pattern:r,disabled:_===es_Et.LOADING}),react.createElement("label",{htmlFor:l},l),react.createElement(es_ft,{formHasError:_===es_Et.ERROR,hasError:o},s)),es_yt=({value:e,onChange:t,placeholder:a,status:l,valueHasError:_,errorMsg:o="Este campo es obligatorio",options:r})=>react.createElement("div",{className:es_pt.InputContainer},react.createElement("select",{value:`${e}`,onChange:e=>t(e.target.value),disabled:l===es_Et.LOADING,id:a},react.createElement("option",{key:`${a}-0`,value:""}," "),r.map((e=>react.createElement("option",{key:e,value:e},e)))),react.createElement("label",{htmlFor:a,className:`${e}`.length?"notEmpty":""},a),react.createElement(dist_es_N,{className:"input-chevron"}),react.createElement(es_ft,{formHasError:l===es_Et.ERROR,hasError:_},o)),es_Bt=({status:e,areaCodes:t,phone:a,phoneHasError:l,onChangePhoneAreaCode:_,onChangePhoneNumber:o})=>{const r=!a.areaCode.value.length||!t.length;return react.createElement("div",{className:es_pt.PhoneInput},a.areaCode.flag.length>0&&react.createElement("img",{src:a.areaCode.flag,alt:a.areaCode.label}),a.areaCode.value.length>0&&react.createElement("span",null,a.areaCode.value),react.createElement(dist_es_N,null),react.createElement("select",{value:a.areaCode.value,onChange:_,disabled:r},t.map((e=>react.createElement("option",{key:e.value,value:e.value},e.label," (",e.value,")")))),react.createElement(es_gt,{type:"number",placeholder:"Tu número de teléfono",status:e,value:a.number,onChange:o,valueHasError:l,errorMsg:"Este campo debe tener al menos 7 dígitos"}))},es_Ct=({status:e,companyName:t,name:a,email:l,position:_,areaCodes:o,phone:r,errorMessages:s,onChangeFormState:c,onChangePhoneNumber:i,onChangePhoneAreaCode:d})=>react.createElement(react.Fragment,null,react.createElement(es_gt,{placeholder:"Nombre de tu empresa",status:e,value:t,onChange:c("companyName"),valueHasError:"companyName"===s}),react.createElement(es_gt,{placeholder:"Tu nombre",status:e,value:a,onChange:c("name"),valueHasError:"name"===s}),react.createElement(es_gt,{type:"email",placeholder:"Tu email corporativo",status:e,value:l,pattern:".+@.+\\..+",onChange:c("email"),valueHasError:"email"===s,errorMsg:"Ingresa un correo corporativo válido"}),react.createElement(es_yt,{placeholder:"Nivel de tu cargo",value:_,onChange:c("position"),status:e,valueHasError:"position"===s,options:["C-Level","Vicepresidente","Director","Gerente","Cargo no gerencial"]}),react.createElement(es_Bt,{status:e,areaCodes:o,phone:r,phoneHasError:"phone"===s,onChangePhoneNumber:i,onChangePhoneAreaCode:d}),react.createElement(es_ft,{formHasError:"submitError"===e,hasError:!0},"Hubo un error, intenta de nuevo"),react.createElement("button",{type:"submit",disabled:"loading"===e},"loading"===e?"Cargando...":"Continuar")),es_Nt="¿Qué necesita aprender tu empresa? (Opcional)",es_wt=({status:e,companyName:t,employees:a,learningNeeds:l,errorMessages:_,onChangeFormState:o,handleChangeToB2C:r,onlyShowB2B:s,openB2CDisclaimerWithLink:c})=>{const i=a>1,d=a<=1||"loading"===e;return react.createElement(react.Fragment,null,react.createElement("span",null,react.createElement("small",null,"Empresa:"),react.createElement("h2",null,t)),react.createElement(es_gt,{type:"number",placeholder:"Número de empleados en tu empresa",status:e,value:0===a?"":a,onChange:o("employees"),valueHasError:"employees"===_}),react.createElement(es_ht,{formHasError:!i,hasError:!0},react.createElement("span",null,"Elige un plan de",react.createElement("a",{href:"#",onClick:e=>(e.preventDefault(),s||c?window.open("/precios","_blank"):r())},"Personas"),"para 1 empleado")),react.createElement("div",{className:es_pt.InputContainer},react.createElement("textarea",{id:es_Nt,value:l,onChange:e=>o("learningNeeds")(e.target.value),disabled:e===es_Et.LOADING}),react.createElement("label",{htmlFor:es_Nt},es_Nt)),react.createElement(es_ft,{formHasError:"submitError"===e,hasError:!0},"Hubo un error, intenta de nuevo"),react.createElement("button",{type:"submit",disabled:d},"loading"===e?"Calculando...":"Obtener precio"))},es_Rt=(e,n)=>{const t=e<=1;let a=!1,l=null;if(t)a=!0;else{const t=(e=>Math.ceil(16/e))(e);n<t&&(a=!0,l=`El mínimo para ${e} empleados son ${t} meses.`)}return{isDisabledBuyCta:a,isOnlyOneEmployee:t,disclaimer:l}};var es_Tt="B2BInvoice-module_B2BInvoice__zmpUV",es_St="B2BInvoice-module_B2BInvoice__AlertMsg__OMjGi",es_At="B2BInvoice-module_B2BInvoice--withCourses__aK5Oc",es_Ot="B2BInvoice-module_B2BInvoice__values__K-qfE",es_It="B2BInvoice-module_B2BInvoice__header__02VLm",es_Mt="B2BInvoice-module_B2BInvoice__calculator__e5Mm3",es_Lt="B2BInvoice-module_B2BInvoice__calculator__desc__BSgTm",es_xt="B2BInvoice-module_B2BInvoice__calculatorValues__5ymZ3",es_kt="B2BInvoice-module_B2BInvoice__calculatorValuesDivider__zWUpP",es_jt="B2BInvoice-module_B2BInvoice__calculatorValue__YYslY",es_Ut="B2BInvoice-module_B2BInvoice__calculatorValueContainer__QI9uZ",es_$t="B2BInvoice-module_B2BInvoice__calculatorValueBtn__CKngT",es_Dt="B2BInvoice-module_B2BInvoice__calculatorResult__Pwnb5",es_Ht="B2BInvoice-module_B2BInvoice__calculatorResultItem__rZ1s4",es_zt="B2BInvoice-module_B2BInvoice__calculatorAlert__dpy2R",es_Ft="B2BInvoice-module_B2BInvoice__lp__-6CSg",es_Yt="B2BInvoice-module_B2BInvoice__buyCTA__McfeK";const es_Vt=({name:e,companyName:a,email:_,phone:o,employees:r,months:s,lpCourses:i,currency:{currency:d,price:u,max_amount:p,flag:P,price_tier_one:h,change_tier:v,min_months:E},onChangeFormState:y,manuallyChangeMonthsState:B,handleChangeToB2C:N,onlyShowB2B:R,openB2CDisclaimerWithLink:T})=>{const[S,A]=(0,react.useState)({}),O=S[`${r}x${s}`]||void 0,{isDisabledBuyCta:I,isOnlyOneEmployee:M,disclaimer:L}=es_Rt(r,s),x=void 0===O,k="LOADING"===O,j=O?.startsWith("http"),U=!x&&!k&&!j,$=Math.max(1,Math.trunc(r)*Math.trunc(s));let D=Math.max(h,$*h);$>v&&(D=Math.max(u,$*u));const H=`es-${d.slice(0,d.length-1)}`,z=new Intl.NumberFormat(H,{style:"currency",maximumFractionDigits:0,currency:d}).format(D),F=D<=p&&$>=E,Y=0===i.length,V=dist_es_b(es_Tt,{[es_At]:!Y});return react.createElement("div",{className:V,"data-class":"B2BInvoice"},react.createElement("div",{className:es_Ot},react.createElement("div",{className:es_It},react.createElement(dist_es_g,null)),react.createElement("div",{className:es_Mt},react.createElement("h4",null,a),react.createElement("p",{className:es_Lt},"Esta propuesta estima el precio total de acceso a todo Platzi para tus ",r," empleados durante"," ",s," meses. Los meses de acceso por empleado pueden ser modificados de acuerdo a tus necesidades."),react.createElement("div",{className:es_xt},react.createElement("label",{htmlFor:"proposalEmployees"},react.createElement("span",null,"Empleados"),react.createElement("input",{className:es_jt,id:"proposalEmployees",type:"number",value:r,onChange:e=>y("employees")(e.target.value),onKeyDown:es_bt,disabled:k})),react.createElement("div",{className:es_kt}),react.createElement("label",{htmlFor:"proposalMonths"},react.createElement("span",null,"Meses ",react.createElement("small",null,"Por empleado")),react.createElement("div",{className:es_Ut,"data-class":"B2BInvoice__calculatorValueContainer"},react.createElement("button",{type:"button",className:es_$t,onClick:()=>{B(Math.max(1,Number(s)-1))},disabled:k},"-"),react.createElement("input",{className:es_jt,id:"proposalMonths",type:"number",value:s,onChange:e=>y("months")(e.target.value),onKeyDown:es_bt,min:1,max:99,disabled:k}),react.createElement("button",{type:"button",className:es_$t,onClick:()=>{B(Math.max(1,Number(s)+1))},disabled:k},"+")))),react.createElement("span",{className:es_St},react.createElement(es_Pt,{formHasError:M,hasError:!0},react.createElement("span",null,"Elige un plan de",react.createElement("a",{href:"#",onClick:e=>(e.preventDefault(),R||T?window.open("/precios","_blank"):N())},"Personas"),"para 1 empleado"))),react.createElement("span",{className:es_St},react.createElement(es_Pt,{formHasError:!!L,hasError:!0},L)),F&&react.createElement("div",{className:es_Dt},react.createElement("div",{className:es_Ht},react.createElement("span",null,$),react.createElement("small",null,"Meses de acceso")),react.createElement("div",{className:es_Ht},react.createElement("span",null,z),react.createElement("img",{src:P,alt:d}),react.createElement("small",null,d))),F&&react.createElement(es_Oe,{variant:"primary",onClick:async()=>{if(!k&&!U)if(j){const e=window.location.search.includes("qa=true")?"_self":"_blank";window.open(O,e)}else if(F){if(x){A((e=>({...e,[`${r}x${s}`]:"LOADING"})));const n=await async function(e){const n=await fetch(es_Ln.SELF_CHECKOUT(es_kn.getBasePath()),{method:"POST",headers:{...es_xn(),"Content-Type":"application/json"},body:JSON.stringify(e)}),{data:t}=await n.json();return t?.url?t.url:"ERROR"}({email:_,name:e,company_name:a,currency:d,employees:r,months:`${s}`});A((e=>({...e,[`${r}x${s}`]:n})));const t={event:es_ue,view:"/"===window.location.pathname?"public_home":"other",step:"comprar"};if(index_754db556_a.send(t),n.startsWith("http")){const e=window.location.search.includes("qa=true")?"_self":"_blank";window.open(n,e)}}}else A((e=>({...e,[`${r}x${s}`]:"TEXT"})))},disabled:k||I,className:es_Yt,size:"lg"},k?react.createElement(es_qe,null):"Comprar"),!F&&react.createElement("div",{className:es_zt},react.createElement(dist_es_C,null),react.createElement("p",null,"Gracias por tu interés. Te contactaremos al correo ",react.createElement("b",null,_)," o al teléfono ",react.createElement("b",null,o)," para más información.")))),!Y&&react.createElement("div",{className:es_Ft},react.createElement("h4",null,"Plan de formación sugerido:"),i.map((e=>react.createElement(react.Fragment,{key:e.title},react.createElement("p",null,e.title),react.createElement("ul",null,e.content.map((e=>react.createElement("li",{key:e.id},react.createElement("a",{href:e.url,target:"_blank",rel:"noopener noreferrer"},react.createElement("img",{src:e.badge_url,alt:`curso de ${e.title}`}),react.createElement("span",null,e.title),react.createElement(dist_es_w,null)))))))))))},es_qt=({b2bStep:e,setB2BStep:l,formState:o,setFormState:r,withinModal:s,handleChangeToB2C:i,onlyShowB2B:d,openB2CDisclaimerWithLink:m})=>{const[u,p]=(0,react.useState)(es_Et.EMPTY),{companyName:f,name:P,email:h,position:v,areaCodes:E,phone:g,employees:y,learningNeeds:B,lpCourses:C,months:N}=o,w=(e=>e.companyName.length?e.name.length?!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(e.email)||es_vt.some((n=>e.email.toLowerCase().includes(n)))?"email":e.position.length?!e.phone.areaCode.value.length||!e.phone.number.length||e.phone.number.length<7?"phone":e.employees<1||`${e.employees}`.includes(".")?"employees":"":"position":"name":"companyName")(o),R=e=>n=>"employees"===e&&Number(n)<=0&&""!==n||"months"===e&&Number(n)<=0&&""!==n?null:r((t=>({...t,[e]:n}))),T=async()=>{if("employees"!==w)p(es_Et.ERROR);else try{p(es_Et.LOADING),await async function(e){try{const{token:n}=await es_jn(),t={...e,num_employees:es_Kn(0),step:1};await fetch(es_Ln.CRM_CREATE_LEAD(es_kn.getApiUrl()),{method:"POST",headers:{...es_xn(),"Content-Type":"application/json","Api-Authorization":`Bearer ${n}`},body:JSON.stringify(t)});const a=await fetch(es_Ln.SELF_CHECKOUT_VALIDATION(es_kn.getBasePath()),{method:"POST",headers:{...es_xn(),"Content-Type":"application/json"},body:JSON.stringify({email:e.email})}),{data:l}=await a.json();return{companyIsNew:l.can_buy}}catch(e){throw console.error("Error creating lead:",e),e}}({company_name:f,full_name:P,email:h,job_title:v,phone:`${g.areaCode.value}${g.number}`}),l(2),p(es_Et.EMPTY);const e={event:es_ue,view:"/"===window.location.pathname?"public_home":"other",step:"step1"};index_754db556_a.send(e)}catch(e){p(es_Et.SUBMIT_ERROR)}},S=(0,react.useRef)(!1);(0,react.useEffect)((()=>{o.phone.areaCode.value.length||(async()=>{if(!S.current){S.current=!0;try{await es_jn();const[e,n]=await Promise.all([es_Xn(),es_Gn()]);r((t=>({...t,areaCodes:e,phone:{...t.phone,areaCode:n}})))}catch(e){console.error("Error fetching area codes:",e)}}})()}),[]);const A=dist_es_b(es_pt.B2BPlans,{[es_pt["B2BPlans--fullDeviceWidth"]]:!s}),O=dist_es_b(es_pt.B2BPlans__form,{[es_pt["B2BPlans__form--steps"]]:e<3,[es_pt["B2BPlans__form--invoice"]]:3===e}),I=3!==e;return react.createElement("div",{className:es_pt.B2BPlansContainer},react.createElement("div",{className:A,id:"b2bPlans"},react.createElement(es_ot,{b2bStep:e,fullDeviceWidth:!s}),I&&react.createElement(es_ut,{fullDeviceWidth:!s}),react.createElement("form",{className:O,onSubmit:n=>{n.preventDefault(),1===e&&T(),2===e&&(async()=>{if("employees"===w)p(es_Et.ERROR);else try{p(es_Et.LOADING);const[e,n,t]=await Promise.all([async function({email:e,num_employees:n,learning_needs_prompt:t}){try{const{token:a}=await es_jn(),l={num_employees:es_Kn(n),num_employees_raw:Number(n),learning_needs_prompt:t,step:2},_=await fetch(es_Ln.CRM_UPDATE_LEAD(es_kn.getApiUrl(),e),{method:"PATCH",headers:{...es_xn(),"Content-Type":"application/json","Api-Authorization":`Bearer ${a}`},body:JSON.stringify(l)});return await _.json()}catch(e){throw console.error("Error updating crm data:",e),e}}({email:h,num_employees:y,learning_needs_prompt:B}),async function({query:e}){try{const n={humanInput:{message:e.length>0?e:"inteligencia artificial para empresas, seguridad informática para empresas, inglés"},source:"public_home"},t=await fetch(es_Ln.LP_MAKER(es_kn.getApiUrl()),{method:"POST",headers:{...es_xn(),"Content-Type":"application/json"},body:JSON.stringify(n)});return(await t.json()).data.recommendations_content}catch(e){throw console.error("Error fetching LP Maker data:",e),e}}({query:B}),es_Zn()]),a=(e=>{let n=3;return e>=2&&e<4?n=6:e>=4&&e<10&&(n=4),n})(y);r((e=>({...e,lpCourses:n,currency:t,months:a}))),l(3),p(es_Et.EMPTY);const _={event:es_ue,view:"/"===window.location.pathname?"public_home":"other",step:"step2"};index_754db556_a.send(_)}catch(e){p(es_Et.SUBMIT_ERROR)}})()},"data-class":"b2bForm"},1===e&&react.createElement(es_Ct,{status:u,companyName:f,name:P,email:h,position:v,areaCodes:E,phone:g,errorMessages:w,onChangeFormState:R,onChangePhoneNumber:e=>{r((n=>({...n,phone:{...n.phone,number:e}})))},onChangePhoneAreaCode:e=>{r((n=>{const t=E.find((n=>n.value===e.target.value))||es_Jn.phone.areaCode;return{...n,phone:{...n.phone,areaCode:t}}}))}}),2===e&&react.createElement(es_wt,{status:u,companyName:f,employees:y,learningNeeds:B,errorMessages:w,onChangeFormState:R,handleChangeToB2C:i,onlyShowB2B:d,openB2CDisclaimerWithLink:m}),3!==e&&react.createElement("p",null,"Al enviar el formulario, aceptas los"," ",react.createElement("a",{href:"https://platzi.com/terminos/",target:"_blank",rel:"noopener noreferrer"},"Términos de servicio")," ","y"," ",react.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:"https://platzi.com/privacidad/"},"Políticas de privacidad")," ","de Platzi.")),3===e&&react.createElement(es_Vt,{name:P,companyName:f,email:h,phone:g.areaCode.value+g.number,months:N,employees:y,lpCourses:C,currency:o.currency,onChangeFormState:R,manuallyChangeMonthsState:e=>{if(e>0&&e<99){const n=Math.trunc(e);r((e=>({...e,months:n})))}},handleChangeToB2C:i,onlyShowB2B:d,openB2CDisclaimerWithLink:m})))};var es_Wt="Toggle-module_Toggle__ooONp",es_Xt="Toggle-module_Toggle_label__-8Ce-",es_Gt="Toggle-module_Toggle_label__active__HumJ5";const es_Kt="b2c",es_Zt="b2b",es_Jt=({checked:e=es_Kt,onChange:t,withB2BTab:a,onlyShowB2B:l})=>{const _=dist_es_b(es_Xt,{[es_Gt]:e===es_Kt}),o=dist_es_b(es_Xt,{[es_Gt]:e===es_Zt});return!a||l?null:react.createElement("div",{className:es_Wt},react.createElement("label",{className:_,htmlFor:`${es_Kt}PlansToggle`},"Personas"," ",react.createElement("input",{type:"radio",id:`${es_Kt}PlansToggle`,name:"toggle",value:es_Kt,checked:e===es_Kt,onChange:()=>{window.location.hash.includes("b2bPlan")&&window.history.replaceState({},document.title,window.location.href.split("#")[0]),t(es_Kt)}})),react.createElement("label",{className:o,htmlFor:`${es_Zt}PlansToggle`},"Empresas"," ",react.createElement("input",{type:"radio",id:`${es_Zt}PlansToggle`,name:"toggle",value:es_Zt,checked:e===es_Zt,onChange:()=>{t(es_Zt)}})))};var es_Qt="Messages-module_Messages__title__SV-SP",es_ea="Messages-module_Messages__subtitle__zPbhw";const es_na=e=>{const{title:t,subtitle:a,disclaimer:l,showDisclaimer:_=!1}=e;return react.createElement(react.Fragment,null,t&&react.createElement("h2",{"data-class":"PlansTable__title",className:es_Qt},t),a&&react.createElement("p",{className:es_ea,"data-trans":"paywalls_modal_subtitle","data-class":"paywalls_modal_subtitle"},a))},es_ta=e=>{const{b2bTitle:t}=e;return react.createElement(react.Fragment,null,t&&react.createElement("h2",{"data-class":"PlansTable__title",className:es_Qt},t))};var es_aa="PlansTable-module_PlansTable__sVr9U",es_la="PlansTable-module_PlansTable__disclaimer--undertable__TdTmz",dist_es_a="PlansTable-module_PlansTable__BenefitsTable__XMQzh";const es_oa=e=>{const{plans:a,messages:l,b2bText:o,showB2BLink:r,showDisclaimer:s,showBanner:c,onClickPlan:i,withB2BTab:d,withinModal:m,onlyShowB2B:u=!1,openB2CDisclaimerWithLink:p=!1,promoBanner:f}=e,P=f&&f?.active,[h,v]=(0,react.useState)((()=>{if("undefined"!=typeof window){return window.location.hash.includes("b2bPlan")||u?"b2b":"b2c"}return"b2c"})),[E,b]=(0,react.useState)(1),[g,y]=(0,react.useState)(es_Jn),B=e=>{const{hash:n}=new URL(e.newURL);n.includes("b2bPlan")&&v("b2b")};(0,react.useEffect)((()=>{"undefined"!=typeof window&&window.addEventListener("hashchange",B)}),[]);const C="b2c"===h,N="b2b"===h;return react.createElement("section",{className:es_aa},C&&react.createElement(es_na,{title:l?.title,subtitle:l?.subtitle,disclaimer:l?.disclaimer,showDisclaimer:s}),N&&react.createElement(es_ta,{b2bTitle:l?.b2bTitle}),react.createElement(es_Jt,{checked:h,onChange:v,withB2BTab:d,onlyShowB2B:u}),C&&!u&&react.createElement(react.Fragment,null,P&&c&&react.createElement(es_Vn,{...f}),react.createElement("div",{className:dist_es_a,"data-class":"PlansTable__BenefitsTable"},react.createElement(es_Fn,{plans:a})),react.createElement(dist_es_Re,{plans:a,b2bLinkText:o,showB2BLink:r,onClickPlan:i})),N&&react.createElement(es_qt,{b2bStep:E,setB2BStep:b,formState:g,setFormState:y,withinModal:m,handleChangeToB2C:()=>{v("b2c")},onlyShowB2B:u,openB2CDisclaimerWithLink:p}),s&&l?.disclaimer&&react.createElement("p",{className:`${es_la}`,"data-class":"PlansTable__disclaimer--undertable"},l?.disclaimer))};
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 3303:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 8253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _e; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.whatsapp-button/node_modules/@platzi/commons/dist/es/index-754db556.js
var a={send:function(a){"undefined"!=typeof window&&window.dataLayer&&window.dataLayer.push(a)}};

;// CONCATENATED MODULE: ./node_modules/@platzi/micro-ui.whatsapp-button/dist/es/index.js
var o="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},es_a={},i={};Object.defineProperty(i,"__esModule",{value:!0});var l,u,_,c={};Object.defineProperty(c,"__esModule",{value:!0}),c.VARIANTS=c.SIZES=c.COLORS=void 0,function(e){e.PLATZI="platzi",e.SKY="sky",e.ERROR="error",e.ADMIN="admin"}(l||(c.COLORS=l={})),function(e){e.LARGE="large",e.MEDIUM="medium",e.SMALL="small"}(u||(c.SIZES=u={})),function(e){e.PRIMARY="primary",e.SECONDARY="secondary",e.TERTIARY="tertiary"}(_||(c.VARIANTS=_={}));var d,s,p,f,O={},b={};Object.defineProperty(b,"__esModule",{value:!0}),b.PLATZI_B2B_COMPANY_PLANS=b.PLATZI_PLANS_MAP_NAMES=b.PLATZI_PLANS_NAMES=b.PLATZI_USER_TYPE=b.PLATZI_PLANS=void 0,function(e){e.BASIC="monthly_plan",e.EXPERT="expert_plan",e.EXPERT_DUO="annual_plan",e.ACADEMY="platzi_academy",e.FAMILY="family_plan",e.FREE="free_plan",e.ENTERPRISE="enterprise"}(d||(b.PLATZI_PLANS=d={})),function(e){e.FREE="free",e.PAY_ONE="pay_one",e.ONE_PAYMENT="one_payment",e.PAY_ANNUAL="pay_annual",e.EXPERT_ANNUAL="expert_annual",e.COURSE_ONLY="course_only",e.MONTHLY_SUBSCRIPTION="monthly_subscription",e.MONTHLY_SUBSCRIPTION_TERM="monthly_subscription_term",e.ANNUAL_SUBSCRIPTION="annual_subscription",e.EXPERT_SUBSCRIPTION="expert_subscription",e.ENGLISH_ACADEMY_SUBSCRIPTION="english_academy_subscription",e.ENGLISH_ACADEMY_ANNUAL="english_academy_annual",e.MANUAL_MENSUAL_SUBSCRIPTION="manual_mensual_subscription",e.UNSUBSCRIBED="unsubscribed",e.UNSUBSCRIBED_MANUAL="unsubscribed_manual",e.PAUSED="paused",e.PENDING_UNSUBSCRIPTION="pending_unsubscription",e.ALLIANCE="alliance",e.BLOCKED="blocked",e.ESSENTIAL="essential",e.TEAM="team",e.STARTUP="startup",e.BUSINESS="business",e.ENTERPRISE="enterprise",e.TEAM_MONTH="team-month",e.BUSINESS_MONTH="business-month",e.ENTERPRISE_MONTH="enterprise-month"}(s||(b.PLATZI_USER_TYPE=s={})),function(e){e.EXPERT="Platzi Expert",e.EXPERT_PLUS="Platzi Expert+",e.B2B="Plan Empresarial",e.ACADEMY="Platzi English Academy"}(p||(b.PLATZI_PLANS_NAMES=p={})),b.PLATZI_PLANS_MAP_NAMES={[d.EXPERT]:p.EXPERT},function(e){e.FLEXIBLE="Flexible"}(f||(b.PLATZI_B2B_COMPANY_PLANS=f={}));var P,v={};Object.defineProperty(v,"__esModule",{value:!0}),v.BUSINESS_MODEL=void 0,function(e){e.B2C="user",e.B2B="b2b"}(P||(v.BUSINESS_MODEL=P={}));var E,y={};Object.defineProperty(y,"__esModule",{value:!0}),y.PLATZI_USER_ROLE=void 0,function(e){e.BETA_TESTER="beta-tester",e.COMPANY_ADMIN="company_admin",e.ORGANIZER="organizer",e.STUDENT="student",e.TEACHER="teacher",e.ANONYMOUS="anonymous",e.READ_ONLY="read-only"}(E||(y.PLATZI_USER_ROLE=E={}));var M,A,S,N={};Object.defineProperty(N,"__esModule",{value:!0}),M=O,A=o&&o.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),S=o&&o.__exportStar||function(e,t){for(var r in e)"default"===r||Object.prototype.hasOwnProperty.call(t,r)||A(t,e,r)},Object.defineProperty(M,"__esModule",{value:!0}),S(b,M),S(v,M),S(y,M),S(N,M);var T={},m={};Object.defineProperty(m,"__esModule",{value:!0}),function(e){var t=o&&o.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),r=o&&o.__exportStar||function(e,r){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(r,n)||t(r,e,n)};Object.defineProperty(e,"__esModule",{value:!0}),r(m,e)}(T);var j={};Object.defineProperty(j,"__esModule",{value:!0});var I={},g={};Object.defineProperty(g,"__esModule",{value:!0});var R={};Object.defineProperty(R,"__esModule",{value:!0});var h={};Object.defineProperty(h,"__esModule",{value:!0});var L={};Object.defineProperty(L,"__esModule",{value:!0});var B={},C={};Object.defineProperty(C,"__esModule",{value:!0});var U={};Object.defineProperty(U,"__esModule",{value:!0});var w={};Object.defineProperty(w,"__esModule",{value:!0});var x={};Object.defineProperty(x,"__esModule",{value:!0});var D={};Object.defineProperty(D,"__esModule",{value:!0});var Y={};Object.defineProperty(Y,"__esModule",{value:!0});var Z={};Object.defineProperty(Z,"__esModule",{value:!0});var H={};Object.defineProperty(H,"__esModule",{value:!0});var W={};Object.defineProperty(W,"__esModule",{value:!0}),function(e){var t=o&&o.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),r=o&&o.__exportStar||function(e,r){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(r,n)||t(r,e,n)};Object.defineProperty(e,"__esModule",{value:!0}),r(C,e),r(U,e),r(w,e),r(x,e),r(D,e),r(Y,e),r(Z,e),r(H,e),r(W,e)}(B);var z,X={};Object.defineProperty(X,"__esModule",{value:!0}),X.CHAT_ACTIONS=void 0,function(e){e.SHOW_LEARNING_PATH="show_learning_path"}(z||(X.CHAT_ACTIONS=z={}));var k={},F={};Object.defineProperty(F,"__esModule",{value:!0});var G={};Object.defineProperty(G,"__esModule",{value:!0});var J={};Object.defineProperty(J,"__esModule",{value:!0});var K={};Object.defineProperty(K,"__esModule",{value:!0});var V={};Object.defineProperty(V,"__esModule",{value:!0});var q={};Object.defineProperty(q,"__esModule",{value:!0});var $={};Object.defineProperty($,"__esModule",{value:!0});var Q={};Object.defineProperty(Q,"__esModule",{value:!0}),function(e){var t=o&&o.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),r=o&&o.__exportStar||function(e,r){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(r,n)||t(r,e,n)};Object.defineProperty(e,"__esModule",{value:!0}),r(F,e),r(G,e),r(J,e),r(K,e),r(V,e),r(q,e),r($,e),r(Q,e)}(k);var ee={};Object.defineProperty(ee,"__esModule",{value:!0}),function(e){var t=o&&o.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),r=o&&o.__exportStar||function(e,r){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(r,n)||t(r,e,n)};Object.defineProperty(e,"__esModule",{value:!0}),r(g,e),r(R,e),r(h,e),r(L,e),r(B,e),r(X,e),r(k,e),r(ee,e)}(I);var te={},re={};Object.defineProperty(re,"__esModule",{value:!0}),function(e){var t=o&&o.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),r=o&&o.__exportStar||function(e,r){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(r,n)||t(r,e,n)};Object.defineProperty(e,"__esModule",{value:!0}),r(re,e)}(te);var ne={};Object.defineProperty(ne,"__esModule",{value:!0});var oe,ae,ie={};Object.defineProperty(ie,"__esModule",{value:!0}),ie.COMMENT_OBJECT_TYPE=ie.COMMENT_RELATION=void 0,function(e){e.DISCUSSION="discussion",e.CONTRIBUTION="contribution",e.MATERIAL="material"}(oe||(ie.COMMENT_RELATION=oe={})),function(e){e.DISCUSSION="discussion",e.COMMENT="comment",e.MATERIAL="material"}(ae||(ie.COMMENT_OBJECT_TYPE=ae={})),function(e){var t=o&&o.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),r=o&&o.__exportStar||function(e,r){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(r,n)||t(r,e,n)};Object.defineProperty(e,"__esModule",{value:!0}),r(i,e),r(c,e),r(O,e),r(T,e),r(j,e),r(I,e),r(te,e),r(ne,e),r(ie,e)}(es_a);const le=t=>react.createElement("svg",Object.assign({width:"1em",height:"1em","aria-hidden":"true","data-icon":"whatsapp","data-prefix":"fab",viewBox:"0 0 448 512",xmlns:"http://www.w3.org/2000/svg"},t),react.createElement("path",{fill:"currentColor",d:"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157m-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6m101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6"}));var ue="WhatsappButton-module_WhatsappButton__c-l7g";!function(e,t){void 0===t&&(t={});var r=t.insertAt;if(e&&"undefined"!=typeof document){var n=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style");o.type="text/css","top"===r&&n.firstChild?n.insertBefore(o,n.firstChild):n.appendChild(o),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(document.createTextNode(e))}}(".WhatsappButton-module_WhatsappButton__c-l7g{align-items:center;background-color:#25d366;border-radius:100%;bottom:2rem;box-shadow:0 0 24px 0 rgba(37,211,102,.5);cursor:pointer;display:flex;height:56px;justify-content:center;position:fixed;right:2rem;transition:background-color .3s;width:56px;z-index:999}.WhatsappButton-module_WhatsappButton__c-l7g svg{font-size:1.7rem}.WhatsappButton-module_WhatsappButton__c-l7g svg path{fill:#fff}");const _e=({user:e=null})=>{const o=null===e||e.userType===es_a.PLATZI_USER_TYPE.FREE,i=async e=>{a.send({event:e})};(0,react.useEffect)((()=>{i("impression_whatsapp_button")}),[]);const l=`https://api.whatsapp.com/send?phone=16282167264&text=${encodeURIComponent("Hola, quiero saber más sobre Platzi")}`;return o?react.createElement("a",{className:ue,href:l,"aria-label":"Inicia chat en Whatsapp",target:"_blank",rel:"noopener noreferrer",onClick:()=>{i("click_whatsapp_button")}},react.createElement(le,null)):null};_e.displayName="WhatsappButton",_e.defaultProps={user:null};
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 5071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ c; }
/* harmony export */ });
/* unused harmony exports A, L, a */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _platzi_commons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7337);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7058);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2814);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faFacebookF__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8101);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faTwitter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2443);
class l extends react__WEBPACK_IMPORTED_MODULE_0__.Component{constructor(...e){return super(...e),this.state={value:this.props.value||this.props.defaultValue||""},this.handleContent=e=>{this.props.handleContent?this.props.handleContent(e.target.value,e.target.name):this.setState({value:e.target.value})},this.onBlurInput=(e,t)=>{this.props.error?e.target.placeholder="":e.target.placeholder=t,this.props.onBlur&&this.props.onBlur(e)},this.getFieldClass=()=>classnames__WEBPACK_IMPORTED_MODULE_1___default()("FormInput-field",{error:this.props.error,filled:this.state.value||this.props.value,isTextArea:this.props.isTextArea,isUrl:"url"===this.props.type,isDate:"date"===this.props.type}),this}render(){const t=this.getFieldClass(),{t:r}=this.props;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`FormInput ${this.props.className}`},this.props.isTextArea?react__WEBPACK_IMPORTED_MODULE_0__.createElement("textarea",{maxLength:"140",id:this.props.id,name:this.props.name,type:this.props.type,required:this.props.required,ref:this.props.inputRef,autoComplete:this.props.autoComplete,placeholder:this.props.error?"":r(this.props.formattedMessageId),className:t,onFocus:e=>e.target.placeholder="",onBlur:e=>this.props.error?e.target.placeholder="":e.target.placeholder=r(this.props.formattedMessageId),onChange:this.handleContent}):react__WEBPACK_IMPORTED_MODULE_0__.createElement("input",{id:this.props.id,name:this.props.name,type:this.props.type,required:this.props.required,ref:this.props.inputRef,autoComplete:"off",placeholder:this.props.error?"":r(this.props.formattedMessageId),className:t,onFocus:e=>e.target.placeholder="",onBlur:e=>this.onBlurInput(e,r(this.props.formattedMessageId)),onChange:this.handleContent,value:this.props.handleContent?this.props.value:this.state.value}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("label",{htmlFor:this.props.id,className:"FormInput-label"},r(this.props.formattedMessageId)),this.props.children,react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",{className:"FormInput-error"},this.props.error))}}l.propTypes={className:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,type:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,required:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.bool,formattedMessageId:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,defaultMessage:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,error:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.node,handleContent:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.func,value:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,onBlur:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.func,autoComplete:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,defaultValue:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string},l.defaultProps={className:"",type:"text",required:!1,placeholder:"",error:"",autoComplete:"off"};var c=_platzi_commons__WEBPACK_IMPORTED_MODULE_4__.i.ReactTranslationsHOC(l);const m=({isLogin:t,next:r})=>{const{t:o}=(0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),s=r.length>0?`?next=${r}`:"";return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"LoginSocial"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"LoginSocial-facebook"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("a",{href:`/login/facebook/${s}`,className:"btn-fcbk btn--big btn--responsive"},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G,{className:"icon--line",icon:_fortawesome_free_brands_svg_icons_faFacebookF__WEBPACK_IMPORTED_MODULE_6__/* .faFacebookF */ .AY}),o(t?"LoginSocial-facebook-login":"LoginSocial-facebook-register"))),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"LoginSocial-twitter"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("a",{href:`/login/twitter/${s}`,className:"btn-twt btn--big btn--responsive "},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G,{className:"icon--line",icon:_fortawesome_free_brands_svg_icons_faTwitter__WEBPACK_IMPORTED_MODULE_7__/* .faTwitter */ .md}),o(t?"LoginSocial-twitter-login":"LoginSocial-twitter-register"))))};m.propTypes={next:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,isLogin:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.bool};const h=()=>{const{t:t}=a();return e.createElement("div",{className:"LoginDivider"},e.createElement("span",{className:"LoginDivider-text"},t("login_or")))},u=({signup:t,handleAccount:r,isLogin:o,next:s})=>{const{t:n}=(0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),i=o?t:"/login/",p=s.length>0?`${i}?next=${s}`:`${i}`;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"AccountFooter"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"AccountFooter-create"},n(o?"AccountFooter-title-register":"AccountFooter-title-login")),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"AccountFooter-link"},r?react__WEBPACK_IMPORTED_MODULE_0__.createElement("a",{onClick:r,className:"AccountFooter-btn"},n(o?"AccountFooter-register":"AccountFooter-login")):react__WEBPACK_IMPORTED_MODULE_0__.createElement("a",{href:p,className:"AccountFooter-btn"},n(o?"AccountFooter-register":"AccountFooter-login"))))};u.propTypes={signup:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,handleAccount:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.func,isLogin:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.bool,next:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string};


/***/ }),

/***/ 56:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ l; }
/* harmony export */ });
/* unused harmony export T */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
const r=n=>{const{defaultVisible:r,updateOn:l,isClickable:c,horizontalOffset:p,config:a,children:d}=n,{content:h}=n,[f,m]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({isVisible:r,toolTipheight:0,mounted:!1}),u="top"===a.position,b="bottom"===a.position,x=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{m({...f,toolTipContentheight:x.current.offsetHeight,toolTipContentWidth:x.current.offsetWidth,toolTipContainerWidth:v.current.offsetWidth,toolTipContainerHeight:v.current.offsetHeight,mounted:!0})}),[f.isVisible,l]);const T=t=>({hoverPosition:{[t.position]:`-${t.hover.verticalOffset}px`,left:p,width:`${t.hover.width}px`,height:`${t.hover.height}px`},contentPosition:{[t.position]:`-${t.content.height+t.content.verticalOffset}px`,left:`-${t.content.width/2-t.content.containerWidht/2-(null==a?void 0:a.horizontalOffset)}px`}}),g=()=>{m({...f,isVisible:!0})},C=()=>{m({...f,isVisible:!1})},O=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Tooltip-content",{"Tooltip-content--is-visible":f.mounted&&f.isVisible}),y=t=>{t.preventDefault(),c&&m({...f,isVisible:!f.isVisible})},w=(()=>{const{position:t,verticalOffset:e}=a,{toolTipContainerWidth:o,toolTipContentWidth:i,toolTipContentheight:n}=f,s={hover:{verticalOffset:e,width:o,height:e},content:{width:i,height:n,containerWidht:o,verticalOffset:e},position:t};return T(s)})();return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Tooltip-container",ref:v,onMouseEnter:c?()=>{}:g,onMouseLeave:c?()=>{}:C},react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{className:"Tooltip-hover",style:{...w.hoverPosition,zIndex:a.zIndex}}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{ref:x,className:O,style:{...w.contentPosition,zIndex:a.zIndex}},b&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{className:"Tooltip-content-arrow",style:{borderBottom:`8px solid ${a.arrowColor}`}}),react__WEBPACK_IMPORTED_MODULE_0__.createElement(h,{setHidden:C,setVisible:g,isVisible:f.isVisible}),u&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{className:"Tooltip-content-arrow",style:{borderTop:`8px solid ${a.arrowColor}`}})),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{onClick:y,className:"Tooltip-children",onKeyPress:t=>{"Enter"===t.key&&y(t)},tabIndex:"0",role:"button"},d))};r.propTypes={content:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.any,children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.any,config:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.shape({position:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,zIndex:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,verticalOffset:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,horizontalOffset:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,arrowColor:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,isClickable:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool})},r.defaultProps={content:react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",null),children:react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",null),config:{position:"top",zIndex:4,arrowColor:"#000",verticalOffset:10,horizontalOffset:0},defaultVisible:!1,updateOn:!1,isClickable:!1};const l=e=>{const{children:o,isActive:i,position:n,styles:r}=e,l=classnames__WEBPACK_IMPORTED_MODULE_1___default()("BasicTooltip",{"BasicTooltip--active":i,"BasicTooltip--top":"top"===n,"BasicTooltip--bottom":"bottom"===n,"BasicTooltip--left":"left"===n,"BasicTooltip--right":"right"===n});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:l,style:{...r}},o)};l.propTypes={children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.node.isRequired,isActive:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool.isRequired,position:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["top","bottom","left","right"]),styles:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.object},l.defaultProps={children:"content",isActive:!1,position:"top",width:null};


/***/ }),

/***/ 3893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ a; }
/* harmony export */ });
/* harmony import */ var _rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
const o={as:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.node.isRequired,type:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,onClick:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.func,size:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["sm","md","lg"]),color:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["platzi","sky","admin","danger"]),hierarchy:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["primary","secondary","tertiary"]),customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,disabled:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool,name:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string},a=s=>{const{as:o,children:a,size:n,color:i,hierarchy:l,customClass:p}=s,m=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Button",{"Button--small":"sm"===n,"Button--medium":"md"===n,"Button--big":"lg"===n},{"Button--platzi":"platzi"===i,"Button--sky":"sky"===i,"Button--admin":"admin"===i,"Button--danger":"danger"===i},{"Button--primary":"primary"===l,"Button--secondary":"secondary"===l,"Button--tertiary":"tertiary"===l},p),d={...s};return"string"==typeof o&&(delete d.customClass,delete d.as),react__WEBPACK_IMPORTED_MODULE_0__.createElement(o,(0,_rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_3__._)({},d,{className:m}),a)};a.propTypes=o,a.defaultProps={as:"button",children:"Button",onClick:()=>{},size:"md",color:"sky",hierarchy:"primary",disabled:!1};


/***/ }),

/***/ 5743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ d; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2814);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faAngleLeft__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2901);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faAngleRight__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4962);
/* harmony import */ var _platzi_commons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6518);
/* harmony import */ var _platzi_commons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8719);
const d=o=>{const[d,f]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[w,b]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[E,g]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[C,x]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[h,v]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(o.numberOfElements.xs),{width:y}=(0,_platzi_commons__WEBPACK_IMPORTED_MODULE_3__.a)();let A=Math.ceil(o.elements.length/h-1);A=A<0?0:A;const k=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Carousel-arrows",{"Carousel-arrows__inside":o.keepArrowsInside,"Carousel-arrows__outside":!o.keepArrowsInside});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>v(y<_platzi_commons__WEBPACK_IMPORTED_MODULE_4__/* .XS_BREAKPOINT */ .Pt?o.numberOfElements.xs:y<_platzi_commons__WEBPACK_IMPORTED_MODULE_4__/* .SM_BREAKPOINT */ .Zb?o.numberOfElements.sm:y<_platzi_commons__WEBPACK_IMPORTED_MODULE_4__/* .MD_BREAKPOINT */ .qY?o.numberOfElements.md:o.numberOfElements.lg)),[y]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{f((C-I())/h)}),[C,h]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{E>A&&g(A),b(E*-C-E*o.margin)}),[E,C]);const N=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e=>{null!==e&&x(e.offsetWidth)}),[y]),I=()=>o.margin*(h-1);if(0===o.elements.length)return null;const O=o.customSizeItems||0===d;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`Carousel ${o.customClass}`},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-external"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{ref:N,className:"Carousel-internal",style:{gap:o.margin+"px",transform:`translateX(${w}px)`}},o.elements.map(((t,s)=>react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{key:`index-${s}`,className:"Carousel-item",style:{width:O?"auto":d}},t))))),o.showArrows&&A>0&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:k,"data-testid":"Carousel-arrows"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-arrows-left"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{type:"button",onClick:()=>g(E-1),disabled:0===E},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G,{icon:_fortawesome_pro_regular_svg_icons_faAngleLeft__WEBPACK_IMPORTED_MODULE_5__/* .faAngleLeft */ .Ey}))),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-arrows-right"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{type:"button",onClick:()=>g(E+1),disabled:E===A},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G,{icon:_fortawesome_pro_regular_svg_icons_faAngleRight__WEBPACK_IMPORTED_MODULE_6__/* .faAngleRight */ .yO})))),o.showBullets&&A>0&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-bullets","data-testid":"Carousel-bullets"},Array.from(new Array(Math.ceil(o.elements.length/h))).map(((t,s)=>react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{key:`bullet-${s}`,className:E===s?"--active":"",type:"button",onClick:()=>g(s)},react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",null))))))};d.propTypes={elements:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.array,customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.string,numberOfElements:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.object,margin:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.number,showArrows:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.bool,showBullets:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.bool,keepArrowsInside:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.bool,customSizeItems:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_7__.p.exports.bool},d.defaultProps={elements:[],customClass:"",numberOfElements:{xs:1,sm:1,md:3,lg:4},margin:24,showArrows:!0,showBullets:!0,keepArrowsInside:!1,customSizeItems:!1};


/***/ }),

/***/ 8318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ i; }
/* harmony export */ });
/* unused harmony export a */
/* harmony import */ var _rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6423);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9960);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__);
var a=react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((function(a,i){var n=a.tag,l=a.html,f=(0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(a,["tag","html"]),p=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((function(){return{__html:isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize(l)}}),[l]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(n,(0,_rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_3__._)({ref:i},f,{dangerouslySetInnerHTML:p}))})),i=react__WEBPACK_IMPORTED_MODULE_0__.memo(a);


/***/ }),

/***/ 6479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ a; }
/* harmony export */ });
/* harmony import */ var _rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
class a extends react__WEBPACK_IMPORTED_MODULE_0__.Component{constructor(...e){return super(...e),this.state={value:this.props.value},this.handleContent=()=>{this.setState({value:!this.state.value}),this.props.handleContent&&this.props.handleContent(!this.state.value,this.props.name)},this}render(){const t=classnames__WEBPACK_IMPORTED_MODULE_1___default()("FormCheckbox-field",{error:this.props.error,switch:this.props.isSwitch}),r=classnames__WEBPACK_IMPORTED_MODULE_1___default()("FormCheckbox",{switch:this.props.isSwitch});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`${r} ${this.props.className}`},react__WEBPACK_IMPORTED_MODULE_0__.createElement("input",(0,_rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_2__._)({},this.props,{type:"checkbox",className:t,onChange:this.handleContent,checked:this.state.value,value:this.state.value})),this.props.isSwitch&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{className:"FormCheckbox-switch",onClick:this.handleContent}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("label",{className:"FormCheckbox-label",htmlFor:this.props.id}))}}a.propTypes={className:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,required:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.bool,error:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.bool,value:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.value,id:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.string,handleContent:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.func,isSwitch:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_3__.p.exports.bool},a.defaultProps={className:"",required:!1,error:"",value:!1,id:"",isSwitch:!1};


/***/ }),

/***/ 4357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ m; }
/* harmony export */ });
/* unused harmony export c */
/* harmony import */ var _rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6423);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9960);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
function c(t){return void 0===t&&(t=""),null===t?"":t}function i(t){try{return new URL(t),!0}catch(t){return!1}}var r="static.platzi.com";function o(t){var a=t.src,n=t.width,i=void 0===n?1024:n,o=t.quality,s=void 0===o?85:o,e=t.format,u=void 0===e?"auto":e,d=["width=".concat(i),"quality=".concat(s),"format=".concat(u)].join(","),l=new URL(a);if(l.hostname===r){var m=c(l.pathname);return"https://".concat(r,"/cdn-cgi/image/").concat(d).concat(m)}return"https://".concat(r,"/cdn-cgi/image/").concat(d,"/").concat(a)}function s(t,a){return null===t?"":i(t)?o({src:t,quality:a}):c({src:t}.src)}function e(t,a,n){return void 0===n&&(n=[]),t&&i(t)?function(t,a,n){return void 0===n&&(n=[]),0===n.length?"":n.map((function(n){return"".concat(o({src:t,width:n,quality:a})," ").concat(n,"w")})).join(", ")}(t,a,n):""}var u=[480,768,1024,1200];var d=function(t){var a=t.src,n=t.customClass,c=t.quality,i=t.sizes,r=t.loading,o=t.dataTrans,d={};return d.src=a?s(a,c):void 0,d.srcSet=a?e(a,c,u):void 0,d.loading=r,n&&(d.className=n),i&&(d.sizes=i),o&&(d["data-trans"]=o),d},l=function(t){var a=t.src,n=t.customClass,c=t.quality,i=t.loading,r=t.width,o=t.height,e=t.dataTrans,u={};return u.src=a?s(a,c):void 0,u.loading=i,u.width=r,u.height=o,n&&(u.className=n),e&&(u["data-trans"]=e),u},m=function(c){var i,r=c.alt,o=c.decoding,s=(0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(c,["alt","decoding"]),e=(i=s).width?l(i):d(i);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("img",(0,_rollupPluginBabelHelpers_c245b26a_js__WEBPACK_IMPORTED_MODULE_2__._)({},e,{alt:r,decoding:o}))};m.defaultProps={quality:85,sizes:"50vw",loading:"lazy",decoding:"async"};


/***/ }),

/***/ 574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
const t={label:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,id:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,name:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,size:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["md","lg"]),behavior:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["default","error","success","warning"]),message:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,handleChange:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.func.isRequired,currentValue:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOfType([_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number]),placeholder:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,type:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,maxlength:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,required:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool,disabled:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool,theme:0},a={label:"",id:"",name:"",size:"lg",behavior:"default",message:"",customClass:"",handleChange:()=>{},currentValue:void 0,placeholder:"",type:"text",maxlength:void 0,theme:"dark"},o=s=>{const{label:t,id:a,size:o,behavior:l,message:n,customClass:m,handleChange:i,currentValue:p,theme:d}=s,{placeholder:u,type:c,disabled:g,maxlength:x,required:h,name:b}=s,f=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Form-input","Input-wrapper",m,{"Form-input--error":"error"===l,"Form-input--success":"success"===l,"Form-input--warning":"warning"===l,[`Form-input--${d}`]:d}),F=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Form-field",{"Form-field--medium":"md"===o});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:f},t&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("label",{htmlFor:a,className:"Form-label"},t),react__WEBPACK_IMPORTED_MODULE_0__.createElement("input",{id:a,name:b,type:c,className:F,onChange:i,value:p,placeholder:u,disabled:g,"aria-label":t,maxLength:x,required:h}),n&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",{className:"Form-message"},n))};o.propTypes=t,o.defaultProps=a;


/***/ }),

/***/ 9191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ r; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3731);
const r=({className:s,children:r})=>react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:s},r);r.propTypes={className:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_1__.p.exports.string,children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_1__.p.exports.node.isRequired},r.defaultProps={className:""};


/***/ }),

/***/ 9077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ v; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Image-ee36dcbe.js
var Image_ee36dcbe = __webpack_require__(4357);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(8130);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/useRegisterModal-23dbb00b.js + 1 modules
var useRegisterModal_23dbb00b = __webpack_require__(6518);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-7de6c45f.js + 1 modules
var index_7de6c45f = __webpack_require__(758);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/constants.js
var constants = __webpack_require__(8719);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-5808dc9d.js
var index_5808dc9d = __webpack_require__(3731);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/validateRoute-47ec3624.js
const n=()=>{if("undefined"==typeof window)return null;return"/"===window.location.pathname?"home":window.location.pathname};

;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/PromoBanner-17b86412.js
const u={flag:index_5808dc9d.p.exports.string,price:index_5808dc9d.p.exports.string},g={"PromoBanner.cta":index_5808dc9d.p.exports.string,countdown_text:index_5808dc9d.p.exports.string,PromoBanner_details_previous_saving:index_5808dc9d.p.exports.string},_={status:index_5808dc9d.p.exports.string,primary_logo:index_5808dc9d.p.exports.string,end_date:index_5808dc9d.p.exports.string,pricing:index_5808dc9d.p.exports.shape(u),previous_price:index_5808dc9d.p.exports.shape(u),saving:index_5808dc9d.p.exports.shape(u),url:index_5808dc9d.p.exports.string,secondary_logo:index_5808dc9d.p.exports.string,primary_color:index_5808dc9d.p.exports.string,secondary_color:index_5808dc9d.p.exports.string,tertiary_color:index_5808dc9d.p.exports.string,font_color:index_5808dc9d.p.exports.string,lang:index_5808dc9d.p.exports.string,pre_banner_text:index_5808dc9d.p.exports.string,banner_text:index_5808dc9d.p.exports.string,promo:index_5808dc9d.p.exports.string,useWhitePaymentMethods:index_5808dc9d.p.exports.string,show_counter:index_5808dc9d.p.exports.bool,has_pricing:index_5808dc9d.p.exports.bool,is_platzi_day_registered:index_5808dc9d.p.exports.bool,messages:index_5808dc9d.p.exports.shape(g),type:index_5808dc9d.p.exports.string,cta_color:index_5808dc9d.p.exports.string,cta_font_color:index_5808dc9d.p.exports.string,installments_banner:{image:index_5808dc9d.p.exports.string,installments:index_5808dc9d.p.exports.number,message:index_5808dc9d.p.exports.string}},x=e=>{const r="undefined"!=typeof document&&document.cookie.match(new RegExp("(?:^|; )"+e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g,"\\$1")+"=([^;]*)"));return r?decodeURIComponent(r[1]):void 0},v=p=>{var u,g;const{t:_}=(0,useTranslation/* useTranslation */.$)(),[v,y]=(0,react.useState)(!1),[P,E]=(0,react.useState)(!1),{width:B}=(0,useRegisterModal_23dbb00b.a)(),{show_counter:f,has_pricing:h,status:b,type:N}=p,{banner_short_text:w,banner_text:k,end_date:C,promo:$,primary_logo:I}=p,{pricing:M,previous_price:j,messages:z,url:R}=p,{primary_color:A,secondary_color:D,font_color:H,cta_color:L,cta_font_color:S,installments_banner:T}=p,[W,U]=(0,react.useState)(!1),q={background:A,color:H},F={background:D,color:null!==(u=p.countdown_styles)&&void 0!==u&&u.color?null===(g=p.countdown_styles)||void 0===g?void 0:g.color:H},G=classnames_default()("PromoBanner",`PromoBanner--${$}`,{"PromoBanner--basic":"basic"===N,"PromoBanner-pre":"pre"===b});(0,react.useEffect)((()=>{const e="referral",r=x(`${e}_url`),t=x(`${e}_expire`);U(!(!r||!t))}),[]),(0,react.useEffect)((()=>{const e={event:"banner_impression",view:n(),type:p.status};index_7de6c45f.T.send(e)}),[W]);const J=()=>{const e={event:"banner_click",view:n(),type:p.status};index_7de6c45f.T.send(e)};if((0,react.useEffect)((()=>{y(B<constants/* SM_BREAKPOINT */.Zb),E(B>=constants/* SM_BREAKPOINT */.Zb&&B<constants/* MD_BREAKPOINT */.qY)}),[B]),W)return null;const K=v||P?w:k;return react.createElement("div",{className:G,style:q},react.createElement("div",{className:"PromoBanner-content"},react.createElement("div",{className:"PromoBanner-details"},react.createElement("div",{className:"PromoBanner-details-left"},I&&react.createElement(Image_ee36dcbe.I,{customClass:"PromoBanner-content-logo",src:I,alt:k}),react.createElement("div",{className:"PromoBanner-details-saving"},react.createElement("p",{dangerouslySetInnerHTML:{__html:K},className:"PromoBanner-details-saving-layout"}))),"promo"===b&&react.createElement("div",{className:"PromoBanner-promoContent"},react.createElement("div",{className:"PromoBanner-details-before"},react.createElement("p",{className:"PromoBanner-details-previous-content","data-trans":"Antes"},_("Antes"),": ",react.createElement("span",{className:"PromoBanner-details-previous-price"},j.price)),react.createElement("div",{className:"PromoBanner-details-pricing"},react.createElement("figure",null,react.createElement(Image_ee36dcbe.I,{src:M.flag,alt:"Currency",width:"16",height:"16"})),react.createElement("div",{className:"PromoBanner-details-price"},react.createElement("strong",null,M.price)))),h&&T&&react.createElement("div",{className:"PromoBanner-details-previous",style:{borderLeft:`1px solid ${H||"white"}`}},react.createElement("p",{className:"PromoBanner-details-previous-content is-msi"},null==T?void 0:T.message),react.createElement("figure",null,react.createElement(Image_ee36dcbe.I,{src:null==T?void 0:T.image,alt:null==T?void 0:T.message})))),react.createElement("a",{href:R,className:"PromoBanner-cta",style:{background:L,color:S},onClick:()=>J()},null==z?void 0:z["PromoBanner.cta"])),f&&react.createElement("div",{className:"PromoBanner-countdown",style:F},react.createElement("p",{className:"PromoBanner-countdown-text"},null==z?void 0:z.countdown_text),react.createElement(index_es/* default */.ZP,{date:new Date(C),renderer:({days:r,hours:t,minutes:o,seconds:n})=>{const s=[{id:1,value:r,text:" Días"},{id:2,value:t,text:" Hrs"},{id:3,value:o,text:" Min"},{id:4,value:n,text:" Seg"}];return react.createElement("div",{className:"PromoBanner-countdown-element"},s.map((({id:r,value:t,text:o})=>react.createElement("div",{className:"PromoBanner-countdown-item",key:r},t,react.createElement("span",{className:"PromoBanner-countdown-unit"},o)))))}}))),react.createElement("a",{href:R,onClick:()=>J(),className:"PromoBanner-anchor"}))};v.propTypes=_,v.defaultProps={status:"",primary_logo:"",end_date:"",pricing:null,previous_price:null,saving:null,url:"",secondary_logo:"",primary_color:"",secondary_color:"",tertiary_color:"",font_color:"",lang:"",msi_banner:"",pre_banner_text:"",banner_text:"",promo:"",useWhitePaymentMethods:"",show_counter:!1,has_pricing:!1,is_platzi_day_registered:!1,messages:{},installments_banner:null};


/***/ }),

/***/ 3167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ r; },
/* harmony export */   "T": function() { return /* binding */ c; }
/* harmony export */ });
/* unused harmony export a */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
const n=({title:t,subtitle:a,onClick:l,prefix:n,active:r})=>{const c=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Tab",{"is-active":r});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:c,onClick:e=>l(n)},t,null!=a&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",null,a))},r=({customClass:l,defaultTab:s,children:r,handleClickOnTab:c})=>{const i=r.filter((e=>e.props.shouldShow)),m=""===s?i[0].key:s,[o,p]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(m),u=e=>(p(e),c(e));return i.length?((0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{p(m)}),[m]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:l},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"u-wrapper"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`${l}-tabs`},i.map((t=>react__WEBPACK_IMPORTED_MODULE_0__.createElement(n,{key:t.key,onClick:u,title:t.props.title,subtitle:t.props.subtitle,prefix:t.key,active:t.key===o}))))),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`${l}-content`},i.length&&i.filter((e=>e.key===o))[0])))):null};r.propTypes={customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,defaultTab:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,handleClickOnTab:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.func},r.defaultProps={customClass:"SmartTabs",defaultTab:"",handleClickOnTab:()=>{}};const c=({children:t})=>react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,t);


/***/ }),

/***/ 6423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ n; }
/* harmony export */ });
function n(){return n=Object.assign?Object.assign.bind():function(n){for(var r=1;r<arguments.length;r++){var a=arguments[r];for(var t in a)({}).hasOwnProperty.call(a,t)&&(n[t]=a[t])}return n},n.apply(null,arguments)}


/***/ }),

/***/ 4230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ e; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
const e=r=>{const e=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Card",r.customClass,{"Card--dark":r.isDark});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:e},r.children)};e.propTypes={children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.node,customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,isDark:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool},e.defaultProps={customClass:""};


/***/ }),

/***/ 3731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ r; }
/* harmony export */ });
var e,r={exports:{}},n={exports:{}},t={};var o,a,i,c,u,f,s,p,l,y,d,m,b,v,h={};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */function g(){return a||(a=1,r=n, true?r.exports=function(){if(e)return t;e=1;var r="function"==typeof Symbol&&Symbol.for,n=r?Symbol.for("react.element"):60103,o=r?Symbol.for("react.portal"):60106,a=r?Symbol.for("react.fragment"):60107,i=r?Symbol.for("react.strict_mode"):60108,c=r?Symbol.for("react.profiler"):60114,u=r?Symbol.for("react.provider"):60109,f=r?Symbol.for("react.context"):60110,s=r?Symbol.for("react.async_mode"):60111,p=r?Symbol.for("react.concurrent_mode"):60111,l=r?Symbol.for("react.forward_ref"):60112,y=r?Symbol.for("react.suspense"):60113,d=r?Symbol.for("react.suspense_list"):60120,m=r?Symbol.for("react.memo"):60115,b=r?Symbol.for("react.lazy"):60116,v=r?Symbol.for("react.block"):60121,h=r?Symbol.for("react.fundamental"):60117,g=r?Symbol.for("react.responder"):60118,S=r?Symbol.for("react.scope"):60119;function O(e){if("object"==typeof e&&null!==e){var r=e.$$typeof;switch(r){case n:switch(e=e.type){case s:case p:case a:case c:case i:case y:return e;default:switch(e=e&&e.$$typeof){case f:case l:case b:case m:case u:return e;default:return r}}case o:return r}}}function w(e){return O(e)===p}return t.AsyncMode=s,t.ConcurrentMode=p,t.ContextConsumer=f,t.ContextProvider=u,t.Element=n,t.ForwardRef=l,t.Fragment=a,t.Lazy=b,t.Memo=m,t.Portal=o,t.Profiler=c,t.StrictMode=i,t.Suspense=y,t.isAsyncMode=function(e){return w(e)||O(e)===s},t.isConcurrentMode=w,t.isContextConsumer=function(e){return O(e)===f},t.isContextProvider=function(e){return O(e)===u},t.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===n},t.isForwardRef=function(e){return O(e)===l},t.isFragment=function(e){return O(e)===a},t.isLazy=function(e){return O(e)===b},t.isMemo=function(e){return O(e)===m},t.isPortal=function(e){return O(e)===o},t.isProfiler=function(e){return O(e)===c},t.isStrictMode=function(e){return O(e)===i},t.isSuspense=function(e){return O(e)===y},t.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===a||e===p||e===c||e===i||e===y||e===d||"object"==typeof e&&null!==e&&(e.$$typeof===b||e.$$typeof===m||e.$$typeof===u||e.$$typeof===f||e.$$typeof===l||e.$$typeof===h||e.$$typeof===g||e.$$typeof===S||e.$$typeof===v)},t.typeOf=O,t}():0),n.exports;var r}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/function S(){if(c)return i;c=1;var e=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,n=Object.prototype.propertyIsEnumerable;return i=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var r={},n=0;n<10;n++)r["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(r).map((function(e){return r[e]})).join(""))return!1;var t={};return"abcdefghijklmnopqrst".split("").forEach((function(e){t[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},t)).join("")}catch(e){return!1}}()?Object.assign:function(t,o){for(var a,i,c=function(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}(t),u=1;u<arguments.length;u++){for(var f in a=Object(arguments[u]))r.call(a,f)&&(c[f]=a[f]);if(e){i=e(a);for(var s=0;s<i.length;s++)n.call(a,i[s])&&(c[i[s]]=a[i[s]])}}return c},i}function O(){if(f)return u;f=1;return u="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function w(){return p?s:(p=1,s=Function.call.bind(Object.prototype.hasOwnProperty))}if(false){ var E; }else r.exports=function(){if(v)return b;v=1;var e=O();function r(){}function n(){}return n.resetWarningCache=r,b=function(){function t(r,n,t,o,a,i){if(i!==e){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function o(){return t}t.isRequired=t;var a={array:t,bigint:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:o,element:t,elementType:t,instanceOf:o,node:t,objectOf:o,oneOf:o,oneOfType:o,shape:o,exact:o,checkPropTypes:n,resetWarningCache:r};return a.PropTypes=a,a}}()();


/***/ }),

/***/ 9344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ a; },
/* harmony export */   "s": function() { return /* binding */ e; },
/* harmony export */   "u": function() { return /* binding */ o; }
/* harmony export */ });
/* unused harmony export i */
const a=a=>({type:"MARK_ALL_AS_READ",payload:a}),o=a=>({type:"UPDATE_USER_INFO",payload:a}),e=a=>({type:"SHOW_BILLING_MODAL",payload:a});var l={notificationsEnabled:a=>({type:"SET_NOTIFICATIONS_STATE",payload:a}),markAllAsRead:a,updateUserInfo:o,showBillingModal:e,setRegisterModalConfig:a=>({type:"SET_REGISTER_MODAL",payload:a})};


/***/ }),

/***/ 5358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ r; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3731);
const r=({customStyle:t})=>react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`Loader ${t}`},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Loader-circle"}));r.propTypes={customStyle:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_1__.p.exports.string},r.defaultProps={customStyle:""};


/***/ }),

/***/ 1855:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'facebook';
var width = 512;
var height = 512;
var aliases = [62000];
var unicode = 'f09a';
var svgPathData = 'M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ne = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8101:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'facebook-f';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f39e';
var svgPathData = 'M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.AY = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'google';
var width = 488;
var height = 512;
var aliases = [];
var unicode = 'f1a0';
var svgPathData = 'M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.xY = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4087:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'instagram';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f16d';
var svgPathData = 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Zz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'twitter';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f099';
var svgPathData = 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.md = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'youtube';
var width = 576;
var height = 512;
var aliases = [61802];
var unicode = 'f167';
var svgPathData = 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.op = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3719:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-down';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f078';
var svgPathData = 'M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.pt = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 7365:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-up';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f077';
var svgPathData = 'M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.mT = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3460:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'credit-card';
var width = 576;
var height = 512;
var aliases = [128179,62083,"credit-card-alt"];
var unicode = 'f09d';
var svgPathData = 'M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Oz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5554:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'heart';
var width = 512;
var height = 512;
var aliases = [128153,128154,128155,128156,128420,129293,129294,129505,9829,10084,61578];
var unicode = 'f004';
var svgPathData = 'M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.m6 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 1066:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'magnifying-glass';
var width = 512;
var height = 512;
var aliases = [128269,"search"];
var unicode = 'f002';
var svgPathData = 'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMagnifyingGlass = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 294:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'play';
var width = 384;
var height = 512;
var aliases = [9654];
var unicode = 'f04b';
var svgPathData = 'M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.zc = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 771:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(1066);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.wn = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(8470);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 8470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'xmark';
var width = 320;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 2901:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'angle-left';
var width = 256;
var height = 512;
var aliases = [8249];
var unicode = 'f104';
var svgPathData = 'M166.5 424.5l-143.1-152c-4.375-4.625-6.562-10.56-6.562-16.5c0-5.938 2.188-11.88 6.562-16.5l143.1-152c9.125-9.625 24.31-10.03 33.93-.9375c9.688 9.125 10.03 24.38 .9375 33.94l-128.4 135.5l128.4 135.5c9.094 9.562 8.75 24.75-.9375 33.94C190.9 434.5 175.7 434.1 166.5 424.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Ey = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4962:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'angle-right';
var width = 256;
var height = 512;
var aliases = [8250];
var unicode = 'f105';
var svgPathData = 'M89.45 87.5l143.1 152c4.375 4.625 6.562 10.56 6.562 16.5c0 5.937-2.188 11.87-6.562 16.5l-143.1 152C80.33 434.1 65.14 434.5 55.52 425.4c-9.688-9.125-10.03-24.38-.9375-33.94l128.4-135.5l-128.4-135.5C45.49 110.9 45.83 95.75 55.52 86.56C65.14 77.47 80.33 77.87 89.45 87.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.yO = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrow-left';
var width = 448;
var height = 512;
var aliases = [8592];
var unicode = 'f060';
var svgPathData = 'M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ac = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2305:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.eF = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4194:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrow-right-to-bracket';
var width = 512;
var height = 512;
var aliases = ["sign-in"];
var unicode = 'f090';
var svgPathData = 'M512 128v256c0 53.02-42.98 96-96 96h-72C330.7 480 320 469.3 320 456c0-13.26 10.75-24 24-24H416c26.4 0 48-21.6 48-48V128c0-26.4-21.6-48-48-48h-72C330.7 80 320 69.25 320 56C320 42.74 330.7 32 344 32H416C469 32 512 74.98 512 128zM345.5 239.6l-128-136C208.4 93.88 193.2 93.44 183.6 102.5C173.9 111.6 173.4 126.8 182.5 136.4L272.4 232H24C10.75 232 0 242.8 0 256s10.75 24 24 24h248.4l-89.92 95.56c-9.094 9.656-8.625 24.84 1.031 33.91C188.2 413.8 194.1 416 200 416c6.375 0 12.75-2.531 17.47-7.562l128-136C354.2 263.2 354.2 248.8 345.5 239.6z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Zh = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8811:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'bars';
var width = 448;
var height = 512;
var aliases = ["navicon"];
var unicode = 'f0c9';
var svgPathData = 'M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H424C437.3 224 448 234.7 448 248C448 261.3 437.3 272 424 272H24C10.75 272 0 261.3 0 248zM424 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H424C437.3 384 448 394.7 448 408C448 421.3 437.3 432 424 432z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.xi = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chart-line';
var width = 512;
var height = 512;
var aliases = ["line-chart"];
var unicode = 'f201';
var svgPathData = 'M48 408C48 421.3 58.75 432 72 432H488C501.3 432 512 442.7 512 456C512 469.3 501.3 480 488 480H72C32.24 480 0 447.8 0 408V56C0 42.75 10.75 32 24 32C37.25 32 48 42.75 48 56V408zM336.1 304.1C327.6 314.3 312.4 314.3 303 304.1L223.1 225.9L144.1 304.1C135.6 314.3 120.4 314.3 111 304.1C101.7 295.6 101.7 280.4 111 271L207 175C211.5 170.5 217.6 168 223.1 168C230.4 168 236.5 170.5 240.1 175L320 254.1L439 135C448.4 125.7 463.6 125.7 472.1 135C482.3 144.4 482.3 159.6 472.1 168.1L336.1 304.1z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.St = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(5779);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.ki = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5779:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'chart-pie-simple';
var width = 512;
var height = 512;
var aliases = ["chart-pie-alt"];
var unicode = 'f64e';
var svgPathData = 'M495.4 240H272V16.58C272 7.555 278.1 0 288 0C411.7 0 512 100.3 512 224C512 233 504.4 240 495.4 240zM224 288H445.3C463.8 288 478.6 303.7 474.8 321.8C451.9 430.5 355.5 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.53 60.12 190.2 37.18C208.3 33.36 224 48.2 224 66.7V288zM176 90.91C101.4 117.3 48 188.4 48 272C48 378 133.1 464 240 464C323.6 464 394.7 410.6 421.1 336H176V90.91z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChartPieSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 8149:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'check';
var width = 448;
var height = 512;
var aliases = [10003,10004];
var unicode = 'f00c';
var svgPathData = 'M440.1 103C450.3 112.4 450.3 127.6 440.1 136.1L176.1 400.1C167.6 410.3 152.4 410.3 143 400.1L7.029 264.1C-2.343 255.6-2.343 240.4 7.029 231C16.4 221.7 31.6 221.7 40.97 231L160 350.1L407 103C416.4 93.66 431.6 93.66 440.1 103V103z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LE = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9464:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chevron-down';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f078';
var svgPathData = 'M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.pt = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5972:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chevron-right';
var width = 320;
var height = 512;
var aliases = [9002];
var unicode = 'f054';
var svgPathData = 'M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports._t = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9312:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-exclamation';
var width = 512;
var height = 512;
var aliases = ["exclamation-circle"];
var unicode = 'f06a';
var svgPathData = 'M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 3830:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-info';
var width = 512;
var height = 512;
var aliases = ["info-circle"];
var unicode = 'f05a';
var svgPathData = 'M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleInfo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 1375:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-xmark';
var width = 512;
var height = 512;
var aliases = [61532,"times-circle","xmark-circle"];
var unicode = 'f057';
var svgPathData = 'M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 9844:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'code';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f121';
var svgPathData = 'M414.9 31.11L270.9 495.1C266.1 507.8 253.5 514.8 240.9 510.9C228.2 506.1 221.1 493.5 225.1 480.9L369.1 16.89C373 4.226 386.5-2.852 399.1 1.077C411.8 5.006 418.9 18.45 414.9 31.11V31.11zM504.4 118.5L632.4 238.5C637.3 243 640 249.4 640 255.1C640 262.6 637.3 268.1 632.4 273.5L504.4 393.5C494.7 402.6 479.6 402.1 470.5 392.4C461.4 382.7 461.9 367.6 471.6 358.5L580.9 255.1L471.6 153.5C461.9 144.4 461.4 129.3 470.5 119.6C479.6 109.9 494.7 109.4 504.4 118.5V118.5zM168.4 153.5L59.09 255.1L168.4 358.5C178.1 367.6 178.6 382.7 169.5 392.4C160.4 402.1 145.3 402.6 135.6 393.5L7.585 273.5C2.746 268.1 0 262.6 0 255.1C0 249.4 2.746 243 7.585 238.5L135.6 118.5C145.3 109.4 160.4 109.9 169.5 119.6C178.6 129.3 178.1 144.4 168.4 153.5V153.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.dT = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 7758:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(6498);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.b7 = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 8848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(2326);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.Eg = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(9256);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.Pj = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(5956);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.iV = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5956:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'ellipsis-vertical';
var width = 128;
var height = 512;
var aliases = ["ellipsis-v"];
var unicode = 'f142';
var svgPathData = 'M64 368C90.51 368 112 389.5 112 416C112 442.5 90.51 464 64 464C37.49 464 16 442.5 16 416C16 389.5 37.49 368 64 368zM64 208C90.51 208 112 229.5 112 256C112 282.5 90.51 304 64 304C37.49 304 16 282.5 16 256C16 229.5 37.49 208 64 208zM64 144C37.49 144 16 122.5 16 96C16 69.49 37.49 48 64 48C90.51 48 112 69.49 112 96C112 122.5 90.51 144 64 144z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEllipsisVertical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 1818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(9312);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.RL = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 9907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(6776);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.eH = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 228:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'eye-slash';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f070';
var svgPathData = 'M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM189.8 123.5L235.8 159.5C258.3 139.9 287.8 128 320 128C390.7 128 448 185.3 448 256C448 277.2 442.9 297.1 433.8 314.7L487.6 356.9C521.1 322.8 545.9 283.1 558.6 256C544.1 225.1 518.4 183.5 479.9 147.7C438.8 109.6 385.2 79.1 320 79.1C269.5 79.1 225.1 97.73 189.8 123.5L189.8 123.5zM394.9 284.2C398.2 275.4 400 265.9 400 255.1C400 211.8 364.2 175.1 320 175.1C319.3 175.1 318.7 176 317.1 176C319.3 181.1 320 186.5 320 191.1C320 202.2 317.6 211.8 313.4 220.3L394.9 284.2zM404.3 414.5L446.2 447.5C409.9 467.1 367.8 480 320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L120.8 191.2C102.1 214.5 89.76 237.6 81.45 255.1C95.02 286 121.6 328.5 160.1 364.3C201.2 402.4 254.8 432 320 432C350.7 432 378.8 425.4 404.3 414.5H404.3zM192 255.1C192 253.1 192.1 250.3 192.3 247.5L248.4 291.7C258.9 312.8 278.5 328.6 302 333.1L358.2 378.2C346.1 381.1 333.3 384 319.1 384C249.3 384 191.1 326.7 191.1 255.1H192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Aq = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 6498:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'gear';
var width = 512;
var height = 512;
var aliases = [9881,"cog"];
var unicode = 'f013';
var svgPathData = 'M160 256C160 202.1 202.1 160 256 160C309 160 352 202.1 352 256C352 309 309 352 256 352C202.1 352 160 309 160 256zM256 208C229.5 208 208 229.5 208 256C208 282.5 229.5 304 256 304C282.5 304 304 282.5 304 256C304 229.5 282.5 208 256 208zM293.1 .0003C315.3 .0003 334.6 15.19 339.8 36.74L347.6 69.21C356.1 73.36 364.2 78.07 371.9 83.28L404 73.83C425.3 67.56 448.1 76.67 459.2 95.87L496.3 160.1C507.3 179.3 503.8 203.6 487.8 218.9L463.5 241.1C463.8 246.6 464 251.3 464 256C464 260.7 463.8 265.4 463.5 270L487.8 293.1C503.8 308.4 507.3 332.7 496.3 351.9L459.2 416.1C448.1 435.3 425.3 444.4 404 438.2L371.9 428.7C364.2 433.9 356.1 438.6 347.6 442.8L339.8 475.3C334.6 496.8 315.3 512 293.1 512H218.9C196.7 512 177.4 496.8 172.2 475.3L164.4 442.8C155.9 438.6 147.8 433.9 140.1 428.7L107.1 438.2C86.73 444.4 63.94 435.3 52.85 416.1L15.75 351.9C4.66 332.7 8.168 308.4 24.23 293.1L48.47 270C48.16 265.4 48 260.7 48 255.1C48 251.3 48.16 246.6 48.47 241.1L24.23 218.9C8.167 203.6 4.66 179.3 15.75 160.1L52.85 95.87C63.94 76.67 86.73 67.56 107.1 73.83L140.1 83.28C147.8 78.07 155.9 73.36 164.4 69.21L172.2 36.74C177.4 15.18 196.7 0 218.9 0L293.1 .0003zM205.5 103.6L194.3 108.3C181.6 113.6 169.8 120.5 159.1 128.7L149.4 136.1L94.42 119.9L57.31 184.1L98.81 223.6L97.28 235.6C96.44 242.3 96 249.1 96 256C96 262.9 96.44 269.7 97.28 276.4L98.81 288.4L57.32 327.9L94.42 392.1L149.4 375.9L159.1 383.3C169.8 391.5 181.6 398.4 194.3 403.7L205.5 408.4L218.9 464H293.1L306.5 408.4L317.7 403.7C330.4 398.4 342.2 391.5 352.9 383.3L362.6 375.9L417.6 392.1L454.7 327.9L413.2 288.4L414.7 276.4C415.6 269.7 416 262.9 416 256C416 249.1 415.6 242.3 414.7 235.6L413.2 223.6L454.7 184.1L417.6 119.9L362.6 136.1L352.9 128.7C342.2 120.5 330.4 113.6 317.7 108.3L306.5 103.6L293.1 48H218.9L205.5 103.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGear = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 7249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'gift';
var width = 512;
var height = 512;
var aliases = [127873];
var unicode = 'f06b';
var svgPathData = 'M256 85.46L280.1 44.45C296.3 16.91 325.9 0 357.8 0H360C408.6 0 448 39.4 448 88C448 102.4 444.5 115.1 438.4 128H464C490.5 128 512 149.5 512 176V240C512 260.9 498.6 278.7 480 285.3V448C480 483.3 451.3 512 416 512H96C60.65 512 32 483.3 32 448V285.3C13.36 278.7 0 260.9 0 240V176C0 149.5 21.49 128 48 128H73.6C67.46 115.1 64 102.4 64 88C64 39.4 103.4 0 152 0H154.2C186.1 0 215.7 16.91 231.9 44.45L256 85.46zM288 176V240H464V176H288zM224 176H48V240H224V176zM224 288H80V448C80 456.8 87.16 464 96 464H224V288zM288 464H416C424.8 464 432 456.8 432 448V288H288V464zM360 128C382.1 128 400 110.1 400 88C400 65.91 382.1 48 360 48H357.8C342.9 48 329.1 55.91 321.5 68.78L286.7 128H360zM225.3 128L190.5 68.78C182.9 55.91 169.1 48 154.2 48H152C129.9 48 112 65.91 112 88C112 110.1 129.9 128 152 128H225.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Cl = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8112:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'globe';
var width = 512;
var height = 512;
var aliases = [127760];
var unicode = 'f0ac';
var svgPathData = 'M256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM256 464C263.4 464 282.1 456.8 303.6 415.6C312.4 397.9 319.1 376.4 325.6 352H186.4C192 376.4 199.6 397.9 208.4 415.6C229 456.8 248.6 464 256 464zM178.5 304H333.5C335.1 288.7 336 272.6 336 256C336 239.4 335.1 223.3 333.5 208H178.5C176.9 223.3 176 239.4 176 256C176 272.6 176.9 288.7 178.5 304V304zM325.6 160C319.1 135.6 312.4 114.1 303.6 96.45C282.1 55.22 263.4 48 256 48C248.6 48 229 55.22 208.4 96.45C199.6 114.1 192 135.6 186.4 160H325.6zM381.8 208C383.2 223.5 384 239.6 384 256C384 272.4 383.2 288.5 381.8 304H458.4C462.1 288.6 464 272.5 464 256C464 239.5 462.1 223.4 458.4 208H381.8zM342.1 66.61C356.2 92.26 367.4 124.1 374.7 160H440.6C419.2 118.9 384.4 85.88 342.1 66.61zM169.9 66.61C127.6 85.88 92.84 118.9 71.43 160H137.3C144.6 124.1 155.8 92.26 169.9 66.61V66.61zM48 256C48 272.5 49.93 288.6 53.57 304H130.2C128.8 288.5 128 272.4 128 256C128 239.6 128.8 223.5 130.2 208H53.57C49.93 223.4 48 239.5 48 256zM440.6 352H374.7C367.4 387.9 356.2 419.7 342.1 445.4C384.4 426.1 419.2 393.1 440.6 352zM137.3 352H71.43C92.84 393.1 127.6 426.1 169.9 445.4C155.8 419.7 144.6 387.9 137.3 352V352z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.g4 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(3830);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.sq = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 7204:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'list';
var width = 512;
var height = 512;
var aliases = ["list-squares"];
var unicode = 'f03a';
var svgPathData = 'M88 48C101.3 48 112 58.75 112 72V120C112 133.3 101.3 144 88 144H40C26.75 144 16 133.3 16 120V72C16 58.75 26.75 48 40 48H88zM488 72C501.3 72 512 82.75 512 96C512 109.3 501.3 120 488 120H184C170.7 120 160 109.3 160 96C160 82.75 170.7 72 184 72H488zM488 232C501.3 232 512 242.7 512 256C512 269.3 501.3 280 488 280H184C170.7 280 160 269.3 160 256C160 242.7 170.7 232 184 232H488zM488 392C501.3 392 512 402.7 512 416C512 429.3 501.3 440 488 440H184C170.7 440 160 429.3 160 416C160 402.7 170.7 392 184 392H488zM16 232C16 218.7 26.75 208 40 208H88C101.3 208 112 218.7 112 232V280C112 293.3 101.3 304 88 304H40C26.75 304 16 293.3 16 280V232zM88 368C101.3 368 112 378.7 112 392V440C112 453.3 101.3 464 88 464H40C26.75 464 16 453.3 16 440V392C16 378.7 26.75 368 40 368H88z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Zr = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5099:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'megaphone';
var width = 576;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = 'M576 55.1V456C576 469.3 565.3 480 552 480C538.7 480 528 469.3 528 456V450.3L350.3 401.9C341.1 446.4 302.9 480 256 480C202.1 480 160 437 160 384C160 372.6 161.1 361.7 165.6 351.5L48 319.4V328C48 341.3 37.25 352 24 352C10.75 352 0 341.3 0 328V184C0 170.7 10.75 160 24 160C37.25 160 48 170.7 48 184V192.6L528 61.67V56C528 42.75 538.7 32 552 32C565.3 32 576 42.75 576 56V55.1zM528 400.6V111.4L48 242.3V269.7L528 400.6zM256 432C280.8 432 301.1 413.2 303.7 389.2L212.3 364.2C209.5 370.2 208 376.9 208 384C208 410.5 229.5 432 256 432H256z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Au = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2326:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'message';
var width = 512;
var height = 512;
var aliases = ["comment-alt"];
var unicode = 'f27a';
var svgPathData = 'M447.1 0h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.98c0 9.836 11.02 15.55 19.12 9.7l124.9-93.68h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 0 447.1 0zM464 352c0 8.75-7.25 16-16 16h-160l-80 60v-60H64c-8.75 0-16-7.25-16-16V64c0-8.75 7.25-16 16-16h384c8.75 0 16 7.25 16 16V352z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5857:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'message-lines';
var width = 512;
var height = 512;
var aliases = ["comment-alt-lines"];
var unicode = 'f4a6';
var svgPathData = 'M360 144h-208C138.8 144 128 154.8 128 168S138.8 192 152 192h208C373.3 192 384 181.3 384 168S373.3 144 360 144zM264 240h-112C138.8 240 128 250.8 128 264S138.8 288 152 288h112C277.3 288 288 277.3 288 264S277.3 240 264 240zM447.1 0h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.1c0 9.836 11.02 15.55 19.12 9.7l124.9-93.7h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 0 447.1 0zM464 352c0 8.75-7.25 16-16 16h-160l-80 60v-60H64c-8.75 0-16-7.25-16-16V64c0-8.75 7.25-16 16-16h384c8.75 0 16 7.25 16 16V352z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.sN = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'message-smile';
var width = 512;
var height = 512;
var aliases = ["comment-alt-smile"];
var unicode = 'f4aa';
var svgPathData = 'M447.1 .0041h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.99c0 9.836 11.02 15.55 19.12 9.7l124.9-93.69h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 .0041 447.1 .0041zM464 352c0 8.75-7.25 16-16 16h-160l-80 60v-60H64c-8.75 0-16-7.25-16-16V64c0-8.75 7.25-16 16-16h384c8.75 0 16 7.25 16 16V352zM320 175.1c17.75 0 32-14.25 32-31.1s-14.25-32-31.1-32s-31.1 14.25-31.1 32S302.3 175.1 320 175.1zM192 175.1c17.75 0 32-14.25 32-31.1s-14.25-32-31.1-32s-31.1 14.25-31.1 32S174.3 175.1 192 175.1zM325.8 240.3C308.5 260.4 283.2 272 256 272c-27.12 0-52.49-11.62-69.74-31.75C177.7 230.1 162.4 229 152.4 237.5C142.3 246.1 141.3 261.3 149.8 271.3c26.5 31 65.09 48.74 106.2 48.74c41.12 0 79.76-17.74 106.3-48.74c8.5-10 7.375-25.12-2.75-33.75C349.5 228.9 334.4 230.1 325.8 240.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessageSmile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 8453:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'pen-nib';
var width = 512;
var height = 512;
var aliases = [10001];
var unicode = 'f5ad';
var svgPathData = 'M368.4 18.34C390.3-3.526 425.7-3.526 447.6 18.34L493.7 64.4C515.5 86.27 515.5 121.7 493.7 143.6L412.2 225L371.6 374.1C366.7 391.9 353.5 406.1 336.1 412.2L71.97 505C53.47 511.5 32.89 506.8 19.03 492.1C5.168 479.1 .4845 458.5 6.982 440L99.79 175.9C105.9 158.5 120.1 145.3 137.9 140.4L286.1 99.77L368.4 18.34zM296.9 146.8L150.5 186.7C147.1 187.4 145.9 189.3 145.1 191.8L62.47 426.9L164.7 324.7C161.7 318.4 160 311.4 160 304C160 277.5 181.5 256 208 256C234.5 256 256 277.5 256 304C256 330.5 234.5 352 208 352C200.6 352 193.6 350.3 187.3 347.3L85.1 449.5L320.2 366.9C322.7 366.1 324.6 364 325.3 361.5L365.2 215.1L296.9 146.8z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Qz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8511:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'rocket';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f135';
var svgPathData = 'M408 143.1C408 166.1 390.1 183.1 368 183.1C345.9 183.1 328 166.1 328 143.1C328 121.9 345.9 103.1 368 103.1C390.1 103.1 408 121.9 408 143.1zM23.1 288C15.38 288 7.414 283.4 3.145 275.9C-1.123 268.4-1.043 259.2 3.356 251.8L55.83 163.3C68.79 141.4 92.33 127.1 117.8 127.1H199.9C202.4 124 204.8 120.3 207.2 116.7C289.1-4.07 411.1-8.142 483.9 5.275C495.6 7.414 504.6 16.43 506.7 28.06C520.1 100.9 516.1 222.9 395.3 304.8C391.7 307.2 387.1 309.6 384 312.1V394.2C384 419.7 370.6 443.2 348.7 456.2L260.2 508.6C252.8 513 243.6 513.1 236.1 508.9C228.6 504.6 223.1 496.6 223.1 488V391.8C215.2 395.6 207.4 398.9 200.1 401.7C189.1 406.6 175.5 403.9 166.5 394.8L115.8 344.1C106.6 334.9 103.9 321.1 109.1 309.2C111.7 303.2 114.9 296 118.5 288L23.1 288zM461.7 50.32C398.4 41.85 309.1 51.1 246.1 143.7C216.8 188.1 178.1 271.9 157.6 318.1L192.6 353.1C239.1 333.2 323.9 295.2 368.3 265C460 202.9 470.2 113.6 461.7 50.32V50.32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.tM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8069:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'seedling';
var width = 512;
var height = 512;
var aliases = [127793,"sprout"];
var unicode = 'f4d8';
var svgPathData = 'M436.4 32c-91 0-168.3 67.88-194.6 161.4C204.6 134.6 144 96 75.63 96L0 95.1V120C0 247.9 91.75 352 204.4 352H232v104C232 469.2 242.8 480 255.1 480S280 469.2 280 456V288h27.62C420.2 288 512 183.9 512 56V32H436.4zM204.4 304c-79.25 0-145.1-69.75-155.1-160h26.25c79.25 0 145.1 69.75 155.1 160H204.4zM307.6 240h-26.25c10-90.25 75.87-160 155.1-160h26.25C452.8 170.2 386.9 240 307.6 240z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.YK = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 128:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'sparkles';
var width = 512;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = 'M327.5 85.19L384 64L405.2 7.491C406.9 2.985 411.2 0 416 0C420.8 0 425.1 2.985 426.8 7.491L448 64L504.5 85.19C509 86.88 512 91.19 512 96C512 100.8 509 105.1 504.5 106.8L448 128L426.8 184.5C425.1 189 420.8 192 416 192C411.2 192 406.9 189 405.2 184.5L384 128L327.5 106.8C322.1 105.1 320 100.8 320 96C320 91.19 322.1 86.88 327.5 85.19V85.19zM176 73.29C178.6 67.63 184.3 64 190.6 64C196.8 64 202.5 67.63 205.1 73.29L257.8 187.3L371.8 240C377.5 242.6 381.1 248.3 381.1 254.6C381.1 260.8 377.5 266.5 371.8 269.1L257.8 321.8L205.1 435.8C202.5 441.5 196.8 445.1 190.6 445.1C184.3 445.1 178.6 441.5 176 435.8L123.3 321.8L9.292 269.1C3.627 266.5 0 260.8 0 254.6C0 248.3 3.627 242.6 9.292 240L123.3 187.3L176 73.29zM166.9 207.5C162.1 217.8 153.8 226.1 143.5 230.9L92.32 254.6L143.5 278.2C153.8 282.1 162.1 291.3 166.9 301.6L190.6 352.8L214.2 301.6C218.1 291.3 227.3 282.1 237.6 278.2L288.8 254.6L237.6 230.9C227.3 226.1 218.1 217.8 214.2 207.5L190.6 156.3L166.9 207.5zM405.2 327.5C406.9 322.1 411.2 320 416 320C420.8 320 425.1 322.1 426.8 327.5L448 384L504.5 405.2C509 406.9 512 411.2 512 416C512 420.8 509 425.1 504.5 426.8L448 448L426.8 504.5C425.1 509 420.8 512 416 512C411.2 512 406.9 509 405.2 504.5L384 448L327.5 426.8C322.1 425.1 320 420.8 320 416C320 411.2 322.1 406.9 327.5 405.2L384 384L405.2 327.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Jy = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4127:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'suitcase';
var width = 512;
var height = 512;
var aliases = [129523];
var unicode = 'f0f2';
var svgPathData = 'M128 96V56C128 25.07 153.1 0 184 0H328C358.9 0 384 25.07 384 56V96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H128zM176 96H336V56C336 51.58 332.4 48 328 48H184C179.6 48 176 51.58 176 56V96zM144 144V432H368V144H144zM48 160V416C48 424.8 55.16 432 64 432H96V144H64C55.16 144 48 151.2 48 160zM464 416V160C464 151.2 456.8 144 448 144H416V432H448C456.8 432 464 424.8 464 416z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.qb = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 224:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(8425);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 465:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(1375);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.nY = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 6776:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'triangle-exclamation';
var width = 512;
var height = 512;
var aliases = [9888,"exclamation-triangle","warning"];
var unicode = 'f071';
var svgPathData = 'M506.3 417l-213.3-364C284.8 39 270.4 32 256 32C241.6 32 227.2 39 218.1 53l-213.2 364C-10.59 444.9 9.851 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM52.58 432L255.1 84.8L459.4 432H52.58zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44c0 17.36 14.11 31.44 31.48 31.44s31.4-14.08 31.4-31.44C287.4 351.2 273.4 337.1 256 337.1zM232 184v96C232 293.3 242.8 304 256 304s24-10.75 24-24v-96C280 170.8 269.3 160 256 160S232 170.8 232 184z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTriangleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 3036:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'video';
var width = 576;
var height = 512;
var aliases = ["video-camera"];
var unicode = 'f03d';
var svgPathData = 'M557.6 102.3c-11.53-7.406-25.88-8.391-38.28-2.688L416 147V128c0-35.35-28.65-64-64-64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64v-19.02l103.3 47.36c5.344 2.453 11.03 3.672 16.69 3.672c7.531 0 15.02-2.141 21.59-6.359C569.1 402.3 576 389.7 576 375.1V136C576 122.3 569.1 109.8 557.6 102.3zM368 384c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V128c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16V384zM528 363.5L416 312.2V199.8l112-51.33V363.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Iy = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8425:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'xmark';
var width = 320;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5235:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.eF = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2480:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-turn-down-right';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e3d6';
var svgPathData = 'M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V224c0 53 43 96 96 96H402.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256H96c-17.7 0-32-14.3-32-32V64z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ii = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 17:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = 'M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm97 225c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0L353 225z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.fi = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9423:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'calendar-circle-plus';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e470';
var svgPathData = 'M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.TI = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9853:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'circle';
var width = 512;
var height = 512;
var aliases = [128308,128309,128992,128993,128994,128995,128996,9679,9898,9899,11044,61708,61915];
var unicode = 'f111';
var svgPathData = 'M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.di = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9447:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-info';
var width = 512;
var height = 512;
var aliases = ["info-circle"];
var unicode = 'f05a';
var svgPathData = 'M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleInfo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 7324:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'clock';
var width = 512;
var height = 512;
var aliases = [128339,"clock-four"];
var unicode = 'f017';
var svgPathData = 'M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.SZ = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(9447);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.sq = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 1870:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'location-dot';
var width = 384;
var height = 512;
var aliases = ["map-marker-alt"];
var unicode = 'f3c5';
var svgPathData = 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLocationDot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 1677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(1870);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.FG = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 7409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'shield-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f2f7';
var svgPathData = 'M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ip = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8606:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'sparkles';
var width = 512;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = 'M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Jy = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2580:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'tag';
var width = 448;
var height = 512;
var aliases = [127991];
var unicode = 'f02b';
var svgPathData = 'M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LE = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 1584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(2414);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 2414:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'xmark';
var width = 320;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 2787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ p; },
/* harmony export */   "v": function() { return /* binding */ u; }
/* harmony export */ });
/* unused harmony exports D, a, b, c, d, e, f, h, i, j, k, l, m, r, s */
/* harmony import */ var _axiosInstance_1cddbf84_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6830);
/* harmony import */ var _apiCalls_c0fe2c19_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3896);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8719);
const i=(t,n,e)=>{window.ga&&ga.create&&window.ga("platziFull.send","event",t,n,e)};function r(t={},{type:n,payload:e}){return t}const c=t=>{const n=document.getElementById(t);n.parentNode.removeChild(n)},d=()=>{delete window.__PRELOADED_STATE__,delete window.initialProps,delete window.translations,c("preloadedState"),c("initialProps"),c("translations")},p=()=>(0,_axiosInstance_1cddbf84_js__WEBPACK_IMPORTED_MODULE_0__.a)(!0).get(_apiCalls_c0fe2c19_js__WEBPACK_IMPORTED_MODULE_1__.c.user.getUserInfo).then((({data:t})=>t)),l=()=>t(!0).get(n.user.isAccountless).then((({data:t})=>t));function u(t=""){return!(String(t).trim()<=0||!_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .emailRegex.test */ .HN.test(String(t).toLowerCase().trim()))}function f(t=""){return!(String(t).trim()<=0||!o.test(String(t).toLowerCase().trim()))}const w=(t="")=>{const n=String(t).toLowerCase().trim();return!(n<=0||!a.test(n))},h=t=>{try{const n=t||window.location.hostname;return["localhost","staging","platzi.dev"].some((t=>n.includes(t)))?"test":"production"}catch(t){return"test"}},m=t=>{const n=h();"undefined"!=typeof window&&"production"===n&&window.dataLayer&&window.dataLayer.push(t)},g=(t,n,e)=>{try{const o=h(),a=t,s="production"===o?a:`${a} Test`;window.ga&&window.ga("platziFull.send","event",s,n,e)}catch(t){throw new Error(`'::ERROR::analytics' ${t}`)}},y=t=>{const n=h();"undefined"!=typeof window&&"production"===n&&window.hj&&window.hj("event",t)};var _="https://static.platzi.com/commons/assets/images/one-person850ef8d9ec30c125.png";const D={default:_,platzi_academy:_,monthly_plan:_,expert_plan:_,annual_plan:"https://static.platzi.com/commons/assets/images/two-people4e0c1925472ce45a.png",family_plan:"https://static.platzi.com/commons/assets/images/four-people7d0727bbebfe9dea.png"},E=t=>D[t]?D[t]:D.default;function S(t){const{token:n,showFreshChat:e,delay:o=1e3,additionalProps:a={}}=t||{};if(!e)return"";const i=s({token:n,host:"https://wchat.freshchat.com",config:{headerProperty:{foregroundColor:"#7F2C98"}}},a);return`\n    <script async defer>\n      function initFreshChat() {\n        window.fcWidget.init(${JSON.stringify(i)});\n      }\n      (function(d, id) {\n        var fcJS;\n        if (d.getElementById(id)) {\n          setTimeout(function() { initFreshChat(); }, ${o});\n          return;\n        }\n        fcJS = d.createElement('script');\n        fcJS.id = id;\n        fcJS.async = true;\n        fcJS.src = 'https://wchat.freshchat.com/js/widget.js';\n        fcJS.onload = initFreshChat;\n        d.head.appendChild(fcJS);\n      }(document, 'freshchat-js-sdk'));\n    <\/script>\n  `}function C(t,n={}){const{DATADOG_CLIENT_TOKEN:e,DATADOG_APPLICATION_ID:o,DATADOG_SERVICE_NAME:a}=t||{};if(!e)return"";const i=s({clientToken:e,applicationId:o,site:"datadoghq.com",service:a,sampleRate:100,trackInteractions:!0},n);return`<script async defer>\n    (function(h,o,u,n,d) {\n      h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}\n      d=o.createElement(u);d.async=1;d.src=n\n      n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)\n    })(window,document,'script','https://www.datadoghq-browser-agent.com/datadog-rum-v4.js','DD_RUM')\n      DD_RUM.onReady(function() {\n        DD_RUM.init(${JSON.stringify(i)});\n      })\n    <\/script>`}const R=t=>`<script>\n      window.dataLayer && window.dataLayer.push({\n        event: 'page_viewed',\n        ${t?`user_id:${t},`:""}\n      })\n    <\/script>`;const v={captureException:function(t,n={}){"undefined"!=typeof DD_RUM&&DD_RUM.onReady((function(){DD_RUM.addError(t,n)}))}};


/***/ }),

/***/ 8336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ r; }
/* harmony export */ });
function r(){return r=Object.assign?Object.assign.bind():function(r){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(r[a]=n[a])}return r},r.apply(this,arguments)}


/***/ }),

/***/ 3896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ s; },
/* harmony export */   "s": function() { return /* binding */ e; }
/* harmony export */ });
const e={middlewares:{verifyUser:"/api/v3/users/is-authenticated/",studentHomeAccess:"/api/v3/users/has-new-home-stundents/",isBetaTester:"/api/v3/users/is-organizer-beta-tester/",enterpriseActivationsAccess:e=>`/api/v3/enterprise/${e}/permissions/can-access-enterprise-activations/`,orgCanAccess:"/api/v3/users/is-es-organization/"},header:"/api/bff/org/header/",home:"/api/bff/web/home/",conf:e=>`/api/v4/conferences/${e}/`,contact:"/api/bff/web/contact-info/",metatags:e=>`/api/bff/org/meta-tags/${e}/`,userLp:"/api/v3/users-learning-paths/",categories:"/api/v3/categories/",b2bDashboard:e=>`/api/v3/companies/${e}/dashboard/overview/`,studentLearningPaths:"/api/v4/user-learning-paths/",studentCategories:"/api/v3/home-user-custom-catalog/",enterpriseActivationsMenu:e=>`/api/v3/enterprise/${e}/menu/`,deals:"/entrenamiento-google/code/",recentLaunches:"/api/v4/recent-launches/",getSchools:"/api/v4/schools-list/",promos:e=>`/api/v4/promo/${e}/`},s={auth:{credentials:"/api/v3/users/credentials/",liveCredentials:e=>`/api/v4/live-credentials/${e}/`},preRegister:"/api/v4/preregister-countdown/",registerB2B:"/empresas/",courses:{manualCourses:"/api/v3/courses/user-manual-courses/",privateCourses:"/api/v3/courses/user-private-courses/",bougthCourses:"/api/v3/courses/user-purchased-courses/",getNewCourses:"/api/v3/courses/new-courses/"},users:{statsUrl:"/api/v3/users/stats/",getAlerts:"/api/v3/users/notifications/",mailVerified:"/api/v3/users/mail-verified/"},materials:{getMaterialProgress:"/api/v3/materials/progress/",removeLatestMaterial:e=>`/api/v3/materials/${e}/remove-latest/`},categories:{getCategories:"/api/v3/categories/"},learningPaths:{getUserLp:"/api/v3/learning-paths/",deleteLp:e=>`/api/v3/users-learning-paths/${e}/`,addLp:e=>`/api/v3/users-learning-paths/${e}/assign/`,availableForAdition:e=>`/api/v4/user-learning-paths/get-lps-available/${e}/`},live:{checkLive:"api/v1/lives/"},notifications:{getHomeFeed:e=>`/api/v3/home-feed/?page=${e}`},recommendations:{courses:"/api/v3/users/recommendations/"},discussions:{like:"/api/v3/home-feed/toggle-star/"},homeCatalog:{categoryDetail:e=>`/api/v3/home-catalog/?category=${e}`,categoryLearningPathDetail:e=>`/api/v3/home-catalog/${e}/`},homeUserCatalog:{studentLearningPathDetail:e=>`/api/v3/home-user-catalog/${e}/`,deleteCourse:()=>"/api/v3/home-user-custom-catalog/course/",addCourse:()=>"/api/v3/home-user-custom-catalog/course/"},globalSearch:e=>`/global-search/?search=${e}`,billing:{getInfo:()=>"/api/v3/payment-data/",saveInfo:()=>"/api/v3/billing-data/"},geo:{getStates:()=>"/api/bff/geo/states/",getCities:e=>`/api/bff/geo/municipalities/${e}/`},conf:{registration:(e,s)=>`/api/v4/conferences/${e}/register/?ticket_type=${s}`},deals:{submitCode:()=>"/entrenamiento-google/code/",registerData:()=>"/entrenamiento-google/data/"},platziDay:()=>"/api/v4/progress/courses/get_progress_platzi_day/",getBenefitiaryProgress:e=>`/api/v4/progress/courses/beneficiary-progress/${e}/`,sif:{tracking:"/api/v1/tracking/"},user:{getUserInfo:"/api/v1/components/headerv2/user/",isAccountless:"/api/v3/users/accountless/"}};


/***/ }),

/***/ 6830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ o; },
/* harmony export */   "b": function() { return /* binding */ i; }
/* harmony export */ });
/* unused harmony export c */
/* harmony import */ var _rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8336);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(4155);
function n(e=""){return e.split("; ").reduce(((e,t)=>{const n=t.split("=");return e[n[0]]=n[1],e}),{})}const o=(o=!1,i={})=>{var r;let s="",c=(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({"X-Requested-With":"XMLHttpRequest","Content-Type":"application/json"},undefined);const a="undefined"!=typeof window&&(null===(r=n(null===document||void 0===document?void 0:document.cookie))||void 0===r?void 0:r.csrftoken)||"";return i.headers&&(c=(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},c),i.headers)),i.baseURL&&(s=i.baseURL),i.custom?(axios__WEBPACK_IMPORTED_MODULE_0___default()):(i.isAuthRequired&&a&&(c=(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},c),{"X-CSRFToken":a})),o?axios__WEBPACK_IMPORTED_MODULE_0___default().create({headers:(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},c),{"X-CSRFToken":a})}):axios__WEBPACK_IMPORTED_MODULE_0___default().create({baseURL:s,headers:c}))},i=(n,o=process.env.API_URL)=>axios__WEBPACK_IMPORTED_MODULE_0___default().create({baseURL:o,headers:(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},n),undefined),{"bff-ip-rewrite":n["cf-connecting-ip"]?n["cf-connecting-ip"]:"","bff-country-rewrite":n["cf-ipcountry"]?n["cf-ipcountry"]:"","Content-Type":"application/json"}),timeout:15e3});


/***/ }),

/***/ 8719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ g; },
/* harmony export */   "BG": function() { return /* binding */ n; },
/* harmony export */   "DN": function() { return /* binding */ l; },
/* harmony export */   "HN": function() { return /* binding */ f; },
/* harmony export */   "P2": function() { return /* binding */ i; },
/* harmony export */   "Pt": function() { return /* binding */ z; },
/* harmony export */   "Zb": function() { return /* binding */ h; },
/* harmony export */   "ag": function() { return /* binding */ o; },
/* harmony export */   "bK": function() { return /* binding */ v; },
/* harmony export */   "cY": function() { return /* binding */ m; },
/* harmony export */   "lB": function() { return /* binding */ a; },
/* harmony export */   "lE": function() { return /* binding */ t; },
/* harmony export */   "qY": function() { return /* binding */ r; },
/* harmony export */   "u3": function() { return /* binding */ s; },
/* harmony export */   "yP": function() { return /* binding */ p; },
/* harmony export */   "zo": function() { return /* binding */ e; }
/* harmony export */ });
/* unused harmony exports ACADEMY, B2B, EXPERT, EXPERT_PLUS, PLAN_FREE, b2bEmailRegex, nameRegex */
const a={amex:"https://static.platzi.com/commons/assets/images/amex8c702aae174e8d5b.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty91f6cb277fa29fea.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivod8f46b2bdaf56e7f.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil5df441661803d43a.png",paypal:"https://static.platzi.com/commons/assets/images/paypalbc538ab7210a384a.png",pse:"https://static.platzi.com/commons/assets/images/psebb0ce4c4463aa51b.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago1001d95e1020bdf8.png",visa:"https://static.platzi.com/commons/assets/images/visa52d765334f273be7.png",sencillito:"https://static.platzi.com/commons/assets/images/sencillitof1aa0eb82ecec56d.png",servipag:"https://static.platzi.com/commons/assets/images/servipage7972ff9af0f8a91.png"};const s={amex:"https://static.platzi.com/commons/assets/images/amexda647adf95f30924.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty22311be7d0475e8f.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivo39a4341bf1f15d31.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil632781fca2af5541.png",paypal:"https://static.platzi.com/commons/assets/images/paypal03ae8e5a43fc2f23.png",pse:"https://static.platzi.com/commons/assets/images/pse3962764fe3faa4ea.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago3cefa48fe3375a12.png",visa:"https://static.platzi.com/commons/assets/images/visa91625977f7206bc0.png"},t={SPANISH_CO:"es-CO",SPANISH_ES:"es-ES",PORTUGUESE:"pt",ENGLISH:"en"},e="monthly_plan",o="expert_plan",i="annual_plan",m="platzi_academy",p="family_plan",c="free_plan",n="enterprise",g="user",l="b2b",f=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,b=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?!(?:hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|live))((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,d=/^[a-zA-Z\s]*$/,z=480,h=768,r=1024,v=1200,x="Platzi Expert",_="Platzi Expert+",y="Plan Empresarial",A="Platzi English Academy";


/***/ }),

/***/ 758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ u; },
  "m": function() { return /* binding */ a; }
});

// UNUSED EXPORTS: a, d

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(1296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/uuid-d9b73e12.js
const uuid_d9b73e12_e=()=>{const e=new Date;return`${e.getTime()}${e.getMilliseconds()}`};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/axiosInstance-1cddbf84.js
var axiosInstance_1cddbf84 = __webpack_require__(6830);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-7de6c45f.js
const i=lodash_debounce_default()(((e,t)=>{t(e)}),350),r=(t,n,i=350)=>{e(((e=t,i=n)=>{i(e)}),i)()};class s{constructor(e){this.options=e,this.plugins=[]}static#e="p.eyJ1IjogIjVjYTk5NDc5LTVkY2EtNDFiNC1hZGJiLWZiN2UwMmJmNjU1NSIsICJpZCI6ICI0OWQxYjEyMC04ODVhLTRiNTAtYTc1Ny0zNGMzM2UyMGMyNDgifQ.T8ubGgyDRv0-75Nl3pOlewUHPLM9eanXPRrAxVrY2Y8";addPlugin(e){this.plugins.push(e)}prepare(e){const t={agent:window.navigator.userAgent,date:(new Date).toISOString(),origin:window.origin,referer:document.referrer,...e};return this.plugins.reduce(((e,t)=>t(e)),t)}send(e){const{token:t=s.#e,name:i}=this.options,r=this.prepare(e);return (0,axiosInstance_1cddbf84.a)(!1,{headers:{Authorization:`Bearer ${t}`}}).post(`${s.urlTinyBird}?name=${i}`,r).catch((e=>{throw new Error("::ERROR::Event",{cause:e})}))}}function o(e,n){const i=uuid_d9b73e12_e();return n.setItem(e,JSON.stringify({data:i,timestamp:Date.now()})),i}s.urlTinyBird="https://api.us-east.tinybird.co/v0/events";var a={create:function(e={}){return new s(e)},SessionStudentPlugin:function(e){let n=window.sessionStorage.getItem("student-session");return n||(n=uuid_d9b73e12_e(),window.sessionStorage.setItem("student-session",n)),{...e,session:n}},createSessionPlugin:function(e,t,n={expireTime:18e5}){return function(i){const r=function(e,t,n={}){try{const i=t.getItem(e),r=JSON.parse(i),{timestamp:s=Date.now(),data:a}=r??{},{expireTime:u=0}=n;return!a||function(e,t,n){return e+t<=Date.now()}(s,u)?o(e,t):a}catch(n){return o(e,t)}}(e,t,n);return{...i,session:r}}}};var u={send:function(e){"undefined"!=typeof window&&window.dataLayer&&window.dataLayer.push(e)}};


/***/ }),

/***/ 7337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ index_f0f30b4f_h; },
  "i": function() { return /* binding */ index_f0f30b4f_m; }
});

// UNUSED EXPORTS: S, b, c, d, v

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/_rollupPluginBabelHelpers-388f54e6.js
var _rollupPluginBabelHelpers_388f54e6 = __webpack_require__(8336);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 7 modules
var i18next = __webpack_require__(5751);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/apiCalls-c0fe2c19.js
var apiCalls_c0fe2c19 = __webpack_require__(3896);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/axiosInstance-1cddbf84.js
var axiosInstance_1cddbf84 = __webpack_require__(6830);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-8d56a83f.js
var e,n,r,t,o,a,i,u,index_8d56a83f_c,f,s,index_8d56a83f_l,index_8d56a83f_p={exports:{}},y={exports:{}},d={};function m(){return n?y.exports:(n=1,y.exports=(e||(e=1,function(){var e="function"==typeof Symbol&&Symbol.for,n=e?Symbol.for("react.element"):60103,r=e?Symbol.for("react.portal"):60106,t=e?Symbol.for("react.fragment"):60107,o=e?Symbol.for("react.strict_mode"):60108,a=e?Symbol.for("react.profiler"):60114,i=e?Symbol.for("react.provider"):60109,u=e?Symbol.for("react.context"):60110,c=e?Symbol.for("react.async_mode"):60111,f=e?Symbol.for("react.concurrent_mode"):60111,s=e?Symbol.for("react.forward_ref"):60112,l=e?Symbol.for("react.suspense"):60113,p=e?Symbol.for("react.suspense_list"):60120,y=e?Symbol.for("react.memo"):60115,m=e?Symbol.for("react.lazy"):60116,b=e?Symbol.for("react.block"):60121,v=e?Symbol.for("react.fundamental"):60117,h=e?Symbol.for("react.responder"):60118,g=e?Symbol.for("react.scope"):60119;function w(e){if("object"==typeof e&&null!==e){var p=e.$$typeof;switch(p){case n:var d=e.type;switch(d){case c:case f:case t:case a:case o:case l:return d;default:var b=d&&d.$$typeof;switch(b){case u:case s:case m:case y:case i:return b;default:return p}}case r:return p}}}var O=c,S=f,x=u,j=i,T=n,E=s,I=t,P=m,$=y,k=r,R=a,A=o,C=l,_=!1;function M(e){return w(e)===f}d.AsyncMode=O,d.ConcurrentMode=S,d.ContextConsumer=x,d.ContextProvider=j,d.Element=T,d.ForwardRef=E,d.Fragment=I,d.Lazy=P,d.Memo=$,d.Portal=k,d.Profiler=R,d.StrictMode=A,d.Suspense=C,d.isAsyncMode=function(e){return _||(_=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),M(e)||w(e)===c},d.isConcurrentMode=M,d.isContextConsumer=function(e){return w(e)===u},d.isContextProvider=function(e){return w(e)===i},d.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===n},d.isForwardRef=function(e){return w(e)===s},d.isFragment=function(e){return w(e)===t},d.isLazy=function(e){return w(e)===m},d.isMemo=function(e){return w(e)===y},d.isPortal=function(e){return w(e)===r},d.isProfiler=function(e){return w(e)===a},d.isStrictMode=function(e){return w(e)===o},d.isSuspense=function(e){return w(e)===l},d.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===t||e===f||e===a||e===o||e===l||e===p||"object"==typeof e&&null!==e&&(e.$$typeof===m||e.$$typeof===y||e.$$typeof===i||e.$$typeof===u||e.$$typeof===s||e.$$typeof===v||e.$$typeof===h||e.$$typeof===g||e.$$typeof===b)},d.typeOf=w}()),d))}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/function b(){if(a)return o;a=1;return o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function v(){return u?i:(u=1,i=Function.call.bind(Object.prototype.hasOwnProperty))}var h=m();index_8d56a83f_p.exports=function(){if(index_8d56a83f_l)return s;index_8d56a83f_l=1;var e,n=m(),o=function(){if(t)return r;t=1;var e=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;function a(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}return r=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var n={},r=0;r<10;r++)n["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(n).map((function(e){return n[e]})).join(""))return!1;var t={};return"abcdefghijklmnopqrst".split("").forEach((function(e){t[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},t)).join("")}catch(e){return!1}}()?Object.assign:function(r,t){for(var i,u,c=a(r),f=1;f<arguments.length;f++){for(var s in i=Object(arguments[f]))n.call(i,s)&&(c[s]=i[s]);if(e){u=e(i);for(var l=0;l<u.length;l++)o.call(i,u[l])&&(c[u[l]]=i[u[l]])}}return c},r}(),a=b(),i=v(),u=function(){if(f)return index_8d56a83f_c;f=1;var e,n=b(),r={},t=v();function o(o,a,i,u,c){for(var f in o)if(t(o,f)){var s;try{if("function"!=typeof o[f]){var l=Error((u||"React class")+": "+i+" type `"+f+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof o[f]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw l.name="Invariant Violation",l}s=o[f](a,f,u,i,null,n)}catch(e){s=e}if(!s||s instanceof Error||e((u||"React class")+": type specification of "+i+" `"+f+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof s+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),s instanceof Error&&!(s.message in r)){r[s.message]=!0;var p=c?c():"";e("Failed "+i+" type: "+s.message+(null!=p?p:""))}}}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},o.resetWarningCache=function(){r={}},index_8d56a83f_c=o}();function p(){return null}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},s=function(r,t){var c="function"==typeof Symbol&&Symbol.iterator,f="<<anonymous>>",s={array:m("array"),bigint:m("bigint"),bool:m("boolean"),func:m("function"),number:m("number"),object:m("object"),string:m("string"),symbol:m("symbol"),any:d(p),arrayOf:function(e){return d((function(n,r,t,o,i){if("function"!=typeof e)return new y("Property `"+i+"` of component `"+t+"` has invalid PropType notation inside arrayOf.");var u=n[r];if(!Array.isArray(u))return new y("Invalid "+o+" `"+i+"` of type `"+h(u)+"` supplied to `"+t+"`, expected an array.");for(var c=0;c<u.length;c++){var f=e(u,c,t,o,i+"["+c+"]",a);if(f instanceof Error)return f}return null}))},element:d((function(e,n,t,o,a){var i=e[n];return r(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement.")})),elementType:d((function(e,r,t,o,a){var i=e[r];return n.isValidElementType(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement type.")})),instanceOf:function(e){return d((function(n,r,t,o,a){if(!(n[r]instanceof e)){var i=e.name||f;return new y("Invalid "+o+" `"+a+"` of type `"+((u=n[r]).constructor&&u.constructor.name?u.constructor.name:f)+"` supplied to `"+t+"`, expected instance of `"+i+"`.")}var u;return null}))},node:d((function(e,n,r,t,o){return v(e[n])?null:new y("Invalid "+t+" `"+o+"` supplied to `"+r+"`, expected a ReactNode.")})),objectOf:function(e){return d((function(n,r,t,o,u){if("function"!=typeof e)return new y("Property `"+u+"` of component `"+t+"` has invalid PropType notation inside objectOf.");var c=n[r],f=h(c);if("object"!==f)return new y("Invalid "+o+" `"+u+"` of type `"+f+"` supplied to `"+t+"`, expected an object.");for(var s in c)if(i(c,s)){var l=e(c,s,t,o,u+"."+s,a);if(l instanceof Error)return l}return null}))},oneOf:function(n){if(!Array.isArray(n))return e(arguments.length>1?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array."),p;function r(e,r,t,o,a){for(var i=e[r],u=0;u<n.length;u++)if(l(i,n[u]))return null;var c=JSON.stringify(n,(function(e,n){return"symbol"===g(n)?String(n):n}));return new y("Invalid "+o+" `"+a+"` of value `"+String(i)+"` supplied to `"+t+"`, expected one of "+c+".")}return d(r)},oneOfType:function(n){if(!Array.isArray(n))return e("Invalid argument supplied to oneOfType, expected an instance of array."),p;for(var r=0;r<n.length;r++){var t=n[r];if("function"!=typeof t)return e("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+w(t)+" at index "+r+"."),p}return d((function(e,r,t,o,u){for(var c=[],f=0;f<n.length;f++){var s=(0,n[f])(e,r,t,o,u,a);if(null==s)return null;s.data&&i(s.data,"expectedType")&&c.push(s.data.expectedType)}return new y("Invalid "+o+" `"+u+"` supplied to `"+t+"`"+(c.length>0?", expected one of type ["+c.join(", ")+"]":"")+".")}))},shape:function(e){return d((function(n,r,t,o,i){var u=n[r],c=h(u);if("object"!==c)return new y("Invalid "+o+" `"+i+"` of type `"+c+"` supplied to `"+t+"`, expected `object`.");for(var f in e){var s=e[f];if("function"!=typeof s)return b(t,o,i,f,g(s));var l=s(u,f,t,o,i+"."+f,a);if(l)return l}return null}))},exact:function(e){return d((function(n,r,t,u,c){var f=n[r],s=h(f);if("object"!==s)return new y("Invalid "+u+" `"+c+"` of type `"+s+"` supplied to `"+t+"`, expected `object`.");var l=o({},n[r],e);for(var p in l){var d=e[p];if(i(e,p)&&"function"!=typeof d)return b(t,u,c,p,g(d));if(!d)return new y("Invalid "+u+" `"+c+"` key `"+p+"` supplied to `"+t+"`.\nBad object: "+JSON.stringify(n[r],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var m=d(f,p,t,u,c+"."+p,a);if(m)return m}return null}))}};function l(e,n){return e===n?0!==e||1/e==1/n:e!=e&&n!=n}function y(e,n){this.message=e,this.data=n&&"object"==typeof n?n:{},this.stack=""}function d(n){var r={},o=0;function i(i,u,c,s,l,p,d){if(s=s||f,p=p||c,d!==a){if(t){var m=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw m.name="Invariant Violation",m}if("undefined"!=typeof console){var b=s+":"+c;!r[b]&&o<3&&(e("You are manually calling a React.PropTypes validation function for the `"+p+"` prop on `"+s+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),r[b]=!0,o++)}}return null==u[c]?i?null===u[c]?new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `null`."):new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `undefined`."):null:n(u,c,s,l,p)}var u=i.bind(null,!1);return u.isRequired=i.bind(null,!0),u}function m(e){return d((function(n,r,t,o,a,i){var u=n[r];return h(u)!==e?new y("Invalid "+o+" `"+a+"` of type `"+g(u)+"` supplied to `"+t+"`, expected `"+e+"`.",{expectedType:e}):null}))}function b(e,n,r,t,o){return new y((e||"React class")+": "+n+" type `"+r+"."+t+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+o+"`.")}function v(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(v);if(null===e||r(e))return!0;var n=function(e){var n=e&&(c&&e[c]||e["@@iterator"]);if("function"==typeof n)return n}(e);if(!n)return!1;var t,o=n.call(e);if(n!==e.entries){for(;!(t=o.next()).done;)if(!v(t.value))return!1}else for(;!(t=o.next()).done;){var a=t.value;if(a&&!v(a[1]))return!1}return!0;default:return!1}}function h(e){var n=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":function(e,n){return"symbol"===e||!!n&&("Symbol"===n["@@toStringTag"]||"function"==typeof Symbol&&n instanceof Symbol)}(n,e)?"symbol":n}function g(e){if(null==e)return""+e;var n=h(e);if("object"===n){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return n}function w(e){var n=g(e);switch(n){case"array":case"object":return"an "+n;case"boolean":case"date":case"regexp":return"a "+n;default:return n}}return y.prototype=Error.prototype,s.checkPropTypes=u,s.resetWarningCache=u.resetWarningCache,s.PropTypes=s,s},s}()(h.isElement,!0);

// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(6245);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-f0f30b4f.js
var index_f0f30b4f_m=Object.freeze({__proto__:null,ReactTranslationsHOC:r=>a=>{const{t:s,i18n:o}=(0,useTranslation/* useTranslation */.$)();return react.createElement(r,(0,_rollupPluginBabelHelpers_388f54e6._)({},a,{t:s,i18n:o}))},translationsConfig:({messages:e,locale:t})=>{const r={[t]:{translations:e}};i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({resources:r,lng:t,fallbackLng:t,debug:!1,ns:["translations"],defaultNS:"translations",keySeparator:!1,interpolation:{escapeValue:!1}})}}),index_f0f30b4f_h=Object.freeze({__proto__:null,serverApi:apiCalls_c0fe2c19.s,clientApi:apiCalls_c0fe2c19.c,axiosInstance:axiosInstance_1cddbf84.a,axiosServerInstance:axiosInstance_1cddbf84.b});const _=(0,react.createContext)(),E=(e,t)=>{switch(t.type){case"init":return{...e,token:t.payload.token,url:t.payload.url,headers:t.payload.headers||{}};case"track":case"visit":return{...e,lastEvent:t.payload.event}}return e},index_f0f30b4f_f={token:null,url:null,lastEvent:null},w=({children:e})=>{const[r,n]=(0,react.useReducer)(E,index_f0f30b4f_f),s={init:async()=>{const e=await (0,axiosInstance_1cddbf84.a)(!0).get(apiCalls_c0fe2c19.c.auth.credentials),{token:t}=null==e?void 0:e.data,r={token:t.access,url:t.microservices.sif_url,headers:t.headers?t.headers:{}};n({type:"init",payload:r})},trackVisit:async(e,t)=>{const a={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},s={source:"web","user-agent":navigator.userAgent,properties:t},o={event:{...s,event:e}};await (0,axiosInstance_1cddbf84.a)(!1,a).post(apiCalls_c0fe2c19.c.sif.tracking,{...s,event:e}),n({type:"visit",payload:o})},track:async(e,t)=>{const a={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},s={source:"web",properties:t},o={event:{...s,event:e}};await (0,axiosInstance_1cddbf84.a)(!1,a).post(apiCalls_c0fe2c19.c.sif.tracking,{...s,event:e}),n({type:"track",payload:o})}};return react.createElement(_.Provider,{value:{sif:r,sifActions:s}},e)};w.propTypes={children:index_8d56a83f_p.exports.node};const index_f0f30b4f_v=async(e="credentials")=>{const t=localStorage.getItem(`${e}_token`),r=localStorage.getItem(`${e}_headers`),a=localStorage.getItem(`${e}_microservicesUrl`);return t&&a?{token:t,headers:JSON.parse(r),microservicesUrl:JSON.parse(a)}:await index_f0f30b4f_y(e)},index_f0f30b4f_y=async(e="credentials",t=null)=>{try{const r=t?`${c.auth.credentials}?company_id=${t}`:c.auth.credentials,a=await l(!0).get("credentials"===e?r:c.auth.liveCredentials(e)),{token:{access:n,headers:s,microservices:o}}=a.data;return await localStorage.setItem(`${e}_token`,n),await localStorage.setItem(`${e}_headers`,JSON.stringify(a.data.token.headers?s:{})),await localStorage.setItem(`${e}_microservicesUrl`,JSON.stringify(a.data.token.microservices?a.data.token.microservices:{})),await{token:n,headers:s,microservicesUrl:o}}catch(e){throw new Error({type:"::ERROR::CLIENT_REQUEST_CREDENTIALS_REFRESH_TOKEN",error:e})}};const g=async(e="credentials",t=null,r=null)=>{const a=localStorage.getItem(`${e}_token`);return a?function(e){const{exp:t}=p(e);return Date.now()>=1e3*t}(a)||function(e,t){if(!e)return!1;const{sub:r}=p(t);return Number(e)!==Number(r)}(t,a)||function(e,t){if(!e)return!1;const{cid:r}=p(t);return Number(e)!==Number(r)}(r,a)?await index_f0f30b4f_y(e,r):void 0:await index_f0f30b4f_v(e)},R=async(e,t,r="credentials")=>{let a=await index_f0f30b4f_v(r);void 0===a.microservicesUrl[`${e}_url`]&&(a=await index_f0f30b4f_y(r));const n={baseURL:`${a.microservicesUrl[`${e}_url`]}`,headers:k(a.token,a.headers)};return await S(0,n,t,r,e)},S=async(e,t,r,a="credentials",n)=>{if(e>=3)return new Promise(((e,t)=>{e({})}));{const{requestURL:o,payload:i,method:c}=r;try{const e=await l(!1,t)[c](o,i);return await e.data}catch(o){var s;if(401===(null==o||null===(s=o.response)||void 0===s?void 0:s.status))return index_f0f30b4f_y(a).then((s=>S(e+1,{...t,headers:k(s.token,s.headers),baseURL:`${s.microservicesUrl[`${n}_url`]}`},r,a,n).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_SEND_REQUEST",error:e})})))).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_REFRESH_TOKEN",error:e})}));throw new Error({type:"::ERROR::CLIENT_REQUEST_REQUEST",err:o})}}},k=(e,t)=>t==={}?{"API-Authorization":`Bearer ${e}`}:{"API-Authorization":`Bearer ${e}`,...t};var index_f0f30b4f_b=Object.freeze({__proto__:null,SIF:(e,t={},r=!1)=>{let a={source:"web",event:e,properties:t};if(r){const e=(()=>{let e={landing:window.location.href,meta_request_method:"GET",meta_path_info:location.pathname};document.referrer.length&&(e={...e,meta_http_referer:document.referrer}),location.search.length&&(e={...e,meta_query_string:location.search});const t=new URLSearchParams(window.location.search);for(const r of t)r[0].includes("utm_")&&(e={...e,[r[0]]:r[1]});return e})();a={...a,properties:{...t,...e},"user-agent":navigator.userAgent}}return a},GOSSIP:()=>{throw new Error("Not implemente yet!")},ENIGMA:()=>{throw new Error("Not implemente yet!")}});


/***/ }),

/***/ 6518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ c; },
  "c": function() { return /* binding */ p; },
  "e": function() { return /* binding */ f; }
});

// UNUSED EXPORTS: b, d, g, u

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(6110);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/ActionTypes-f5b854b0.js
const E="SET_REGISTER_MODAL";

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-7de6c45f.js + 1 modules
var index_7de6c45f = __webpack_require__(758);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/useRegisterModal-23dbb00b.js
const d=o=>{const[t,n]=e(o);return{value:t,onChange:e=>n(e.target.value)}},s="undefined"!=typeof window,a=()=>({width:s?window.innerWidth:void 0,height:s?window.innerHeight:void 0}),c=()=>{const[t,n]=(0,react.useState)(a());return (0,react.useEffect)((()=>{const e=()=>{n(a())};return s?(window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}):null}),[]),t},l=(t,n)=>{if("undefined"==typeof window)return[n,null];const[i,r]=e((()=>window.localStorage.getItem(t)||n));return o((()=>{window.localStorage.setItem(t,i)}),[t,i]),[i,r]},m=e=>"undefined"!=typeof document&&document.cookie.split(";").some((o=>o.trim().startsWith(`${e}=`))),u=(e,o,t)=>document.cookie=`${e}=${o}; max-age=${t}`,g=e=>{const o="undefined"!=typeof document&&document.cookie.match(new RegExp("(?:^|; )"+e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g,"\\$1")+"=([^;]*)"));return o?decodeURIComponent(o[1]):void 0},p=()=>({checkCookie:m,setCookie:u,getCookie:g}),w=t=>{const[n,i]=e("");return o((()=>{if("undefined"!=typeof window){const e=new URLSearchParams(window.location.search);i(e.get(t))}}),[]),{variable:n}},f=()=>{var e;const o=(0,es/* useDispatch */.I0)(),d=(null===(e=(0,es/* useSelector */.v9)((e=>e.get("header").get("register_modal"))))||void 0===e?void 0:e.toJS())||{},s=e=>{var t;o((t={...d,...e},{type:E,payload:t}))};return{isRegisterModalOpen:(null==d?void 0:d.isOpen)||!1,openRegisterModal:(e={})=>{index_7de6c45f.T.send({event:"register_modal_impression",...e}),s({isOpen:!0})},closeRegisterModal:(e={})=>{index_7de6c45f.T.send({event:"register_modal_close",...e}),s({isOpen:!1})},setModalConfig:s,configRegisterModal:d}};


/***/ }),

/***/ 9634:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 6445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,o){ true?module.exports=o(__webpack_require__(9634)):0}(this,(function(e){"use strict";function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(e),d={name:"es",monthsShort:"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),weekStart:1,formats:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinal:function(e){return e+"º"}};return s.default.locale(d,null,!0),d}));

/***/ }),

/***/ 3938:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 9960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "cy": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __extends, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 4955:
/***/ (function(module) {

/*! algoliasearch.umd.js | 4.16.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";function t(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function e(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function r(r){for(var n=1;n<arguments.length;n++){var a=null!=arguments[n]?arguments[n]:{};n%2?e(Object(a),!0).forEach((function(e){t(r,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(r,Object.getOwnPropertyDescriptors(a)):e(Object(a)).forEach((function(t){Object.defineProperty(r,t,Object.getOwnPropertyDescriptor(a,t))}))}return r}function n(t,e){if(null==t)return{};var r,n,a=function(t,e){if(null==t)return{};var r,n,a={},o=Object.keys(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||(a[r]=t[r]);return a}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(t,r)&&(a[r]=t[r])}return a}function a(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if(!(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t)))return;var r=[],n=!0,a=!1,o=void 0;try{for(var i,u=t[Symbol.iterator]();!(n=(i=u.next()).done)&&(r.push(i.value),!e||r.length!==e);n=!0);}catch(t){a=!0,o=t}finally{try{n||null==u.return||u.return()}finally{if(a)throw o}}return r}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function o(t){return function(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function i(t){var e,r="algoliasearch-client-js-".concat(t.key),n=function(){return void 0===e&&(e=t.localStorage||window.localStorage),e},o=function(){return JSON.parse(n().getItem(r)||"{}")};return{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return Promise.resolve().then((function(){var r=JSON.stringify(t),n=o()[r];return Promise.all([n||e(),void 0!==n])})).then((function(t){var e=a(t,2),n=e[0],o=e[1];return Promise.all([n,o||r.miss(n)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve().then((function(){var a=o();return a[JSON.stringify(t)]=e,n().setItem(r,JSON.stringify(a)),e}))},delete:function(t){return Promise.resolve().then((function(){var e=o();delete e[JSON.stringify(t)],n().setItem(r,JSON.stringify(e))}))},clear:function(){return Promise.resolve().then((function(){n().removeItem(r)}))}}}function u(t){var e=o(t.caches),r=e.shift();return void 0===r?{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},n=e();return n.then((function(t){return Promise.all([t,r.miss(t)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve(e)},delete:function(t){return Promise.resolve()},clear:function(){return Promise.resolve()}}:{get:function(t,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return r.get(t,n,a).catch((function(){return u({caches:e}).get(t,n,a)}))},set:function(t,n){return r.set(t,n).catch((function(){return u({caches:e}).set(t,n)}))},delete:function(t){return r.delete(t).catch((function(){return u({caches:e}).delete(t)}))},clear:function(){return r.clear().catch((function(){return u({caches:e}).clear()}))}}}function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{serializable:!0},e={};return{get:function(r,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},o=JSON.stringify(r);if(o in e)return Promise.resolve(t.serializable?JSON.parse(e[o]):e[o]);var i=n(),u=a&&a.miss||function(){return Promise.resolve()};return i.then((function(t){return u(t)})).then((function(){return i}))},set:function(r,n){return e[JSON.stringify(r)]=t.serializable?JSON.stringify(n):n,Promise.resolve(n)},delete:function(t){return delete e[JSON.stringify(t)],Promise.resolve()},clear:function(){return e={},Promise.resolve()}}}function c(t,e,r){var n={"x-algolia-api-key":r,"x-algolia-application-id":e};return{headers:function(){return t===m.WithinHeaders?n:{}},queryParameters:function(){return t===m.WithinQueryParameters?n:{}}}}function f(t){var e=0;return t((function r(){return e++,new Promise((function(n){setTimeout((function(){n(t(r))}),Math.min(100*e,1e3))}))}))}function d(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(t,e){return Promise.resolve()};return Object.assign(t,{wait:function(r){return d(t.then((function(t){return Promise.all([e(t,r),t])})).then((function(t){return t[1]})))}})}function l(t){for(var e=t.length-1;e>0;e--){var r=Math.floor(Math.random()*(e+1)),n=t[e];t[e]=t[r],t[r]=n}return t}function p(t,e){return e?(Object.keys(e).forEach((function(r){t[r]=e[r](t)})),t):t}function h(t){for(var e=arguments.length,r=new Array(e>1?e-1:0),n=1;n<e;n++)r[n-1]=arguments[n];var a=0;return t.replace(/%s/g,(function(){return encodeURIComponent(r[a++])}))}var m={WithinQueryParameters:0,WithinHeaders:1};function y(t,e){var r=t||{},n=r.data||{};return Object.keys(r).forEach((function(t){-1===["timeout","headers","queryParameters","data","cacheable"].indexOf(t)&&(n[t]=r[t])})),{data:Object.entries(n).length>0?n:void 0,timeout:r.timeout||e,headers:r.headers||{},queryParameters:r.queryParameters||{},cacheable:r.cacheable}}var g={Read:1,Write:2,Any:3},v=1,b=2,P=3;function w(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:v;return r(r({},t),{},{status:e,lastUpdate:Date.now()})}function O(t){return"string"==typeof t?{protocol:"https",url:t,accept:g.Any}:{protocol:t.protocol||"https",url:t.url,accept:t.accept||g.Any}}var I="DELETE",x="GET",j="POST",D="PUT";function q(t,e){return Promise.all(e.map((function(e){return t.get(e,(function(){return Promise.resolve(w(e))}))}))).then((function(t){var r=t.filter((function(t){return function(t){return t.status===v||Date.now()-t.lastUpdate>12e4}(t)})),n=t.filter((function(t){return function(t){return t.status===P&&Date.now()-t.lastUpdate<=12e4}(t)})),a=[].concat(o(r),o(n));return{getTimeout:function(t,e){return(0===n.length&&0===t?1:n.length+3+t)*e},statelessHosts:a.length>0?a.map((function(t){return O(t)})):e}}))}function S(t,e,n,a){var i=[],u=function(t,e){if(t.method===x||void 0===t.data&&void 0===e.data)return;var n=Array.isArray(t.data)?t.data:r(r({},t.data),e.data);return JSON.stringify(n)}(n,a),s=function(t,e){var n=r(r({},t.headers),e.headers),a={};return Object.keys(n).forEach((function(t){var e=n[t];a[t.toLowerCase()]=e})),a}(t,a),c=n.method,f=n.method!==x?{}:r(r({},n.data),a.data),d=r(r(r({"x-algolia-agent":t.userAgent.value},t.queryParameters),f),a.queryParameters),l=0,p=function e(r,o){var f=r.pop();if(void 0===f)throw{name:"RetryError",message:"Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",transporterStackTrace:R(i)};var p={data:u,headers:s,method:c,url:N(f,n.path,d),connectTimeout:o(l,t.timeouts.connect),responseTimeout:o(l,a.timeout)},h=function(t){var e={request:p,response:t,host:f,triesLeft:r.length};return i.push(e),e},m={onSuccess:function(t){return function(t){try{return JSON.parse(t.content)}catch(e){throw function(t,e){return{name:"DeserializationError",message:t,response:e}}(e.message,t)}}(t)},onRetry:function(n){var a=h(n);return n.isTimedOut&&l++,Promise.all([t.logger.info("Retryable failure",A(a)),t.hostsCache.set(f,w(f,n.isTimedOut?P:b))]).then((function(){return e(r,o)}))},onFail:function(t){throw h(t),function(t,e){var r=t.content,n=t.status,a=r;try{a=JSON.parse(r).message}catch(t){}return function(t,e,r){return{name:"ApiError",message:t,status:e,transporterStackTrace:r}}(a,n,e)}(t,R(i))}};return t.requester.send(p).then((function(t){return function(t,e){return function(t){var e=t.status;return t.isTimedOut||function(t){var e=t.isTimedOut,r=t.status;return!e&&0==~~r}(t)||2!=~~(e/100)&&4!=~~(e/100)}(t)?e.onRetry(t):2==~~(t.status/100)?e.onSuccess(t):e.onFail(t)}(t,m)}))};return q(t.hostsCache,e).then((function(t){return p(o(t.statelessHosts).reverse(),t.getTimeout)}))}function k(t){var e=t.hostsCache,r=t.logger,n=t.requester,o=t.requestsCache,i=t.responsesCache,u=t.timeouts,s=t.userAgent,c=t.hosts,f=t.queryParameters,d={hostsCache:e,logger:r,requester:n,requestsCache:o,responsesCache:i,timeouts:u,userAgent:s,headers:t.headers,queryParameters:f,hosts:c.map((function(t){return O(t)})),read:function(t,e){var r=y(e,d.timeouts.read),n=function(){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Read)})),t,r)};if(!0!==(void 0!==r.cacheable?r.cacheable:t.cacheable))return n();var o={request:t,mappedRequestOptions:r,transporter:{queryParameters:d.queryParameters,headers:d.headers}};return d.responsesCache.get(o,(function(){return d.requestsCache.get(o,(function(){return d.requestsCache.set(o,n()).then((function(t){return Promise.all([d.requestsCache.delete(o),t])}),(function(t){return Promise.all([d.requestsCache.delete(o),Promise.reject(t)])})).then((function(t){var e=a(t,2);e[0];return e[1]}))}))}),{miss:function(t){return d.responsesCache.set(o,t)}})},write:function(t,e){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Write)})),t,y(e,d.timeouts.write))}};return d}function T(t){var e={value:"Algolia for JavaScript (".concat(t,")"),add:function(t){var r="; ".concat(t.segment).concat(void 0!==t.version?" (".concat(t.version,")"):"");return-1===e.value.indexOf(r)&&(e.value="".concat(e.value).concat(r)),e}};return e}function N(t,e,r){var n=E(r),a="".concat(t.protocol,"://").concat(t.url,"/").concat("/"===e.charAt(0)?e.substr(1):e);return n.length&&(a+="?".concat(n)),a}function E(t){return Object.keys(t).map((function(e){return h("%s=%s",e,(r=t[e],"[object Object]"===Object.prototype.toString.call(r)||"[object Array]"===Object.prototype.toString.call(r)?JSON.stringify(t[e]):t[e]));var r})).join("&")}function R(t){return t.map((function(t){return A(t)}))}function A(t){var e=t.request.headers["x-algolia-api-key"]?{"x-algolia-api-key":"*****"}:{};return r(r({},t),{},{request:r(r({},t.request),{},{headers:r(r({},t.request.headers),e)})})}var C=function(t){return function(e,r){return t.transporter.write({method:j,path:"2/abtests",data:e},r)}},U=function(t){return function(e,r){return t.transporter.write({method:I,path:h("2/abtests/%s",e)},r)}},z=function(t){return function(e,r){return t.transporter.read({method:x,path:h("2/abtests/%s",e)},r)}},J=function(t){return function(e){return t.transporter.read({method:x,path:"2/abtests"},e)}},F=function(t){return function(e,r){return t.transporter.write({method:j,path:h("2/abtests/%s/stop",e)},r)}},H=function(t){return function(e){return t.transporter.read({method:x,path:"1/strategies/personalization"},e)}},M=function(t){return function(e,r){return t.transporter.write({method:j,path:"1/strategies/personalization",data:e},r)}};function K(t){return function e(r){return t.request(r).then((function(n){if(void 0!==t.batch&&t.batch(n.hits),!t.shouldStop(n))return n.cursor?e({cursor:n.cursor}):e({page:(r.page||0)+1})}))}({})}var W=function(t){return function(e,a){var o=a||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=r({acl:e},void 0!==i?{queryParameters:i}:{});return d(t.transporter.write({method:j,path:"1/keys",data:s},u),(function(e,r){return f((function(n){return tt(t)(e.key,r).catch((function(t){if(404!==t.status)throw t;return n()}))}))}))}},B=function(t){return function(e,r,n){var a=y(n);return a.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:j,path:"1/clusters/mapping",data:{cluster:r}},a)}},Q=function(t){return function(e,r,n){return t.transporter.write({method:j,path:"1/clusters/mapping/batch",data:{users:e,cluster:r}},n)}},G=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:{action:"addEntry",body:[]}}},r),(function(e,r){return jt(t)(e.taskID,r)}))}},L=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"copy",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},V=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Rules]}))}},_=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Settings]}))}},X=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Synonyms]}))}},Y=function(t){return function(e,r){return e.method===x?t.transporter.read(e,r):t.transporter.write(e,r)}},Z=function(t){return function(e,r){return d(t.transporter.write({method:I,path:h("1/keys/%s",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).then(r).catch((function(t){if(404!==t.status)throw t}))}))}))}},$=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"deleteEntry",body:{objectID:t}}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},tt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/keys/%s",e)},r)}},et=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/task/%s",e.toString())},r)}},rt=function(t){return function(e){return t.transporter.read({method:x,path:"/1/dictionaries/*/settings"},e)}},nt=function(t){return function(e){return t.transporter.read({method:x,path:"1/logs"},e)}},at=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping/top"},e)}},ot=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/clusters/mapping/%s",e)},r)}},it=function(t){return function(e){var r=e||{},a=r.retrieveMappings,o=n(r,["retrieveMappings"]);return!0===a&&(o.getClusters=!0),t.transporter.read({method:x,path:"1/clusters/mapping/pending"},o)}},ut=function(t){return function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={transporter:t.transporter,appId:t.appId,indexName:e};return p(n,r.methods)}},st=function(t){return function(e){return t.transporter.read({method:x,path:"1/keys"},e)}},ct=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters"},e)}},ft=function(t){return function(e){return t.transporter.read({method:x,path:"1/indexes"},e)}},dt=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping"},e)}},lt=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"move",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},pt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:"1/indexes/*/batch",data:{requests:e}},r),(function(e,r){return Promise.all(Object.keys(e.taskID).map((function(n){return ut(t)(n,{methods:{waitTask:de}}).waitTask(e.taskID[n],r)})))}))}},ht=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:e}},r)}},mt=function(t){return function(e,n){var a=e.map((function(t){return r(r({},t),{},{params:E(t.params||{})})}));return t.transporter.read({method:j,path:"1/indexes/*/queries",data:{requests:a},cacheable:!0},n)}},yt=function(t){return function(e,a){return Promise.all(e.map((function(e){var o=e.params,i=o.facetName,u=o.facetQuery,s=n(o,["facetName","facetQuery"]);return ut(t)(e.indexName,{methods:{searchForFacetValues:ue}}).searchForFacetValues(i,u,r(r({},a),s))})))}},gt=function(t){return function(e,r){var n=y(r);return n.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:I,path:"1/clusters/mapping"},n)}},vt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},bt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/keys/%s/restore",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).catch((function(t){if(404!==t.status)throw t;return r()}))}))}))}},Pt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},wt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("/1/dictionaries/%s/search",e),data:{query:r},cacheable:!0},n)}},Ot=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/clusters/mapping/search",data:{query:e}},r)}},It=function(t){return function(e,r){return d(t.transporter.write({method:D,path:"/1/dictionaries/*/settings",data:e},r),(function(e,r){return jt(t)(e.taskID,r)}))}},xt=function(t){return function(e,r){var a=Object.assign({},r),o=r||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=i?{queryParameters:i}:{},c=["acl","indexes","referers","restrictSources","queryParameters","description","maxQueriesPerIPPerHour","maxHitsPerQuery"];return d(t.transporter.write({method:D,path:h("1/keys/%s",e),data:s},u),(function(r,n){return f((function(r){return tt(t)(e,n).then((function(t){return function(t){return Object.keys(a).filter((function(t){return-1!==c.indexOf(t)})).every((function(e){return t[e]===a[e]}))}(t)?Promise.resolve():r()}))}))}))}},jt=function(t){return function(e,r){return f((function(n){return et(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},Dt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/batch",t.indexName),data:{requests:e}},r),(function(e,r){return de(t)(e.taskID,r)}))}},qt=function(t){return function(e){return K(r(r({shouldStop:function(t){return void 0===t.cursor}},e),{},{request:function(r){return t.transporter.read({method:j,path:h("1/indexes/%s/browse",t.indexName),data:r},e)}}))}},St=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return se(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},kt=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return ce(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},Tt=function(t){return function(e,r,a){var o=a||{},i=o.batchSize,u=n(o,["batchSize"]),s={taskIDs:[],objectIDs:[]};return d(function n(){var a,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,c=[];for(a=o;a<e.length&&(c.push(e[a]),c.length!==(i||1e3));a++);return 0===c.length?Promise.resolve(s):Dt(t)(c.map((function(t){return{action:r,body:t}})),u).then((function(t){return s.objectIDs=s.objectIDs.concat(t.objectIDs),s.taskIDs.push(t.taskID),a++,n(a)}))}(),(function(e,r){return Promise.all(e.taskIDs.map((function(e){return de(t)(e,r)})))}))}},Nt=function(t){return function(e){return d(t.transporter.write({method:j,path:h("1/indexes/%s/clear",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Et=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},Rt=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},At=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/deleteByQuery",t.indexName),data:e},r),(function(e,r){return de(t)(e.taskID,r)}))}},Ct=function(t){return function(e){return d(t.transporter.write({method:I,path:h("1/indexes/%s",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Ut=function(t){return function(e,r){return d(zt(t)([e],r).then((function(t){return{taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},zt=function(t){return function(e,r){var n=e.map((function(t){return{objectID:t}}));return Tt(t)(n,le.DeleteObject,r)}},Jt=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/rules/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ft=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ht=function(t){return function(e){return Lt(t)(e).then((function(){return!0})).catch((function(t){if(404!==t.status)throw t;return!1}))}},Mt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/answers/%s/prediction",t.indexName),data:{query:e,queryLanguages:r},cacheable:!0},n)}},Kt=function(t){return function(e,o){var i=o||{},u=i.query,s=i.paginate,c=n(i,["query","paginate"]),f=0;return function n(){return ie(t)(u||"",r(r({},c),{},{page:f})).then((function(t){for(var r=0,o=Object.entries(t.hits);r<o.length;r++){var i=a(o[r],2),u=i[0],c=i[1];if(e(c))return{object:c,position:parseInt(u,10),page:f}}if(f++,!1===s||f>=t.nbPages)throw{name:"ObjectNotFoundError",message:"Object not found."};return n()}))}()}},Wt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/%s",t.indexName,e)},r)}},Bt=function(){return function(t,e){for(var r=0,n=Object.entries(t.hits);r<n.length;r++){var o=a(n[r],2),i=o[0];if(o[1].objectID===e)return parseInt(i,10)}return-1}},Qt=function(t){return function(e,a){var o=a||{},i=o.attributesToRetrieve,u=n(o,["attributesToRetrieve"]),s=e.map((function(e){return r({indexName:t.indexName,objectID:e},i?{attributesToRetrieve:i}:{})}));return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:s}},u)}},Gt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/rules/%s",t.indexName,e)},r)}},Lt=function(t){return function(e){return t.transporter.read({method:x,path:h("1/indexes/%s/settings",t.indexName),data:{getVersion:2}},e)}},Vt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},r)}},_t=function(t){return function(e,r){return d(Xt(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},Xt=function(t){return function(e,r){var a=r||{},o=a.createIfNotExists,i=n(a,["createIfNotExists"]),u=o?le.PartialUpdateObject:le.PartialUpdateObjectNoCreate;return Tt(t)(e,u,i)}},Yt=function(t){return function(e,i){var u=i||{},s=u.safe,c=u.autoGenerateObjectIDIfNotExist,f=u.batchSize,l=n(u,["safe","autoGenerateObjectIDIfNotExist","batchSize"]),p=function(e,r,n,a){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:n,destination:r}},a),(function(e,r){return de(t)(e.taskID,r)}))},m=Math.random().toString(36).substring(7),y="".concat(t.indexName,"_tmp_").concat(m),g=ee({appId:t.appId,transporter:t.transporter,indexName:y}),v=[],b=p(t.indexName,y,"copy",r(r({},l),{},{scope:["settings","synonyms","rules"]}));return v.push(b),d((s?b.wait(l):b).then((function(){var t=g(e,r(r({},l),{},{autoGenerateObjectIDIfNotExist:c,batchSize:f}));return v.push(t),s?t.wait(l):t})).then((function(){var e=p(y,t.indexName,"move",l);return v.push(e),s?e.wait(l):e})).then((function(){return Promise.all(v)})).then((function(t){var e=a(t,3),r=e[0],n=e[1],i=e[2];return{objectIDs:n.objectIDs,taskIDs:[r.taskID].concat(o(n.taskIDs),[i.taskID])}})),(function(t,e){return Promise.all(v.map((function(t){return t.wait(e)})))}))}},Zt=function(t){return function(e,n){return ne(t)(e,r(r({},n),{},{clearExistingRules:!0}))}},$t=function(t){return function(e,n){return oe(t)(e,r(r({},n),{},{clearExistingSynonyms:!0}))}},te=function(t){return function(e,r){return d(ee(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},ee=function(t){return function(e,r){var a=r||{},o=a.autoGenerateObjectIDIfNotExist,i=n(a,["autoGenerateObjectIDIfNotExist"]),u=o?le.AddObject:le.UpdateObject;if(u===le.UpdateObject){var s=!0,c=!1,f=void 0;try{for(var l,p=e[Symbol.iterator]();!(s=(l=p.next()).done);s=!0){if(void 0===l.value.objectID)return d(Promise.reject({name:"MissingObjectIDError",message:"All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."}))}}catch(t){c=!0,f=t}finally{try{s||null==p.return||p.return()}finally{if(c)throw f}}}return Tt(t)(e,u,i)}},re=function(t){return function(e,r){return ne(t)([e],r)}},ne=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingRules,u=y(n(a,["forwardToReplicas","clearExistingRules"]));return o&&(u.queryParameters.forwardToReplicas=1),i&&(u.queryParameters.clearExistingRules=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/batch",t.indexName),data:e},u),(function(e,r){return de(t)(e.taskID,r)}))}},ae=function(t){return function(e,r){return oe(t)([e],r)}},oe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingSynonyms,u=a.replaceExistingSynonyms,s=y(n(a,["forwardToReplicas","clearExistingSynonyms","replaceExistingSynonyms"]));return o&&(s.queryParameters.forwardToReplicas=1),(u||i)&&(s.queryParameters.replaceExistingSynonyms=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/batch",t.indexName),data:e},s),(function(e,r){return de(t)(e.taskID,r)}))}},ie=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/query",t.indexName),data:{query:e},cacheable:!0},r)}},ue=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/indexes/%s/facets/%s/query",t.indexName,e),data:{facetQuery:r},cacheable:!0},n)}},se=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/rules/search",t.indexName),data:{query:e}},r)}},ce=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/synonyms/search",t.indexName),data:{query:e}},r)}},fe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:D,path:h("1/indexes/%s/settings",t.indexName),data:e},i),(function(e,r){return de(t)(e.taskID,r)}))}},de=function(t){return function(e,r){return f((function(n){return function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/task/%s",t.indexName,e.toString())},r)}}(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},le={AddObject:"addObject",UpdateObject:"updateObject",PartialUpdateObject:"partialUpdateObject",PartialUpdateObjectNoCreate:"partialUpdateObjectNoCreate",DeleteObject:"deleteObject",DeleteIndex:"delete",ClearIndex:"clear"},pe={Settings:"settings",Synonyms:"synonyms",Rules:"rules"},he=1,me=2,ye=3;function ge(t,e,n){var a,o={appId:t,apiKey:e,timeouts:{connect:1,read:2,write:30},requester:{send:function(t){return new Promise((function(e){var r=new XMLHttpRequest;r.open(t.method,t.url,!0),Object.keys(t.headers).forEach((function(e){return r.setRequestHeader(e,t.headers[e])}));var n,a=function(t,n){return setTimeout((function(){r.abort(),e({status:0,content:n,isTimedOut:!0})}),1e3*t)},o=a(t.connectTimeout,"Connection timeout");r.onreadystatechange=function(){r.readyState>r.OPENED&&void 0===n&&(clearTimeout(o),n=a(t.responseTimeout,"Socket timeout"))},r.onerror=function(){0===r.status&&(clearTimeout(o),clearTimeout(n),e({content:r.responseText||"Network request failed",status:r.status,isTimedOut:!1}))},r.onload=function(){clearTimeout(o),clearTimeout(n),e({content:r.responseText,status:r.status,isTimedOut:!1})},r.send(t.data)}))}},logger:(a=ye,{debug:function(t,e){return he>=a&&console.debug(t,e),Promise.resolve()},info:function(t,e){return me>=a&&console.info(t,e),Promise.resolve()},error:function(t,e){return console.error(t,e),Promise.resolve()}}),responsesCache:s(),requestsCache:s({serializable:!1}),hostsCache:u({caches:[i({key:"".concat("4.16.0","-").concat(t)}),s()]}),userAgent:T("4.16.0").add({segment:"Browser"})},f=r(r({},o),n),d=function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"personalization.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{getPersonalizationStrategy:H,setPersonalizationStrategy:M}}))}};return function(t){var e=t.appId,n=c(void 0!==t.authMode?t.authMode:m.WithinHeaders,e,t.apiKey),a=k(r(r({hosts:[{url:"".concat(e,"-dsn.algolia.net"),accept:g.Read},{url:"".concat(e,".algolia.net"),accept:g.Write}].concat(l([{url:"".concat(e,"-1.algolianet.com")},{url:"".concat(e,"-2.algolianet.com")},{url:"".concat(e,"-3.algolianet.com")}]))},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/x-www-form-urlencoded"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({transporter:a,appId:e,addAlgoliaAgent:function(t,e){a.userAgent.add({segment:t,version:e})},clearCache:function(){return Promise.all([a.requestsCache.clear(),a.responsesCache.clear()]).then((function(){}))}},t.methods)}(r(r({},f),{},{methods:{search:mt,searchForFacetValues:yt,multipleBatch:pt,multipleGetObjects:ht,multipleQueries:mt,copyIndex:L,copySettings:_,copySynonyms:X,copyRules:V,moveIndex:lt,listIndices:ft,getLogs:nt,listClusters:ct,multipleSearchForFacetValues:yt,getApiKey:tt,addApiKey:W,listApiKeys:st,updateApiKey:xt,deleteApiKey:Z,restoreApiKey:bt,assignUserID:B,assignUserIDs:Q,getUserID:ot,searchUserIDs:Ot,listUserIDs:dt,getTopUserIDs:at,removeUserID:gt,hasPendingMappings:it,clearDictionaryEntries:G,deleteDictionaryEntries:$,getDictionarySettings:rt,getAppTask:et,replaceDictionaryEntries:vt,saveDictionaryEntries:Pt,searchDictionaryEntries:wt,setDictionarySettings:It,waitAppTask:jt,customRequest:Y,initIndex:function(t){return function(e){return ut(t)(e,{methods:{batch:Dt,delete:Ct,findAnswers:Mt,getObject:Wt,getObjects:Qt,saveObject:te,saveObjects:ee,search:ie,searchForFacetValues:ue,waitTask:de,setSettings:fe,getSettings:Lt,partialUpdateObject:_t,partialUpdateObjects:Xt,deleteObject:Ut,deleteObjects:zt,deleteBy:At,clearObjects:Nt,browseObjects:qt,getObjectPosition:Bt,findObject:Kt,exists:Ht,saveSynonym:ae,saveSynonyms:oe,getSynonym:Vt,searchSynonyms:ce,browseSynonyms:kt,deleteSynonym:Ft,clearSynonyms:Rt,replaceAllObjects:Yt,replaceAllSynonyms:$t,searchRules:se,getRule:Gt,deleteRule:Jt,saveRule:re,saveRules:ne,replaceAllRules:Zt,browseRules:St,clearRules:Et}})}},initAnalytics:function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"analytics.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{addABTest:C,getABTest:z,getABTests:J,stopABTest:F,deleteABTest:U}}))}},initPersonalization:d,initRecommendation:function(){return function(t){return f.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."),d()(t)}}}}))}return ge.version="4.16.0",ge}));


/***/ }),

/***/ 7166:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(this && this[key] || key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 7856:
/***/ (function(module) {

/*! @license DOMPurify 2.5.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.0/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
    setPrototypeOf = Object.setPrototypeOf,
    isFrozen = Object.isFrozen,
    getPrototypeOf = Object.getPrototypeOf,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
    seal = Object.seal,
    create = Object.create; // eslint-disable-line import/no-mutable-exports
  var _ref = typeof Reflect !== 'undefined' && Reflect,
    apply = _ref.apply,
    construct = _ref.construct;
  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }
  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }
  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }
  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }
  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;
    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }
    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);
    var property;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }
    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }
        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }
    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);
  var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }
    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };
  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.5.0';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];
    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      Element = window.Element,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      HTMLFormElement = window.HTMLFormElement,
      DOMParser = window.DOMParser,
      trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }
    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      createDocumentFragment = _document.createDocumentFragment,
      getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}
    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
      ERB_EXPR$1 = ERB_EXPR,
      TMPLIT_EXPR$1 = TMPLIT_EXPR,
      DATA_ATTR$1 = DATA_ATTR,
      ARIA_ATTR$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
      CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));

    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */
    var ALLOW_SELF_CLOSE_IN_ATTR = true;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */
    var SAFE_FOR_XML = true;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */
    var SANITIZE_DOM = true;

    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */
    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Allowed XHTML+XML namespaces */
    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');
    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES),
      // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS),
      // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }
      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }
      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }
        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }
      CONFIG = cfg;
    };
    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']);

    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }
      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);
      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }
      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }
      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }
      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // For XHTML and XML documents that support custom namespaces
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }
      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;
      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }
      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }
      var body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }
      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any ocurrence of processing instructions */
      if (currentNode.nodeType === 7) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any kind of possibly harmful comments */
      if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }

        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
          if (childNodes && parentNode) {
            var childCount = childNodes.length;
            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }
        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Make sure that older browsers don't get fallback-tag mXSS */
      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);
      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;
      return true;
    };

    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */
    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);
      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */
      if (!attributes) {
        return;
      }
      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */
        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode);

          // Prefix the value and later re-create the attribute with the sanitized value
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }

        /* Handle attributes that require Trusted Types */
        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }
              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }
          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }
        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }
      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);
        oldNode = currentNode;
      }
      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }
        return returnNode;
      }
      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Serialize doctype if allowed */
      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }
      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }
      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };
    return DOMPurify;
  }
  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 9238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(7856)["default"]) || __webpack_require__(7856));

/***/ }),

/***/ 6245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InvalidTokenError */
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (o)));
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),

/***/ 5107:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function() {
/**
 * Global dependencies.
 * @global {Object} document - DOM
 */

var devnull = function() {},
    bundleIdCache = {},
    bundleResultCache = {},
    bundleCallbackQueue = {};


/**
 * Subscribe to bundle load event.
 * @param {string[]} bundleIds - Bundle ids
 * @param {Function} callbackFn - The callback function
 */
function subscribe(bundleIds, callbackFn) {
  // listify
  bundleIds = bundleIds.push ? bundleIds : [bundleIds];

  var depsNotFound = [],
      i = bundleIds.length,
      numWaiting = i,
      fn,
      bundleId,
      r,
      q;

  // define callback function
  fn = function (bundleId, pathsNotFound) {
    if (pathsNotFound.length) depsNotFound.push(bundleId);

    numWaiting--;
    if (!numWaiting) callbackFn(depsNotFound);
  };

  // register callback
  while (i--) {
    bundleId = bundleIds[i];

    // execute callback if in result cache
    r = bundleResultCache[bundleId];
    if (r) {
      fn(bundleId, r);
      continue;
    }

    // add to callback queue
    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
    q.push(fn);
  }
}


/**
 * Publish bundle load event.
 * @param {string} bundleId - Bundle id
 * @param {string[]} pathsNotFound - List of files not found
 */
function publish(bundleId, pathsNotFound) {
  // exit if id isn't defined
  if (!bundleId) return;

  var q = bundleCallbackQueue[bundleId];

  // cache result
  bundleResultCache[bundleId] = pathsNotFound;

  // exit if queue is empty
  if (!q) return;

  // empty callback queue
  while (q.length) {
    q[0](bundleId, pathsNotFound);
    q.splice(0, 1);
  }
}


/**
 * Execute callbacks.
 * @param {Object or Function} args - The callback args
 * @param {string[]} depsNotFound - List of dependencies not found
 */
function executeCallbacks(args, depsNotFound) {
  // accept function as argument
  if (args.call) args = {success: args};

  // success and error callbacks
  if (depsNotFound.length) (args.error || devnull)(depsNotFound);
  else (args.success || devnull)(args);
}


/**
 * Load individual file.
 * @param {string} path - The file path
 * @param {Function} callbackFn - The callback function
 */
function loadFile(path, callbackFn, args, numTries) {
  var doc = document,
      async = args.async,
      maxTries = (args.numRetries || 0) + 1,
      beforeCallbackFn = args.before || devnull,
      pathname = path.replace(/[\?|#].*$/, ''),
      pathStripped = path.replace(/^(css|img)!/, ''),
      isLegacyIECss,
      e;

  numTries = numTries || 0;

  if (/(^css!|\.css$)/.test(pathname)) {
    // css
    e = doc.createElement('link');
    e.rel = 'stylesheet';
    e.href = pathStripped;

    // tag IE9+
    isLegacyIECss = 'hideFocus' in e;

    // use preload in IE Edge (to detect load errors)
    if (isLegacyIECss && e.relList) {
      isLegacyIECss = 0;
      e.rel = 'preload';
      e.as = 'style';
    }
  } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {
    // image
    e = doc.createElement('img');
    e.src = pathStripped;    
  } else {
    // javascript
    e = doc.createElement('script');
    e.src = path;
    e.async = async === undefined ? true : async;
  }

  e.onload = e.onerror = e.onbeforeload = function (ev) {
    var result = ev.type[0];

    // treat empty stylesheets as failures to get around lack of onerror
    // support in IE9-11
    if (isLegacyIECss) {
      try {
        if (!e.sheet.cssText.length) result = 'e';
      } catch (x) {
        // sheets objects created from load errors don't allow access to
        // `cssText` (unless error is Code:18 SecurityError)
        if (x.code != 18) result = 'e';
      }
    }

    // handle retries in case of load failure
    if (result == 'e') {
      // increment counter
      numTries += 1;

      // exit function and try again
      if (numTries < maxTries) {
        return loadFile(path, callbackFn, args, numTries);
      }
    } else if (e.rel == 'preload' && e.as == 'style') {
      // activate preloaded stylesheets
      return e.rel = 'stylesheet'; // jshint ignore:line
    }
    
    // execute callback
    callbackFn(path, result, ev.defaultPrevented);
  };

  // add to document (unless callback returns `false`)
  if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
}


/**
 * Load multiple files.
 * @param {string[]} paths - The file paths
 * @param {Function} callbackFn - The callback function
 */
function loadFiles(paths, callbackFn, args) {
  // listify paths
  paths = paths.push ? paths : [paths];

  var numWaiting = paths.length,
      x = numWaiting,
      pathsNotFound = [],
      fn,
      i;

  // define callback function
  fn = function(path, result, defaultPrevented) {
    // handle error
    if (result == 'e') pathsNotFound.push(path);

    // handle beforeload event. If defaultPrevented then that means the load
    // will be blocked (ex. Ghostery/ABP on Safari)
    if (result == 'b') {
      if (defaultPrevented) pathsNotFound.push(path);
      else return;
    }

    numWaiting--;
    if (!numWaiting) callbackFn(pathsNotFound);
  };

  // load scripts
  for (i=0; i < x; i++) loadFile(paths[i], fn, args);
}


/**
 * Initiate script load and register bundle.
 * @param {(string|string[])} paths - The file paths
 * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
 *   callback or (3) object literal with success/error arguments, numRetries,
 *   etc.
 * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
 *   literal with success/error arguments, numRetries, etc.
 */
function loadjs(paths, arg1, arg2) {
  var bundleId,
      args;

  // bundleId (if string)
  if (arg1 && arg1.trim) bundleId = arg1;

  // args (default is {})
  args = (bundleId ? arg2 : arg1) || {};

  // throw error if bundle is already defined
  if (bundleId) {
    if (bundleId in bundleIdCache) {
      throw "LoadJS";
    } else {
      bundleIdCache[bundleId] = true;
    }
  }

  function loadFn(resolve, reject) {
    loadFiles(paths, function (pathsNotFound) {
      // execute callbacks
      executeCallbacks(args, pathsNotFound);
      
      // resolve Promise
      if (resolve) {
        executeCallbacks({success: resolve, error: reject}, pathsNotFound);
      }

      // publish bundle load event
      publish(bundleId, pathsNotFound);
    }, args);
  }
  
  if (args.returnPromise) return new Promise(loadFn);
  else loadFn();
}


/**
 * Execute callbacks when dependencies have been satisfied.
 * @param {(string|string[])} deps - List of bundle ids
 * @param {Object} args - success/error arguments
 */
loadjs.ready = function ready(deps, args) {
  // subscribe to bundle load event
  subscribe(deps, function (depsNotFound) {
    // execute callbacks
    executeCallbacks(args, depsNotFound);
  });

  return loadjs;
};


/**
 * Manually satisfy bundle dependencies.
 * @param {string} bundleId - The bundle id
 */
loadjs.done = function done(bundleId) {
  publish(bundleId, []);
};


/**
 * Reset loadjs dependencies statuses
 */
loadjs.reset = function reset() {
  bundleIdCache = {};
  bundleResultCache = {};
  bundleCallbackQueue = {};
};


/**
 * Determine if bundle has already been defined
 * @param String} bundleId - The bundle id
 */
loadjs.isDefined = function isDefined(bundleId) {
  return bundleId in bundleIdCache;
};


// export
return loadjs;

}));


/***/ }),

/***/ 5655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ 6086:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 8130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports calcTimeDelta, formatTimeDelta, zeroPad */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var strValue = String(value);
  if (length === 0) return strValue;
  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
  var prefix = match ? match[1] : '';
  var suffix = match ? match[3] : '';
  var strNo = match ? match[2] : strValue;
  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function () {
    return '0';
  }).join('') + strNo).slice(length * -1);
  return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
  daysInHours: false,
  zeroPadTime: 2
};
function calcTimeDelta(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$now = options.now,
      now = _options$now === void 0 ? Date.now : _options$now,
      _options$precision = options.precision,
      precision = _options$precision === void 0 ? 0 : _options$precision,
      controlled = options.controlled,
      _options$offsetTime = options.offsetTime,
      offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime,
      overtime = options.overtime;
  var startTimestamp;

  if (typeof date === 'string') {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }

  if (!controlled) {
    startTimestamp += offsetTime;
  }

  var timeLeft = controlled ? startTimestamp : startTimestamp - now();
  var clampedPrecision = Math.min(20, Math.max(0, precision));
  var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
  var seconds = Math.abs(total) / 1000;
  return {
    total: total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1000).toFixed()),
    completed: total <= 0
  };
}
function formatTimeDelta(timeDelta, options) {
  var days = timeDelta.days,
      hours = timeDelta.hours,
      minutes = timeDelta.minutes,
      seconds = timeDelta.seconds;

  var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options),
      daysInHours = _Object$assign.daysInHours,
      zeroPadTime = _Object$assign.zeroPadTime,
      _Object$assign$zeroPa = _Object$assign.zeroPadDays,
      zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;

  var zeroPadTimeLength = Math.min(2, zeroPadTime);
  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
  return {
    days: daysInHours ? '' : zeroPad(days, zeroPadDays),
    hours: formattedHours,
    minutes: zeroPad(minutes, zeroPadTimeLength),
    seconds: zeroPad(seconds, zeroPadTimeLength)
  };
}

var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);

  var _super = _createSuper(Countdown);

  function Countdown() {
    var _this;

    _classCallCheck(this, Countdown);

    _this = _super.apply(this, arguments);
    _this.state = {
      count: _this.props.count || 3
    };

    _this.startCountdown = function () {
      _this.interval = window.setInterval(function () {
        var count = _this.state.count - 1;

        if (count === 0) {
          _this.stopCountdown();

          _this.props.onComplete && _this.props.onComplete();
        } else {
          _this.setState(function (prevState) {
            return {
              count: prevState.count - 1
            };
          });
        }
      }, 1000);
    };

    _this.stopCountdown = function () {
      clearInterval(_this.interval);
    };

    _this.addTime = function (seconds) {
      _this.stopCountdown();

      _this.setState(function (prevState) {
        return {
          count: prevState.count + seconds
        };
      }, _this.startCountdown);
    };

    return _this;
  }

  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCountdown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(this.props.children, {
        count: this.state.count
      }) : null;
    }
  }]);

  return Countdown;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
Countdown.propTypes = {
  count: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1__.element,
  onComplete: prop_types__WEBPACK_IMPORTED_MODULE_1__.func
};

var Countdown$1 = function (_React$Component) {
  _inherits(Countdown$1, _React$Component);

  var _super = _createSuper(Countdown$1);

  function Countdown$1(props) {
    var _this;

    _classCallCheck(this, Countdown$1);

    _this = _super.call(this, props);
    _this.mounted = false;
    _this.initialTimestamp = _this.calcOffsetStartTimestamp();
    _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
    _this.offsetTime = 0;
    _this.legacyMode = false;
    _this.legacyCountdownRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)();

    _this.tick = function () {
      var timeDelta = _this.calcTimeDelta();

      var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;

      _this.setTimeDeltaState(timeDelta, undefined, callback);
    };

    _this.start = function () {
      if (_this.isStarted()) return;
      var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
      _this.offsetStartTimestamp = 0;
      _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;

      var timeDelta = _this.calcTimeDelta();

      _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);

      if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
        _this.clearTimer();

        _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
      }
    };

    _this.pause = function () {
      if (_this.isPaused()) return;

      _this.clearTimer();

      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();

      _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
    };

    _this.stop = function () {
      if (_this.isStopped()) return;

      _this.clearTimer();

      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
      _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;

      _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
    };

    _this.isStarted = function () {
      return _this.isStatus("STARTED");
    };

    _this.isPaused = function () {
      return _this.isStatus("PAUSED");
    };

    _this.isStopped = function () {
      return _this.isStatus("STOPPED");
    };

    _this.isCompleted = function () {
      return _this.isStatus("COMPLETED");
    };

    if (props.date) {
      var timeDelta = _this.calcTimeDelta();

      _this.state = {
        timeDelta: timeDelta,
        status: timeDelta.completed ? "COMPLETED" : "STOPPED"
      };
    } else {
      _this.legacyMode = true;
    }

    return _this;
  }

  _createClass(Countdown$1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = true;
      if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
      if (this.props.autoStart) this.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.legacyMode) {
        return;
      }

      if (this.props.date !== prevProps.date) {
        this.initialTimestamp = this.calcOffsetStartTimestamp();
        this.offsetStartTimestamp = this.initialTimestamp;
        this.offsetTime = 0;
        this.setTimeDeltaState(this.calcTimeDelta());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = false;
      this.clearTimer();
    }
  }, {
    key: "calcTimeDelta",
    value: function calcTimeDelta$1() {
      var _this$props = this.props,
          date = _this$props.date,
          now = _this$props.now,
          precision = _this$props.precision,
          controlled = _this$props.controlled,
          overtime = _this$props.overtime;
      return calcTimeDelta(date, {
        now: now,
        precision: precision,
        controlled: controlled,
        offsetTime: this.offsetTime,
        overtime: overtime
      });
    }
  }, {
    key: "calcOffsetStartTimestamp",
    value: function calcOffsetStartTimestamp() {
      return Date.now();
    }
  }, {
    key: "addTime",
    value: function addTime(seconds) {
      this.legacyCountdownRef.current.addTime(seconds);
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      window.clearInterval(this.interval);
    }
  }, {
    key: "isStatus",
    value: function isStatus(status) {
      return this.state.status === status;
    }
  }, {
    key: "setTimeDeltaState",
    value: function setTimeDeltaState(timeDelta, status, callback) {
      var _this2 = this;

      if (!this.mounted) return;
      var completing = timeDelta.completed && !this.state.timeDelta.completed;
      var completedOnStart = timeDelta.completed && status === "STARTED";

      if (completing && !this.props.overtime) {
        this.clearTimer();
      }

      var onDone = function onDone() {
        if (callback) callback(_this2.state.timeDelta);

        if (_this2.props.onComplete && (completing || completedOnStart)) {
          _this2.props.onComplete(timeDelta, completedOnStart);
        }
      };

      return this.setState(function (prevState) {
        var newStatus = status || prevState.status;

        if (timeDelta.completed && !_this2.props.overtime) {
          newStatus = "COMPLETED";
        } else if (!status && newStatus === "COMPLETED") {
          newStatus = "STOPPED";
        }

        return {
          timeDelta: timeDelta,
          status: newStatus
        };
      }, onDone);
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.api = this.api || {
        start: this.start,
        pause: this.pause,
        stop: this.stop,
        isStarted: this.isStarted,
        isPaused: this.isPaused,
        isStopped: this.isStopped,
        isCompleted: this.isCompleted
      };
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps() {
      var _this$props2 = this.props,
          daysInHours = _this$props2.daysInHours,
          zeroPadTime = _this$props2.zeroPadTime,
          zeroPadDays = _this$props2.zeroPadDays;
      var timeDelta = this.state.timeDelta;
      return Object.assign(Object.assign({}, timeDelta), {
        api: this.getApi(),
        props: this.props,
        formatted: formatTimeDelta(timeDelta, {
          daysInHours: daysInHours,
          zeroPadTime: zeroPadTime,
          zeroPadDays: zeroPadDays
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.legacyMode) {
        var _this$props3 = this.props,
            count = _this$props3.count,
            _children = _this$props3.children,
            onComplete = _this$props3.onComplete;
        return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Countdown, {
          ref: this.legacyCountdownRef,
          count: count,
          onComplete: onComplete
        }, _children);
      }

      var _this$props4 = this.props,
          className = _this$props4.className,
          overtime = _this$props4.overtime,
          children = _this$props4.children,
          renderer = _this$props4.renderer;
      var renderProps = this.getRenderProps();

      if (renderer) {
        return renderer(renderProps);
      }

      if (children && this.state.timeDelta.completed && !overtime) {
        return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
          countdown: renderProps
        });
      }

      var _renderProps$formatte = renderProps.formatted,
          days = _renderProps$formatte.days,
          hours = _renderProps$formatte.hours,
          minutes = _renderProps$formatte.minutes,
          seconds = _renderProps$formatte.seconds;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("span", {
        className: className
      }, renderProps.total < 0 ? '-' : '', days, days ? ':' : '', hours, ":", minutes, ":", seconds);
    }
  }]);

  return Countdown$1;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
  controlled: false,
  intervalDelay: 1000,
  precision: 0,
  autoStart: true
});
Countdown$1.propTypes = {
  date: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([(0,prop_types__WEBPACK_IMPORTED_MODULE_1__.instanceOf)(Date), prop_types__WEBPACK_IMPORTED_MODULE_1__.string, prop_types__WEBPACK_IMPORTED_MODULE_1__.number]),
  daysInHours: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  zeroPadTime: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  zeroPadDays: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  controlled: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  precision: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  autoStart: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  overtime: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1__.element,
  renderer: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  now: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onMount: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onStart: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onPause: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onStop: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onTick: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onComplete: prop_types__WEBPACK_IMPORTED_MODULE_1__.func
};

/* harmony default export */ __webpack_exports__["ZP"] = (Countdown$1);



/***/ }),

/***/ 7058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ useTranslation; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(3878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js + 1 modules
var unsupportedIterableToArray = __webpack_require__(1563);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(5267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context/* I18nContext */.OO) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || (0,context/* getI18n */.nI)();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new context/* ReportNamespaces */.zv();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0,context/* getDefaults */.JP)()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

/***/ }),

/***/ 9945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tP": function() { return /* binding */ Tweet; }
});

// UNUSED EXPORTS: Follow, Hashtag, Mention, Share, Timeline, eagerLoadTwitterLibrary

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/loadjs/dist/loadjs.umd.js
var loadjs_umd = __webpack_require__(5107);
var loadjs_umd_default = /*#__PURE__*/__webpack_require__.n(loadjs_umd);
;// CONCATENATED MODULE: ./node_modules/react-twitter-widgets/es/utils.js


var twScriptUrl = "https://platform.twitter.com/widgets.js";
var twScriptWindowFieldName = "twttr";
var twScriptName = twScriptWindowFieldName;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function loadTwitterLibrary() {
  if (!loadjs_umd_default().isDefined(twScriptName)) {
    loadjs_umd_default()(twScriptUrl, twScriptName);
  }
}
function twWidgetFactory() {
  return new Promise(function (resolve, reject) {
    var rejectWithError = function rejectWithError() {
      return reject(new Error("Could not load remote twitter widgets js"));
    };

    loadTwitterLibrary();
    loadjs_umd_default().ready(twScriptName, {
      success: function success() {
        // Ensure loaded
        var twttr = window[twScriptWindowFieldName];

        if (!twttr || !twttr.widgets) {
          rejectWithError();
        }

        resolve(twttr.widgets);
      },
      error: rejectWithError
    });
  });
}
function removeChildrenWithAttribute(node, attribute) {
  if (node) {
    node.querySelectorAll("*").forEach(function (child) {
      if (child.hasAttribute(attribute)) {
        child.remove();
      }
    });
  }
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function isShallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function useShallowCompareMemoize(value) {
  var ref = (0,react.useRef)();

  if (!isShallowEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
function cloneShallow(value) {
  return typeof value === "object" ? Object.assign({}, value) : value;
}
;// CONCATENATED MODULE: ./node_modules/react-twitter-widgets/es/index.js



var childDivIdentifyingAttribute = "twdiv";

function useTwitterWidget(factoryFunctionName, primaryArg, options, onLoad) {
  var _useState = (0,react.useState)(null),
      error = _useState[0],
      setError = _useState[1];

  var ref = (0,react.useRef)(null); // noop if ssr

  if (!canUseDOM) {
    return {
      ref: ref,
      error: error
    };
  } // Make deps for useEffect.
  // options, and possibly primaryArg, are objects that should be compared (shallow).
  // There currently aren't any nested arrays or objects, so they
  // can be cloned in a shallow manner.
  // NOTE onLoad is used in useCallback, but it is not listed as a dependency.
  // Listing it would likely cause unnecessary loads. The latest onLoad should be
  // used regardless, since it will not be called unless the other dependencies
  // change, so it works out.


  var deps = [factoryFunctionName, useShallowCompareMemoize(primaryArg), useShallowCompareMemoize(options)];
  (0,react.useEffect)(function () {
    // Reset error
    setError(null); // Protect against race conditions
    // (set to true in cleanup function;
    // checked if canceled in async loadWidget)

    var isCanceled = false;

    if (ref.current) {
      removeChildrenWithAttribute(ref.current, childDivIdentifyingAttribute);

      if (!ref || !ref.current) {
        return;
      }

      var childEl = document.createElement("div");
      childEl.setAttribute(childDivIdentifyingAttribute, "yes");
      ref.current.appendChild(childEl);
      twWidgetFactory().then(function (wf) {
        // primaryArg (possibly an object) and options must be cloned
        // since twitter mutates them (gah!).
        // There currently aren't any nested arrays or objects, so they
        // can be cloned in a shallow manner.
        return wf[factoryFunctionName](cloneShallow(primaryArg), childEl, cloneShallow(options));
      }).then(function (resultMaybe) {
        // Twitter returns undefined if widget creation fails.
        // However, if deps are stale (isCanceled), suppress error (likely race condition).
        if (!resultMaybe && !isCanceled) {
          throw new Error("Twitter could not create widget. If it is a Timeline or " + "Tweet, ensure the screenName/tweetId exists.");
        }

        if (!ref || !ref.current) {
          return;
        }

        if (isCanceled) {
          if (childEl) {
            childEl.remove();
          }

          return;
        }

        if (onLoad) {
          onLoad();
        }
      })["catch"](function (e) {
        console.error(e);
        setError(e);
      });
    }

    return function () {
      isCanceled = true;
    };
  }, deps);
  return {
    ref: ref,
    error: error
  };
}

var Follow = function Follow(_ref) {
  var username = _ref.username,
      options = _ref.options,
      onLoad = _ref.onLoad,
      renderError = _ref.renderError;

  var _useTwitterWidget = useTwitterWidget("createFollowButton", username, options, onLoad),
      ref = _useTwitterWidget.ref,
      error = _useTwitterWidget.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Hashtag = function Hashtag(_ref2) {
  var hashtag = _ref2.hashtag,
      options = _ref2.options,
      onLoad = _ref2.onLoad,
      renderError = _ref2.renderError;

  var _useTwitterWidget2 = useTwitterWidget("createHashtagButton", hashtag, options, onLoad),
      ref = _useTwitterWidget2.ref,
      error = _useTwitterWidget2.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Mention = function Mention(_ref3) {
  var username = _ref3.username,
      options = _ref3.options,
      onLoad = _ref3.onLoad,
      renderError = _ref3.renderError;

  var _useTwitterWidget3 = useTwitterWidget("createMentionButton", username, options, onLoad),
      ref = _useTwitterWidget3.ref,
      error = _useTwitterWidget3.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Share = function Share(_ref4) {
  var url = _ref4.url,
      options = _ref4.options,
      onLoad = _ref4.onLoad,
      renderError = _ref4.renderError;

  var _useTwitterWidget4 = useTwitterWidget("createShareButton", url, options, onLoad),
      ref = _useTwitterWidget4.ref,
      error = _useTwitterWidget4.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Timeline = function Timeline(_ref5) {
  var dataSource = _ref5.dataSource,
      options = _ref5.options,
      onLoad = _ref5.onLoad,
      renderError = _ref5.renderError;

  var _useTwitterWidget5 = useTwitterWidget("createTimeline", dataSource, options, onLoad),
      ref = _useTwitterWidget5.ref,
      error = _useTwitterWidget5.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Tweet = function Tweet(_ref6) {
  var tweetId = _ref6.tweetId,
      options = _ref6.options,
      onLoad = _ref6.onLoad,
      renderError = _ref6.renderError;

  var _useTwitterWidget6 = useTwitterWidget("createTweet", tweetId, options, onLoad),
      ref = _useTwitterWidget6.ref,
      error = _useTwitterWidget6.error;

  return /*#__PURE__*/react.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};

/***/ }),

/***/ 973:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vc": function() { return /* binding */ config$1; }
/* harmony export */ });
/* unused harmony exports noAuto, library, dom, parse, findIconDefinition, toHtml, icon, layer, text, counter, api */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5;

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_CSS_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var FAMILY_CLASSIC = 'classic';
var FAMILY_SHARP = 'sharp';
var FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];

function familyProxy(obj) {
  // Defaults to the classic family if family is not available
  return new Proxy(obj, {
    get: function get(target, prop) {
      return prop in target ? target[prop] : target[FAMILY_CLASSIC];
    }
  });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
  'fa': 'solid',
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit'
}), _defineProperty(_familyProxy, FAMILY_SHARP, {
  'fa': 'solid',
  'fass': 'solid',
  'fa-solid': 'solid'
}), _familyProxy));
var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
}), _defineProperty(_familyProxy2, FAMILY_SHARP, {
  'solid': 'fass'
}), _familyProxy2));
var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
}), _defineProperty(_familyProxy3, FAMILY_SHARP, {
  'fass': 'fa-solid'
}), _familyProxy3));
var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
}), _defineProperty(_familyProxy4, FAMILY_SHARP, {
  'fa-solid': 'fass'
}), _familyProxy4));
var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss)?[\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i; // TODO: this needs to support fass
// TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
}), _defineProperty(_familyProxy5, FAMILY_SHARP, {
  '900': 'fass'
}), _familyProxy5));
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var prefixes = new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-css-prefix', 'cssPrefix'], ['data-family-default', 'familyDefault'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  styleDefault: 'solid',
  familyDefault: 'classic',
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present

if (initial.familyPrefix) {
  initial.cssPrefix = initial.familyPrefix;
}

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_default).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0

Object.defineProperty(config, 'familyPrefix', {
  enumerable: true,
  set: function set(val) {
    _config.cssPrefix = val;

    _onChangeCb.forEach(function (cb) {
      return cb(config);
    });
  },
  get: function get() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dcp = DEFAULT_CSS_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.cssPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dcp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var _LONG_STYLE, _PREFIXES, _PREFIXES_FOR_FAMILY;
var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = (_PREFIXES = {}, _defineProperty(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(cssPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === cssPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$family = params.family,
      family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
  var style = PREFIX_TO_STYLE[family][styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(values) {
  var _famProps;

  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var famProps = (_famProps = {}, _defineProperty(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
  var givenPrefix = null;
  var family = FAMILY_CLASSIC;

  if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v);
  })) {
    family = FAMILY_CLASSIC;
  }

  if (values.includes(famProps[FAMILY_SHARP]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v);
  })) {
    family = FAMILY_SHARP;
  }

  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.cssPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES[family].indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls, {
        family: family
      });
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (values.includes('fa-brands') || values.includes('fab')) {
    canonical.prefix = 'fab';
  }

  if (values.includes('fa-duotone') || values.includes('fad')) {
    canonical.prefix = 'fad';
  }

  if (!canonical.prefix && family === FAMILY_SHARP && (styles['fass'] || config.autoFetchSvg)) {
    canonical.prefix = 'fass';
    canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
  }

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change

        var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.2.1\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

var knownPrefixes = new Set();
FAMILIES.map(function (family) {
  knownPrefixes.add("fa-".concat(family));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = _toConsumableArray(knownPrefixes);

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function (f) {
    return "fa-".concat(f);
  }).concat(Object.keys(styles$2));

  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }

  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var family = ~['Sharp'].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;




/***/ })

}]);